// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/animate.css/animate.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/slick-carousel/slick/slick.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/slick-carousel/slick/slick-theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/select2/dist/css/select2.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/images/bg/banner-bg2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/images/shape/box-shape2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/assets/images/shape/box-shape3.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Exo:ital,wght@0,100..900;1,100..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Outfit:wght@100..900&family=Quicksand:wght@300..700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*====================== CSS Index Here =======================*/
/*
01. Abstracts
    1.1. Classes
    1.2. Extend
    1.3. Functions
    1.4. Mixins
    1.5. Variable
    1.6. Wordpress Default

02. Base
    2.1. Margin
    2.2. Padding
    2.3. Typography

03. Components
    3.1. Accordion
    3.2. Button
    3.3. Form
    3.4. Pagination
    3.6. Tab

04. Layout
    4.1. Blog Sidebar
    4.2. Breadcrumb
    4.3. Comment
    4.4. Footer
    4.5. Header Top
    4.6. Header
    4.7. Preloader
    4.8. Scroll Top
    4.9. Section Heading
    4.10. Slick
    4.11. Social Icon
*/
/*======================== CSS Index End ======================*/
/* Convert to Rem start */
/* Convert to Rem End */
/* ======================== Functions Css End ======================= */
/* ======================== Functions Css End ======================= */
/* Font Family*/
/* ========================= Variable Css Start ======================== */
:root {
  /* Font Family Variable */
  --heading-font: "Quicksand", sans-serif ;
  --heading-font-two: "Exo", sans-serif;
  --heading-font-three: "Outfit", sans-serif;
  --heading-font-four: "Dancing Script", cursive;
  --body-font: "Inter", sans-serif;
  /* Font Size Variable Start */
  --heading-one: clamp(2.25rem, -0.0733rem + 6.3692vw, 4.5rem);
  --heading-two: clamp(2rem, 0.7133rem + 2.8846vw, 3.5rem);
  --heading-three: clamp(1.75rem, 0.3353rem + 2.1661vw, 3rem);
  --heading-four: clamp(1.5rem, 0.5569rem + 1.444vw, 2.5rem);
  --heading-five: clamp(1.25rem, 1.2rem + 0.722vw, 2.25rem);
  --heading-six: clamp(1.125rem, 0.769rem + 0.6813vw, 1.5rem);
  --display-200: clamp(3.75rem, -0.0733rem + 6.3692vw, 12.5rem);
  --display-one: clamp(2.5rem, -0.0733rem + 6.3692vw, 7.5rem);
  /* Font Size End */
  /* template main color */
  --main-h: 148;
  --main-s: 59%;
  --main-l: 39%;
  --main: var(--main-h) var(--main-s) var(--main-l);
  /* template main color */
  --main-two-h: 25;
  --main-two-s: 100%;
  --main-two-l: 49%;
  --main-two: var(--main-two-h) var(--main-two-s) var(--main-two-l);
  /* White Color */
  --white: 0 0% 100%;
  --black: 235 49% 14%;
  --light: 0 0% 51%;
  --heading-color: var(--black);
  --body-color: var(--light);
  --body-bg: var(--gray);
  --border-color: 236 13% 77%;
  --bg-color-one: #F3FAF2;
  --bg-color-two: #FFFBF4;
  --bg-color-three: #F1F1F1;
  --neutral: #121535;
  --translate-x-middle: translateX(-50%);
  --translate-y-middle: translateY(-50%);
  --size-2: 0.125rem;
  --size-3: 0.1875rem;
  --size-4: 0.25rem;
  --size-5: 0.3125rem;
  --size-6: 0.375rem;
  --size-7: 0.4375rem;
  --size-8: 0.5rem;
  --size-9: 0.5625rem;
  --size-10: 0.625rem;
  --size-11: 0.6875rem;
  --size-12: 0.75rem;
  --size-13: 0.8125rem;
  --size-14: 0.875rem;
  --size-16: 1rem;
  --size-18: 1.125rem;
  --size-20: 1.25rem;
  --size-22: 1.375rem;
  --size-24: 1.5rem;
  --size-26: 1.625rem;
  --size-28: 1.75rem;
  --size-30: 1.875rem;
  --size-32: 2rem;
  --size-36: 2rem;
  --size-40: 2.5rem;
  --size-44: 2.75rem;
  --size-48: 3rem;
  --size-52: 3.25rem;
  --size-56: 3.5rem;
  --size-60: 3.75rem;
  --size-64: 4rem;
  --size-68: 4.25rem;
  --size-72: 4.5rem;
  --size-76: 4.75rem;
  --size-80: 5rem;
  --size-90: 5.625rem;
  --size-110: 6.875rem;
  --size-120: 7.5rem;
  --size-144: 9rem;
  --size-160: 10rem;
  --size-210: 13.125rem;
  --main-50: hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.9));
  --main-100: hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.8));
  --main-200: hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.7));
  --main-300: hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.6));
  --main-400: hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.5));
  --main-500: hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.4));
  --main-600: hsl(var(--main-h), var(--main-s), var(--main-l));
  --main-700: hsl(var(--main-h), var(--main-s), calc(var(--main-l) - var(--main-l) * 0.1));
  --main-800: hsl(var(--main-h), var(--main-s), calc(var(--main-l) - var(--main-l) * 0.2));
  --main-900: hsl(var(--main-h), var(--main-s), calc(var(--main-l) - var(--main-l) * 0.3));
  --main-two-50: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.9));
  --main-two-100: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.8));
  --main-two-200: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.7));
  --main-two-300: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.6));
  --main-two-400: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.5));
  --main-two-500: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.4));
  --main-two-600: hsl(var(--main-two-h), var(--main-two-s), var(--main-two-l));
  --main-two-700: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) - var(--main-two-l) * 0.1));
  --main-two-800: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) - var(--main-two-l) * 0.2));
  --main-two-900: hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) - var(--main-two-l) * 0.3));
  --neutral-50: #ECF1F9;
  --neutral-100: #E6E6E6;
  --neutral-200: #CCCCCC;
  --neutral-300: #B3B3B3;
  --neutral-400: #999999;
  --neutral-500: #808080;
  --neutral-600: #121535;
  --neutral-700: #060710;
  --neutral-800: #11132e;
  --neutral-900: #1A1A1A;
  --gray-50: #F1F1F1;
  --gray-100: #E6E6E6;
  --gray-200: #CCCCCC;
  --gray-300: #B3B3B3;
  --gray-400: #999999;
  --gray-500: #808080;
  --gray-600: #666666;
  --gray-700: #4D4D4D;
  --gray-800: #333333;
  --gray-900: #1A1A1A;
  --light-50: #F5F6FA;
  --light-100: #F3F4F6;
  --light-600: #E4F1FF;
  --light-700: #374151;
  --light-800: #1F2937;
  --primary-50: #E4F1FF;
  --primary-100: #BFDCFF;
  --primary-200: #95C7FF;
  --primary-300: #6BB1FF;
  --primary-400: #519FFF;
  --primary-500: #458EFF;
  --primary-600: #487FFF;
  --primary-700: #486CEA;
  --primary-800: #4759D6;
  --primary-900: #4536B6;
  --danger-50: #FEF2F2;
  --danger-100: #FEE2E2;
  --danger-200: #FECACA;
  --danger-300: #FCA5A5;
  --danger-400: #F87171;
  --danger-500: #EF4444;
  --danger-600: #DC2626;
  --danger-700: #B91C1C;
  --danger-800: #991B1B;
  --danger-900: #7F1D1D;
  --success-50: #F0FDF4;
  --success-100: #DCFCE7;
  --success-200: #BBF7D0;
  --success-300: #86EFAC;
  --success-400: #4ADE80;
  --success-500: #22C55E;
  --success-600: #27AE60;
  --success-700: #15803D;
  --success-800: #166534;
  --success-900: #14532D;
  --warning-50: #FEFCE8;
  --warning-100: #FEF9C3;
  --warning-200: #FEF08A;
  --warning-300: #FDE047;
  --warning-400: #FACC15;
  --warning-500: #EAB308;
  --warning-600: #FF9F29;
  --warning-700: #f39016;
  --warning-800: #e58209;
  --warning-900: #d77907;
  --info-50: #EFF6FF;
  --info-100: #DBEAFE;
  --info-200: #BFDBFE;
  --info-300: #93C5FD;
  --info-400: #60A5FA;
  --info-500: #3B82F6;
  --info-600: #2563EB;
  --info-700: #1D4ED8;
  --info-800: #1E40AF;
  --info-900: #1E3A8A;
  --tertiary-50: #d1c8ff;
  --tertiary-100: #c2b6ff;
  --tertiary-600: #3C23B5;
  --font-xs: 0.75rem;
  --font-sm: 0.875rem;
  --font-md: 1rem;
  --font-lg: 1.125rem;
  --font-xl: 1.25rem;
  --font-2xl: 1.5rem;
  --font-3xl: 1.875rem;
  --font-4xl: 2.25rem;
  --font-5xl: 3rem;
  --font-6xl: 3.75rem;
}

/* ========================= Variable Css End ======================== */
/* ============================ Mixins Css Start ============================ */
/* Media Breakpoint for Each Device Start */
/* Media Breakpoint for Each Device End */
/* ============================ Mixins Css End ============================ */
/* =========================== Accordion Css start ============================= */
.common-accordion .accordion-item {
  border: 1px solid var(--border-color);
  background-color: hsl(var(--white)) !important;
  border-radius: 8px;
  overflow: hidden;
}
.common-accordion .accordion-item:not(:last-child) {
  margin-block-end: 20px;
}
.common-accordion .accordion-header {
  line-height: 1;
}
.common-accordion .accordion-body {
  padding: 20px 30px;
  padding-block-start: 0;
}
@media screen and (max-width: 575px) {
  .common-accordion .accordion-body {
    padding: 12px 20px;
    padding-block-start: 0;
  }
}
.common-accordion:first-of-type .accordion-button.collapsed {
  border-radius: 5px;
}
.common-accordion:last-of-type .accordion-button.collapsed {
  border-radius: 5px;
}
.common-accordion .accordion-button {
  color: var(--heading-color);
  padding: 20px 30px;
  padding-inline-end: 46px;
  font-weight: 600;
  font-size: clamp(1rem, 0.696rem + 0.634vw, 1.25rem);
  font-family: var(--heading-font);
}
@media screen and (max-width: 575px) {
  .common-accordion .accordion-button {
    padding: 12px 20px;
    padding-inline-end: 36px;
  }
}
.common-accordion .accordion-button::after {
  background-image: none;
}
.common-accordion .accordion-button:focus {
  box-shadow: none;
}
.common-accordion .accordion-button:not(.collapsed) {
  background-color: transparent !important;
  box-shadow: none;
  color: hsl(var(--main));
}
.common-accordion .accordion-button:not(.collapsed)::after {
  background-image: none;
  color: hsl(var(--main));
}
.common-accordion .accordion-button[aria-expanded=true]::after, .common-accordion .accordion-button[aria-expanded=false]::after {
  font-family: "Phosphor";
  font-weight: 900;
  content: "\\e136";
  color: hsl(var(--main));
  display: inline-block;
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  inset-inline-end: 30px;
  height: unset;
  text-align: center;
}
@media screen and (max-width: 575px) {
  .common-accordion .accordion-button[aria-expanded=true]::after, .common-accordion .accordion-button[aria-expanded=false]::after {
    inset-inline-end: 20px;
  }
}
.common-accordion .accordion-button[aria-expanded=false]::after {
  content: "\\f107";
  color: hsl(var(--heading-color));
}

/* ================================= Accordion Css End =========================== */
/* ================================= Button Css Start =========================== */
.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  color: none;
  background-color: none;
  border-color: none;
}

.btn {
  position: relative;
  border-radius: 5px;
  border: 1px solid transparent;
  font-weight: 500;
  font-family: var(--body-font);
  color: hsl(var(--white)) !important;
  z-index: 1;
  line-height: 1;
  padding: 13px 24px;
}
.btn:hover, .btn:focus, .btn:focus-visible {
  box-shadow: none !important;
}
@media screen and (max-width: 1399px) {
  .btn {
    padding: 10px 20px;
    font-size: 0.875rem;
  }
}
.btn-sm {
  padding: 10px 16px !important;
}
.btn:active {
  transform: scale(1.01);
}
.btn-main {
  background-color: hsl(var(--main)) !important;
  border-color: hsl(var(--main)) !important;
}
.btn-main:hover {
  background-color: var(--main-800) !important;
  border-color: var(--main-800) !important;
}
.btn-outline-main {
  background-color: transparent !important;
  border-color: hsl(var(--main)) !important;
  color: hsl(var(--main)) !important;
}
.btn-outline-main:hover {
  background-color: hsl(var(--main)/0.15) !important;
  border-color: hsl(var(--main)/0.4) !important;
}
.btn-main-two {
  background-color: hsl(var(--main-two)) !important;
  border-color: hsl(var(--main-two)) !important;
  color: hsl(var(--white)) !important;
}
.btn-main-two:hover {
  background-color: var(--main-two-800) !important;
  border-color: var(--main-two-800) !important;
}
.btn-outline-main-two {
  background-color: transparent !important;
  border-color: hsl(var(--main-two)) !important;
  color: hsl(var(--main-two)) !important;
}
.btn-outline-main-two:hover {
  background-color: hsl(var(--main-two)/0.15) !important;
  border-color: hsl(var(--main-two)/0.4) !important;
}
.btn-white {
  background-color: hsl(var(--white)) !important;
  border-color: hsl(var(--white)) !important;
  color: hsl(var(--heading-color)) !important;
}
.btn-white:hover {
  background-color: hsl(var(--white)/0.9) !important;
  border-color: hsl(var(--white)/0.9) !important;
}
.btn-outline-white {
  background-color: transparent !important;
  border-color: hsl(var(--white)) !important;
  color: hsl(var(--white)) !important;
}
.btn-outline-white:hover {
  background-color: hsl(var(--white)) !important;
  border-color: hsl(var(--white)) !important;
  color: hsl(var(--heading-color)) !important;
}
.btn-black {
  background-color: hsl(var(--black)) !important;
  border-color: hsl(var(--black)) !important;
  color: hsl(var(--white)) !important;
}
.btn-black:hover {
  background-color: hsl(var(--black)/0.8) !important;
  border-color: hsl(var(--black)/0.8) !important;
}
.btn-outline-black {
  background-color: transparent !important;
  border-color: hsl(var(--black)) !important;
  color: hsl(var(--black)) !important;
}
.btn-outline-black:hover {
  background-color: hsl(var(--black)) !important;
  border-color: hsl(var(--black)) !important;
  color: hsl(var(--white)) !important;
}

/* ================================= Button Css End =========================== */
/* ================================= Form Css Start =========================== */
/* input Start */
.common-input {
  border-radius: 5px;
  font-weight: 400;
  outline: none;
  width: 100%;
  padding: 17px 24px;
  background-color: transparent !important;
  border: 1px solid var(--gray-100);
  color: hsl(var(--black));
  line-height: 1;
}
.common-input.style-two {
  background-color: hsl(var(--white)) !important;
  color: hsl(var(--black));
}
@media screen and (max-width: 991px) {
  .common-input {
    padding: 12px 24px;
  }
}
@media screen and (max-width: 767px) {
  .common-input {
    padding: 10px 16px;
  }
}
.common-input::placeholder {
  color: var(--gray-500);
  transition: 0.2s linear;
  font-size: 0.875rem;
  font-weight: 400;
}
.common-input--md {
  padding: 13px 16px;
}
.common-input--lg {
  padding: 23px 24px;
}
@media screen and (max-width: 767px) {
  .common-input--lg {
    padding: 18px 24px;
  }
}
.common-input:focus {
  border-color: hsl(var(--main));
  box-shadow: none;
}
.common-input:focus::placeholder {
  visibility: hidden;
  opacity: 0;
}
.common-input:disabled, .common-input[readonly] {
  background-color: hsl(var(--black)/0.2);
  opacity: 1;
  border: 0;
}
.common-input[type=password] {
  color: hsl(var(--black)/0.5);
}
.common-input[type=password]:focus {
  color: hsl(var(--black));
}
.common-input[type=file] {
  line-height: 50px;
  padding: 0;
  position: relative;
}
.common-input[type=file]::file-selector-button {
  border: 1px solid hsl(var(--black)/0.08);
  padding: 4px 6px;
  border-radius: 0.2em;
  background-color: hsl(var(--main)) !important;
  transition: 0.2s linear;
  line-height: 25px;
  position: relative;
  margin-inline-start: 15px;
  color: hsl(var(--body-color)) !important;
}
.common-input[type=file]::file-selector-button:hover {
  background-color: hsl(var(--main));
  border: 1px solid hsl(var(--main));
  color: hsl(var(--black));
}

.common-input--withIcon {
  padding-inline-end: 50px !important;
}
.common-input--withLeftIcon {
  padding-inline-start: 50px !important;
}

/* input End */
/* input icon */
.input-icon {
  position: absolute;
  inset-inline-end: 24px;
  inset-block-start: 50%;
  transform: translateY(-50%);
  color: hsl(var(--heading-color));
}
.input-icon--left {
  inset-inline-start: 20px;
  inset-inline-end: auto;
}

textarea + .input-icon {
  inset-block-start: 15px;
  transform: translateY(0);
}

/* input icon */
/* Label */
.form-label {
  margin-block-end: 6px;
  color: hsl(var(--heading-color));
  font-weight: 500;
}

/* Form Select */
.select-has-icon {
  position: relative;
}
.select-has-icon::before {
  position: absolute;
  content: "\\f107";
  inset-inline-end: 20px;
  inset-block-start: 50%;
  transform: translateY(-50%);
  font-family: "Phosphor";
  font-weight: 900;
  color: hsl(var(--main));
  transition: 0.2s linear;
  pointer-events: none;
  color: hsl(var(--black)) !important;
}
.select-has-icon.icon-black::before {
  -webkit-text-fill-color: hsl(var(--black));
}
.select-has-icon select {
  background-image: none;
  -webkit-appearance: none;
  padding: 20px 24px;
  font-size: 18px;
}
@media screen and (max-width: 991px) {
  .select-has-icon select {
    padding: 15px 24px;
  }
}
@media screen and (max-width: 767px) {
  .select-has-icon select {
    padding: 12px 16px;
  }
}
.select-has-icon .common-input {
  padding-inline-end: 30px !important;
}

.select {
  color: hsl(var(--black)/0.6) !important;
  padding: 16px 24px;
}
@media screen and (max-width: 991px) {
  .select {
    padding: 11px 24px;
  }
}
@media screen and (max-width: 767px) {
  .select {
    padding: 9px 24px;
  }
}
.select:focus {
  border-color: hsl(var(--main));
  color: hsl(var(--black)) !important;
  outline: none;
}
.select option {
  background-color: hsl(var(--white));
  color: hsl(var(--heading-color));
}

/* Form Select End */
textarea.common-input {
  height: 140px;
}
@media screen and (max-width: 767px) {
  textarea.common-input {
    height: 110px;
  }
}

/* Autofill Css */
input:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active,
textarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, textarea:-webkit-autofill:active {
  -webkit-transition: background-color 5000s ease-in-out 0s;
  transition: background-color 5000s ease-in-out 0s;
}

input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill, textarea:-webkit-autofill, textarea:-webkit-autofill, textarea:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px transparent inset;
  -webkit-text-fill-color: hsl(var(--heading-color)) !important;
  caret-color: hsl(var(--heading-color));
}

/* Autofill Css End */
/* Show Hide Password */
input#your-password, input#confirm-password {
  padding-inline-end: 50px;
}

.password-show-hide {
  position: absolute;
  inset-inline-end: 20px;
  z-index: 5;
  cursor: pointer;
  inset-block-start: 50%;
  transform: translateY(-50%);
  color: hsl(var(--black)/0.4);
}

/* Number Arrow None */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type=number] {
  -moz-appearance: textfield;
}

/* Custom Checkbox & Radio Css Start */
.common-check {
  margin-block-end: 16px;
}
.common-check:last-child {
  margin-block-end: 0;
}
.common-check a {
  display: inline;
}
.common-check.common-radio .form-check-input {
  border-radius: 50%;
}
.common-check.common-radio .form-check-input:checked {
  background-color: transparent !important;
}
.common-check.common-radio .form-check-input:checked::after {
  visibility: visible;
  opacity: 1;
  transform: translate(-50%, -50%) scale(1);
}
.common-check .form-check-input {
  transition: 0.2s linear;
  box-shadow: none;
  background-color: transparent;
  box-shadow: none !important;
  border: 0;
  position: relative;
  border-radius: 3px;
  width: 18px;
  height: 18px;
  border: 1px solid hsl(var(--black)/0.4);
  cursor: pointer;
  transition: 0.2s linear;
  margin-block-start: 0;
}
.common-check .form-check-input::before {
  position: absolute;
  content: "\\e182";
  font-family: "Phosphor";
  font-weight: 900;
  color: hsl(var(--white));
  font-size: 12px;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%);
  transition: 0.2s linear;
  visibility: hidden;
  opacity: 0;
}
.common-check .form-check-input::after {
  position: absolute;
  content: "";
  inset-block-start: 50%;
  inset-inline-start: 50%;
  transform: translate(-50%, -50%) scale(0.2);
  width: 10px;
  height: 10px;
  background-color: hsl(var(--main));
  border-radius: 50%;
  transition: 0.2s linear;
  z-index: 1;
  visibility: hidden;
  opacity: 0;
}
.common-check .form-check-input:checked {
  background-color: hsl(var(--main)) !important;
  border-color: hsl(var(--main)) !important;
  box-shadow: none;
}
.common-check .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.common-check .form-check-input:checked::before {
  visibility: visible;
  opacity: 1;
}
.common-check .form-check-label {
  font-weight: 500;
  width: calc(100% - 18px);
  padding-inline-start: 12px;
  cursor: pointer;
  color: hsl(var(--heading-color));
  font-family: var(--poppins-font);
}

.checked-black .form-check-input {
  border: 1px solid hsl(var(--black));
}
.checked-black .form-check-input::after {
  background-color: hsl(var(--black));
}
.checked-black .form-check-input:checked {
  background-color: hsl(var(--black)) !important;
  border-color: hsl(var(--black)) !important;
}
.checked-primary .form-check-input {
  border: 1px solid var(--primary-600);
}
.checked-primary .form-check-input::after {
  background-color: var(--primary-600);
}
.checked-primary .form-check-input:checked {
  background-color: var(--primary-600) !important;
  border-color: var(--primary-600) !important;
}
.checked-gray .form-check-input {
  border: 1px solid var(--gray-600);
}
.checked-gray .form-check-input::after {
  background-color: var(--gray-600);
}
.checked-gray .form-check-input:checked {
  background-color: var(--gray-600) !important;
  border-color: var(--gray-600) !important;
}
.checked-success .form-check-input {
  border: 1px solid var(--success-600);
}
.checked-success .form-check-input::after {
  background-color: var(--success-600);
}
.checked-success .form-check-input:checked {
  background-color: var(--success-600) !important;
  border-color: var(--success-600) !important;
}
.checked-danger .form-check-input {
  border: 1px solid var(--danger-600);
}
.checked-danger .form-check-input::after {
  background-color: var(--danger-600);
}
.checked-danger .form-check-input:checked {
  background-color: var(--danger-600) !important;
  border-color: var(--danger-600) !important;
}
.checked-purple .form-check-input {
  border: 1px solid var(--tertiary-600);
}
.checked-purple .form-check-input::after {
  background-color: var(--tertiary-600);
}
.checked-purple .form-check-input:checked {
  background-color: var(--tertiary-600) !important;
  border-color: var(--tertiary-600) !important;
}
.checked-white .form-check-input {
  border: 1px solid var(--gray-100);
}
.checked-white .form-check-input::after {
  background-color: var(--gray-100);
}
.checked-white .form-check-input:checked {
  background-color: var(--gray-100) !important;
  border-color: var(--gray-100) !important;
}

/* Custom Checkbox & Radio Css End */
.toggle-password.active::before {
  content: "\\e220" !important;
}

/* ================================= Form Css End =========================== */
/* ================================= Pagination Css Start =========================== */
.pagination {
  margin-block-start: 64px;
}
@media screen and (max-width: 1199px) {
  .pagination {
    margin-block-start: 48px;
  }
}
@media screen and (max-width: 991px) {
  .pagination {
    margin-block-start: 40px;
  }
}
@media screen and (max-width: 767px) {
  .pagination {
    margin-block-start: 32px;
  }
}
.pagination .page-item.active .page-link {
  background-color: var(--main-600) !important;
  border-color: var(--main-600) !important;
  color: hsl(var(--white)) !important;
}
.pagination .page-item .page-link {
  box-shadow: none !important;
}
.pagination .page-item .page-link:hover, .pagination .page-item .page-link:active, .pagination .page-item .page-link:focus {
  color: var(--main-600) !important;
  background-color: var(--main-100) !important;
  border-color: var(--main-300) !important;
}

/* ================================= Pagination Css End =========================== */
/* ================================= Tab Css Start =========================== */
.common-tab {
  margin-block-end: 20px;
  gap: 8px;
}
.common-tab .nav-item {
  border-bottom: 0;
}
.common-tab .nav-item .nav-link {
  color: var(--gray-500);
  padding: 9px 24px !important;
  background-color: transparent;
  transition: 0.2s linear;
  border: 1px solid var(--border-color);
  position: relative;
  font-weight: 400;
  overflow: hidden;
  border-radius: 50px;
  font-size: 16px;
}
@media screen and (max-width: 1399px) {
  .common-tab .nav-item .nav-link {
    padding: 6px 16px !important;
    font-size: 0.875rem;
  }
}
.common-tab .nav-item .nav-link.active {
  color: hsl(var(--white)) !important;
  border-color: var(--main-600) !important;
  background-color: var(--main-600) !important;
}
.common-tab .nav-item .nav-link:hover {
  color: var(--main-600);
}
.common-tab.style-two .nav-link {
  border: 1px solid var(--gray-100);
  color: var(--neutral-600);
}
.common-tab.style-two .nav-link.active {
  color: hsl(var(--white)) !important;
  border-color: var(--main-two-600) !important;
  background-color: var(--main-two-600) !important;
}
.common-tab.style-two .nav-link:hover {
  color: var(--main-two-600);
}

/* ================================= Tab Css End =========================== */
/* ======================= Common Table Css Start ======================= */
.table-card {
  border: 1px solid hsl(var(--white)/0.2);
  border-radius: 10px;
  padding: clamp(1.25rem, 0.033rem + 2.536vw, 2.25rem);
}

.table {
  color: hsl(var(--white));
  margin-block-end: 0;
  min-width: max-content;
}
.table > :not(caption) > * > * {
  border-bottom: 0;
}
.table tr th {
  padding-inline-start: 0;
  padding: 32px;
}
.table tr th:first-child {
  padding-inline-start: 0;
}
.table tr th:last-child {
  padding-inline-end: 0;
}
.table tr th, .table tr td {
  text-align: center;
  vertical-align: middle;
}
.table tr th:first-child, .table tr td:first-child {
  text-align: left;
}
.table tr th:last-child, .table tr td:last-child {
  text-align: right;
  padding-inline-end: 0;
}
.table thead tr {
  border-bottom: 1px solid hsl(var(--white)/0.2);
}
.table thead tr th {
  padding-block-start: 0;
  font-size: clamp(1rem, 0.696rem + 0.634vw, 1.25rem);
  font-weight: 400;
  padding-block-end: clamp(1rem, -0.065rem + 2.219vw, 1.875rem);
}
.table tbody tr {
  border-bottom: 1px solid hsl(var(--white)/0.2);
}
.table tbody tr:last-child {
  border-bottom: 0;
}
.table tbody tr:last-child td {
  padding-block-end: 0;
}
.table tbody tr td {
  font-size: clamp(0.875rem, 0.723rem + 0.317vw, 1rem);
  font-weight: 400;
  padding: clamp(1rem, -0.065rem + 2.219vw, 1.875rem) 0;
}
.table.style-two {
  color: hsl(var(--heading-color));
}
.table.style-two thead tr, .table.style-two tbody tr {
  border-bottom: 1px solid hsl(var(--black)/0.1);
}
.table.style-two thead tr th {
  padding-block-end: 16px;
  font-size: 15px;
}
.table.style-three tbody tr {
  border-bottom: 1px solid var(--gray-100);
}
.table.style-three tbody tr:last-child {
  border: 0;
}
.table.style-three tbody tr td:first-child {
  padding-inline-start: 0;
}
.table.style-three tbody tr td:last-child {
  padding-inline-end: 0;
}
.table.style-three tbody tr td {
  padding: clamp(1.5rem, 0.283rem + 2.536vw, 2.5rem) 24px;
}

/* ======================= Common Table Css End ======================= */
/* ================= Common Card Css Start ========================= */
.common-card {
  border: 0;
}
.common-card .card-header, .common-card .card-footer {
  padding: 12px 24px;
  background-color: transparent;
  border-bottom: 1px solid var(--border-color);
}
@media screen and (max-width: 424px) {
  .common-card .card-header, .common-card .card-footer {
    padding: 12px 16px;
  }
}
.common-card .card-header {
  background-color: hsl(var(--black));
}
.common-card .card-header .title {
  color: hsl(var(--white));
  margin-block-end: 0;
}
.common-card .card-body {
  padding: 24px;
}
@media screen and (max-width: 424px) {
  .common-card .card-body {
    padding: 16px;
  }
}
.common-card .card-footer {
  border-top: 1px solid var(--border-color);
  border-bottom: 0;
}

/* ================= Common Card Css End ========================= */
/* ======================= Select 2 Css Start =========================== */
.select2-container--default .select2-selection--single {
  border: 0;
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border: 0;
  position: relative;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b::before {
  position: relative;
  content: "\\e136";
  font-family: "Phosphor";
  font-weight: 900;
  color: hsl(var(--heading-color)/0.4);
  transition: 0.2s linear;
}

.select2-container--open.select2-container--default .select2-selection--single .select2-selection__arrow b::before {
  content: "\\e13c" !important;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  border: 0 !important;
  margin: 0 !important;
  inset-block-start: 0 !important;
  inset-inline-start: 0 !important;
  position: relative !important;
}

.select2-container {
  height: inherit !important;
  width: auto !important;
}

.select2-selection.select2-selection--single {
  height: inherit !important;
  border: 1px solid var(--gray-200) !important;
  background-color: transparent !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.radius-end-0 .select2-selection.select2-selection--single {
  border-start-start-radius: 50px !important;
  border-end-start-radius: 50px !important;
}

.select2-selection.select2-selection--single {
  position: relative;
}

.select2-container .selection {
  height: inherit;
}

.select2-selection__arrow {
  right: 16px !important;
  inset-block-start: 50% !important;
  transform: translateY(-50%) !important;
  width: unset !important;
}
@media screen and (max-width: 1199px) {
  .select2-selection__arrow {
    right: 6px !important;
  }
}

.select2-container .select2-selection--single .select2-selection__rendered {
  padding-inline-start: 24px !important;
  padding-inline-end: 40px !important;
}
@media screen and (max-width: 1199px) {
  .select2-container .select2-selection--single .select2-selection__rendered {
    padding-inline-start: 10px !important;
    padding-inline-end: 24px !important;
  }
}

.select-border-end-0 .select2-selection.select2-selection--single {
  border-inline-end: 0 !important;
}

.select2-dropdown {
  border: 1px solid var(--gray-100) !important;
  padding: 10px !important;
  border-radius: 6px !important;
  min-width: 200px;
}
@media screen and (max-width: 767px) {
  .select2-dropdown {
    min-width: 170px;
  }
}
@media screen and (max-width: 424px) {
  .select2-dropdown {
    min-width: 150px;
  }
}

.select2-search--dropdown {
  padding: 0 !important;
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  border: 1px solid var(--gray-100) !important;
  border-radius: 6px !important;
  padding: 4px 10px;
}

.select2-container--default .select2-search--dropdown .select2-search__field:focus-visible {
  outline: 1px solid var(--main-200);
}

.select2-results {
  margin-block-start: 8px !important;
}

.select2-results__option.select2-results__option--selectable {
  border-radius: 6px !important;
  padding: 6px 12px !important;
  color: var(--gray-500);
  font-size: 14px !important;
}
@media screen and (max-width: 767px) {
  .select2-results__option.select2-results__option--selectable {
    padding: 4px 10px !important;
    font-size: 12px !important;
  }
}

.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable {
  background-color: var(--main-600) !important;
  color: white !important;
}

.select2-results__option.select2-results__option--selectable:hover {
  background-color: var(--main-100) !important;
  color: var(--main-600) !important;
}

.select2-container--default .select2-results__option--selected, .select2-container--default .select2-results__option--selected:hover {
  background-color: var(--main-600) !important;
  color: #fff !important;
}

.select2-container--default .select2-results > .select2-results__options {
  padding-inline-end: 8px;
}
.select2-container--default .select2-results > .select2-results__options::-webkit-scrollbar {
  width: 6px;
}
.select2-container--default .select2-results > .select2-results__options::-webkit-scrollbar-track {
  background: #e4e4e4;
}
.select2-container--default .select2-results > .select2-results__options::-webkit-scrollbar-thumb {
  background: #a2a2a2;
  border-radius: 50px;
}
.select2-container--default .select2-results > .select2-results__options::-webkit-scrollbar-thumb:hover {
  background: #6d6d6d;
}

.select2-container--open.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: var(--main-600) !important;
}
.select2-container--open.select2-container--default .select2-selection--single .select2-selection__arrow b::before {
  color: var(--main-600) !important;
}

/* Location Box Css  */
.location-box .select2-container .select2-selection--single .select2-selection__rendered {
  padding-inline-start: 0px !important;
  padding-inline-end: 50px !important;
}
.location-box .select2-selection__arrow {
  right: 0px !important;
  inset-block-start: 10% !important;
}
.location-box .select2-selection.select2-selection--single {
  border: 0 !important;
}
.location-box .select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 14px;
  color: var(--gray-900);
  font-weight: 700;
  font-family: var(--heading-font-two);
}

@media screen and (max-width: 991px) {
  .select2-container--open .select2-dropdown {
    left: -74px;
  }
}
@media screen and (max-width: 424px) {
  .select2-container--open .select2-dropdown {
    left: -40px;
  }
}

@media screen and (max-width: 991px) {
  .location-box, .search-category.h-48 {
    height: 40px !important;
  }
  .location-box .select2-selection__rendered, .search-category.h-48 .select2-selection__rendered {
    font-size: 12px;
  }
}
/* ======================= Select 2 Css End =========================== */
/* ========================== Count Down Css Start =============================== */
.countdown-list {
  gap: 20px;
}
@media screen and (max-width: 1399px) {
  .countdown-list {
    gap: 6px;
  }
}
.countdown-list__item {
  background-color: hsl(var(--white));
  padding: clamp(0.375rem, -2.248rem + 3vw, 0.75rem) clamp(0.5rem, -2.998rem + 4vw, 1rem);
  border-radius: 8px;
  position: relative;
}
@media screen and (max-width: 1399px) {
  .countdown-list__item {
    font-size: 0.75rem !important;
  }
}
.countdown-list__item:last-child::before {
  display: none;
}
.countdown-list__item::before {
  position: absolute;
  content: ":";
  inset-block-start: 50%;
  inset-inline-end: -10px;
  transform: translateY(-50%);
  font-weight: 700;
}
@media screen and (max-width: 1399px) {
  .countdown-list__item::before {
    display: none;
  }
}
.countdown-list__item.colon-white::before {
  color: #fff;
}
.countdown-list.style-two .countdown-list__item {
  background-color: var(--main-600);
  color: #fff !important;
}
.countdown-list.style-two .countdown-list__item::before {
  color: var(--main-600) !important;
}
.countdown-list.style-three {
  gap: 12px;
}
.countdown-list.style-three .countdown-list__item {
  background-color: var(--main-50);
  font-size: 11px !important;
  padding: 6px;
  color: #1A1A1A !important;
}
.countdown-list.style-four .countdown-list__item {
  width: 64px;
  height: 64px;
  align-items: center;
  padding: 2px;
  justify-content: center;
}
.countdown-list.style-four .countdown-list__item::before {
  color: var(--neutral-600);
}

/* ========================== Count Down Css End =============================== */
.badge-notification {
  margin-bottom: 6px;
  position: absolute;
  inset-block-start: -18px;
  inset-inline-start: 0;
  animation: notification 0.8s infinite;
}
.badge-notification::before {
  position: absolute;
  content: "";
  width: 11px;
  height: 6px;
  background-color: inherit;
  top: calc(100% - 1px);
  clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%);
}

.badge-style-two::before {
  position: absolute;
  content: "";
  width: 12px;
  height: 12px;
  background: var(--main-two-600);
  border-radius: 2px;
  inset-inline-start: -4px;
  transform: translateY(-50%) rotate(45deg);
  top: 50%;
}

@keyframes notification {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
}
/* ================================= Range Slider Css Start =========================== */
.custom--range #slider-range {
  height: 4px;
  border: 0;
  background: var(--gray-200);
  margin: 8px;
}
.custom--range #slider-range .ui-slider-handle {
  width: 16px !important;
  height: 16px !important;
  background-color: var(--main-600) !important;
  border-radius: 50%;
  top: 50%;
  transform: translateY(-50%);
  border: 0 !important;
  outline: 0 !important;
  transition: 0.2s linear;
}
.custom--range #slider-range .ui-slider-handle:hover, .custom--range #slider-range .ui-slider-handle.ui-state-active {
  transform: translateY(-50%) scale(1.3);
}
.custom--range #slider-range .ui-slider-handle.ui-state-active {
  box-shadow: 0px 0px 12px 4px rgba(149, 149, 149, 0.2549019608) !important;
}
.custom--range #slider-range .ui-widget-header {
  background-color: var(--main-600);
  transition: 0.2s linear;
}
.custom--range #slider-range span:focus {
  background-color: var(--main-600);
}
.custom--range__prices {
  width: 58px;
}
.custom--range input {
  border: 0;
  color: hsl(var(--body-color));
  font-weight: 500;
  outline: 0;
}

/* ================================= Range Slider Css End =========================== */
/* ================================= Typography Css Start =========================== */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: var(--body-font);
  color: hsl(var(--body-color));
  word-break: break-word;
  background-color: hsl(var(--white));
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

html, body {
  overflow-x: hidden;
}

p {
  font-weight: 400;
  margin: 0;
  line-height: 1.6;
}

span {
  display: inline-block;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0 0 16px 0;
  font-family: var(--heading-font);
  color: hsl(var(--heading-color));
  line-height: 1.2;
  font-weight: 700;
}

h1, .h1 {
  font-size: var(--heading-one);
}

h2, .h2 {
  font-size: var(--heading-two);
}

h3, .h3 {
  font-size: var(--heading-three);
}

h4, .h4 {
  font-size: var(--heading-four);
}

h5, .h5 {
  font-size: var(--heading-five);
}

h6, .h6 {
  font-size: var(--heading-six);
}

h1 > a,
h2 > a,
h3 > a,
h4 > a,
h5 > a,
h6 > a {
  font-weight: inherit;
  font-size: inherit;
  color: inherit;
  transition: 0.2s linear;
  line-height: inherit;
}
h1 > a:hover,
h2 > a:hover,
h3 > a:hover,
h4 > a:hover,
h5 > a:hover,
h6 > a:hover {
  color: hsl(var(--main));
}

a {
  display: inline-block;
  transition: 0.2s linear;
  text-decoration: none;
  color: #0661e9;
}

a:hover {
  color: #1d72f2;
}

img {
  max-width: 100%;
  height: auto;
}

select {
  cursor: pointer;
}

ul,
ol {
  padding: 0;
  margin: 0;
  list-style: none;
}

button {
  border: 0;
  background-color: transparent;
}
button:focus {
  outline: none;
  box-shadow: none;
}

.form-select:focus {
  outline: 0;
  box-shadow: none;
}

input:focus-visible {
  outline: 0;
}

/* ================================= Typography Css End =========================== */
/* ================================= Margin Css Start =========================== */
.m-2 {
  margin: var(--size-2) !important;
}

.m-3 {
  margin: var(--size-3) !important;
}

.m-4 {
  margin: var(--size-4) !important;
}

.m-5 {
  margin: var(--size-5) !important;
}

.m-6 {
  margin: var(--size-6) !important;
}

.m-7 {
  margin: var(--size-7) !important;
}

.m-8 {
  margin: var(--size-8) !important;
}

.m-9 {
  margin: var(--size-9) !important;
}

.m-10 {
  margin: var(--size-10) !important;
}

.m-11 {
  margin: var(--size-11) !important;
}

.m-12 {
  margin: var(--size-12) !important;
}

.m-13 {
  margin: var(--size-13) !important;
}

.m-14 {
  margin: var(--size-14) !important;
}

.m-16 {
  margin: var(--size-16) !important;
}

.m-18 {
  margin: var(--size-18) !important;
}

.m-20 {
  margin: var(--size-20) !important;
}

.m-22 {
  margin: var(--size-22) !important;
}

.m-24 {
  margin: var(--size-24) !important;
}

.m-26 {
  margin: var(--size-26) !important;
}

.m-28 {
  margin: var(--size-28) !important;
}

.m-30 {
  margin: var(--size-30) !important;
}

.m-32 {
  margin: var(--size-32) !important;
}

.m-36 {
  margin: var(--size-36) !important;
}

.m-40 {
  margin: var(--size-40) !important;
}

.m-44 {
  margin: var(--size-44) !important;
}

.m-48 {
  margin: var(--size-48) !important;
}

.m-52 {
  margin: var(--size-52) !important;
}

.m-56 {
  margin: var(--size-56) !important;
}

.m-60 {
  margin: var(--size-60) !important;
}

.m-64 {
  margin: var(--size-64) !important;
}

.m-68 {
  margin: var(--size-68) !important;
}

.m-72 {
  margin: var(--size-72) !important;
}

.m-76 {
  margin: var(--size-76) !important;
}

.m-80 {
  margin: var(--size-80) !important;
}

.m-90 {
  margin: var(--size-90) !important;
}

.m-110 {
  margin: var(--size-110) !important;
}

.m-120 {
  margin: var(--size-120) !important;
}

.m-144 {
  margin: var(--size-144) !important;
}

.m-160 {
  margin: var(--size-160) !important;
}

.m-210 {
  margin: var(--size-210) !important;
}

.mx-2 {
  margin-inline: var(--size-2) !important;
}

.mx-3 {
  margin-inline: var(--size-3) !important;
}

.mx-4 {
  margin-inline: var(--size-4) !important;
}

.mx-5 {
  margin-inline: var(--size-5) !important;
}

.mx-6 {
  margin-inline: var(--size-6) !important;
}

.mx-7 {
  margin-inline: var(--size-7) !important;
}

.mx-8 {
  margin-inline: var(--size-8) !important;
}

.mx-9 {
  margin-inline: var(--size-9) !important;
}

.mx-10 {
  margin-inline: var(--size-10) !important;
}

.mx-11 {
  margin-inline: var(--size-11) !important;
}

.mx-12 {
  margin-inline: var(--size-12) !important;
}

.mx-13 {
  margin-inline: var(--size-13) !important;
}

.mx-14 {
  margin-inline: var(--size-14) !important;
}

.mx-16 {
  margin-inline: var(--size-16) !important;
}

.mx-18 {
  margin-inline: var(--size-18) !important;
}

.mx-20 {
  margin-inline: var(--size-20) !important;
}

.mx-22 {
  margin-inline: var(--size-22) !important;
}

.mx-24 {
  margin-inline: var(--size-24) !important;
}

.mx-26 {
  margin-inline: var(--size-26) !important;
}

.mx-28 {
  margin-inline: var(--size-28) !important;
}

.mx-30 {
  margin-inline: var(--size-30) !important;
}

.mx-32 {
  margin-inline: var(--size-32) !important;
}

.mx-36 {
  margin-inline: var(--size-36) !important;
}

.mx-40 {
  margin-inline: var(--size-40) !important;
}

.mx-44 {
  margin-inline: var(--size-44) !important;
}

.mx-48 {
  margin-inline: var(--size-48) !important;
}

.mx-52 {
  margin-inline: var(--size-52) !important;
}

.mx-56 {
  margin-inline: var(--size-56) !important;
}

.mx-60 {
  margin-inline: var(--size-60) !important;
}

.mx-64 {
  margin-inline: var(--size-64) !important;
}

.mx-68 {
  margin-inline: var(--size-68) !important;
}

.mx-72 {
  margin-inline: var(--size-72) !important;
}

.mx-76 {
  margin-inline: var(--size-76) !important;
}

.mx-80 {
  margin-inline: var(--size-80) !important;
}

.mx-90 {
  margin-inline: var(--size-90) !important;
}

.mx-110 {
  margin-inline: var(--size-110) !important;
}

.mx-120 {
  margin-inline: var(--size-120) !important;
}

.mx-144 {
  margin-inline: var(--size-144) !important;
}

.mx-160 {
  margin-inline: var(--size-160) !important;
}

.mx-210 {
  margin-inline: var(--size-210) !important;
}

.my-2 {
  margin-block: var(--size-2) !important;
}

.my-3 {
  margin-block: var(--size-3) !important;
}

.my-4 {
  margin-block: var(--size-4) !important;
}

.my-5 {
  margin-block: var(--size-5) !important;
}

.my-6 {
  margin-block: var(--size-6) !important;
}

.my-7 {
  margin-block: var(--size-7) !important;
}

.my-8 {
  margin-block: var(--size-8) !important;
}

.my-9 {
  margin-block: var(--size-9) !important;
}

.my-10 {
  margin-block: var(--size-10) !important;
}

.my-11 {
  margin-block: var(--size-11) !important;
}

.my-12 {
  margin-block: var(--size-12) !important;
}

.my-13 {
  margin-block: var(--size-13) !important;
}

.my-14 {
  margin-block: var(--size-14) !important;
}

.my-16 {
  margin-block: var(--size-16) !important;
}

.my-18 {
  margin-block: var(--size-18) !important;
}

.my-20 {
  margin-block: var(--size-20) !important;
}

.my-22 {
  margin-block: var(--size-22) !important;
}

.my-24 {
  margin-block: var(--size-24) !important;
}

.my-26 {
  margin-block: var(--size-26) !important;
}

.my-28 {
  margin-block: var(--size-28) !important;
}

.my-30 {
  margin-block: var(--size-30) !important;
}

.my-32 {
  margin-block: var(--size-32) !important;
}

.my-36 {
  margin-block: var(--size-36) !important;
}

.my-40 {
  margin-block: var(--size-40) !important;
}

.my-44 {
  margin-block: var(--size-44) !important;
}

.my-48 {
  margin-block: var(--size-48) !important;
}

.my-52 {
  margin-block: var(--size-52) !important;
}

.my-56 {
  margin-block: var(--size-56) !important;
}

.my-60 {
  margin-block: var(--size-60) !important;
}

.my-64 {
  margin-block: var(--size-64) !important;
}

.my-68 {
  margin-block: var(--size-68) !important;
}

.my-72 {
  margin-block: var(--size-72) !important;
}

.my-76 {
  margin-block: var(--size-76) !important;
}

.my-80 {
  margin-block: var(--size-80) !important;
}

.my-90 {
  margin-block: var(--size-90) !important;
}

.my-110 {
  margin-block: var(--size-110) !important;
}

.my-120 {
  margin-block: var(--size-120) !important;
}

.my-144 {
  margin-block: var(--size-144) !important;
}

.my-160 {
  margin-block: var(--size-160) !important;
}

.my-210 {
  margin-block: var(--size-210) !important;
}

.ms-2 {
  margin-inline-start: var(--size-2) !important;
}

.ms-3 {
  margin-inline-start: var(--size-3) !important;
}

.ms-4 {
  margin-inline-start: var(--size-4) !important;
}

.ms-5 {
  margin-inline-start: var(--size-5) !important;
}

.ms-6 {
  margin-inline-start: var(--size-6) !important;
}

.ms-7 {
  margin-inline-start: var(--size-7) !important;
}

.ms-8 {
  margin-inline-start: var(--size-8) !important;
}

.ms-9 {
  margin-inline-start: var(--size-9) !important;
}

.ms-10 {
  margin-inline-start: var(--size-10) !important;
}

.ms-11 {
  margin-inline-start: var(--size-11) !important;
}

.ms-12 {
  margin-inline-start: var(--size-12) !important;
}

.ms-13 {
  margin-inline-start: var(--size-13) !important;
}

.ms-14 {
  margin-inline-start: var(--size-14) !important;
}

.ms-16 {
  margin-inline-start: var(--size-16) !important;
}

.ms-18 {
  margin-inline-start: var(--size-18) !important;
}

.ms-20 {
  margin-inline-start: var(--size-20) !important;
}

.ms-22 {
  margin-inline-start: var(--size-22) !important;
}

.ms-24 {
  margin-inline-start: var(--size-24) !important;
}

.ms-26 {
  margin-inline-start: var(--size-26) !important;
}

.ms-28 {
  margin-inline-start: var(--size-28) !important;
}

.ms-30 {
  margin-inline-start: var(--size-30) !important;
}

.ms-32 {
  margin-inline-start: var(--size-32) !important;
}

.ms-36 {
  margin-inline-start: var(--size-36) !important;
}

.ms-40 {
  margin-inline-start: var(--size-40) !important;
}

.ms-44 {
  margin-inline-start: var(--size-44) !important;
}

.ms-48 {
  margin-inline-start: var(--size-48) !important;
}

.ms-52 {
  margin-inline-start: var(--size-52) !important;
}

.ms-56 {
  margin-inline-start: var(--size-56) !important;
}

.ms-60 {
  margin-inline-start: var(--size-60) !important;
}

.ms-64 {
  margin-inline-start: var(--size-64) !important;
}

.ms-68 {
  margin-inline-start: var(--size-68) !important;
}

.ms-72 {
  margin-inline-start: var(--size-72) !important;
}

.ms-76 {
  margin-inline-start: var(--size-76) !important;
}

.ms-80 {
  margin-inline-start: var(--size-80) !important;
}

.ms-90 {
  margin-inline-start: var(--size-90) !important;
}

.ms-110 {
  margin-inline-start: var(--size-110) !important;
}

.ms-120 {
  margin-inline-start: var(--size-120) !important;
}

.ms-144 {
  margin-inline-start: var(--size-144) !important;
}

.ms-160 {
  margin-inline-start: var(--size-160) !important;
}

.ms-210 {
  margin-inline-start: var(--size-210) !important;
}

.me-2 {
  margin-inline-end: var(--size-2) !important;
}

.me-3 {
  margin-inline-end: var(--size-3) !important;
}

.me-4 {
  margin-inline-end: var(--size-4) !important;
}

.me-5 {
  margin-inline-end: var(--size-5) !important;
}

.me-6 {
  margin-inline-end: var(--size-6) !important;
}

.me-7 {
  margin-inline-end: var(--size-7) !important;
}

.me-8 {
  margin-inline-end: var(--size-8) !important;
}

.me-9 {
  margin-inline-end: var(--size-9) !important;
}

.me-10 {
  margin-inline-end: var(--size-10) !important;
}

.me-11 {
  margin-inline-end: var(--size-11) !important;
}

.me-12 {
  margin-inline-end: var(--size-12) !important;
}

.me-13 {
  margin-inline-end: var(--size-13) !important;
}

.me-14 {
  margin-inline-end: var(--size-14) !important;
}

.me-16 {
  margin-inline-end: var(--size-16) !important;
}

.me-18 {
  margin-inline-end: var(--size-18) !important;
}

.me-20 {
  margin-inline-end: var(--size-20) !important;
}

.me-22 {
  margin-inline-end: var(--size-22) !important;
}

.me-24 {
  margin-inline-end: var(--size-24) !important;
}

.me-26 {
  margin-inline-end: var(--size-26) !important;
}

.me-28 {
  margin-inline-end: var(--size-28) !important;
}

.me-30 {
  margin-inline-end: var(--size-30) !important;
}

.me-32 {
  margin-inline-end: var(--size-32) !important;
}

.me-36 {
  margin-inline-end: var(--size-36) !important;
}

.me-40 {
  margin-inline-end: var(--size-40) !important;
}

.me-44 {
  margin-inline-end: var(--size-44) !important;
}

.me-48 {
  margin-inline-end: var(--size-48) !important;
}

.me-52 {
  margin-inline-end: var(--size-52) !important;
}

.me-56 {
  margin-inline-end: var(--size-56) !important;
}

.me-60 {
  margin-inline-end: var(--size-60) !important;
}

.me-64 {
  margin-inline-end: var(--size-64) !important;
}

.me-68 {
  margin-inline-end: var(--size-68) !important;
}

.me-72 {
  margin-inline-end: var(--size-72) !important;
}

.me-76 {
  margin-inline-end: var(--size-76) !important;
}

.me-80 {
  margin-inline-end: var(--size-80) !important;
}

.me-90 {
  margin-inline-end: var(--size-90) !important;
}

.me-110 {
  margin-inline-end: var(--size-110) !important;
}

.me-120 {
  margin-inline-end: var(--size-120) !important;
}

.me-144 {
  margin-inline-end: var(--size-144) !important;
}

.me-160 {
  margin-inline-end: var(--size-160) !important;
}

.me-210 {
  margin-inline-end: var(--size-210) !important;
}

.mt-2 {
  margin-block-start: var(--size-2) !important;
}

.mt-3 {
  margin-block-start: var(--size-3) !important;
}

.mt-4 {
  margin-block-start: var(--size-4) !important;
}

.mt-5 {
  margin-block-start: var(--size-5) !important;
}

.mt-6 {
  margin-block-start: var(--size-6) !important;
}

.mt-7 {
  margin-block-start: var(--size-7) !important;
}

.mt-8 {
  margin-block-start: var(--size-8) !important;
}

.mt-9 {
  margin-block-start: var(--size-9) !important;
}

.mt-10 {
  margin-block-start: var(--size-10) !important;
}

.mt-11 {
  margin-block-start: var(--size-11) !important;
}

.mt-12 {
  margin-block-start: var(--size-12) !important;
}

.mt-13 {
  margin-block-start: var(--size-13) !important;
}

.mt-14 {
  margin-block-start: var(--size-14) !important;
}

.mt-16 {
  margin-block-start: var(--size-16) !important;
}

.mt-18 {
  margin-block-start: var(--size-18) !important;
}

.mt-20 {
  margin-block-start: var(--size-20) !important;
}

.mt-22 {
  margin-block-start: var(--size-22) !important;
}

.mt-24 {
  margin-block-start: var(--size-24) !important;
}

.mt-26 {
  margin-block-start: var(--size-26) !important;
}

.mt-28 {
  margin-block-start: var(--size-28) !important;
}

.mt-30 {
  margin-block-start: var(--size-30) !important;
}

.mt-32 {
  margin-block-start: var(--size-32) !important;
}

.mt-36 {
  margin-block-start: var(--size-36) !important;
}

.mt-40 {
  margin-block-start: var(--size-40) !important;
}

.mt-44 {
  margin-block-start: var(--size-44) !important;
}

.mt-48 {
  margin-block-start: var(--size-48) !important;
}

.mt-52 {
  margin-block-start: var(--size-52) !important;
}

.mt-56 {
  margin-block-start: var(--size-56) !important;
}

.mt-60 {
  margin-block-start: var(--size-60) !important;
}

.mt-64 {
  margin-block-start: var(--size-64) !important;
}

.mt-68 {
  margin-block-start: var(--size-68) !important;
}

.mt-72 {
  margin-block-start: var(--size-72) !important;
}

.mt-76 {
  margin-block-start: var(--size-76) !important;
}

.mt-80 {
  margin-block-start: var(--size-80) !important;
}

.mt-90 {
  margin-block-start: var(--size-90) !important;
}

.mt-110 {
  margin-block-start: var(--size-110) !important;
}

.mt-120 {
  margin-block-start: var(--size-120) !important;
}

.mt-144 {
  margin-block-start: var(--size-144) !important;
}

.mt-160 {
  margin-block-start: var(--size-160) !important;
}

.mt-210 {
  margin-block-start: var(--size-210) !important;
}

.mb-2 {
  margin-block-end: var(--size-2) !important;
}

.mb-3 {
  margin-block-end: var(--size-3) !important;
}

.mb-4 {
  margin-block-end: var(--size-4) !important;
}

.mb-5 {
  margin-block-end: var(--size-5) !important;
}

.mb-6 {
  margin-block-end: var(--size-6) !important;
}

.mb-7 {
  margin-block-end: var(--size-7) !important;
}

.mb-8 {
  margin-block-end: var(--size-8) !important;
}

.mb-9 {
  margin-block-end: var(--size-9) !important;
}

.mb-10 {
  margin-block-end: var(--size-10) !important;
}

.mb-11 {
  margin-block-end: var(--size-11) !important;
}

.mb-12 {
  margin-block-end: var(--size-12) !important;
}

.mb-13 {
  margin-block-end: var(--size-13) !important;
}

.mb-14 {
  margin-block-end: var(--size-14) !important;
}

.mb-16 {
  margin-block-end: var(--size-16) !important;
}

.mb-18 {
  margin-block-end: var(--size-18) !important;
}

.mb-20 {
  margin-block-end: var(--size-20) !important;
}

.mb-22 {
  margin-block-end: var(--size-22) !important;
}

.mb-24 {
  margin-block-end: var(--size-24) !important;
}

.mb-26 {
  margin-block-end: var(--size-26) !important;
}

.mb-28 {
  margin-block-end: var(--size-28) !important;
}

.mb-30 {
  margin-block-end: var(--size-30) !important;
}

.mb-32 {
  margin-block-end: var(--size-32) !important;
}

.mb-36 {
  margin-block-end: var(--size-36) !important;
}

.mb-40 {
  margin-block-end: var(--size-40) !important;
}

.mb-44 {
  margin-block-end: var(--size-44) !important;
}

.mb-48 {
  margin-block-end: var(--size-48) !important;
}

.mb-52 {
  margin-block-end: var(--size-52) !important;
}

.mb-56 {
  margin-block-end: var(--size-56) !important;
}

.mb-60 {
  margin-block-end: var(--size-60) !important;
}

.mb-64 {
  margin-block-end: var(--size-64) !important;
}

.mb-68 {
  margin-block-end: var(--size-68) !important;
}

.mb-72 {
  margin-block-end: var(--size-72) !important;
}

.mb-76 {
  margin-block-end: var(--size-76) !important;
}

.mb-80 {
  margin-block-end: var(--size-80) !important;
}

.mb-90 {
  margin-block-end: var(--size-90) !important;
}

.mb-110 {
  margin-block-end: var(--size-110) !important;
}

.mb-120 {
  margin-block-end: var(--size-120) !important;
}

.mb-144 {
  margin-block-end: var(--size-144) !important;
}

.mb-160 {
  margin-block-end: var(--size-160) !important;
}

.mb-210 {
  margin-block-end: var(--size-210) !important;
}

.mt-0 {
  margin-block-start: 0 !important;
}

.mb-0 {
  margin-block-end: 0 !important;
}

.ms-0 {
  margin-inline-start: 0 !important;
}

.me-0 {
  margin-inline-end: 0 !important;
}

.my-120 {
  margin-block-start: 60px !important;
  margin-block-end: 60px !important;
}
@media (min-width: 576px) {
  .my-120 {
    margin-block-start: 80px !important;
    margin-block-end: 80px !important;
  }
}
@media (min-width: 992px) {
  .my-120 {
    margin-block-start: 120px !important;
    margin-block-end: 120px !important;
  }
}

.mt-120 {
  margin-block-start: 60px !important;
}
@media (min-width: 576px) {
  .mt-120 {
    margin-block-start: 80px !important;
  }
}
@media (min-width: 992px) {
  .mt-120 {
    margin-block-start: 120px !important;
  }
}

.mb-120 {
  margin-block-end: 60px !important;
}
@media (min-width: 576px) {
  .mb-120 {
    margin-block-end: 80px !important;
  }
}
@media (min-width: 992px) {
  .mb-120 {
    margin-block-end: 120px !important;
  }
}

.my-60 {
  margin-block-start: 30px !important;
  margin-block-end: 30px !important;
}
@media (min-width: 576px) {
  .my-60 {
    margin-block-start: 40px !important;
    margin-block-end: 40px !important;
  }
}
@media (min-width: 992px) {
  .my-60 {
    margin-block-start: 60px !important;
    margin-block-end: 60px !important;
  }
}

.mt-60 {
  margin-block-start: 30px !important;
}
@media (min-width: 576px) {
  .mt-60 {
    margin-block-start: 40px !important;
  }
}
@media (min-width: 992px) {
  .mt-60 {
    margin-block-start: 60px !important;
  }
}

.mb-60 {
  margin-block-end: 30px !important;
}
@media (min-width: 576px) {
  .mb-60 {
    margin-block-end: 40px !important;
  }
}
@media (min-width: 992px) {
  .mb-60 {
    margin-block-end: 60px !important;
  }
}

/* ================================= Margin Css End =========================== */
/* ================================= Padding Css Start =========================== */
.p-2 {
  padding: var(--size-2) !important;
}

.p-3 {
  padding: var(--size-3) !important;
}

.p-4 {
  padding: var(--size-4) !important;
}

.p-5 {
  padding: var(--size-5) !important;
}

.p-6 {
  padding: var(--size-6) !important;
}

.p-7 {
  padding: var(--size-7) !important;
}

.p-8 {
  padding: var(--size-8) !important;
}

.p-9 {
  padding: var(--size-9) !important;
}

.p-10 {
  padding: var(--size-10) !important;
}

.p-11 {
  padding: var(--size-11) !important;
}

.p-12 {
  padding: var(--size-12) !important;
}

.p-13 {
  padding: var(--size-13) !important;
}

.p-14 {
  padding: var(--size-14) !important;
}

.p-16 {
  padding: var(--size-16) !important;
}

.p-18 {
  padding: var(--size-18) !important;
}

.p-20 {
  padding: var(--size-20) !important;
}

.p-22 {
  padding: var(--size-22) !important;
}

.p-24 {
  padding: var(--size-24) !important;
}

.p-26 {
  padding: var(--size-26) !important;
}

.p-28 {
  padding: var(--size-28) !important;
}

.p-30 {
  padding: var(--size-30) !important;
}

.p-32 {
  padding: var(--size-32) !important;
}

.p-36 {
  padding: var(--size-36) !important;
}

.p-40 {
  padding: var(--size-40) !important;
}

.p-44 {
  padding: var(--size-44) !important;
}

.p-48 {
  padding: var(--size-48) !important;
}

.p-52 {
  padding: var(--size-52) !important;
}

.p-56 {
  padding: var(--size-56) !important;
}

.p-60 {
  padding: var(--size-60) !important;
}

.p-64 {
  padding: var(--size-64) !important;
}

.p-68 {
  padding: var(--size-68) !important;
}

.p-72 {
  padding: var(--size-72) !important;
}

.p-76 {
  padding: var(--size-76) !important;
}

.p-80 {
  padding: var(--size-80) !important;
}

.p-90 {
  padding: var(--size-90) !important;
}

.p-110 {
  padding: var(--size-110) !important;
}

.p-120 {
  padding: var(--size-120) !important;
}

.p-144 {
  padding: var(--size-144) !important;
}

.p-160 {
  padding: var(--size-160) !important;
}

.p-210 {
  padding: var(--size-210) !important;
}

.px-2 {
  padding-inline: var(--size-2) !important;
}

.px-3 {
  padding-inline: var(--size-3) !important;
}

.px-4 {
  padding-inline: var(--size-4) !important;
}

.px-5 {
  padding-inline: var(--size-5) !important;
}

.px-6 {
  padding-inline: var(--size-6) !important;
}

.px-7 {
  padding-inline: var(--size-7) !important;
}

.px-8 {
  padding-inline: var(--size-8) !important;
}

.px-9 {
  padding-inline: var(--size-9) !important;
}

.px-10 {
  padding-inline: var(--size-10) !important;
}

.px-11 {
  padding-inline: var(--size-11) !important;
}

.px-12 {
  padding-inline: var(--size-12) !important;
}

.px-13 {
  padding-inline: var(--size-13) !important;
}

.px-14 {
  padding-inline: var(--size-14) !important;
}

.px-16 {
  padding-inline: var(--size-16) !important;
}

.px-18 {
  padding-inline: var(--size-18) !important;
}

.px-20 {
  padding-inline: var(--size-20) !important;
}

.px-22 {
  padding-inline: var(--size-22) !important;
}

.px-24 {
  padding-inline: var(--size-24) !important;
}

.px-26 {
  padding-inline: var(--size-26) !important;
}

.px-28 {
  padding-inline: var(--size-28) !important;
}

.px-30 {
  padding-inline: var(--size-30) !important;
}

.px-32 {
  padding-inline: var(--size-32) !important;
}

.px-36 {
  padding-inline: var(--size-36) !important;
}

.px-40 {
  padding-inline: var(--size-40) !important;
}

.px-44 {
  padding-inline: var(--size-44) !important;
}

.px-48 {
  padding-inline: var(--size-48) !important;
}

.px-52 {
  padding-inline: var(--size-52) !important;
}

.px-56 {
  padding-inline: var(--size-56) !important;
}

.px-60 {
  padding-inline: var(--size-60) !important;
}

.px-64 {
  padding-inline: var(--size-64) !important;
}

.px-68 {
  padding-inline: var(--size-68) !important;
}

.px-72 {
  padding-inline: var(--size-72) !important;
}

.px-76 {
  padding-inline: var(--size-76) !important;
}

.px-80 {
  padding-inline: var(--size-80) !important;
}

.px-90 {
  padding-inline: var(--size-90) !important;
}

.px-110 {
  padding-inline: var(--size-110) !important;
}

.px-120 {
  padding-inline: var(--size-120) !important;
}

.px-144 {
  padding-inline: var(--size-144) !important;
}

.px-160 {
  padding-inline: var(--size-160) !important;
}

.px-210 {
  padding-inline: var(--size-210) !important;
}

.py-2 {
  padding-block: var(--size-2) !important;
}

.py-3 {
  padding-block: var(--size-3) !important;
}

.py-4 {
  padding-block: var(--size-4) !important;
}

.py-5 {
  padding-block: var(--size-5) !important;
}

.py-6 {
  padding-block: var(--size-6) !important;
}

.py-7 {
  padding-block: var(--size-7) !important;
}

.py-8 {
  padding-block: var(--size-8) !important;
}

.py-9 {
  padding-block: var(--size-9) !important;
}

.py-10 {
  padding-block: var(--size-10) !important;
}

.py-11 {
  padding-block: var(--size-11) !important;
}

.py-12 {
  padding-block: var(--size-12) !important;
}

.py-13 {
  padding-block: var(--size-13) !important;
}

.py-14 {
  padding-block: var(--size-14) !important;
}

.py-16 {
  padding-block: var(--size-16) !important;
}

.py-18 {
  padding-block: var(--size-18) !important;
}

.py-20 {
  padding-block: var(--size-20) !important;
}

.py-22 {
  padding-block: var(--size-22) !important;
}

.py-24 {
  padding-block: var(--size-24) !important;
}

.py-26 {
  padding-block: var(--size-26) !important;
}

.py-28 {
  padding-block: var(--size-28) !important;
}

.py-30 {
  padding-block: var(--size-30) !important;
}

.py-32 {
  padding-block: var(--size-32) !important;
}

.py-36 {
  padding-block: var(--size-36) !important;
}

.py-40 {
  padding-block: var(--size-40) !important;
}

.py-44 {
  padding-block: var(--size-44) !important;
}

.py-48 {
  padding-block: var(--size-48) !important;
}

.py-52 {
  padding-block: var(--size-52) !important;
}

.py-56 {
  padding-block: var(--size-56) !important;
}

.py-60 {
  padding-block: var(--size-60) !important;
}

.py-64 {
  padding-block: var(--size-64) !important;
}

.py-68 {
  padding-block: var(--size-68) !important;
}

.py-72 {
  padding-block: var(--size-72) !important;
}

.py-76 {
  padding-block: var(--size-76) !important;
}

.py-80 {
  padding-block: var(--size-80) !important;
}

.py-90 {
  padding-block: var(--size-90) !important;
}

.py-110 {
  padding-block: var(--size-110) !important;
}

.py-120 {
  padding-block: var(--size-120) !important;
}

.py-144 {
  padding-block: var(--size-144) !important;
}

.py-160 {
  padding-block: var(--size-160) !important;
}

.py-210 {
  padding-block: var(--size-210) !important;
}

.ps-2 {
  padding-inline-start: var(--size-2) !important;
}

.ps-3 {
  padding-inline-start: var(--size-3) !important;
}

.ps-4 {
  padding-inline-start: var(--size-4) !important;
}

.ps-5 {
  padding-inline-start: var(--size-5) !important;
}

.ps-6 {
  padding-inline-start: var(--size-6) !important;
}

.ps-7 {
  padding-inline-start: var(--size-7) !important;
}

.ps-8 {
  padding-inline-start: var(--size-8) !important;
}

.ps-9 {
  padding-inline-start: var(--size-9) !important;
}

.ps-10 {
  padding-inline-start: var(--size-10) !important;
}

.ps-11 {
  padding-inline-start: var(--size-11) !important;
}

.ps-12 {
  padding-inline-start: var(--size-12) !important;
}

.ps-13 {
  padding-inline-start: var(--size-13) !important;
}

.ps-14 {
  padding-inline-start: var(--size-14) !important;
}

.ps-16 {
  padding-inline-start: var(--size-16) !important;
}

.ps-18 {
  padding-inline-start: var(--size-18) !important;
}

.ps-20 {
  padding-inline-start: var(--size-20) !important;
}

.ps-22 {
  padding-inline-start: var(--size-22) !important;
}

.ps-24 {
  padding-inline-start: var(--size-24) !important;
}

.ps-26 {
  padding-inline-start: var(--size-26) !important;
}

.ps-28 {
  padding-inline-start: var(--size-28) !important;
}

.ps-30 {
  padding-inline-start: var(--size-30) !important;
}

.ps-32 {
  padding-inline-start: var(--size-32) !important;
}

.ps-36 {
  padding-inline-start: var(--size-36) !important;
}

.ps-40 {
  padding-inline-start: var(--size-40) !important;
}

.ps-44 {
  padding-inline-start: var(--size-44) !important;
}

.ps-48 {
  padding-inline-start: var(--size-48) !important;
}

.ps-52 {
  padding-inline-start: var(--size-52) !important;
}

.ps-56 {
  padding-inline-start: var(--size-56) !important;
}

.ps-60 {
  padding-inline-start: var(--size-60) !important;
}

.ps-64 {
  padding-inline-start: var(--size-64) !important;
}

.ps-68 {
  padding-inline-start: var(--size-68) !important;
}

.ps-72 {
  padding-inline-start: var(--size-72) !important;
}

.ps-76 {
  padding-inline-start: var(--size-76) !important;
}

.ps-80 {
  padding-inline-start: var(--size-80) !important;
}

.ps-90 {
  padding-inline-start: var(--size-90) !important;
}

.ps-110 {
  padding-inline-start: var(--size-110) !important;
}

.ps-120 {
  padding-inline-start: var(--size-120) !important;
}

.ps-144 {
  padding-inline-start: var(--size-144) !important;
}

.ps-160 {
  padding-inline-start: var(--size-160) !important;
}

.ps-210 {
  padding-inline-start: var(--size-210) !important;
}

.pe-2 {
  padding-inline-end: var(--size-2) !important;
}

.pe-3 {
  padding-inline-end: var(--size-3) !important;
}

.pe-4 {
  padding-inline-end: var(--size-4) !important;
}

.pe-5 {
  padding-inline-end: var(--size-5) !important;
}

.pe-6 {
  padding-inline-end: var(--size-6) !important;
}

.pe-7 {
  padding-inline-end: var(--size-7) !important;
}

.pe-8 {
  padding-inline-end: var(--size-8) !important;
}

.pe-9 {
  padding-inline-end: var(--size-9) !important;
}

.pe-10 {
  padding-inline-end: var(--size-10) !important;
}

.pe-11 {
  padding-inline-end: var(--size-11) !important;
}

.pe-12 {
  padding-inline-end: var(--size-12) !important;
}

.pe-13 {
  padding-inline-end: var(--size-13) !important;
}

.pe-14 {
  padding-inline-end: var(--size-14) !important;
}

.pe-16 {
  padding-inline-end: var(--size-16) !important;
}

.pe-18 {
  padding-inline-end: var(--size-18) !important;
}

.pe-20 {
  padding-inline-end: var(--size-20) !important;
}

.pe-22 {
  padding-inline-end: var(--size-22) !important;
}

.pe-24 {
  padding-inline-end: var(--size-24) !important;
}

.pe-26 {
  padding-inline-end: var(--size-26) !important;
}

.pe-28 {
  padding-inline-end: var(--size-28) !important;
}

.pe-30 {
  padding-inline-end: var(--size-30) !important;
}

.pe-32 {
  padding-inline-end: var(--size-32) !important;
}

.pe-36 {
  padding-inline-end: var(--size-36) !important;
}

.pe-40 {
  padding-inline-end: var(--size-40) !important;
}

.pe-44 {
  padding-inline-end: var(--size-44) !important;
}

.pe-48 {
  padding-inline-end: var(--size-48) !important;
}

.pe-52 {
  padding-inline-end: var(--size-52) !important;
}

.pe-56 {
  padding-inline-end: var(--size-56) !important;
}

.pe-60 {
  padding-inline-end: var(--size-60) !important;
}

.pe-64 {
  padding-inline-end: var(--size-64) !important;
}

.pe-68 {
  padding-inline-end: var(--size-68) !important;
}

.pe-72 {
  padding-inline-end: var(--size-72) !important;
}

.pe-76 {
  padding-inline-end: var(--size-76) !important;
}

.pe-80 {
  padding-inline-end: var(--size-80) !important;
}

.pe-90 {
  padding-inline-end: var(--size-90) !important;
}

.pe-110 {
  padding-inline-end: var(--size-110) !important;
}

.pe-120 {
  padding-inline-end: var(--size-120) !important;
}

.pe-144 {
  padding-inline-end: var(--size-144) !important;
}

.pe-160 {
  padding-inline-end: var(--size-160) !important;
}

.pe-210 {
  padding-inline-end: var(--size-210) !important;
}

.pt-2 {
  padding-block-start: var(--size-2) !important;
}

.pt-3 {
  padding-block-start: var(--size-3) !important;
}

.pt-4 {
  padding-block-start: var(--size-4) !important;
}

.pt-5 {
  padding-block-start: var(--size-5) !important;
}

.pt-6 {
  padding-block-start: var(--size-6) !important;
}

.pt-7 {
  padding-block-start: var(--size-7) !important;
}

.pt-8 {
  padding-block-start: var(--size-8) !important;
}

.pt-9 {
  padding-block-start: var(--size-9) !important;
}

.pt-10 {
  padding-block-start: var(--size-10) !important;
}

.pt-11 {
  padding-block-start: var(--size-11) !important;
}

.pt-12 {
  padding-block-start: var(--size-12) !important;
}

.pt-13 {
  padding-block-start: var(--size-13) !important;
}

.pt-14 {
  padding-block-start: var(--size-14) !important;
}

.pt-16 {
  padding-block-start: var(--size-16) !important;
}

.pt-18 {
  padding-block-start: var(--size-18) !important;
}

.pt-20 {
  padding-block-start: var(--size-20) !important;
}

.pt-22 {
  padding-block-start: var(--size-22) !important;
}

.pt-24 {
  padding-block-start: var(--size-24) !important;
}

.pt-26 {
  padding-block-start: var(--size-26) !important;
}

.pt-28 {
  padding-block-start: var(--size-28) !important;
}

.pt-30 {
  padding-block-start: var(--size-30) !important;
}

.pt-32 {
  padding-block-start: var(--size-32) !important;
}

.pt-36 {
  padding-block-start: var(--size-36) !important;
}

.pt-40 {
  padding-block-start: var(--size-40) !important;
}

.pt-44 {
  padding-block-start: var(--size-44) !important;
}

.pt-48 {
  padding-block-start: var(--size-48) !important;
}

.pt-52 {
  padding-block-start: var(--size-52) !important;
}

.pt-56 {
  padding-block-start: var(--size-56) !important;
}

.pt-60 {
  padding-block-start: var(--size-60) !important;
}

.pt-64 {
  padding-block-start: var(--size-64) !important;
}

.pt-68 {
  padding-block-start: var(--size-68) !important;
}

.pt-72 {
  padding-block-start: var(--size-72) !important;
}

.pt-76 {
  padding-block-start: var(--size-76) !important;
}

.pt-80 {
  padding-block-start: var(--size-80) !important;
}

.pt-90 {
  padding-block-start: var(--size-90) !important;
}

.pt-110 {
  padding-block-start: var(--size-110) !important;
}

.pt-120 {
  padding-block-start: var(--size-120) !important;
}

.pt-144 {
  padding-block-start: var(--size-144) !important;
}

.pt-160 {
  padding-block-start: var(--size-160) !important;
}

.pt-210 {
  padding-block-start: var(--size-210) !important;
}

.pb-2 {
  padding-block-end: var(--size-2) !important;
}

.pb-3 {
  padding-block-end: var(--size-3) !important;
}

.pb-4 {
  padding-block-end: var(--size-4) !important;
}

.pb-5 {
  padding-block-end: var(--size-5) !important;
}

.pb-6 {
  padding-block-end: var(--size-6) !important;
}

.pb-7 {
  padding-block-end: var(--size-7) !important;
}

.pb-8 {
  padding-block-end: var(--size-8) !important;
}

.pb-9 {
  padding-block-end: var(--size-9) !important;
}

.pb-10 {
  padding-block-end: var(--size-10) !important;
}

.pb-11 {
  padding-block-end: var(--size-11) !important;
}

.pb-12 {
  padding-block-end: var(--size-12) !important;
}

.pb-13 {
  padding-block-end: var(--size-13) !important;
}

.pb-14 {
  padding-block-end: var(--size-14) !important;
}

.pb-16 {
  padding-block-end: var(--size-16) !important;
}

.pb-18 {
  padding-block-end: var(--size-18) !important;
}

.pb-20 {
  padding-block-end: var(--size-20) !important;
}

.pb-22 {
  padding-block-end: var(--size-22) !important;
}

.pb-24 {
  padding-block-end: var(--size-24) !important;
}

.pb-26 {
  padding-block-end: var(--size-26) !important;
}

.pb-28 {
  padding-block-end: var(--size-28) !important;
}

.pb-30 {
  padding-block-end: var(--size-30) !important;
}

.pb-32 {
  padding-block-end: var(--size-32) !important;
}

.pb-36 {
  padding-block-end: var(--size-36) !important;
}

.pb-40 {
  padding-block-end: var(--size-40) !important;
}

.pb-44 {
  padding-block-end: var(--size-44) !important;
}

.pb-48 {
  padding-block-end: var(--size-48) !important;
}

.pb-52 {
  padding-block-end: var(--size-52) !important;
}

.pb-56 {
  padding-block-end: var(--size-56) !important;
}

.pb-60 {
  padding-block-end: var(--size-60) !important;
}

.pb-64 {
  padding-block-end: var(--size-64) !important;
}

.pb-68 {
  padding-block-end: var(--size-68) !important;
}

.pb-72 {
  padding-block-end: var(--size-72) !important;
}

.pb-76 {
  padding-block-end: var(--size-76) !important;
}

.pb-80 {
  padding-block-end: var(--size-80) !important;
}

.pb-90 {
  padding-block-end: var(--size-90) !important;
}

.pb-110 {
  padding-block-end: var(--size-110) !important;
}

.pb-120 {
  padding-block-end: var(--size-120) !important;
}

.pb-144 {
  padding-block-end: var(--size-144) !important;
}

.pb-160 {
  padding-block-end: var(--size-160) !important;
}

.pb-210 {
  padding-block-end: var(--size-210) !important;
}

.p--24 {
  padding: 24px;
}

.p-56-px {
  padding: clamp(0.5rem, -9.243rem + 12vw, 3.5rem);
}

.pt-0 {
  padding-block-start: 0 !important;
}

.pb-0 {
  padding-block-end: 0 !important;
}

.ps-0 {
  padding-inline-start: 0 !important;
}

.pe-0 {
  padding-inline-end: 0 !important;
}

.py-100 {
  padding-block-start: 40px !important;
  padding-block-end: 40px !important;
}
@media (min-width: 992px) {
  .py-100 {
    padding-block-start: 60px !important;
    padding-block-end: 60px !important;
  }
}
@media (min-width: 1200px) {
  .py-100 {
    padding-block-start: 80px !important;
    padding-block-end: 80px !important;
  }
}
@media (min-width: 1400px) {
  .py-100 {
    padding-block-start: 100px !important;
    padding-block-end: 100px !important;
  }
}

.py-80 {
  padding-block-start: 60px !important;
  padding-block-end: 60px !important;
}
@media (min-width: 992px) {
  .py-80 {
    padding-block-start: 80px !important;
    padding-block-end: 80px !important;
  }
}

.pt-80 {
  padding-block-start: 60px !important;
}
@media (min-width: 992px) {
  .pt-80 {
    padding-block-start: 80px !important;
  }
}

.pb-80 {
  padding-block-end: 60px !important;
}
@media (min-width: 992px) {
  .pb-80 {
    padding-block-end: 80px !important;
  }
}

.py-60 {
  padding-block-start: 30px !important;
  padding-block-end: 30px !important;
}
@media (min-width: 576px) {
  .py-60 {
    padding-block-start: 40px !important;
    padding-block-end: 40px !important;
  }
}
@media (min-width: 992px) {
  .py-60 {
    padding-block-start: 60px !important;
    padding-block-end: 60px !important;
  }
}

.pt-60 {
  padding-block-start: 30px !important;
}
@media (min-width: 576px) {
  .pt-60 {
    padding-block-start: 40px !important;
  }
}
@media (min-width: 992px) {
  .pt-60 {
    padding-block-start: 60px !important;
  }
}

.pb-60 {
  padding-block-end: 30px !important;
}
@media (min-width: 576px) {
  .pb-60 {
    padding-block-end: 40px !important;
  }
}
@media (min-width: 992px) {
  .pb-60 {
    padding-block-end: 60px !important;
  }
}

/* ================================= Padding Css End =========================== */
/* ================================= Classes Css Start =========================== */
/* Section Background */
.bg-color-one {
  background-color: #ebf5ff !important;
}
.bg-color-two {
  background-color: var(--bg-color-two) !important;
}
.bg-color-three {
  background-color: var(--bg-color-three) !important;
}
.bg-color-neutral {
  background-color: var(--neutral) !important;
}

.container-lg {
  max-width: 1680px;
}

/* Column Extra Small Screen */
@media screen and (min-width: 425px) and (max-width: 575px) {
  .col-xs-6 {
    width: 50%;
  }
}

@media (min-width: 424px) {
  .d-xs-flex {
    display: flex !important;
  }
}
.opacity-6 {
  opacity: 0.06 !important;
}

/* Transition */
.transition-1 {
  transition: 0.1s linear;
}
.transition-2 {
  transition: 0.2s linear;
}
.transition-3 {
  transition: 0.3s linear;
}

.display-200 {
  font-size: var(--display-200);
}

.display-one {
  font-size: var(--display-one);
}

.min-width-max-content {
  min-width: max-content;
}

.inset-inline-start-0 {
  inset-inline-start: 0 !important;
}
.inset-inline-start-100 {
  inset-inline-start: 100% !important;
}
.inset-inline-start-auto {
  inset-inline-start: auto !important;
}
.inset-inline-end-0 {
  inset-inline-end: 0 !important;
}
.inset-inline-end-auto {
  inset-inline-end: auto !important;
}
.inset-block-start-0 {
  inset-block-start: 0 !important;
}
.inset-block-end-0 {
  inset-block-end: 0 !important;
}

.start-auto {
  inset-inline-start: auto !important;
}

.end-auto {
  inset-inline-end: auto !important;
}

.line-height-0 {
  line-height: 0;
}
.line-height-1 {
  line-height: 1;
}
.line-height-73 {
  line-height: 0.73;
}

/* Text Color */
.hover-text-decoration-underline:hover {
  text-decoration: underline;
}
.hover-text-decoration-none:hover {
  text-decoration: none;
}

.font-heading {
  font-family: var(--heading-font);
}
.font-heading-two {
  font-family: var(--heading-font-two);
}
.font-heading-four {
  font-family: var(--heading-font-four);
}
.font-body {
  font-family: var(--body-font);
}

/* Bg Image Css */
.bg-img {
  background-size: cover !important;
  background-repeat: no-repeat !important;
  background-position: center center !important;
  width: 100%;
  height: 100%;
}

.list-inside {
  list-style: inside !important;
}

.aspect-ratio-1 {
  aspect-ratio: 1;
}

.cursor-pointer {
  cursor: pointer;
}

.bg-blur {
  backdrop-filter: blur(90px);
  background-color: hsl(var(--white)/0.3) !important;
  transition: 0.2s linear;
}
.bg-blur:hover {
  transform: scale(1.2);
}

.rotate-10 {
  transform: rotate(-10deg);
}

.bg-overlay::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(0deg, rgba(18, 21, 53, 0.7) 0%, rgba(18, 21, 53, 0.7) 100%);
  z-index: -1;
}
.bg-overlay.style-two::before {
  background: linear-gradient(180deg, rgba(18, 21, 53, 0.47) 34.18%, rgba(18, 21, 53, 0.5) 75.48%), linear-gradient(180deg, rgba(18, 21, 53, 0) 27.17%, rgba(18, 21, 53, 0.5) 79.35%);
  z-index: 0;
}

.bg-start {
  background-position: left !important;
}

.arrow-left-clip {
  clip-path: polygon(10% 0, 100% 0, 100% 50%, 100% 100%, 10% 100%, 0% 50%);
}

.w-30-percent {
  width: 30%;
}

.group:hover .group-item-white {
  color: hsl(var(--white)) !important;
}

/* ================================= Classes Css End =========================== */
/* ============================ Extend Css Start ======================== */
/* Cover image Css */
.cover-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Display Flex Css Start */
.flex-align, .common-check {
  display: flex;
  align-items: center;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Display Flex Css End */
/* ============================ Extend Css End ======================== */
.w-2 {
  width: 0.125rem !important;
}

.w-3 {
  width: 0.1875rem !important;
}

.w-4 {
  width: 0.25rem !important;
}

.w-5 {
  width: 0.3125rem !important;
}

.w-6 {
  width: 0.375rem !important;
}

.w-7 {
  width: 0.4375rem !important;
}

.w-8 {
  width: 0.5rem !important;
}

.w-9 {
  width: 0.5625rem !important;
}

.w-10 {
  width: 0.625rem !important;
}

.w-11 {
  width: 0.6875rem !important;
}

.w-12 {
  width: 0.75rem !important;
}

.w-13 {
  width: 0.8125rem !important;
}

.w-14 {
  width: 0.875rem !important;
}

.w-16 {
  width: 1rem !important;
}

.w-18 {
  width: 1.125rem !important;
}

.w-20 {
  width: 1.25rem !important;
}

.w-22 {
  width: 1.375rem !important;
}

.w-24 {
  width: 1.5rem !important;
}

.w-26 {
  width: 1.625rem !important;
}

.w-28 {
  width: 1.75rem !important;
}

.w-30 {
  width: 1.875rem !important;
}

.w-32 {
  width: 2rem !important;
}

.w-36 {
  width: 2rem !important;
}

.w-40 {
  width: 2.5rem !important;
}

.w-44 {
  width: 2.75rem !important;
}

.w-48 {
  width: 3rem !important;
}

.w-52 {
  width: 3.25rem !important;
}

.w-56 {
  width: 3.5rem !important;
}

.w-60 {
  width: 3.75rem !important;
}

.w-64 {
  width: 4rem !important;
}

.w-68 {
  width: 4.25rem !important;
}

.w-72 {
  width: 4.5rem !important;
}

.w-76 {
  width: 4.75rem !important;
}

.w-80 {
  width: 5rem !important;
}

.w-90 {
  width: 5.625rem !important;
}

.w-110 {
  width: 6.875rem !important;
}

.w-120 {
  width: 7.5rem !important;
}

.w-144 {
  width: 9rem !important;
}

.w-160 {
  width: 10rem !important;
}

.w-210 {
  width: 13.125rem !important;
}

.w-300 {
  width: 300px !important;
}
.w-265 {
  width: 265px !important;
}
.w-unset {
  width: unset !important;
}

.h-2 {
  height: 0.125rem !important;
}

.h-3 {
  height: 0.1875rem !important;
}

.h-4 {
  height: 0.25rem !important;
}

.h-5 {
  height: 0.3125rem !important;
}

.h-6 {
  height: 0.375rem !important;
}

.h-7 {
  height: 0.4375rem !important;
}

.h-8 {
  height: 0.5rem !important;
}

.h-9 {
  height: 0.5625rem !important;
}

.h-10 {
  height: 0.625rem !important;
}

.h-11 {
  height: 0.6875rem !important;
}

.h-12 {
  height: 0.75rem !important;
}

.h-13 {
  height: 0.8125rem !important;
}

.h-14 {
  height: 0.875rem !important;
}

.h-16 {
  height: 1rem !important;
}

.h-18 {
  height: 1.125rem !important;
}

.h-20 {
  height: 1.25rem !important;
}

.h-22 {
  height: 1.375rem !important;
}

.h-24 {
  height: 1.5rem !important;
}

.h-26 {
  height: 1.625rem !important;
}

.h-28 {
  height: 1.75rem !important;
}

.h-30 {
  height: 1.875rem !important;
}

.h-32 {
  height: 2rem !important;
}

.h-36 {
  height: 2rem !important;
}

.h-40 {
  height: 2.5rem !important;
}

.h-44 {
  height: 2.75rem !important;
}

.h-48 {
  height: 3rem !important;
}

.h-52 {
  height: 3.25rem !important;
}

.h-56 {
  height: 3.5rem !important;
}

.h-60 {
  height: 3.75rem !important;
}

.h-64 {
  height: 4rem !important;
}

.h-68 {
  height: 4.25rem !important;
}

.h-72 {
  height: 4.5rem !important;
}

.h-76 {
  height: 4.75rem !important;
}

.h-80 {
  height: 5rem !important;
}

.h-90 {
  height: 5.625rem !important;
}

.h-110 {
  height: 6.875rem !important;
}

.h-120 {
  height: 7.5rem !important;
}

.h-144 {
  height: 9rem !important;
}

.h-160 {
  height: 10rem !important;
}

.h-210 {
  height: 13.125rem !important;
}

.h-unset {
  height: unset !important;
}

.max-h-unset {
  max-height: unset !important;
}
.max-h-120 {
  max-height: 120px !important;
}
.max-h-200 {
  max-height: 200px !important;
}
.max-h-260 {
  max-height: 260px !important;
}
.max-h-300 {
  max-height: 300px !important;
}
.max-h-326 {
  max-height: 326px !important;
}
.max-h-400 {
  max-height: 400px !important;
}
.max-h-540 {
  max-height: 540px !important;
}

.max-w-unset {
  max-width: unset !important;
}
.max-w-120 {
  max-width: 120px;
}
.max-w-260 {
  max-width: 260px !important;
}
.max-w-375 {
  max-width: 375px;
}
.max-w-340 {
  max-width: 340px;
}
.max-w-392 {
  max-width: 392px;
}
.max-w-275 {
  max-width: 275px;
}
.max-w-472 {
  max-width: 472px;
}
.max-w-418 {
  max-width: 418px;
}
.max-w-990 {
  max-width: 990px;
}

.min-h-485 {
  min-height: 485px;
}

.top-n6 {
  inset-block-start: -6px;
}

.end-n4 {
  inset-inline-end: -6px;
}

.text-main-50 {
  color: var(--main-50) !important;
}

.text-main-100 {
  color: var(--main-100) !important;
}

.text-main-200 {
  color: var(--main-200) !important;
}

.text-main-300 {
  color: var(--main-300) !important;
}

.text-main-400 {
  color: var(--main-400) !important;
}

.text-main-500 {
  color: var(--main-500) !important;
}

.text-main-600 {
  color: var(--main-600) !important;
}

.text-main-700 {
  color: var(--main-700) !important;
}

.text-main-800 {
  color: var(--main-800) !important;
}

.text-main-900 {
  color: var(--main-900) !important;
}

.text-main-two-50 {
  color: var(--main-two-50) !important;
}

.text-main-two-100 {
  color: var(--main-two-100) !important;
}

.text-main-two-200 {
  color: var(--main-two-200) !important;
}

.text-main-two-300 {
  color: var(--main-two-300) !important;
}

.text-main-two-400 {
  color: var(--main-two-400) !important;
}

.text-main-two-500 {
  color: var(--main-two-500) !important;
}

.text-main-two-600 {
  color: var(--main-two-600) !important;
}

.text-main-two-700 {
  color: var(--main-two-700) !important;
}

.text-main-two-800 {
  color: var(--main-two-800) !important;
}

.text-main-two-900 {
  color: var(--main-two-900) !important;
}

.text-neutral-50 {
  color: var(--neutral-50) !important;
}

.text-neutral-100 {
  color: var(--neutral-100) !important;
}

.text-neutral-200 {
  color: var(--neutral-200) !important;
}

.text-neutral-300 {
  color: var(--neutral-300) !important;
}

.text-neutral-400 {
  color: var(--neutral-400) !important;
}

.text-neutral-500 {
  color: var(--neutral-500) !important;
}

.text-neutral-600 {
  color: var(--neutral-600) !important;
}

.text-neutral-700 {
  color: var(--neutral-700) !important;
}

.text-neutral-800 {
  color: var(--neutral-800) !important;
}

.text-neutral-900 {
  color: var(--neutral-900) !important;
}

.text-gray-50 {
  color: var(--gray-50) !important;
}

.text-gray-100 {
  color: var(--gray-100) !important;
}

.text-gray-200 {
  color: var(--gray-200) !important;
}

.text-gray-300 {
  color: var(--gray-300) !important;
}

.text-gray-400 {
  color: var(--gray-400) !important;
}

.text-gray-500 {
  color: var(--gray-500) !important;
}

.text-gray-600 {
  color: var(--gray-600) !important;
}

.text-gray-700 {
  color: var(--gray-700) !important;
}

.text-gray-800 {
  color: var(--gray-800) !important;
}

.text-gray-900 {
  color: var(--gray-900) !important;
}

.text-light-50 {
  color: var(--light-50) !important;
}

.text-light-100 {
  color: var(--light-100) !important;
}

.text-light-600 {
  color: var(--light-600) !important;
}

.text-light-700 {
  color: var(--light-700) !important;
}

.text-light-800 {
  color: var(--light-800) !important;
}

.text-primary-50 {
  color: var(--primary-50) !important;
}

.text-primary-100 {
  color: var(--primary-100) !important;
}

.text-primary-200 {
  color: var(--primary-200) !important;
}

.text-primary-300 {
  color: var(--primary-300) !important;
}

.text-primary-400 {
  color: var(--primary-400) !important;
}

.text-primary-500 {
  color: var(--primary-500) !important;
}

.text-primary-600 {
  color: var(--primary-600) !important;
}

.text-primary-700 {
  color: var(--primary-700) !important;
}

.text-primary-800 {
  color: var(--primary-800) !important;
}

.text-primary-900 {
  color: var(--primary-900) !important;
}

.text-danger-50 {
  color: var(--danger-50) !important;
}

.text-danger-100 {
  color: var(--danger-100) !important;
}

.text-danger-200 {
  color: var(--danger-200) !important;
}

.text-danger-300 {
  color: var(--danger-300) !important;
}

.text-danger-400 {
  color: var(--danger-400) !important;
}

.text-danger-500 {
  color: var(--danger-500) !important;
}

.text-danger-600 {
  color: var(--danger-600) !important;
}

.text-danger-700 {
  color: var(--danger-700) !important;
}

.text-danger-800 {
  color: var(--danger-800) !important;
}

.text-danger-900 {
  color: var(--danger-900) !important;
}

.text-success-50 {
  color: var(--success-50) !important;
}

.text-success-100 {
  color: var(--success-100) !important;
}

.text-success-200 {
  color: var(--success-200) !important;
}

.text-success-300 {
  color: var(--success-300) !important;
}

.text-success-400 {
  color: var(--success-400) !important;
}

.text-success-500 {
  color: var(--success-500) !important;
}

.text-success-600 {
  color: var(--success-600) !important;
}

.text-success-700 {
  color: var(--success-700) !important;
}

.text-success-800 {
  color: var(--success-800) !important;
}

.text-success-900 {
  color: var(--success-900) !important;
}

.text-warning-50 {
  color: var(--warning-50) !important;
}

.text-warning-100 {
  color: var(--warning-100) !important;
}

.text-warning-200 {
  color: var(--warning-200) !important;
}

.text-warning-300 {
  color: var(--warning-300) !important;
}

.text-warning-400 {
  color: var(--warning-400) !important;
}

.text-warning-500 {
  color: var(--warning-500) !important;
}

.text-warning-600 {
  color: var(--warning-600) !important;
}

.text-warning-700 {
  color: var(--warning-700) !important;
}

.text-warning-800 {
  color: var(--warning-800) !important;
}

.text-warning-900 {
  color: var(--warning-900) !important;
}

.text-info-50 {
  color: var(--info-50) !important;
}

.text-info-100 {
  color: var(--info-100) !important;
}

.text-info-200 {
  color: var(--info-200) !important;
}

.text-info-300 {
  color: var(--info-300) !important;
}

.text-info-400 {
  color: var(--info-400) !important;
}

.text-info-500 {
  color: var(--info-500) !important;
}

.text-info-600 {
  color: var(--info-600) !important;
}

.text-info-700 {
  color: var(--info-700) !important;
}

.text-info-800 {
  color: var(--info-800) !important;
}

.text-info-900 {
  color: var(--info-900) !important;
}

.text-tertiary-50 {
  color: var(--tertiary-50) !important;
}

.text-tertiary-100 {
  color: var(--tertiary-100) !important;
}

.text-tertiary-600 {
  color: var(--tertiary-600) !important;
}

.text-heading {
  color: hsl(var(--heading-color)) !important;
}
.text-body {
  color: hsl(var(--body-color)) !important;
}
.text-main {
  color: hsl(var(--main)) !important;
}

.hover-text-main-50:hover {
  color: var(--main-50) !important;
}

.hover-text-main-100:hover {
  color: var(--main-100) !important;
}

.hover-text-main-200:hover {
  color: var(--main-200) !important;
}

.hover-text-main-300:hover {
  color: var(--main-300) !important;
}

.hover-text-main-400:hover {
  color: var(--main-400) !important;
}

.hover-text-main-500:hover {
  color: var(--main-500) !important;
}

.hover-text-main-600:hover {
  color: var(--main-600) !important;
}

.hover-text-main-700:hover {
  color: var(--main-700) !important;
}

.hover-text-main-800:hover {
  color: var(--main-800) !important;
}

.hover-text-main-900:hover {
  color: var(--main-900) !important;
}

.hover-text-main-two-50:hover {
  color: var(--main-two-50) !important;
}

.hover-text-main-two-100:hover {
  color: var(--main-two-100) !important;
}

.hover-text-main-two-200:hover {
  color: var(--main-two-200) !important;
}

.hover-text-main-two-300:hover {
  color: var(--main-two-300) !important;
}

.hover-text-main-two-400:hover {
  color: var(--main-two-400) !important;
}

.hover-text-main-two-500:hover {
  color: var(--main-two-500) !important;
}

.hover-text-main-two-600:hover {
  color: var(--main-two-600) !important;
}

.hover-text-main-two-700:hover {
  color: var(--main-two-700) !important;
}

.hover-text-main-two-800:hover {
  color: var(--main-two-800) !important;
}

.hover-text-main-two-900:hover {
  color: var(--main-two-900) !important;
}

.hover-text-neutral-50:hover {
  color: var(--neutral-50) !important;
}

.hover-text-neutral-100:hover {
  color: var(--neutral-100) !important;
}

.hover-text-neutral-200:hover {
  color: var(--neutral-200) !important;
}

.hover-text-neutral-300:hover {
  color: var(--neutral-300) !important;
}

.hover-text-neutral-400:hover {
  color: var(--neutral-400) !important;
}

.hover-text-neutral-500:hover {
  color: var(--neutral-500) !important;
}

.hover-text-neutral-600:hover {
  color: var(--neutral-600) !important;
}

.hover-text-neutral-700:hover {
  color: var(--neutral-700) !important;
}

.hover-text-neutral-800:hover {
  color: var(--neutral-800) !important;
}

.hover-text-neutral-900:hover {
  color: var(--neutral-900) !important;
}

.hover-text-gray-50:hover {
  color: var(--gray-50) !important;
}

.hover-text-gray-100:hover {
  color: var(--gray-100) !important;
}

.hover-text-gray-200:hover {
  color: var(--gray-200) !important;
}

.hover-text-gray-300:hover {
  color: var(--gray-300) !important;
}

.hover-text-gray-400:hover {
  color: var(--gray-400) !important;
}

.hover-text-gray-500:hover {
  color: var(--gray-500) !important;
}

.hover-text-gray-600:hover {
  color: var(--gray-600) !important;
}

.hover-text-gray-700:hover {
  color: var(--gray-700) !important;
}

.hover-text-gray-800:hover {
  color: var(--gray-800) !important;
}

.hover-text-gray-900:hover {
  color: var(--gray-900) !important;
}

.hover-text-light-50:hover {
  color: var(--light-50) !important;
}

.hover-text-light-100:hover {
  color: var(--light-100) !important;
}

.hover-text-light-600:hover {
  color: var(--light-600) !important;
}

.hover-text-light-700:hover {
  color: var(--light-700) !important;
}

.hover-text-light-800:hover {
  color: var(--light-800) !important;
}

.hover-text-primary-50:hover {
  color: var(--primary-50) !important;
}

.hover-text-primary-100:hover {
  color: var(--primary-100) !important;
}

.hover-text-primary-200:hover {
  color: var(--primary-200) !important;
}

.hover-text-primary-300:hover {
  color: var(--primary-300) !important;
}

.hover-text-primary-400:hover {
  color: var(--primary-400) !important;
}

.hover-text-primary-500:hover {
  color: var(--primary-500) !important;
}

.hover-text-primary-600:hover {
  color: var(--primary-600) !important;
}

.hover-text-primary-700:hover {
  color: var(--primary-700) !important;
}

.hover-text-primary-800:hover {
  color: var(--primary-800) !important;
}

.hover-text-primary-900:hover {
  color: var(--primary-900) !important;
}

.hover-text-danger-50:hover {
  color: var(--danger-50) !important;
}

.hover-text-danger-100:hover {
  color: var(--danger-100) !important;
}

.hover-text-danger-200:hover {
  color: var(--danger-200) !important;
}

.hover-text-danger-300:hover {
  color: var(--danger-300) !important;
}

.hover-text-danger-400:hover {
  color: var(--danger-400) !important;
}

.hover-text-danger-500:hover {
  color: var(--danger-500) !important;
}

.hover-text-danger-600:hover {
  color: var(--danger-600) !important;
}

.hover-text-danger-700:hover {
  color: var(--danger-700) !important;
}

.hover-text-danger-800:hover {
  color: var(--danger-800) !important;
}

.hover-text-danger-900:hover {
  color: var(--danger-900) !important;
}

.hover-text-success-50:hover {
  color: var(--success-50) !important;
}

.hover-text-success-100:hover {
  color: var(--success-100) !important;
}

.hover-text-success-200:hover {
  color: var(--success-200) !important;
}

.hover-text-success-300:hover {
  color: var(--success-300) !important;
}

.hover-text-success-400:hover {
  color: var(--success-400) !important;
}

.hover-text-success-500:hover {
  color: var(--success-500) !important;
}

.hover-text-success-600:hover {
  color: var(--success-600) !important;
}

.hover-text-success-700:hover {
  color: var(--success-700) !important;
}

.hover-text-success-800:hover {
  color: var(--success-800) !important;
}

.hover-text-success-900:hover {
  color: var(--success-900) !important;
}

.hover-text-warning-50:hover {
  color: var(--warning-50) !important;
}

.hover-text-warning-100:hover {
  color: var(--warning-100) !important;
}

.hover-text-warning-200:hover {
  color: var(--warning-200) !important;
}

.hover-text-warning-300:hover {
  color: var(--warning-300) !important;
}

.hover-text-warning-400:hover {
  color: var(--warning-400) !important;
}

.hover-text-warning-500:hover {
  color: var(--warning-500) !important;
}

.hover-text-warning-600:hover {
  color: var(--warning-600) !important;
}

.hover-text-warning-700:hover {
  color: var(--warning-700) !important;
}

.hover-text-warning-800:hover {
  color: var(--warning-800) !important;
}

.hover-text-warning-900:hover {
  color: var(--warning-900) !important;
}

.hover-text-info-50:hover {
  color: var(--info-50) !important;
}

.hover-text-info-100:hover {
  color: var(--info-100) !important;
}

.hover-text-info-200:hover {
  color: var(--info-200) !important;
}

.hover-text-info-300:hover {
  color: var(--info-300) !important;
}

.hover-text-info-400:hover {
  color: var(--info-400) !important;
}

.hover-text-info-500:hover {
  color: var(--info-500) !important;
}

.hover-text-info-600:hover {
  color: var(--info-600) !important;
}

.hover-text-info-700:hover {
  color: var(--info-700) !important;
}

.hover-text-info-800:hover {
  color: var(--info-800) !important;
}

.hover-text-info-900:hover {
  color: var(--info-900) !important;
}

.hover-text-tertiary-50:hover {
  color: var(--tertiary-50) !important;
}

.hover-text-tertiary-100:hover {
  color: var(--tertiary-100) !important;
}

.hover-text-tertiary-600:hover {
  color: var(--tertiary-600) !important;
}

/* Text Color */
.hover-text-white:hover {
  color: #fff !important;
}
.hover-text-heading:hover {
  color: hsl(var(--heading-color)) !important;
}
.hover-text-body:hover {
  color: hsl(var(--body-color)) !important;
}
.hover-text-main:hover {
  color: hsl(var(--main)) !important;
}

.border-main-50 {
  border-color: var(--main-50) !important;
}

.border-main-100 {
  border-color: var(--main-100) !important;
}

.border-main-200 {
  border-color: var(--main-200) !important;
}

.border-main-300 {
  border-color: var(--main-300) !important;
}

.border-main-400 {
  border-color: var(--main-400) !important;
}

.border-main-500 {
  border-color: var(--main-500) !important;
}

.border-main-600 {
  border-color: var(--main-600) !important;
}

.border-main-700 {
  border-color: var(--main-700) !important;
}

.border-main-800 {
  border-color: var(--main-800) !important;
}

.border-main-900 {
  border-color: var(--main-900) !important;
}

.border-main-two-50 {
  border-color: var(--main-two-50) !important;
}

.border-main-two-100 {
  border-color: var(--main-two-100) !important;
}

.border-main-two-200 {
  border-color: var(--main-two-200) !important;
}

.border-main-two-300 {
  border-color: var(--main-two-300) !important;
}

.border-main-two-400 {
  border-color: var(--main-two-400) !important;
}

.border-main-two-500 {
  border-color: var(--main-two-500) !important;
}

.border-main-two-600 {
  border-color: var(--main-two-600) !important;
}

.border-main-two-700 {
  border-color: var(--main-two-700) !important;
}

.border-main-two-800 {
  border-color: var(--main-two-800) !important;
}

.border-main-two-900 {
  border-color: var(--main-two-900) !important;
}

.border-neutral-50 {
  border-color: var(--neutral-50) !important;
}

.border-neutral-100 {
  border-color: var(--neutral-100) !important;
}

.border-neutral-200 {
  border-color: var(--neutral-200) !important;
}

.border-neutral-300 {
  border-color: var(--neutral-300) !important;
}

.border-neutral-400 {
  border-color: var(--neutral-400) !important;
}

.border-neutral-500 {
  border-color: var(--neutral-500) !important;
}

.border-neutral-600 {
  border-color: var(--neutral-600) !important;
}

.border-neutral-700 {
  border-color: var(--neutral-700) !important;
}

.border-neutral-800 {
  border-color: var(--neutral-800) !important;
}

.border-neutral-900 {
  border-color: var(--neutral-900) !important;
}

.border-gray-50 {
  border-color: var(--gray-50) !important;
}

.border-gray-100 {
  border-color: var(--gray-100) !important;
}

.border-gray-200 {
  border-color: var(--gray-200) !important;
}

.border-gray-300 {
  border-color: var(--gray-300) !important;
}

.border-gray-400 {
  border-color: var(--gray-400) !important;
}

.border-gray-500 {
  border-color: var(--gray-500) !important;
}

.border-gray-600 {
  border-color: var(--gray-600) !important;
}

.border-gray-700 {
  border-color: var(--gray-700) !important;
}

.border-gray-800 {
  border-color: var(--gray-800) !important;
}

.border-gray-900 {
  border-color: var(--gray-900) !important;
}

.border-light-50 {
  border-color: var(--light-50) !important;
}

.border-light-100 {
  border-color: var(--light-100) !important;
}

.border-light-600 {
  border-color: var(--light-600) !important;
}

.border-light-700 {
  border-color: var(--light-700) !important;
}

.border-light-800 {
  border-color: var(--light-800) !important;
}

.border-primary-50 {
  border-color: var(--primary-50) !important;
}

.border-primary-100 {
  border-color: var(--primary-100) !important;
}

.border-primary-200 {
  border-color: var(--primary-200) !important;
}

.border-primary-300 {
  border-color: var(--primary-300) !important;
}

.border-primary-400 {
  border-color: var(--primary-400) !important;
}

.border-primary-500 {
  border-color: var(--primary-500) !important;
}

.border-primary-600 {
  border-color: var(--primary-600) !important;
}

.border-primary-700 {
  border-color: var(--primary-700) !important;
}

.border-primary-800 {
  border-color: var(--primary-800) !important;
}

.border-primary-900 {
  border-color: var(--primary-900) !important;
}

.border-danger-50 {
  border-color: var(--danger-50) !important;
}

.border-danger-100 {
  border-color: var(--danger-100) !important;
}

.border-danger-200 {
  border-color: var(--danger-200) !important;
}

.border-danger-300 {
  border-color: var(--danger-300) !important;
}

.border-danger-400 {
  border-color: var(--danger-400) !important;
}

.border-danger-500 {
  border-color: var(--danger-500) !important;
}

.border-danger-600 {
  border-color: var(--danger-600) !important;
}

.border-danger-700 {
  border-color: var(--danger-700) !important;
}

.border-danger-800 {
  border-color: var(--danger-800) !important;
}

.border-danger-900 {
  border-color: var(--danger-900) !important;
}

.border-success-50 {
  border-color: var(--success-50) !important;
}

.border-success-100 {
  border-color: var(--success-100) !important;
}

.border-success-200 {
  border-color: var(--success-200) !important;
}

.border-success-300 {
  border-color: var(--success-300) !important;
}

.border-success-400 {
  border-color: var(--success-400) !important;
}

.border-success-500 {
  border-color: var(--success-500) !important;
}

.border-success-600 {
  border-color: var(--success-600) !important;
}

.border-success-700 {
  border-color: var(--success-700) !important;
}

.border-success-800 {
  border-color: var(--success-800) !important;
}

.border-success-900 {
  border-color: var(--success-900) !important;
}

.border-warning-50 {
  border-color: var(--warning-50) !important;
}

.border-warning-100 {
  border-color: var(--warning-100) !important;
}

.border-warning-200 {
  border-color: var(--warning-200) !important;
}

.border-warning-300 {
  border-color: var(--warning-300) !important;
}

.border-warning-400 {
  border-color: var(--warning-400) !important;
}

.border-warning-500 {
  border-color: var(--warning-500) !important;
}

.border-warning-600 {
  border-color: var(--warning-600) !important;
}

.border-warning-700 {
  border-color: var(--warning-700) !important;
}

.border-warning-800 {
  border-color: var(--warning-800) !important;
}

.border-warning-900 {
  border-color: var(--warning-900) !important;
}

.border-info-50 {
  border-color: var(--info-50) !important;
}

.border-info-100 {
  border-color: var(--info-100) !important;
}

.border-info-200 {
  border-color: var(--info-200) !important;
}

.border-info-300 {
  border-color: var(--info-300) !important;
}

.border-info-400 {
  border-color: var(--info-400) !important;
}

.border-info-500 {
  border-color: var(--info-500) !important;
}

.border-info-600 {
  border-color: var(--info-600) !important;
}

.border-info-700 {
  border-color: var(--info-700) !important;
}

.border-info-800 {
  border-color: var(--info-800) !important;
}

.border-info-900 {
  border-color: var(--info-900) !important;
}

.border-tertiary-50 {
  border-color: var(--tertiary-50) !important;
}

.border-tertiary-100 {
  border-color: var(--tertiary-100) !important;
}

.border-tertiary-600 {
  border-color: var(--tertiary-600) !important;
}

.hover-border-main-50:hover {
  border-color: var(--main-50) !important;
}

.hover-border-main-100:hover {
  border-color: var(--main-100) !important;
}

.hover-border-main-200:hover {
  border-color: var(--main-200) !important;
}

.hover-border-main-300:hover {
  border-color: var(--main-300) !important;
}

.hover-border-main-400:hover {
  border-color: var(--main-400) !important;
}

.hover-border-main-500:hover {
  border-color: var(--main-500) !important;
}

.hover-border-main-600:hover {
  border-color: var(--main-600) !important;
}

.hover-border-main-700:hover {
  border-color: var(--main-700) !important;
}

.hover-border-main-800:hover {
  border-color: var(--main-800) !important;
}

.hover-border-main-900:hover {
  border-color: var(--main-900) !important;
}

.hover-border-main-two-50:hover {
  border-color: var(--main-two-50) !important;
}

.hover-border-main-two-100:hover {
  border-color: var(--main-two-100) !important;
}

.hover-border-main-two-200:hover {
  border-color: var(--main-two-200) !important;
}

.hover-border-main-two-300:hover {
  border-color: var(--main-two-300) !important;
}

.hover-border-main-two-400:hover {
  border-color: var(--main-two-400) !important;
}

.hover-border-main-two-500:hover {
  border-color: var(--main-two-500) !important;
}

.hover-border-main-two-600:hover {
  border-color: var(--main-two-600) !important;
}

.hover-border-main-two-700:hover {
  border-color: var(--main-two-700) !important;
}

.hover-border-main-two-800:hover {
  border-color: var(--main-two-800) !important;
}

.hover-border-main-two-900:hover {
  border-color: var(--main-two-900) !important;
}

.hover-border-neutral-50:hover {
  border-color: var(--neutral-50) !important;
}

.hover-border-neutral-100:hover {
  border-color: var(--neutral-100) !important;
}

.hover-border-neutral-200:hover {
  border-color: var(--neutral-200) !important;
}

.hover-border-neutral-300:hover {
  border-color: var(--neutral-300) !important;
}

.hover-border-neutral-400:hover {
  border-color: var(--neutral-400) !important;
}

.hover-border-neutral-500:hover {
  border-color: var(--neutral-500) !important;
}

.hover-border-neutral-600:hover {
  border-color: var(--neutral-600) !important;
}

.hover-border-neutral-700:hover {
  border-color: var(--neutral-700) !important;
}

.hover-border-neutral-800:hover {
  border-color: var(--neutral-800) !important;
}

.hover-border-neutral-900:hover {
  border-color: var(--neutral-900) !important;
}

.hover-border-gray-50:hover {
  border-color: var(--gray-50) !important;
}

.hover-border-gray-100:hover {
  border-color: var(--gray-100) !important;
}

.hover-border-gray-200:hover {
  border-color: var(--gray-200) !important;
}

.hover-border-gray-300:hover {
  border-color: var(--gray-300) !important;
}

.hover-border-gray-400:hover {
  border-color: var(--gray-400) !important;
}

.hover-border-gray-500:hover {
  border-color: var(--gray-500) !important;
}

.hover-border-gray-600:hover {
  border-color: var(--gray-600) !important;
}

.hover-border-gray-700:hover {
  border-color: var(--gray-700) !important;
}

.hover-border-gray-800:hover {
  border-color: var(--gray-800) !important;
}

.hover-border-gray-900:hover {
  border-color: var(--gray-900) !important;
}

.hover-border-light-50:hover {
  border-color: var(--light-50) !important;
}

.hover-border-light-100:hover {
  border-color: var(--light-100) !important;
}

.hover-border-light-600:hover {
  border-color: var(--light-600) !important;
}

.hover-border-light-700:hover {
  border-color: var(--light-700) !important;
}

.hover-border-light-800:hover {
  border-color: var(--light-800) !important;
}

.hover-border-primary-50:hover {
  border-color: var(--primary-50) !important;
}

.hover-border-primary-100:hover {
  border-color: var(--primary-100) !important;
}

.hover-border-primary-200:hover {
  border-color: var(--primary-200) !important;
}

.hover-border-primary-300:hover {
  border-color: var(--primary-300) !important;
}

.hover-border-primary-400:hover {
  border-color: var(--primary-400) !important;
}

.hover-border-primary-500:hover {
  border-color: var(--primary-500) !important;
}

.hover-border-primary-600:hover {
  border-color: var(--primary-600) !important;
}

.hover-border-primary-700:hover {
  border-color: var(--primary-700) !important;
}

.hover-border-primary-800:hover {
  border-color: var(--primary-800) !important;
}

.hover-border-primary-900:hover {
  border-color: var(--primary-900) !important;
}

.hover-border-danger-50:hover {
  border-color: var(--danger-50) !important;
}

.hover-border-danger-100:hover {
  border-color: var(--danger-100) !important;
}

.hover-border-danger-200:hover {
  border-color: var(--danger-200) !important;
}

.hover-border-danger-300:hover {
  border-color: var(--danger-300) !important;
}

.hover-border-danger-400:hover {
  border-color: var(--danger-400) !important;
}

.hover-border-danger-500:hover {
  border-color: var(--danger-500) !important;
}

.hover-border-danger-600:hover {
  border-color: var(--danger-600) !important;
}

.hover-border-danger-700:hover {
  border-color: var(--danger-700) !important;
}

.hover-border-danger-800:hover {
  border-color: var(--danger-800) !important;
}

.hover-border-danger-900:hover {
  border-color: var(--danger-900) !important;
}

.hover-border-success-50:hover {
  border-color: var(--success-50) !important;
}

.hover-border-success-100:hover {
  border-color: var(--success-100) !important;
}

.hover-border-success-200:hover {
  border-color: var(--success-200) !important;
}

.hover-border-success-300:hover {
  border-color: var(--success-300) !important;
}

.hover-border-success-400:hover {
  border-color: var(--success-400) !important;
}

.hover-border-success-500:hover {
  border-color: var(--success-500) !important;
}

.hover-border-success-600:hover {
  border-color: var(--success-600) !important;
}

.hover-border-success-700:hover {
  border-color: var(--success-700) !important;
}

.hover-border-success-800:hover {
  border-color: var(--success-800) !important;
}

.hover-border-success-900:hover {
  border-color: var(--success-900) !important;
}

.hover-border-warning-50:hover {
  border-color: var(--warning-50) !important;
}

.hover-border-warning-100:hover {
  border-color: var(--warning-100) !important;
}

.hover-border-warning-200:hover {
  border-color: var(--warning-200) !important;
}

.hover-border-warning-300:hover {
  border-color: var(--warning-300) !important;
}

.hover-border-warning-400:hover {
  border-color: var(--warning-400) !important;
}

.hover-border-warning-500:hover {
  border-color: var(--warning-500) !important;
}

.hover-border-warning-600:hover {
  border-color: var(--warning-600) !important;
}

.hover-border-warning-700:hover {
  border-color: var(--warning-700) !important;
}

.hover-border-warning-800:hover {
  border-color: var(--warning-800) !important;
}

.hover-border-warning-900:hover {
  border-color: var(--warning-900) !important;
}

.hover-border-info-50:hover {
  border-color: var(--info-50) !important;
}

.hover-border-info-100:hover {
  border-color: var(--info-100) !important;
}

.hover-border-info-200:hover {
  border-color: var(--info-200) !important;
}

.hover-border-info-300:hover {
  border-color: var(--info-300) !important;
}

.hover-border-info-400:hover {
  border-color: var(--info-400) !important;
}

.hover-border-info-500:hover {
  border-color: var(--info-500) !important;
}

.hover-border-info-600:hover {
  border-color: var(--info-600) !important;
}

.hover-border-info-700:hover {
  border-color: var(--info-700) !important;
}

.hover-border-info-800:hover {
  border-color: var(--info-800) !important;
}

.hover-border-info-900:hover {
  border-color: var(--info-900) !important;
}

.hover-border-tertiary-50:hover {
  border-color: var(--tertiary-50) !important;
}

.hover-border-tertiary-100:hover {
  border-color: var(--tertiary-100) !important;
}

.hover-border-tertiary-600:hover {
  border-color: var(--tertiary-600) !important;
}

.border-dashed {
  border-style: dashed !important;
}
.border-dotted {
  border-style: dotted !important;
}

.bg-main-50 {
  background-color: #2F8DD5 !important;
}

.bg-main-100 {
  background-color: #2F8DD5 !important;
}

.bg-main-200 {
  background-color: #2F8DD5 !important;
}

.bg-main-300 {
  background-color: #2F8DD5 !important;
}

.bg-main-400 {
  background-color: #2F8DD5 !important;
}

.bg-main-500 {
  background-color: #2F8DD5 !important;
}

.bg-main-600 {
  background-color: #2F8DD5 !important;
}

.bg-main-700 {
  background-color: #2F8DD5 !important;
}

.bg-main-800 {
  background-color: #2F8DD5 !important;
}

.bg-main-900 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-50 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-100 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-200 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-300 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-400 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-500 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-600 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-700 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-800 {
  background-color: #2F8DD5 !important;
}

.bg-main-two-900 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-50 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-100 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-200 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-300 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-400 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-500 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-600 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-700 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-800 {
  background-color: #2F8DD5 !important;
}

.bg-neutral-900 {
  background-color: #2F8DD5 !important;
}

.bg-gray-50 {
  background-color: #2F8DD5 !important;
}

.bg-gray-100 {
  background-color: #2F8DD5 !important;
}

.bg-gray-200 {
  background-color: #2F8DD5 !important;
}

.bg-gray-300 {
  background-color: #2F8DD5 !important;
}

.bg-gray-400 {
  background-color: #2F8DD5 !important;
}

.bg-gray-500 {
  background-color: #2F8DD5 !important;
}

.bg-gray-600 {
  background-color: #2F8DD5 !important;
}

.bg-gray-700 {
  background-color: #2F8DD5 !important;
}

.bg-gray-800 {
  background-color: #2F8DD5 !important;
}

.bg-gray-900 {
  background-color: #2F8DD5 !important;
}

.bg-light-50 {
  background-color: #2F8DD5 !important;
}

.bg-light-100 {
  background-color: #2F8DD5 !important;
}

.bg-light-600 {
  background-color: #2F8DD5 !important;
}

.bg-light-700 {
  background-color: #2F8DD5 !important;
}

.bg-light-800 {
  background-color: #2F8DD5 !important;
}

.bg-primary-50 {
  background-color: #2F8DD5 !important;
}

.bg-primary-100 {
  background-color: #2F8DD5 !important;
}

.bg-primary-200 {
  background-color: #2F8DD5 !important;
}

.bg-primary-300 {
  background-color: #2F8DD5 !important;
}

.bg-primary-400 {
  background-color: #2F8DD5 !important;
}

.bg-primary-500 {
  background-color: #2F8DD5 !important;
}

.bg-primary-600 {
  background-color: #2F8DD5 !important;
}

.bg-primary-700 {
  background-color: #2F8DD5 !important;
}

.bg-primary-800 {
  background-color: #2F8DD5 !important;
}

.bg-primary-900 {
  background-color: #2F8DD5 !important;
}

.bg-danger-50 {
  background-color: #2F8DD5 !important;
}

.bg-danger-100 {
  background-color: #2F8DD5 !important;
}

.bg-danger-200 {
  background-color: #2F8DD5 !important;
}

.bg-danger-300 {
  background-color: #2F8DD5 !important;
}

.bg-danger-400 {
  background-color: #2F8DD5 !important;
}

.bg-danger-500 {
  background-color: #2F8DD5 !important;
}

.bg-danger-600 {
  background-color: #2F8DD5 !important;
}

.bg-danger-700 {
  background-color: #2F8DD5 !important;
}

.bg-danger-800 {
  background-color: #2F8DD5 !important;
}

.bg-danger-900 {
  background-color: #2F8DD5 !important;
}

.bg-success-50 {
  background-color: #2F8DD5 !important;
}

.bg-success-100 {
  background-color: #2F8DD5 !important;
}

.bg-success-200 {
  background-color: #2F8DD5 !important;
}

.bg-success-300 {
  background-color: #2F8DD5 !important;
}

.bg-success-400 {
  background-color: #2F8DD5 !important;
}

.bg-success-500 {
  background-color: #2F8DD5 !important;
}

.bg-success-600 {
  background-color: #2F8DD5 !important;
}

.bg-success-700 {
  background-color: #2F8DD5 !important;
}

.bg-success-800 {
  background-color: #2F8DD5 !important;
}

.bg-success-900 {
  background-color: #2F8DD5 !important;
}

.bg-warning-50 {
  background-color: #2F8DD5 !important;
}

.bg-warning-100 {
  background-color: #2F8DD5 !important;
}

.bg-warning-200 {
  background-color: #2F8DD5 !important;
}

.bg-warning-300 {
  background-color: #2F8DD5 !important;
}

.bg-warning-400 {
  background-color: #2F8DD5 !important;
}

.bg-warning-500 {
  background-color: #2F8DD5 !important;
}

.bg-warning-600 {
  background-color: #2F8DD5 !important;
}

.bg-warning-700 {
  background-color: #2F8DD5 !important;
}

.bg-warning-800 {
  background-color: #2F8DD5 !important;
}

.bg-warning-900 {
  background-color: #2F8DD5 !important;
}

.bg-info-50 {
  background-color: #2F8DD5 !important;
}

.bg-info-100 {
  background-color: #2F8DD5 !important;
}

.bg-info-200 {
  background-color: #2F8DD5 !important;
}

.bg-info-300 {
  background-color: #2F8DD5 !important;
}

.bg-info-400 {
  background-color: #2F8DD5 !important;
}

.bg-info-500 {
  background-color: #2F8DD5 !important;
}

.bg-info-600 {
  background-color: #2F8DD5 !important;
}

.bg-info-700 {
  background-color: #2F8DD5 !important;
}

.bg-info-800 {
  background-color: #2F8DD5 !important;
}

.bg-info-900 {
  background-color: #2F8DD5 !important;
}

.bg-tertiary-50 {
  background-color: #2F8DD5 !important;
}

.bg-tertiary-100 {
  background-color: #2F8DD5 !important;
}

.bg-tertiary-600 {
  background-color: #2F8DD5 !important;
}

.hover-bg-main-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-main-two-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-neutral-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-gray-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-light-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-light-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-light-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-light-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-light-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-primary-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-danger-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-success-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-warning-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-200:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-300:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-400:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-500:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-700:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-800:hover {
  background-color: #83c0ee !important;
}

.hover-bg-info-900:hover {
  background-color: #83c0ee !important;
}

.hover-bg-tertiary-50:hover {
  background-color: #83c0ee !important;
}

.hover-bg-tertiary-100:hover {
  background-color: #83c0ee !important;
}

.hover-bg-tertiary-600:hover {
  background-color: #83c0ee !important;
}

.hover-bg-white:hover {
  background-color: hsl(var(--white)) !important;
}

.bg-light-purple {
  background: #ECDBEC !important;
}

.bg-yellow-light {
  background-color: #FFFCE1 !important;
}
.bg-danger-light {
  background-color: #FFEBEE !important;
}
.bg-purple-light {
  background-color: #F5E7FC !important;
}
.bg-danger-light {
  background-color: #FFE2F5 !important;
}
.bg-warning-light {
  background-color: #FBEEDD !important;
}
.bg-success-light {
  background-color: #F6F5DB !important;
}

/* Font Size Class Start */
.text-inherit {
  font-size: inherit;
}

.text-xs {
  font-size: 0.75rem !important;
}

.text-sm {
  font-size: 0.875rem !important;
}

.text-md {
  font-size: 1rem !important;
}

.text-lg {
  font-size: 1.125rem !important;
}

.text-xl {
  font-size: 1.25rem !important;
}

.text-2xl {
  font-size: 1.5rem !important;
}

.text-3xl {
  font-size: 1.875rem !important;
}

.text-4xl {
  font-size: 2.25rem !important;
}

.text-5xl {
  font-size: 3rem !important;
}

.text-6xl {
  font-size: 3.75rem !important;
}

.text-2 {
  font-size: 0.125rem !important;
}

.text-3 {
  font-size: 0.1875rem !important;
}

.text-4 {
  font-size: 0.25rem !important;
}

.text-5 {
  font-size: 0.3125rem !important;
}

.text-6 {
  font-size: 0.375rem !important;
}

.text-7 {
  font-size: 0.4375rem !important;
}

.text-8 {
  font-size: 0.5rem !important;
}

.text-9 {
  font-size: 0.5625rem !important;
}

.text-10 {
  font-size: 0.625rem !important;
}

.text-11 {
  font-size: 0.6875rem !important;
}

.text-12 {
  font-size: 0.75rem !important;
}

.text-13 {
  font-size: 0.8125rem !important;
}

.text-14 {
  font-size: 0.875rem !important;
}

.text-16 {
  font-size: 1rem !important;
}

.text-18 {
  font-size: 1.125rem !important;
}

.text-20 {
  font-size: 1.25rem !important;
}

.text-22 {
  font-size: 1.375rem !important;
}

.text-24 {
  font-size: 1.5rem !important;
}

.text-26 {
  font-size: 1.625rem !important;
}

.text-28 {
  font-size: 1.75rem !important;
}

.text-30 {
  font-size: 1.875rem !important;
}

.text-32 {
  font-size: 2rem !important;
}

.text-36 {
  font-size: 2rem !important;
}

.text-40 {
  font-size: 2.5rem !important;
}

.text-44 {
  font-size: 2.75rem !important;
}

.text-48 {
  font-size: 3rem !important;
}

.text-52 {
  font-size: 3.25rem !important;
}

.text-56 {
  font-size: 3.5rem !important;
}

.text-60 {
  font-size: 3.75rem !important;
}

.text-64 {
  font-size: 4rem !important;
}

.text-68 {
  font-size: 4.25rem !important;
}

.text-72 {
  font-size: 4.5rem !important;
}

.text-76 {
  font-size: 4.75rem !important;
}

.text-80 {
  font-size: 5rem !important;
}

.text-90 {
  font-size: 5.625rem !important;
}

.text-110 {
  font-size: 6.875rem !important;
}

.text-120 {
  font-size: 7.5rem !important;
}

.text-144 {
  font-size: 9rem !important;
}

.text-160 {
  font-size: 10rem !important;
}

.text-210 {
  font-size: 13.125rem !important;
}

/* Font Size Class End */
/* Box shadow start */
.box-shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
.box-shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
}
.box-shadow-lg, .submenus-submenu, .common-dropdown {
  box-shadow: 0px 7px 21px -5px rgba(0, 0, 0, 0.1), 0 4px 21px -4px rgba(0, 0, 0, 0.1);
}
.box-shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
}
.box-shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}
.box-shadow-inner {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

/* Box shadow End */
/* Border Radius */
.rounded-2 {
  border-radius: 0.125rem !important;
}

.rounded-3 {
  border-radius: 0.1875rem !important;
}

.rounded-4 {
  border-radius: 0.25rem !important;
}

.rounded-5 {
  border-radius: 0.3125rem !important;
}

.rounded-6 {
  border-radius: 0.375rem !important;
}

.rounded-7 {
  border-radius: 0.4375rem !important;
}

.rounded-8 {
  border-radius: 0.5rem !important;
}

.rounded-9 {
  border-radius: 0.5625rem !important;
}

.rounded-10 {
  border-radius: 0.625rem !important;
}

.rounded-11 {
  border-radius: 0.6875rem !important;
}

.rounded-12 {
  border-radius: 0.75rem !important;
}

.rounded-13 {
  border-radius: 0.8125rem !important;
}

.rounded-14 {
  border-radius: 0.875rem !important;
}

.rounded-16 {
  border-radius: 1rem !important;
}

.rounded-18 {
  border-radius: 1.125rem !important;
}

.rounded-20 {
  border-radius: 1.25rem !important;
}

.rounded-22 {
  border-radius: 1.375rem !important;
}

.rounded-24 {
  border-radius: 1.5rem !important;
}

.rounded-26 {
  border-radius: 1.625rem !important;
}

.rounded-28 {
  border-radius: 1.75rem !important;
}

.rounded-30 {
  border-radius: 1.875rem !important;
}

.rounded-32 {
  border-radius: 2rem !important;
}

.rounded-36 {
  border-radius: 2rem !important;
}

.rounded-40 {
  border-radius: 2.5rem !important;
}

.rounded-44 {
  border-radius: 2.75rem !important;
}

.rounded-48 {
  border-radius: 3rem !important;
}

.rounded-52 {
  border-radius: 3.25rem !important;
}

.rounded-56 {
  border-radius: 3.5rem !important;
}

.rounded-60 {
  border-radius: 3.75rem !important;
}

.rounded-64 {
  border-radius: 4rem !important;
}

.rounded-68 {
  border-radius: 4.25rem !important;
}

.rounded-72 {
  border-radius: 4.5rem !important;
}

.rounded-76 {
  border-radius: 4.75rem !important;
}

.rounded-80 {
  border-radius: 5rem !important;
}

.rounded-90 {
  border-radius: 5.625rem !important;
}

.rounded-110 {
  border-radius: 6.875rem !important;
}

.rounded-120 {
  border-radius: 7.5rem !important;
}

.rounded-144 {
  border-radius: 9rem !important;
}

.rounded-160 {
  border-radius: 10rem !important;
}

.rounded-210 {
  border-radius: 13.125rem !important;
}

.rounded-top-right-0 {
  border-top-right-radius: 0 !important;
}

/* Hide Scroll bar Css For Custom Modal */
.scroll-hide {
  position: absolute;
  overflow-y: hidden;
  padding-inline-end: 17px;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
}
@media screen and (max-width: 991px) {
  .scroll-hide {
    padding-inline-end: 0;
  }
}
@media screen and (max-width: 991px) {
  .scroll-hide-sm {
    position: absolute;
    overflow-y: hidden;
    inset-block-start: 0;
    inset-inline-start: 0;
    width: calc(100% - 0px);
  }
}

/* Hide Scroll bar Css For Custom Modal End */
/* Overlay Start */
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  content: "";
  inset-inline-start: 0;
  inset-block-start: 0;
  background-color: hsl(var(--black)/0.6);
  z-index: 99;
  transition: 0.2s linear;
  visibility: hidden;
  opacity: 0;
}
.overlay.show-overlay {
  visibility: visible;
  opacity: 1;
}

.side-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  content: "";
  inset-inline-start: 0;
  inset-block-start: 0;
  background-color: hsl(var(--black)/0.6);
  z-index: 8;
  transition: 0.2s linear;
  visibility: hidden;
  opacity: 0;
}
@media screen and (max-width: 991px) {
  .side-overlay.show {
    visibility: visible;
    opacity: 1;
  }
}

/* Overlay End */
.text-line-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-line-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-line-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-sm::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
}
.scroll-sm::-webkit-scrollbar-thumb {
  background-color: #b1b3b8;
}
.scroll-sm::-webkit-scrollbar-thumb:hover {
  background-color: #7e7d7d;
}
.scroll-sm::-webkit-scrollbar-track {
  background-color: #d6d9de;
}

.gap-2 {
  gap: var(--size-2) !important;
}

.gap-3 {
  gap: var(--size-3) !important;
}

.gap-4 {
  gap: var(--size-4) !important;
}

.gap-5 {
  gap: var(--size-5) !important;
}

.gap-6 {
  gap: var(--size-6) !important;
}

.gap-7 {
  gap: var(--size-7) !important;
}

.gap-8 {
  gap: var(--size-8) !important;
}

.gap-9 {
  gap: var(--size-9) !important;
}

.gap-10 {
  gap: var(--size-10) !important;
}

.gap-11 {
  gap: var(--size-11) !important;
}

.gap-12 {
  gap: var(--size-12) !important;
}

.gap-13 {
  gap: var(--size-13) !important;
}

.gap-14 {
  gap: var(--size-14) !important;
}

.gap-16 {
  gap: var(--size-16) !important;
}

.gap-18 {
  gap: var(--size-18) !important;
}

.gap-20 {
  gap: var(--size-20) !important;
}

.gap-22 {
  gap: var(--size-22) !important;
}

.gap-24 {
  gap: var(--size-24) !important;
}

.gap-26 {
  gap: var(--size-26) !important;
}

.gap-28 {
  gap: var(--size-28) !important;
}

.gap-30 {
  gap: var(--size-30) !important;
}

.gap-32 {
  gap: var(--size-32) !important;
}

.gap-36 {
  gap: var(--size-36) !important;
}

.gap-40 {
  gap: var(--size-40) !important;
}

.gap-44 {
  gap: var(--size-44) !important;
}

.gap-48 {
  gap: var(--size-48) !important;
}

.gap-52 {
  gap: var(--size-52) !important;
}

.gap-56 {
  gap: var(--size-56) !important;
}

.gap-60 {
  gap: var(--size-60) !important;
}

.gap-64 {
  gap: var(--size-64) !important;
}

.gap-68 {
  gap: var(--size-68) !important;
}

.gap-72 {
  gap: var(--size-72) !important;
}

.gap-76 {
  gap: var(--size-76) !important;
}

.gap-80 {
  gap: var(--size-80) !important;
}

.gap-90 {
  gap: var(--size-90) !important;
}

.gap-110 {
  gap: var(--size-110) !important;
}

.gap-120 {
  gap: var(--size-120) !important;
}

.gap-144 {
  gap: var(--size-144) !important;
}

.gap-160 {
  gap: var(--size-160) !important;
}

.gap-210 {
  gap: var(--size-210) !important;
}

/* Hover Classes Start */
.item-hover:hover .item-hover__text {
  color: var(--main-600) !important;
}

.item-hover-two:hover .item-hover__text {
  color: var(--main-two-600) !important;
}

.on-hover-dropdown {
  visibility: hidden;
  opacity: 0;
  margin-block-start: 16px;
}

.on-hover-item {
  position: relative;
}
.on-hover-item:hover .on-hover-dropdown {
  visibility: visible;
  opacity: 1;
  margin-block-start: 0;
}
@media (min-width: 992px) {
  .on-hover-item:hover > a::before {
    color: hsl(var(--main));
    transform: translateY(-50%) rotate(180deg);
  }
}

/* Hover Classes End */
.g-8, .gy-8 {
  --bs-gutter-y: .5rem !important;
}

.g-12, .gy-12 {
  --bs-gutter-y: .75rem !important;
}

.g-8, .gx-8 {
  --bs-gutter-x: .5rem !important;
}

.g-12, .gx-12 {
  --bs-gutter-x: .75rem !important;
}

/* ================================= preload Css Start =========================== */
.preloader {
  background-color: hsl(var(--white));
  inset-block-end: 0;
  inset-inline-start: 0;
  position: fixed;
  inset-inline-end: 0;
  inset-block-start: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ================================= preload Css End ===========================  */
/* =========================== header top Css Start =============================== */
@media screen and (max-width: 767px) {
  .header-top__right {
    width: 100%;
  }
  .header-top__right li:last-child {
    margin-inline-start: auto;
  }
  .header-top__right li:nth-last-child(2) {
    margin-inline-end: 0 !important;
    padding-inline-end: 0 !important;
  }
  .header-top__right li:nth-last-child(2)::before {
    display: none;
  }
}
.header-top__right.style-two > li {
  padding-inline-end: 16px !important;
  margin-inline-end: 0 !important;
}
.header-top__right.style-two > li:last-child {
  padding-inline-end: 0 !important;
}
.header-top__right.style-two > li::before {
  display: none !important;
}
.header-top__right.style-two > li a {
  padding-inline-end: 20px;
}
@media screen and (max-width: 991px) {
  .header-top__right.style-two > li a {
    color: #fff !important;
  }
}
.header-top__right.style-two > li a::before {
  color: var(--heading-color) !important;
  font-size: 14px !important;
}
.header-top__right.style-two > li > ul {
  inset-inline-end: auto !important;
  inset-inline-start: calc(-100% - 24px) !important;
}
@media screen and (max-width: 991px) {
  .header-top__right.style-two > li > ul li a {
    color: var(--neutral-600) !important;
  }
}

@media screen and (max-width: 991px) {
  .border-right-item a {
    font-size: 12px !important;
  }
}
.border-right-item {
  position: relative;
}
.border-right-item:not(:last-child) {
  margin-inline-end: 24px;
  padding-inline-end: 24px;
}
@media screen and (max-width: 1399px) {
  .border-right-item:not(:last-child) {
    margin-inline-end: 16px !important;
    padding-inline-end: 16px !important;
  }
}
@media screen and (max-width: 1199px) {
  .border-right-item:not(:last-child) {
    margin-inline-end: 10px !important;
    padding-inline-end: 10px !important;
  }
}
.border-right-item:not(:last-child)::before {
  position: absolute;
  content: "";
  inset-block-start: 50%;
  transform: translateY(-50%);
  inset-inline-end: 0;
  width: 1px;
  height: 15px;
  background-color: hsl(var(--white)/0.3);
}
.border-right-item-sm-space:not(:last-child) {
  margin-inline-end: 20px;
  padding-inline-end: 20px;
}

/* Has Dropdown Css */
.arrow-white > a {
  padding-inline-end: 12px;
}
.arrow-white > a::before {
  color: hsl(var(--white)) !important;
  font-size: 8px;
}

/* =========================== header top Css End =============================== */
/* ============= Header Start Here ======================= */
.header {
  transition: 0.2s linear;
}
.header.fixed-header {
  position: fixed;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-inline-end: 0;
  width: 100%;
  z-index: 8;
  backdrop-filter: blur(24px);
  animation: slideDown 0.35s ease-out;
  box-shadow: 0 5px 16px rgba(0, 0, 0, 0.1);
}
@media screen and (max-width: 991px) {
  .header.fixed-header {
    inset-block-start: -1px;
  }
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}
.logo img {
  max-width: 200px;
}
@media screen and (max-width: 424px) {
  .logo img {
    max-width: 148px;
  }
}

/* Header Menu and Submenu Css Start */
.nav-menu {
  gap: 32px;
}
@media screen and (max-width: 1399px) {
  .nav-menu {
    gap: 24px;
  }
}
@media screen and (max-width: 1199px) {
  .nav-menu {
    gap: 16px;
  }
}
.nav-menu__item.activePage > a {
  color: hsl(var(--main));
}
.nav-menu__item.activePage > a::before {
  color: hsl(var(--main));
}
.nav-menu__item:hover > a {
  color: var(--gray-400);
}
@media (min-width: 992px) {
  .nav-menu__item:hover > a {
    color: hsl(var(--main));
  }
}
.nav-menu__link {
  color: var(--gray-400);
  font-weight: 500;
  width: 100%;
  padding: 16px 0;
  width: 100%;
}
@media (max-width: 1299px) {
  .nav-menu__link {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 1199px) {
  .nav-menu__link {
    font-size: 0.8125rem;
  }
}
@media (max-width: 1299px) {
  .nav-menu .common-dropdown__link {
    font-size: 0.875rem;
  }
}
@media screen and (max-width: 1199px) {
  .nav-menu .common-dropdown__link {
    font-size: 0.8125rem;
  }
}

.has-submenu {
  position: relative;
}
.has-submenu .nav-menu__link {
  padding-inline-end: 16px;
}
.has-submenu.active > a, .has-submenu.active > a::before {
  color: hsl(var(--main));
}
.has-submenu.active > a::before {
  transform: translateY(-50%) rotate(180deg) !important;
}
.has-submenu > a {
  position: relative;
}
.has-submenu > a::before {
  position: absolute;
  content: "\\e136";
  inset-inline-end: 0;
  inset-block-start: 50%;
  transform: translateY(-50%);
  font-family: "Phosphor";
  font-weight: 900;
  color: hsl(var(--heading-color)/0.4);
  transition: 0.2s linear;
}

/* Submenu Start */
.common-dropdown {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 100%;
  width: max-content;
  background-color: hsl(var(--white));
  border-radius: 6px;
  min-width: 190px;
  overflow: hidden;
  padding: 8px;
  transition: 0.2s linear;
  z-index: 99;
}
@media (min-width: 992px) {
  .common-dropdown {
    max-height: 400px;
    overflow-y: auto;
  }
}
.common-dropdown--sm {
  width: 132px;
  min-width: unset;
}
.common-dropdown__item {
  display: block;
  border-radius: 4px;
  transition: 0.2s linear;
  position: relative;
}
@media screen and (max-width: 991px) {
  .common-dropdown__item {
    border-radius: 0;
  }
}
.common-dropdown__item.activePage .common-dropdown__link {
  color: hsl(var(--main)) !important;
}
.common-dropdown__link {
  color: var(--gray-400);
  font-weight: 500;
  width: 100%;
  padding-inline-end: 16px;
  width: 100%;
  padding: 8px 14px;
  border-radius: inherit;
}
.common-dropdown__link:hover {
  color: var(--gray-600) !important;
}
.common-dropdown__link::before {
  position: absolute;
}

/* Submenu End */
/* Header Menu and Submenu Css End */
/* Category Submenus Submenu Css Start */
.menu-category-wrapper {
  gap: clamp(0.75rem, -8.243rem + 12vw, 4.5rem);
}

.submenus-submenu-wrapper {
  overflow: unset;
}

.submenus-submenu {
  position: absolute;
  z-index: 99999999999;
  background: hsl(var(--white));
  width: 300px;
  inset-inline-start: 100%;
  inset-block-start: 0px;
  border-radius: 6px;
  visibility: hidden;
  opacity: 0;
  overflow: hidden;
}
.submenus-submenu__list li a {
  padding: 10px 16px;
  padding-inline-start: 32px;
  display: block;
  color: var(--gray-500);
  position: relative;
}
.submenus-submenu__list li a::before {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  inset-inline-start: 16px;
  inset-block-start: 50%;
  transform: translateY(-50%);
  background: var(--gray-300);
  border-radius: 80%;
  transition: 0.2s linear;
}
.submenus-submenu__list li a:hover {
  background-color: var(--gray-50);
  color: var(--gray-800);
  font-weight: 600;
}
.submenus-submenu__list li a:hover::before {
  background: var(--gray-600);
}

@media (min-width: 991px) {
  .has-submenus-submenu:hover > a {
    background-color: var(--gray-50);
    color: var(--gray-900) !important;
    font-weight: 600;
  }
  .has-submenus-submenu:hover .submenus-submenu {
    visibility: visible;
    opacity: 1;
  }
}
@media screen and (max-width: 767px) {
  .category .category__button {
    padding: 12px 3px !important;
    font-size: 12px !important;
  }
}
@media screen and (max-width: 575px) {
  .category .category__button {
    padding-left: 10px !important;
  }
}
@media (min-width: 992px) {
  .category:hover .category__button {
    color: var(--main-600) !important;
    background-color: var(--gray-50) !important;
  }
  .category:hover .category__button .arrow-icon i::before {
    content: "\\e13c";
  }
}

/* Style Two */
.category-two {
  position: relative;
}
@media (min-width: 992px) {
  .category-two {
    width: 265px;
  }
}
.category-two .category__button {
  width: 100%;
}
@media screen and (max-width: 575px) {
  .category-two .category__button {
    font-size: 12px;
    padding: 8px 4px !important;
  }
}
.category-two .category__button.active .arrow-icon i::before {
  content: "\\e13a";
}

.responsive-dropdown.style-two {
  width: 100%;
  border-radius: 0 0 16px 16px;
  width: 265px;
  max-height: 900px;
}
.responsive-dropdown.style-two .responsive-dropdown__list {
  max-height: 900px;
}
@media screen and (max-width: 1199px) {
  .responsive-dropdown.style-two .responsive-dropdown__list {
    max-height: 438px;
  }
}
@media (min-width: 992px) {
  .responsive-dropdown.style-two {
    z-index: 1;
  }
}

/* Category Submenus Submenu Css End */
.header-border-0 .header {
  border-bottom: 0 !important;
}

/* ================================= Header Css End =========================== */
/* =========================== header Middle Css Start =============================== */
.header-middle {
  padding: 30px 0;
}
.header-middle.style-two {
  padding: 24px 0;
}
@media screen and (max-width: 1399px) {
  .header-middle {
    padding: 24px 0;
  }
}
@media screen and (max-width: 1199px) {
  .header-middle {
    padding: 16px 0 !important;
  }
}
@media screen and (max-width: 991px) {
  .header-middle {
    padding: 8px 0 !important;
  }
}
@media screen and (max-width: 1199px) {
  .header-middle .location-box {
    padding: 6px 8px !important;
  }
}
@media screen and (max-width: 767px) {
  .header-middle .location-box {
    padding-left: 14px !important;
  }
}

.form-location-wrapper {
  gap: clamp(0.5rem, -0.999rem + 2vw, 1rem);
}

/* Search Form Css Here */
@media screen and (max-width: 991px) {
  .search-form .select2-selection.select2-selection--single {
    border-radius: 50px !important;
    border-radius: 50px !important;
    background-color: hsl(var(--white)) !important;
    border: 1px solid var(--gray-100) !important;
  }
}
@media screen and (max-width: 991px) {
  .search-form__wrapper {
    display: none;
  }
}
.search-form__input {
  border-color: var(--gray-200) !important;
  width: 520px;
}
@media screen and (max-width: 1499px) {
  .search-form__input {
    width: 400px;
  }
}
@media screen and (max-width: 1399px) {
  .search-form__input {
    width: 300px;
  }
}
@media screen and (max-width: 1199px) {
  .search-form__input {
    width: 200px;
  }
}

/* Header Activities Css Start */
@media screen and (max-width: 1399px) {
  .header-two-activities {
    gap: 24px !important;
  }
}
@media screen and (max-width: 991px) {
  .header-two-activities {
    gap: 16px !important;
  }
}
@media screen and (max-width: 767px) {
  .header-two-activities {
    gap: 10px !important;
  }
}
@media screen and (max-width: 991px) {
  .header-two-activities .item-hover-two > span {
    font-size: 18px !important;
    color: var(--neutral-600) !important;
  }
}

/* Header Activities Css End */
/* Header Activities Css start */
.search-category.style-two {
  background-color: hsl(var(--white));
  border-radius: 8px;
  overflow: hidden;
}
.search-category.style-two .select2-container--default .select2-selection--single {
  border-radius: 0;
  border-left: 0 !important;
  border-top: 0 !important;
  border-bottom: 0 !important;
}

/* Header Activities Css End */
/* Category Dropdown Responsive Css Start */
@media screen and (max-width: 991px) {
  .responsive-dropdown {
    position: fixed;
    inset-inline-start: 0;
    inset-block-start: 0;
    visibility: visible;
    opacity: 1;
    margin-top: 0;
    border-radius: 0;
    width: unset !important;
    height: 100vh;
    overflow-y: auto;
    transform: translateX(-100%);
    padding-top: 8px !important;
  }
  .responsive-dropdown.active {
    transform: translateX(0);
  }
  .responsive-dropdown ul {
    max-height: 100% !important;
  }
  .responsive-dropdown ul li.active > a {
    background: var(--gray-50);
    color: var(--gray-800) !important;
    font-weight: 600;
  }
  .responsive-dropdown ul li.active > a .icon {
    transform: rotate(90deg);
  }
  .responsive-dropdown ul li a {
    border-bottom: 1px solid var(--gray-100);
  }
  .responsive-dropdown .submenus-submenu {
    position: static;
    visibility: visible;
    opacity: 1;
    box-shadow: none;
    border-radius: 0;
    margin-left: 40px;
    width: unset;
    padding-top: 8px !important;
    display: none;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .responsive-dropdown .submenus-submenu__title {
    display: none;
  }
  .responsive-dropdown .submenus-submenu__list {
    max-height: unset !important;
  }
  .responsive-dropdown .submenus-submenu__list li a {
    padding-left: 16px;
  }
  .responsive-dropdown .submenus-submenu__list li a::before {
    inset-inline-start: 0;
  }
}
/* Category Dropdown Responsive Css End */
/* =========================== header Middle Css End =============================== */
/* Mobile Menu Sidebar Start */
.mobile-menu {
  position: fixed;
  background-color: hsl(var(--white));
  width: 300px;
  height: 100vh;
  overflow-y: auto;
  padding: 24px;
  z-index: 991;
  transform: translateX(-100%);
  transition: 0.2s linear;
  padding-block-end: 68px;
}
.mobile-menu.active {
  transform: translateX(0%);
}

.close-button {
  position: absolute;
  inset-inline-end: 8px;
  inset-block-start: 8px;
  width: 28px;
  height: 28px;
  background-color: var(--gray-200);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;
}
.close-button:hover {
  background-color: hsl(var(--black));
  color: hsl(var(--white));
}

.nav-menu--mobile {
  display: block;
  margin-block-start: 16px;
}
.nav-menu--mobile .nav-menu__item > a::before {
  transform: translateY(-50%) rotate(0deg);
}
.nav-menu--mobile .nav-menu__link {
  border-bottom: 1px solid var(--gray-100) !important;
  position: relative;
  padding: 12px 0;
  padding-inline-end: 16px;
}
.nav-menu--mobile .nav-submenu {
  position: static;
  visibility: visible;
  opacity: 1;
  box-shadow: none;
  width: 100%;
  margin-block-start: 0;
  padding: 0;
  margin-inline-start: 16px;
  display: none;
  transition: 0s;
}
.nav-menu--mobile .nav-submenu__link {
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid var(--gray-100) !important;
}
.nav-menu--mobile .nav-submenu__item:hover {
  background-color: transparent;
  color: hsl(var(--main));
}
.nav-menu--mobile .nav-submenu__item::before {
  display: none;
}

/* Mobile Menu Sidebar Start */
/* ============= Footer Start Here ======================= */
.footer {
  margin-block-start: auto;
}
.footer-item-wrapper {
  gap: clamp(2rem, 0.715rem + 1.714vw, 2.75rem);
}
.footer-item-two-wrapper {
  gap: clamp(2rem, -4.209rem + 8.286vw, 5.625rem);
}
.footer-item__logo {
  margin-block-end: 20px;
}
.footer-item__logo a img {
  width: 100%;
  height: 100%;
  max-width: 190px;
  max-height: 64px;
}

.body-bottom-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: -1;
}

/* ============= Footer End Here ======================= */
/* ===================== Scroll to Top Start ================================= */
.progress-wrap {
  position: fixed;
  inset-inline-end: 36px;
  inset-block-end: 36px;
  height: 46px;
  line-height: 46px;
  width: 46px;
  cursor: pointer;
  display: block;
  border-radius: 50px;
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  opacity: 0;
  visibility: hidden;
  transform: translateY(15px);
  transition: all 200ms linear;
  background-color: transparent;
}
@media screen and (max-width: 991px) {
  .progress-wrap {
    inset-inline-end: 24px;
    inset-block-end: 24px;
    height: 40px;
    width: 40px;
    line-height: 40px;
  }
}
.progress-wrap.active-progress {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.progress-wrap:hover {
  transform: scale(1.06);
}
.progress-wrap::after {
  position: absolute;
  font-family: "Phosphor";
  font-weight: 900;
  content: "\\e08e";
  text-align: center;
  height: 46px;
  width: 46px;
  line-height: 46px;
  font-size: 18px;
  inset-inline-start: 0;
  inset-block-start: 0;
  cursor: pointer;
  display: block;
  z-index: 1;
  transition: all 200ms linear;
  color: hsl(var(--main)) !important;
}
@media screen and (max-width: 991px) {
  .progress-wrap::after {
    height: 40px;
    width: 40px;
    line-height: 40px;
  }
}

.progress-wrap svg path {
  fill: none;
}

.progress-wrap svg.progress-circle path {
  stroke: hsl(var(--main));
  stroke-width: 5;
  box-sizing: border-box;
  transition: all 200ms linear;
}

/* ===================== Scroll to Top End ================================= */
.search-box {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: hsl(var(--black));
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;
  transition: 0.2s linear;
  transform: scale(0.8);
  z-index: 9;
}
.search-box.active {
  visibility: visible;
  opacity: 1;
  transform: scale(1);
}

/* ================= Slick Arrow & Dots css Start ================ */
.slick-initialized.slick-slider .slick-track {
  display: flex;
}
.slick-initialized.slick-slider .slick-slide {
  cursor: grab;
  height: auto;
  margin: 0 10px;
}
.slick-initialized.slick-slider .slick-slide > div {
  height: 100%;
}
.slick-initialized.slick-slider .slick-slide > div > div {
  height: 100%;
}

/* Slick Slider Arrow */
.slick-arrow {
  width: 48px;
  height: 48px;
}
.slick-arrow:active {
  transform: scale(1.02);
}
@media screen and (max-width: 991px) {
  .slick-arrow {
    width: 40px;
    height: 40px;
  }
}
@media screen and (max-width: 767px) {
  .slick-arrow {
    width: 32px;
    height: 32px;
  }
}

/* Arrow Style Two */
.arrow-center {
  position: relative;
}
.arrow-center .slick-arrow {
  position: absolute;
  inset-block-start: 50%;
  transform: translateY(-50%);
  inset-inline-start: 16px;
  z-index: 2;
}
.arrow-center .slick-arrow.slick-next {
  inset-inline-start: auto;
  inset-inline-end: 16px;
}

.slick-arrows-style-three .slick-arrow {
  visibility: hidden;
  opacity: 0;
}
.slick-arrows-style-three:hover .slick-arrow {
  visibility: visible;
  opacity: 1;
}

/* Dots Css Start */
.slick-dots {
  text-align: center;
  position: absolute;
  inset-block-end: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 1;
  line-height: 1;
}
.slick-dots li {
  display: inline-block;
  display: flex;
}
.slick-dots li button {
  border: none;
  background-color: hsl(var(--white)/0.3);
  color: hsl(var(--white));
  margin: 0 3px;
  width: 12px;
  height: 12px;
  border-radius: 1px;
  border-radius: 50px;
  text-indent: -9999px;
  transition: 0.3s linear;
}
.slick-dots li.slick-active button {
  width: 40px;
  background-color: hsl(var(--main-two));
}

/* Dots Css End */
/* ================= Slick Arrow & Dots css Start ================ */
/* ================== Section Heading Css Start ========================= */
.section-heading {
  margin-bottom: 40px;
}
@media screen and (max-width: 1199px) {
  .section-heading {
    margin-bottom: 24px;
  }
}
@media (min-width: 1200px) {
  .section-heading.writing-mode {
    writing-mode: vertical-lr;
    transform: rotate(180deg);
  }
}
@media (max-width: 1199px) {
  .section-heading.writing-mode {
    margin-bottom: 60px !important;
  }
}

/* ================== Section Heading Css End ========================= */
/* ============================== Banner Css Start ========================== */
.banner {
  margin-top: 32px;
}
@media screen and (max-width: 767px) {
  .banner {
    margin-bottom: 32px;
  }
}
.banner .slick-slider {
  position: unset;
}
.banner .slick-initialized.slick-slider .slick-slide {
  margin: 0;
}

.banner-item {
  position: relative;
  padding-block-start: clamp(2rem, -1.928rem + 8.183vw, 6.25rem);
  padding-block-end: clamp(2rem, -8.859rem + 22.623vw, 13.75rem);
  padding-inline-start: clamp(1rem, -11.87rem + 20.758vw, 8.875rem);
  padding-inline-end: clamp(1rem, -5.129rem + 9.885vw, 4.75rem);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-repeat: no-repeat;
  background: #83c0ee;
  mask-position: top;
  mask-size: 100% 100%;
  gap: clamp(1.5rem, -2.151rem + 7.607vw, 4.5rem);
}
@media screen and (max-width: 767px) {
  .banner-item {
    mask-image: none;
    overflow: unset !important;
  }
}
.banner-item__title {
  margin-block-end: clamp(1rem, -2.347rem + 6.973vw, 3.75rem);
}
@media screen and (max-width: 1499px) {
  .banner-item__title {
    font-size: 3.5rem;
  }
}
@media screen and (max-width: 1199px) {
  .banner-item__title {
    font-size: 2.875rem;
  }
}
@media screen and (max-width: 991px) {
  .banner-item__title {
    font-size: 1.75rem;
  }
}
@media screen and (max-width: 767px) {
  .banner-item__title {
    font-size: 1.625rem;
  }
}
.banner-item__content {
  max-width: 852px;
}
@media screen and (max-width: 1499px) {
  .banner-item__content {
    max-width: 750px;
  }
}
@media screen and (max-width: 575px) {
  .banner-item__thumb img {
    max-width: 350px;
    width: 100%;
  }
}

@media screen and (max-width: 575px) {
  .banner-slider__inner {
    flex-wrap: wrap;
  }
}

.scroll-down {
  width: 94px;
  height: 94px;
  position: relative;
  margin-bottom: 24px;
  z-index: 2;
}
@media screen and (max-width: 1399px) {
  .scroll-down {
    width: 74px;
    height: 74px;
    margin-bottom: 16px;
  }
}
@media screen and (max-width: 767px) {
  .scroll-down {
    margin-bottom: -36px;
  }
}
.scroll-down::before {
  position: absolute;
  content: "";
  width: 2px;
  height: 32px;
  border: 2px dashed hsl(var(--white)/0.4);
  top: 16px;
  animation: upDown 2s linear infinite;
}
@media screen and (max-width: 1399px) {
  .scroll-down::before {
    top: 8px;
  }
}
.scroll-down .icon {
  animation: upDown 2s linear infinite;
  font-size: 1.75rem;
  margin-top: 16px;
}

@keyframes upDown {
  0% {
    transform: translateY(10px);
  }
  50% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(10px);
  }
}
/* ============================== Banner Css End ========================== */
/* ============================ Feature Section Css start =============================== */
.feature {
  margin-top: 32px;
}
.feature .arrow-center:hover .slick-arrow {
  visibility: visible;
  opacity: 1;
  margin-left: -28px;
}
.feature .arrow-center:hover .slick-arrow.slick-next {
  margin-right: -20px;
}
.feature .arrow-center .slick-arrow {
  transform: translateY(0);
  margin-left: -40px;
  border: 1px solid var(--gray-100);
  visibility: hidden;
  opacity: 0;
  top: 54px;
}
.feature .arrow-center .slick-arrow.slick-next {
  margin-right: -30px;
}
.feature.feature-three .arrow-center .slick-arrow {
  top: 110px;
}

.feature-item-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));
  gap: 16px;
}
.feature-item-wrapper .feature-item:nth-child(10n+1) .feature-item__thumb {
  background: #E8F9E9;
}
.feature-item-wrapper .feature-item:nth-child(10n+2) .feature-item__thumb {
  background: #FCEDED;
}
.feature-item-wrapper .feature-item:nth-child(10n+3) .feature-item__thumb {
  background: #F6EBF3;
}
.feature-item-wrapper .feature-item:nth-child(10n+4) .feature-item__thumb {
  background: #FCF2E7;
}
.feature-item-wrapper .feature-item:nth-child(10n+5) .feature-item__thumb {
  background: #F5FBE3;
}
.feature-item-wrapper .feature-item:nth-child(10n+6) .feature-item__thumb {
  background: #E3FBE9;
}
.feature-item-wrapper .feature-item:nth-child(10n+7) .feature-item__thumb {
  background: #E9E3FB;
}
.feature-item-wrapper .feature-item:nth-child(10n+8) .feature-item__thumb {
  background: #ECF8F2;
}
.feature-item-wrapper .feature-item:nth-child(10n+9) .feature-item__thumb {
  background: #F8F5E5;
}
.feature-item-wrapper .feature-item:nth-child(10n+10) .feature-item__thumb {
  background: #F0F8E5;
}
.feature-item-wrapper .feature-item:nth-child(10n+11) .feature-item__thumb {
  background: #ddd;
}
.feature-item__thumb {
  max-width: 153px;
  max-height: 153px;
  background-color: var(--main-50);
  aspect-ratio: 1;
  margin: 0 auto;
}
.feature-item__thumb img {
  transition: 0.2s linear;
}
.feature-item:hover .feature-item__thumb img {
  transform: scale(1.2);
}

.featured-products .product-card, .popular-products .product-card {
  flex-direction: row;
  align-items: unset;
}

.popular-products .product-card__thumb {
  width: 120px !important;
}

/* ============================ Feature Section Css End =============================== */
/* ======================== promotional banner Css Start ============================== */
.promotional-banner-item {
  padding: clamp(2rem, -1.956rem + 8.241vw, 5.25rem) 24px;
}
@media screen and (max-width: 575px) {
  .promotional-banner-item {
    padding: 24px 16px;
  }
}
.promotional-banner-item__content {
  max-width: 200px;
}
@media screen and (max-width: 1399px) {
  .promotional-banner-item__title {
    font-size: 1.5rem !important;
  }
}

/* ======================== promotional banner Css End ============================== */
/* ========================= flash sales Start ================================ */
.flash-sales-item {
  padding: 40px 32px;
}

/* ========================= flash sales End ================================ */
/* ============================= Product Card Css Start ========================== */
.product-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
}
.product-card:hover .product-card__thumb img {
  transform: scale(1.2);
}
@media screen and (max-width: 1499px) {
  .product-card__cart {
    font-size: 12px;
    padding: 9px 12px !important;
  }
}
.product-card__badge {
  border-radius: 16px 0 16px 0;
}
.product-card__thumb {
  height: 232px;
  width: 100%;
  transition: 0s !important;
}
.product-card__thumb img {
  max-width: 200px;
  width: 100%;
  transition: 0.1s linear;
}
.product-card.style-two {
  flex-direction: row;
}
.product-card.style-two .product-card__thumb {
  width: 260px;
  height: 190px;
}
@media screen and (max-width: 991px) {
  .product-card.style-two .product-card__thumb {
    width: 190px;
  }
}
@media screen and (max-width: 575px) {
  .product-card.style-two .product-card__thumb {
    width: 124px;
  }
}

@media screen and (max-width: 1199px) {
  .product-card__thumb {
    min-height: 160px;
  }
  .product-card__thumb img {
    max-width: 120px;
  }
  .product-card__content .product-card__price span {
    font-size: 0.75rem !important;
  }
  .product-card__content .title .link {
    font-size: 0.875rem;
  }
  .product-card__content .text-xs {
    font-size: 0.625rem !important;
  }
}
/* ============================= Product Card Css End ========================== */
/* ======================= Offer Css Start =========================== */
@media screen and (max-width: 1499px) {
  .offer-card__thumb img {
    max-width: 246px;
    width: 100%;
  }
}
@media screen and (max-width: 1199px) {
  .offer-card__thumb img {
    max-width: 163px;
  }
}

/* ======================= Offer Css End =========================== */
/* ===================================== Vendor Css Start ================================== */
.vendor-card {
  background-color: var(--main-100);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  mask-repeat: no-repeat;
  background: #f4f6e6;
  mask-position: top;
  mask-size: 100% 100%;
}
.vendor-card.style-two {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.vendor-card__logo {
  max-width: 66px;
}
.vendor-card__item {
  max-width: 64px;
  max-height: 64px;
  aspect-ratio: 1;
  width: 100%;
  height: 100%;
}
.vendor-card .vendor-card__list.style-two .vendor-card__item {
  max-width: 88px;
  max-height: 88px;
  border-radius: 8px !important;
}
.vendor-card .vendor-card__list.style-two .slick-slide {
  margin: 0 4px !important;
}

.vendor-card-wrapper div[class*=col]:nth-child(8n+1) .vendor-card {
  background: #f4f6e6;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+2) .vendor-card {
  background: #e6f6f6;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+3) .vendor-card {
  background: #f6e6f6;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+4) .vendor-card {
  background: #f8eae4;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+5) .vendor-card {
  background: #f8eae4;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+6) .vendor-card {
  background: #dee6f3;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+7) .vendor-card {
  background: #daf2db;
}
.vendor-card-wrapper div[class*=col]:nth-child(8n+8) .vendor-card {
  background: #ebf1da;
}

/* ===================================== Vendor Css End ================================== */
@media (min-width: 768px) {
  .delivery-section {
    margin-bottom: 28px;
  }
}
.delivery__man {
  margin-bottom: -56px;
}

/* ================================== short product Css Start ================================== */
.underlined-line::before, .underlined-line::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 2px;
  left: 0;
  bottom: 0;
  background-color: hsl(var(--white));
}
.underlined-line::after {
  width: 50%;
  background-color: var(--main-600);
}

.short-product-list.arrow-style-two .slick-arrow {
  inset-inline-end: 16px;
  inset-block-end: calc(100% + 52px);
}
.short-product-list.arrow-style-two .slick-prev {
  inset-inline-end: 50px;
}

/* ================================== short product Css End ================================== */
/* ========================= Brand Css Start ======================== */
.brand-item img {
  max-width: 152px !important;
}
@media screen and (max-width: 1399px) {
  .brand-item img {
    max-width: 132px !important;
  }
}
@media screen and (max-width: 991px) {
  .brand-item img {
    max-width: 86px !important;
  }
}

/* ========================= Brand Css End ======================== */
/* Shipping Css Start */
.shipping-item {
  padding: clamp(1.5rem, 0.891rem + 1.268vw, 2rem) clamp(1.5rem, -3.746rem + 6vw, 3.375rem);
}

/* Shipping Css End */
/* ======================= Newsletter Css Start =========================== */
.newsletter-box {
  background-color: #121535;
  padding: 32px clamp(1.5rem, -8.492rem + 13.333vw, 4rem);
}

@media screen and (max-width: 991px) {
  .newsletter-two__form {
    width: 100% !important;
  }
}

/* ======================= Newsletter Css End =========================== */
/* Home Two Css Start */
.color-two:root {
  --main-h: 24;
  --main-s: 100%;
  --main-l: 49%;
}

.font-exo h1,
.font-exo h2,
.font-exo h3,
.font-exo h4,
.font-exo h5,
.font-exo h6 {
  font-family: var(--heading-font-two);
}
.font-exo h1, .font-exo .h1, .font-exo h2, .font-exo .h2, .font-exo h3, .font-exo .h3, .font-exo h4, .font-exo .h4, .font-exo h5, .font-exo .h5, .font-exo h6, .font-exo .h6 {
  font-family: var(--heading-font-two);
}

.font-outfit h1,
.font-outfit h2,
.font-outfit h3,
.font-outfit h4,
.font-outfit h5,
.font-outfit h6 {
  font-family: var(--heading-font-three);
}
.font-outfit h1, .font-outfit .h1, .font-outfit h2, .font-outfit .h2, .font-outfit h3, .font-outfit .h3, .font-outfit h4, .font-outfit .h4, .font-outfit h5, .font-outfit .h5, .font-outfit h6, .font-outfit .h6 {
  font-family: var(--heading-font-three);
}

/* Home Two Css End */
/* ================================= Banner Two Css Start ================================= */
.banner-item-two {
  padding: 186px clamp(2rem, -10.739rem + 17vw, 6.25rem) 186px;
  position: relative;
}
@media screen and (max-width: 1199px) {
  .banner-item-two {
    padding: 86px clamp(2rem, -10.739rem + 17vw, 6.25rem) 86px;
  }
}
@media screen and (max-width: 991px) {
  .banner-item-two {
    padding: 60px clamp(2rem, -10.739rem + 17vw, 6.25rem) 60px;
  }
}
@media screen and (max-width: 767px) {
  .banner-item-two {
    padding: 40px clamp(2rem, -10.739rem + 17vw, 6.25rem) 40px;
  }
}
.banner-item-two-wrapper {
  margin: 32px;
  margin-inline-end: 0;
}
@media screen and (max-width: 991px) {
  .banner-item-two-wrapper {
    margin-inline-start: 0;
  }
}
.banner-item-two__content {
  max-width: 504px;
}
@media screen and (max-width: 991px) {
  .banner-item-two__content {
    max-width: 362px;
  }
}
@media screen and (max-width: 575px) {
  .banner-item-two__content {
    max-width: 320px;
  }
}
@media screen and (max-width: 575px) {
  .banner-item-two__title {
    font-size: 1.5rem;
  }
}
.banner-item-two__thumb {
  inset-inline-end: clamp(1.5rem, -20.232rem + 29vw, 8.75rem);
  text-align: end;
  max-width: 41%;
}
@media screen and (max-width: 575px) {
  .banner-item-two__thumb {
    max-width: 50%;
    position: relative !important;
    margin-top: 32px;
    inset-inline-end: 0;
  }
}

/* ================================= Banner Two Css End ================================= */
/* Week Deals Start  */
.deal-week-box__content {
  padding: clamp(1.5rem, -1.239rem + 5.705vw, 3.75rem) 0;
}

/* Week Deals End  */
/* ============================ trending products css Start =========================== */
.trending-products-three .product-card__thumb {
  height: 330px;
}

.trending-products-box {
  background-color: #F3EDDE;
}
.trending-products-box__title {
  max-width: 364px;
  margin: 0 auto;
}

.expand-btn {
  color: var(--neutral-600);
}

.expand-icons {
  display: none;
  flex-direction: column;
}

/* ============================ trending products css End =========================== */
/* =============================== Discount css Start ============================ */
.discount-item {
  padding: clamp(1.5rem, -2.996rem + 6vw, 3rem);
}
.discount-item__content {
  max-width: 320px;
}

.discount-three-item {
  padding: clamp(2rem, -5.911rem + 16.482vw, 8.5rem) clamp(1.5rem, -0.934rem + 5.071vw, 3.5rem);
}

/* =============================== Discount css End ============================ */
/* ====================== Popular Products Start ==================== */
@media screen and (max-width: 767px) {
  .popular-products .product-card {
    flex-direction: column;
  }
}

/* ====================== Popular Products End ==================== */
/*  */
.day-sale-box__content {
  max-width: 500px;
}

/*  */
/* ========================== Top Brand Section Start ================================ */
.top-brand__item {
  max-height: 84px;
  max-width: 160px;
  width: 100%;
  aspect-ratio: 1;
}

/* ========================== Top Brand Section End ================================ */
/* ================================ Featured Products Css Start ============================ */
@media screen and (max-width: 424px) {
  .featured-products .product-card {
    flex-direction: column;
  }
}

/* ================================ Featured Products Css End ============================ */
/* ============================= Banner Three Css Start ================================= */
.banner-three {
  background-color: var(--neutral-600);
  padding: 80px 0;
}
@media (width: 991px) {
  .banner-three {
    padding: 60px 0;
  }
}

.animation {
  position: absolute;
  max-width: 10%;
}

.star-shape {
  bottom: 4%;
  inset-inline-start: 5%;
  opacity: 0.3;
}
.star-shape.style-two {
  inset-inline-start: auto;
  bottom: auto;
  top: 10%;
  inset-inline-end: 8%;
}

.line-shape {
  top: 14%;
  left: 58%;
}

.animation-rotate {
  animation: rotation 6s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ============================= Banner Three Css End ================================= */
/* ============================== Promotional Banner Three Start ==========================  */
.promo-three-item {
  padding: clamp(2rem, -4.542rem + 13.629vw, 7.375rem) clamp(1.5rem, -1.543rem + 6.339vw, 4rem);
}

/* ============================== Promotional Banner Three End ==========================  */
.js-marquee {
  display: flex;
  gap: 32px;
}

/* ============================== Deals Section Css Start ========================== */
.deals__img {
  transform: translateY(12px);
}

.products-group__list {
  position: absolute;
  left: 35%;
  bottom: 30%;
  z-index: 1;
}
.products-group__list:nth-child(2) {
  bottom: 48%;
  left: 65%;
}
.products-group__list:nth-child(3) {
  bottom: 56%;
  left: 80%;
}
.products-group__list:hover .products-group__card {
  margin-bottom: 0;
  visibility: visible;
  opacity: 1;
}
.products-group__card {
  transform: translateX(-68%) rotate(-10deg);
  margin-bottom: -32px;
  visibility: hidden;
  opacity: 0;
}

/* ============================== Deals Section Css End ========================== */
/* ================================= Testimonials Section Css Start ==================================== */
@media (min-width: 768px) {
  .testimonials-item__desc {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media (min-width: 768px) {
  .testimonials-slider {
    position: absolute;
    top: 0;
    left: 25.5%;
  }
}
@media (max-width: 1299px) {
  .testimonials-slider {
    left: 34%;
  }
}
@media (max-width: 767px) {
  .testimonials-slider {
    left: 0;
  }
}

.testimonials-thumbs {
  overflow: hidden;
}
.testimonials-thumbs__img {
  max-height: 350px;
  height: 100%;
  width: 100%;
  transition: 0.6s linear;
  position: relative;
}
.testimonials-thumbs__img img {
  object-position: top;
}
.testimonials-thumbs__img::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(2deg, rgba(0, 0, 0, 0.9098039216), transparent);
  visibility: hidden;
  opacity: 0;
  transition: 0.2s linear;
}
.testimonials-thumbs:hover .testimonials-thumbs__img::before, .testimonials-thumbs:hover .testimonials-thumbs__content {
  visibility: visible !important;
  opacity: 1 !important;
}

.testimonials .slick-slider .slick-track {
  display: flex;
  align-items: end;
}
.testimonials .slick-slide.slick-active.slick-current .testimonials-thumbs {
  overflow: unset !important;
}
.testimonials .slick-slide.slick-active.slick-current .testimonials-thumbs__img {
  object-fit: cover;
  max-height: 100%;
}

.testimonials-thumbs-slider .slick-slide {
  height: 630px !important;
}

@media (min-width: 768px) {
  .testimonials-slider .slick-slide {
    height: 630px !important;
  }
}

/* ================================= Testimonials Section Css End ==================================== */
/* ============================ Product Details Css Start ============================= */
.product-details__thumb-slider {
  padding: clamp(3rem, -2.173rem + 10.777vw, 7.25rem);
}
.product-details .slick-initialized.slick-slider .slick-slide > div > div {
  height: 100%;
}

.product-dContent__box, .product-dContent__header {
  padding: 16px 40px;
}

.product-dContent__box {
  padding-top: 48px;
  padding-bottom: 48px;
}

/* ============================ Product Details Css End ============================= */
/* ================================ Shop Page css Start =============================== */
@media (max-width: 479px) {
  .list-grid-btns {
    display: none;
  }
}

.list-grid-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
  gap: 24px;
}

@media (min-width: 480px) {
  .list-view {
    grid-template-columns: repeat(auto-fit, minmax(430px, 1fr));
  }
  .list-view .product-card {
    display: flex;
    align-items: center;
    flex-direction: row;
  }
  .list-view .product-card__thumb {
    max-width: 200px;
    height: 100% !important;
  }
  .list-view .product-card__content {
    margin-top: 0 !important;
    margin-left: 20px;
    flex-grow: 1;
  }
}
@media (max-width: 1199px) {
  .shop-sidebar__box {
    padding: 16px !important;
  }
}
@media (max-width: 991px) {
  .shop-sidebar {
    position: fixed;
    top: 0;
    height: 100vh;
    background-color: #fff;
    z-index: 11;
    left: 0;
    border-radius: 0 !important;
    overflow-y: auto;
    width: 300px;
    border-right: 1px solid var(--gray-100);
    transform: translateX(-100%);
    transition: 0.2s linear;
  }
  .shop-sidebar.active {
    transform: translateX(0);
  }
  .shop-sidebar__box {
    border-radius: 0 !important;
    border: 0 !important;
  }
}
/* ================================ Shop Page css End =============================== */
/* ========================== Cart Page Css Start ============================ */
.table-product__thumb {
  max-width: 150px;
  max-height: 150px;
  width: 100%;
  height: 100%;
  aspect-ratio: 1;
}
.table-product__thumb img {
  max-width: 75px;
}
/* ========================== Cart Page Css End ============================ */
/* ======================= Checkout Css Start ============================= */
.payment-item__content {
  display: none;
}
.payment-item__content::before {
  position: absolute;
  content: "";
  width: 20px;
  height: 14px;
  background-color: var(--main-50);
  left: 32px;
  bottom: calc(100% - 1px);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

/* ======================= Checkout Css End ============================= */
/* ========================= Blog Css Start ============================= */
.blog-item {
  margin-bottom: 48px;
}
.blog-item:last-child {
  margin-bottom: 0;
}

/* ========================= Blog Css End ============================= */
.line-wrapper > div {
  position: relative;
}
.line-wrapper > div:last-child::before {
  display: none;
}
.line-wrapper > div::before {
  position: absolute;
  content: "";
  width: 1px;
  height: 100%;
  right: 0;
  top: 0;
  background: hsl(var(--white)/0.1);
}
@media (max-width: 991px) {
  .line-wrapper > div::before {
    display: none;
  }
}

/* ======================== Vendors Two Page css Start ============================= */
.grid-cols-3 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr !important;
  gap: 24px;
}
@media screen and (max-width: 1199px) {
  .grid-cols-3 {
    grid-template-columns: 1fr 1fr !important;
  }
}
@media screen and (max-width: 575px) {
  .grid-cols-3 {
    grid-template-columns: 1fr !important;
  }
}
.grid-cols-3.list-view {
  grid-template-columns: 1fr 1fr !important;
}
@media screen and (max-width: 1399px) {
  .grid-cols-3.list-view {
    grid-template-columns: 1fr !important;
  }
}

.list-view .vendors-two-item {
  display: flex;
}

/* ======================== Vendors Two Page css End ============================= */
/* ============================== Vendor Two Details Css Start =============================== */
.grid-cols-4 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr !important;
  gap: 24px;
}
@media screen and (max-width: 1399px) {
  .grid-cols-4 {
    grid-template-columns: 1fr 1fr 1fr !important;
  }
}
@media screen and (max-width: 1199px) {
  .grid-cols-4 {
    grid-template-columns: 1fr 1fr !important;
  }
}
@media screen and (max-width: 575px) {
  .grid-cols-4 {
    grid-template-columns: 1fr !important;
  }
}
.grid-cols-4.list-view {
  grid-template-columns: 1fr 1fr !important;
}
@media screen and (max-width: 1399px) {
  .grid-cols-4.list-view {
    grid-template-columns: 1fr !important;
  }
}

.vendor-two-details .shop-sidebar {
  width: 332px;
}
.vendor-two-details__contents {
  flex-grow: 1;
  width: calc(100% - 356px);
}

/* ============================== Vendor Two Details Css End =============================== */
.slick-arrow::before {
  display: none;
}

.slick-arrow .ph {
  color: #333;
}
.slick-arrow:hover .ph {
  color: #fff;
}

.flash-sales .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .flash-sales .mr-point {
    margin-right: 108px;
  }
}
.flash-sales .flash-sales__slider .slick-arrow.slick-prev {
  position: absolute;
  top: -60px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-prev {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-prev {
    top: -40px;
  }
}
@media screen and (max-width: 767px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-prev {
    top: -37px;
  }
}
.flash-sales .flash-sales__slider .slick-arrow.slick-next {
  position: absolute;
  top: -60px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-next {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-next {
    top: -40px;
  }
}
@media screen and (max-width: 767px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-next {
    top: -37px;
  }
}
@media screen and (max-width: 991px) {
  .flash-sales .flash-sales__slider .slick-arrow.slick-next {
    right: 14px;
  }
}

.hot-deals .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .hot-deals .mr-point {
    margin-right: 5px;
  }
}
.hot-deals .hot-deals-slider .slick-arrow.slick-prev {
  position: absolute;
  top: -60px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-prev {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-prev {
    top: -40px;
  }
}
@media screen and (max-width: 767px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-prev {
    top: -37px;
  }
}
.hot-deals .hot-deals-slider .slick-arrow.slick-next {
  position: absolute;
  top: -60px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-next {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-next {
    top: -40px;
  }
}
@media screen and (max-width: 991px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .hot-deals .hot-deals-slider .slick-arrow.slick-next {
    top: -37px;
  }
}

.organic-food .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .organic-food .mr-point {
    margin-right: 108px;
  }
}
.organic-food .organic-food__slider .slick-arrow.slick-prev {
  position: absolute;
  top: -60px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .organic-food .organic-food__slider .slick-arrow.slick-prev {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .organic-food .organic-food__slider .slick-arrow.slick-prev {
    top: -40px;
  }
}
@media screen and (max-width: 767px) {
  .organic-food .organic-food__slider .slick-arrow.slick-prev {
    top: -37px;
  }
}
.organic-food .organic-food__slider .slick-arrow.slick-next {
  position: absolute;
  top: -60px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .organic-food .organic-food__slider .slick-arrow.slick-next {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .organic-food .organic-food__slider .slick-arrow.slick-next {
    top: -40px;
  }
}
@media screen and (max-width: 991px) {
  .organic-food .organic-food__slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .organic-food .organic-food__slider .slick-arrow.slick-next {
    top: -37px;
  }
}

.short-product .mr-point {
  margin-right: 124px;
}
.short-product .slick-arrow {
  width: 38px;
  height: 38px;
}
.short-product .short-product-list .slick-arrow.slick-prev {
  position: absolute;
  top: -70px;
  left: auto;
  right: 50px;
}
.short-product .short-product-list .slick-arrow.slick-next {
  position: absolute;
  top: -70px;
  left: auto;
  right: 5px;
}

.brand .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .brand .mr-point {
    margin-right: 108px;
  }
}
.brand .brand-slider .slick-arrow.slick-prev {
  position: absolute;
  top: -60px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .brand .brand-slider .slick-arrow.slick-prev {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .brand .brand-slider .slick-arrow.slick-prev {
    top: -40px;
  }
}
@media screen and (max-width: 767px) {
  .brand .brand-slider .slick-arrow.slick-prev {
    top: -37px;
  }
}
.brand .brand-slider .slick-arrow.slick-next {
  position: absolute;
  top: -60px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .brand .brand-slider .slick-arrow.slick-next {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .brand .brand-slider .slick-arrow.slick-next {
    top: -40px;
  }
}
@media screen and (max-width: 991px) {
  .brand .brand-slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .brand .brand-slider .slick-arrow.slick-next {
    top: -37px;
  }
}

.new-arrival .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .new-arrival .mr-point {
    margin-right: 108px;
  }
}
.new-arrival .new-arrival__slider .slick-arrow.slick-prev {
  position: absolute;
  top: -60px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-prev {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-prev {
    top: -40px;
  }
}
@media screen and (max-width: 767px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-prev {
    top: -37px;
  }
}
.new-arrival .new-arrival__slider .slick-arrow.slick-next {
  position: absolute;
  top: -60px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-next {
    top: -58px;
  }
}
@media screen and (max-width: 1199px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-next {
    top: -40px;
  }
}
@media screen and (max-width: 991px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .new-arrival .new-arrival__slider .slick-arrow.slick-next {
    top: -37px;
  }
}

.deals-weeek .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .deals-weeek .mr-point {
    margin-right: 108px;
  }
}
.deals-weeek .deals-week-slider .slick-arrow.slick-prev {
  position: absolute;
  top: -300px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-prev {
    top: -290px;
  }
}
@media screen and (max-width: 1199px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-prev {
    top: -218px;
  }
}
@media screen and (max-width: 767px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-prev {
    top: -218px;
  }
}
.deals-weeek .deals-week-slider .slick-arrow.slick-next {
  position: absolute;
  top: -300px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-next {
    top: -290px;
  }
}
@media screen and (max-width: 1199px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-next {
    top: -218px;
  }
}
@media screen and (max-width: 991px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .deals-weeek .deals-week-slider .slick-arrow.slick-next {
    top: -218px;
  }
}

.top-selling-products .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .top-selling-products .mr-point {
    margin-right: 5px;
  }
}
.top-selling-products .top-selling-product-slider .slick-arrow.slick-prev {
  position: absolute;
  top: -45px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
@media screen and (max-width: 1199px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
@media screen and (max-width: 767px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
.top-selling-products .top-selling-product-slider .slick-arrow.slick-next {
  position: absolute;
  top: -45px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-next {
    top: -42px;
  }
}
@media screen and (max-width: 1199px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-next {
    top: -42px;
  }
}
@media screen and (max-width: 991px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .top-selling-products .top-selling-product-slider .slick-arrow.slick-next {
    top: -42px;
  }
}

.featured-products .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .featured-products .mr-point {
    margin-right: 108px;
  }
}
.featured-products .featured-product-slider .slick-arrow.slick-prev {
  position: absolute;
  top: -45px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .featured-products .featured-product-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
@media screen and (max-width: 1199px) {
  .featured-products .featured-product-slider .slick-arrow.slick-prev {
    top: -38px;
  }
}
@media screen and (max-width: 767px) {
  .featured-products .featured-product-slider .slick-arrow.slick-prev {
    top: -38px;
  }
}
.featured-products .featured-product-slider .slick-arrow.slick-next {
  position: absolute;
  top: -45px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .featured-products .featured-product-slider .slick-arrow.slick-next {
    top: -42px;
  }
}
@media screen and (max-width: 1199px) {
  .featured-products .featured-product-slider .slick-arrow.slick-next {
    top: -38px;
  }
}
@media screen and (max-width: 991px) {
  .featured-products .featured-product-slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .featured-products .featured-product-slider .slick-arrow.slick-next {
    top: -38px;
  }
}

.vendor-card .slick-arrow .ph {
  color: #fff;
}

.recommended .mr-point {
  margin-right: 124px;
}
@media screen and (max-width: 767px) {
  .recommended .mr-point {
    margin-right: 108px;
  }
}
.recommended .recommended-slider .slick-arrow.slick-prev {
  position: absolute;
  top: -45px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .recommended .recommended-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
@media screen and (max-width: 1199px) {
  .recommended .recommended-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
@media screen and (max-width: 767px) {
  .recommended .recommended-slider .slick-arrow.slick-prev {
    top: -42px;
  }
}
.recommended .recommended-slider .slick-arrow.slick-next {
  position: absolute;
  top: -45px;
  right: 0px;
  left: auto;
}
@media screen and (max-width: 1399px) {
  .recommended .recommended-slider .slick-arrow.slick-next {
    top: -42px;
  }
}
@media screen and (max-width: 1199px) {
  .recommended .recommended-slider .slick-arrow.slick-next {
    top: -42px;
  }
}
@media screen and (max-width: 991px) {
  .recommended .recommended-slider .slick-arrow.slick-next {
    right: 14px;
  }
}
@media screen and (max-width: 767px) {
  .recommended .recommended-slider .slick-arrow.slick-next {
    top: -42px;
  }
}

.top-brand .mr-point {
  margin-right: 124px;
}
.top-brand .top-brand__slider .slick-arrow.slick-prev {
  position: absolute;
  top: -45px;
  right: 60px;
  left: auto;
}
@media screen and (max-width: 767px) {
  .top-brand .top-brand__slider .slick-arrow.slick-prev {
    right: 46px;
  }
}
.top-brand .top-brand__slider .slick-arrow.slick-next {
  position: absolute;
  top: -45px;
  right: 0px;
  left: auto;
}

.banner-item-two__slider .slick-dots {
  display: flex !important;
  gap: 4px;
}
.banner-item-two__slider .slick-dots li {
  margin: 0;
}
.banner-item-two__slider .slick-dots .slick-active {
  width: auto;
}

.banner-three-slider .slick-next {
  right: -100px !important;
}
.banner-three-slider .slick-prev {
  left: -100px !important;
}
.banner-three-slider .slick-arrow .ph {
  color: #ddd;
}

.horizontal-slider .example-track.example-track-0,
.horizontal-slider .example-track.example-track-2 {
  height: 8px;
  border-radius: 5px;
  background: #cccccc;
}
.horizontal-slider .example-track.example-track-1 {
  height: 8px;
  border-radius: 5px;
  z-index: 9;
  background-color: var(--main-600) !important;
}
.horizontal-slider .example-thumb {
  left: 76.7775px;
  top: 12px;
  background-color: var(--main-600) !important;
  border-radius: 5px;
  width: 40px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
}
.horizontal-slider .example-thumb:focus-visible {
  outline: none;
}

.product-details__thumb-slider {
  padding: clamp(3rem, -2.173rem + 10.777vw, 7.25rem);
  min-width: 400px;
  height: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.center {
  display: flex !important;
  justify-content: center;
  align-items: center;
}

.product-details__images-slider .thum {
  width: 60px;
  object-fit: contain;
}

.mobile-menu .nav-submenu {
  display: block !important;
  max-height: 0;
  overflow: hidden;
  height: 0;
  transition: all 0s linear !important;
}

.mobile-menu .nav-submenu.open {
  max-height: 500px;
  height: 100%;
  transition: all 2s linear !important;
  /* Adjust this value based on your content */
}

.submenus-submenu.open {
  max-height: 500px;
  height: 100%;
  transition: all 2s linear !important;
  /* Adjust this value based on your content */
}

@media screen and (max-width: 991px) {
  .responsive-dropdown.cat .submenus-submenu {
    display: block !important;
    max-height: 0;
    overflow: hidden;
    height: 0;
    transition: all 0s linear !important;
  }
  .responsive-dropdown.cat .submenus-submenu.open {
    max-height: 500px;
    height: 100%;
    transition: all 0.5s linear !important;
  }
}
.promotional-banner {
  position: relative;
  z-index: 0;
}

.scroll-to-top {
  z-index: 9999;
}

.common-dropdown__item .common-dropdown__link.activePage {
  color: hsl(var(--main)) !important;
}

.nav-menu__link.activePage {
  color: hsl(var(--main));
}

@media screen and (max-width: 991px) {
  .category-two {
    display: block !important;
  }
}

@media screen and (max-width: 991px) {
  .category.main {
    display: none !important;
  }
}

.nav-menu--mobile .nav-submenu {
  margin-inline-start: 10px;
}

.nav-menu--mobile .nav-submenu__link {
  padding: 10px 8px;
}

.has-submenus-submenu:focus-within .submenus-submenu {
  visibility: visible;
  opacity: 1;
}

.Marquee_text-slider .rfm-child {
  margin-right: 40px;
}

.countdown-list__item::before {
  content: "";
}

.trending-products-three .group:hover .expand-icons,
.popular-products-three .group:hover .expand-icons,
.vendor-two-details .group:hover .expand-icons,
.new-arrival-three .group:hover .expand-icons {
  display: flex !important;
}
.trending-products-three .group:hover .expand-btn,
.popular-products-three .group:hover .expand-btn,
.vendor-two-details .group:hover .expand-btn,
.new-arrival-three .group:hover .expand-btn {
  background-color: var(--main-two-600) !important;
}
.trending-products-three .group:hover .expand-btn .ph,
.popular-products-three .group:hover .expand-btn .ph,
.vendor-two-details .group:hover .expand-btn .ph,
.new-arrival-three .group:hover .expand-btn .ph {
  transform: rotate(45deg);
  color: #fff;
}

.top-brand.three .slick-arrow {
  transform: translateY(0);
}
.top-brand.three .top-brand__slider .slick-arrow {
  top: -68px;
}

.testimonials .slick-arrow.slick-prev {
  position: absolute;
  bottom: -100px;
  top: auto;
  transform: translateX(-50%);
  left: 46%;
}
.testimonials .slick-arrow.slick-next {
  position: absolute;
  bottom: -100px;
  top: auto;
  transform: translateX(-50%);
  right: 46%;
}
.testimonials .slick-arrow i {
  color: #fff;
}

.instagram .slick-arrow {
  z-index: 9999;
  transform: translateY(0);
}
.instagram .instagram-slider .slick-arrow {
  top: 50%;
  transform: translateY(-50%);
}

@media screen and (max-width: 767px) {
  .vendor-two .list-grid-wrapper.list-view {
    display: grid;
  }
}`, "",{"version":3,"sources":["webpack://./public/assets/sass/abstracts/_css-index.scss","webpack://./public/assets/sass/abstracts/_functions.scss","webpack://./public/assets/sass/abstracts/_variable.scss","webpack://./src/index.scss","webpack://./public/assets/sass/abstracts/_mixins.scss","webpack://./public/assets/sass/components/_accordion.scss","webpack://./public/assets/sass/components/_button.scss","webpack://./public/assets/sass/components/_form.scss","webpack://./public/assets/sass/components/_pagination.scss","webpack://./public/assets/sass/components/_tab.scss","webpack://./public/assets/sass/components/_table.scss","webpack://./public/assets/sass/components/_card.scss","webpack://./public/assets/sass/components/_select2.scss","webpack://./public/assets/sass/components/_countdown.scss","webpack://./public/assets/sass/components/_badge.scss","webpack://./public/assets/sass/components/_range-slider.scss","webpack://./public/assets/sass/utilities/_typography.scss","webpack://./public/assets/sass/utilities/_margin.scss","webpack://./public/assets/sass/utilities/_padding.scss","webpack://./public/assets/sass/utilities/_classes.scss","webpack://./public/assets/sass/utilities/_extend.scss","webpack://./public/assets/sass/utilities/_size.scss","webpack://./public/assets/sass/utilities/_colors.scss","webpack://./public/assets/sass/utilities/_border.scss","webpack://./public/assets/sass/utilities/_bg.scss","webpack://./public/assets/sass/utilities/_font-size.scss","webpack://./public/assets/sass/utilities/_shadow.scss","webpack://./public/assets/sass/utilities/_radius.scss","webpack://./public/assets/sass/utilities/_scroll-hide.scss","webpack://./public/assets/sass/utilities/_overlay.scss","webpack://./public/assets/sass/utilities/_line-clamp.scss","webpack://./public/assets/sass/utilities/_scrollbar.scss","webpack://./public/assets/sass/utilities/_gap.scss","webpack://./public/assets/sass/utilities/_hover.scss","webpack://./public/assets/sass/utilities/_gutter.scss","webpack://./public/assets/sass/layout/_preloader.scss","webpack://./public/assets/sass/layout/_header-top.scss","webpack://./public/assets/sass/layout/_header.scss","webpack://./public/assets/sass/layout/_header-middle.scss","webpack://./public/assets/sass/layout/_mobile-nav-menu.scss","webpack://./public/assets/sass/layout/_footer.scss","webpack://./public/assets/sass/layout/_scroll-top.scss","webpack://./public/assets/sass/layout/_search-form.scss","webpack://./public/assets/sass/layout/_slick.scss","webpack://./public/assets/sass/layout/_section-heading.scss","webpack://./public/assets/sass/partials/home/_banner.scss","webpack://./public/assets/sass/partials/home/_feature.scss","webpack://./public/assets/sass/partials/home/_promotional-banner.scss","webpack://./public/assets/sass/partials/home/_flash-sales.scss","webpack://./public/assets/sass/partials/home/_product-card.scss","webpack://./public/assets/sass/partials/home/_offer.scss","webpack://./public/assets/sass/partials/home/_vendor.scss","webpack://./public/assets/sass/partials/home/_delivery.scss","webpack://./public/assets/sass/partials/home/_short-product.scss","webpack://./public/assets/sass/partials/home/_brand.scss","webpack://./public/assets/sass/partials/home/_shipping.scss","webpack://./public/assets/sass/partials/home/_newsletter.scss","webpack://./public/assets/sass/partials/home-two/_color-two.scss","webpack://./public/assets/sass/partials/home-two/_banner-two.scss","webpack://./public/assets/sass/partials/home-two/_deals.scss","webpack://./public/assets/sass/partials/home-two/_trending-products.scss","webpack://./public/assets/sass/partials/home-two/_discount.scss","webpack://./public/assets/sass/partials/home-two/_popular-products.scss","webpack://./public/assets/sass/partials/home-two/_day-sale.scss","webpack://./public/assets/sass/partials/home-two/_top-brand.scss","webpack://./public/assets/sass/partials/home-two/_featured-products.scss","webpack://./public/assets/sass/partials/homeThree/_banner-three.scss","webpack://./public/assets/sass/partials/homeThree/_promotional-banner-three.scss","webpack://./public/assets/sass/partials/homeThree/_text-slider.scss","webpack://./public/assets/sass/partials/homeThree/_deals.scss","webpack://./public/assets/sass/partials/homeThree/_testimonials.scss","webpack://./public/assets/sass/partials/othersPage/_product-details.scss","webpack://./public/assets/sass/partials/othersPage/_shop.scss","webpack://./public/assets/sass/partials/othersPage/_cart.scss","webpack://./public/assets/sass/partials/othersPage/_checkout.scss","webpack://./public/assets/sass/partials/othersPage/_blog.scss","webpack://./public/assets/sass/partials/othersPage/_counter.scss","webpack://./public/assets/sass/partials/othersPage/_vendors-two.scss","webpack://./public/assets/sass/partials/othersPage/_vendor-two-details.scss","webpack://./public/assets/sass/_extra.scss"],"names":[],"mappings":"AAAA,gEAAA;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAAA;AAkCA,gEAAA;ACnCA,yBAAA;AAQA,uBAAA;AAGA,uEAAA;AA2CA,uEAAA;ACtDA,eAAA;AAkMA,0EAAA;AACA;EAEE,yBAAA;EACA,wCAAA;EACA,qCAAA;EACA,0CAAA;EACA,8CAAA;EACA,gCAAA;EAEA,6BAAA;EACA,4DAAA;EACA,wDAAA;EACA,2DAAA;EACA,0DAAA;EACA,yDAAA;EACA,2DAAA;EAEA,6DAAA;EACA,2DAAA;EACA,kBAAA;EAEA,wBAAA;EACA,aAAA;EACA,aAAA;EACA,aAAA;EACA,iDAAA;EAEA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iEAAA;EAEC,gBAAA;EACD,kBAAA;EACA,oBAAA;EACA,iBAAA;EAEA,6BAAA;EACA,0BAAA;EACA,sBAAA;EACA,2BAAA;EAEA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,sCAAA;EACA,sCAAA;EAIE,kBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,iBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,iBAAA;EAAA,qBAAA;EAME,gGAAA;EAAA,iGAAA;EAAA,iGAAA;EAAA,iGAAA;EAAA,iGAAA;EAAA,iGAAA;EAAA,4DAAA;EAAA,wFAAA;EAAA,wFAAA;EAAA,wFAAA;EAAA,oHAAA;EAAA,qHAAA;EAAA,qHAAA;EAAA,qHAAA;EAAA,qHAAA;EAAA,qHAAA;EAAA,4EAAA;EAAA,4GAAA;EAAA,4GAAA;EAAA,4GAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,oBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,qBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,kBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,uBAAA;EAMF,kBAAA;EAAA,mBAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,mBAAA;ACxBJ;;AD2BA,wEAAA;AEvQA,+EAAA;AACA,2CAAA;AA4DA,yCAAA;AAEA,6EAAA;AC/DA,kFAAA;AAEI;EACI,qCAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AFmPR;AElPQ;EACI,sBAAA;AFoPZ;AEjPI;EACI,cAAA;AFmPR;AEjPI;EACI,kBAAA;EAEA,sBAAA;AFkPR;ACnPE;ECFE;IAKQ,kBAAA;IACA,sBAAA;EFoPV;AACF;AElPI;EACI,kBAAA;AFoPR;AElPI;EACI,kBAAA;AFoPR;AElPI;EACI,2BAAA;EAEA,kBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mDAAA;EACA,gCAAA;AFmPR;ACvQE;ECaE;IASQ,kBAAA;IACA,wBAAA;EFqPV;AACF;AEpPQ;EACI,sBAAA;AFsPZ;AEpPQ;EACI,gBAAA;AFsPZ;AEpPQ;EACI,wCAAA;EACA,gBAAA;EACA,uBAAA;AFsPZ;AErPY;EACI,sBAAA;EACA,uBAAA;AFuPhB;AEnPY;EACI,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EAEA,kBAAA;AFoPhB;ACzSE;ECyCU;IAcQ,sBAAA;EFsPlB;AACF;AElPY;EACI,gBAAA;EACA,gCAAA;AFoPhB;;AE/OA,oFAAA;ACnFA,mFAAA;AACA;EACI,WAAA;EACA,sBAAA;EACA,kBAAA;AHsUJ;;AGnUA;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,6BAAA;EACA,mCAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;AHsUJ;AGrUI;EACI,2BAAA;AHuUR;AC7SE;EErCF;IAcQ,kBAAA;IACA,mBAAA;EHwUN;AACF;AGvUI;EACI,6BAAA;AHyUR;AGvUI;EACI,sBAAA;AHyUR;AGtUI;EACI,6CAAA;EACA,yCAAA;AHwUR;AGvUQ;EACI,4CAAA;EACA,wCAAA;AHyUZ;AGtUI;EACI,wCAAA;EACA,yCAAA;EACA,kCAAA;AHwUR;AGvUQ;EACI,kDAAA;EACA,6CAAA;AHyUZ;AGtUI;EACI,iDAAA;EACA,6CAAA;EACA,mCAAA;AHwUR;AGvUQ;EACI,gDAAA;EACA,4CAAA;AHyUZ;AGtUI;EACI,wCAAA;EACA,6CAAA;EACA,sCAAA;AHwUR;AGvUQ;EACI,sDAAA;EACA,iDAAA;AHyUZ;AGtUI;EACI,8CAAA;EACA,0CAAA;EACA,2CAAA;AHwUR;AGvUQ;EACI,kDAAA;EACA,8CAAA;AHyUZ;AGtUI;EACI,wCAAA;EACA,0CAAA;EACA,mCAAA;AHwUR;AGvUQ;EACI,8CAAA;EACA,0CAAA;EACA,2CAAA;AHyUZ;AGtUI;EACI,8CAAA;EACA,0CAAA;EACA,mCAAA;AHwUR;AGvUQ;EACI,kDAAA;EACA,8CAAA;AHyUZ;AGtUI;EACI,wCAAA;EACA,0CAAA;EACA,mCAAA;AHwUR;AGvUQ;EACI,8CAAA;EACA,0CAAA;EACA,mCAAA;AHyUZ;;AGrUA,iFAAA;ACzGA,iFAAA;AACA,gBAAA;AACA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,iCAAA;EACA,wBAAA;EACA,cAAA;AJkbJ;AIjbI;EACI,8CAAA;EACA,wBAAA;AJmbR;ACnaE;EG5BF;IAeQ,kBAAA;EJobN;AACF;AC/aE;EGrBF;IAkBQ,kBAAA;EJsbN;AACF;AIpbI;EACI,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AJsbR;AIpbI;EACI,kBAAA;AJsbR;AInbI;EACI,kBAAA;AJqbR;AChcE;EGUE;IAGQ,kBAAA;EJubV;AACF;AIrbI;EACI,8BAAA;EACA,gBAAA;AJubR;AItbQ;EACI,kBAAA;EACA,UAAA;AJwbZ;AIrbI;EACI,uCAAA;EACA,UAAA;EACA,SAAA;AJubR;AIrbI;EACI,4BAAA;AJubR;AItbQ;EACI,wBAAA;AJwbZ;AIrbI;EACI,iBAAA;EACA,UAAA;EACA,kBAAA;AJubR;AItbQ;EACI,wCAAA;EACA,gBAAA;EACA,oBAAA;EACA,6CAAA;EACA,uBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,wCAAA;AJwbZ;AIvbY;EACI,kCAAA;EACA,kCAAA;EACA,wBAAA;AJybhB;;AInbI;EACI,mCAAA;AJsbR;AIpbI;EACI,qCAAA;AJsbR;;AInbA,cAAA;AAEA,eAAA;AACA;EACI,kBAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,gCAAA;AJqbJ;AInbI;EACI,wBAAA;EACA,sBAAA;AJqbR;;AIlbA;EACI,uBAAA;EACA,wBAAA;AJqbJ;;AInbA,eAAA;AAEA,UAAA;AACA;EACI,qBAAA;EACA,gCAAA;EACA,gBAAA;AJqbJ;;AIlbA,gBAAA;AACA;EACI,kBAAA;AJqbJ;AIpbI;EACI,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,uBAAA;EACA,oBAAA;EACA,mCAAA;AJqbR;AInbI;EACI,0CAAA;AJqbR;AInbI;EACI,sBAAA;EACA,wBAAA;EACA,kBAAA;EACA,eAAA;AJqbR;ACniBE;EG0GE;IAMQ,kBAAA;EJubV;AACF;AC/iBE;EGiHE;IASQ,kBAAA;EJybV;AACF;AIvbI;EACI,mCAAA;AJybR;;AItbA;EACI,uCAAA;EACA,kBAAA;AJybJ;ACrjBE;EG0HF;IAIQ,kBAAA;EJ2bN;AACF;ACjkBE;EGiIF;IAOQ,iBAAA;EJ6bN;AACF;AI3bI;EACI,8BAAA;EACA,mCAAA;EACA,aAAA;AJ6bR;AI3bI;EACI,mCAAA;EACA,gCAAA;AJ6bR;;AI1bA,oBAAA;AAII;EACI,aAAA;AJ0bR;ACplBE;EGyJE;IAGQ,aAAA;EJ4bV;AACF;;AIzbA,iBAAA;AACA;;EAGI,yDAAA;EAAA,iDAAA;AJ4bJ;;AI1bA;EACI,oDAAA;EACA,6DAAA;EACA,sCAAA;AJ6bJ;;AI3bA,qBAAA;AAEA,uBAAA;AACA;EACI,wBAAA;AJ6bJ;;AI3bA;EACI,kBAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;AJ8bJ;;AI3bA,sBAAA;AACA;;EAEI,wBAAA;AJ8bJ;;AI5bA;EACI,0BAAA;AJ+bJ;;AI5bA,sCAAA;AACA;EAEI,sBAAA;AJ8bJ;AI7bI;EACI,mBAAA;AJ+bR;AI7bI;EACI,eAAA;AJ+bR;AI5bQ;EACI,kBAAA;AJ8bZ;AI7bY;EACI,wCAAA;AJ+bhB;AI9bgB;EACI,mBAAA;EACA,UAAA;EAEA,yCAAA;AJgcpB;AI1bI;EACI,uBAAA;EACA,gBAAA;EACA,6BAAA;EACA,2BAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;AJ4bR;AI3bQ;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AJ6bZ;AI3bQ;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EAEA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AJ6bZ;AI3bQ;EACI,6CAAA;EACA,yCAAA;EACA,gBAAA;AJ6bZ;AI5bY;EACI,sBAAA;AJ8bhB;AI5bY;EACI,mBAAA;EACA,UAAA;AJ8bhB;AI1bI;EACI,gBAAA;EACA,wBAAA;EACA,0BAAA;EACA,eAAA;EAEA,gCAAA;EACA,gCAAA;AJ2bR;;AIrbQ;EACI,mCAAA;AJwbZ;AIvbY;EACI,mCAAA;AJybhB;AIvbY;EACI,8CAAA;EACA,0CAAA;AJybhB;AIpbQ;EACI,oCAAA;AJsbZ;AIrbY;EACI,oCAAA;AJubhB;AIrbY;EACI,+CAAA;EACA,2CAAA;AJubhB;AIlbQ;EACI,iCAAA;AJobZ;AInbY;EACI,iCAAA;AJqbhB;AInbY;EACI,4CAAA;EACA,wCAAA;AJqbhB;AIhbQ;EACI,oCAAA;AJkbZ;AIjbY;EACI,oCAAA;AJmbhB;AIjbY;EACI,+CAAA;EACA,2CAAA;AJmbhB;AI9aQ;EACI,mCAAA;AJgbZ;AI/aY;EACI,mCAAA;AJibhB;AI/aY;EACI,8CAAA;EACA,0CAAA;AJibhB;AI5aQ;EACI,qCAAA;AJ8aZ;AI7aY;EACI,qCAAA;AJ+ahB;AI7aY;EACI,gDAAA;EACA,4CAAA;AJ+ahB;AI1aQ;EACI,iCAAA;AJ4aZ;AI3aY;EACI,iCAAA;AJ6ahB;AI3aY;EACI,4CAAA;EACA,wCAAA;AJ6ahB;;AIxaA,oCAAA;AAEA;EACI,2BAAA;AJ0aJ;;AIxaA,+EAAA;ACnZA,uFAAA;AACA;EACI,wBAAA;AL+zBJ;AC5xBE;EIpCF;IAGQ,wBAAA;ELi0BN;AACF;ACxyBE;EI7BF;IAMQ,wBAAA;ELm0BN;AACF;ACpzBE;EItBF;IASQ,wBAAA;ELq0BN;AACF;AKl0BY;EACI,4CAAA;EACA,wCAAA;EACA,mCAAA;ALo0BhB;AKj0BQ;EACI,2BAAA;ALm0BZ;AKl0BY;EACI,iCAAA;EACA,4CAAA;EACA,wCAAA;ALo0BhB;;AK9zBA,qFAAA;AC/BA,gFAAA;AACA;EACI,sBAAA;EACA,QAAA;ANi2BJ;AMh2BI;EACI,gBAAA;ANk2BR;AMj2BQ;EACI,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;ANm2BZ;ACv0BE;EKtCM;IAYQ,4BAAA;IACA,mBAAA;ENq2Bd;AACF;AMp2BY;EACI,mCAAA;EACA,wCAAA;EACA,4CAAA;ANs2BhB;AMp2BY;EACI,sBAAA;ANs2BhB;AMj2BQ;EACI,iCAAA;EACA,yBAAA;ANm2BZ;AMl2BY;EACI,mCAAA;EACA,4CAAA;EACA,gDAAA;ANo2BhB;AMl2BY;EACI,0BAAA;ANo2BhB;;AM/1BA,8EAAA;AC9CA,2EAAA;AACA;EACI,uCAAA;EACA,mBAAA;EACA,oDAAA;APi5BJ;;AO/4BA;EACI,wBAAA;EACA,mBAAA;EACA,sBAAA;APk5BJ;AOj5BI;EACI,gBAAA;APm5BR;AOh5BQ;EACI,uBAAA;EACA,aAAA;APk5BZ;AOj5BY;EACI,uBAAA;APm5BhB;AOj5BY;EACI,qBAAA;APm5BhB;AOh5BQ;EACI,kBAAA;EACA,sBAAA;APk5BZ;AOj5BY;EACI,gBAAA;APm5BhB;AOj5BY;EACI,iBAAA;EACA,qBAAA;APm5BhB;AO94BQ;EACI,8CAAA;APg5BZ;AO/4BY;EACI,sBAAA;EACA,mDAAA;EACA,gBAAA;EACA,6DAAA;APi5BhB;AO54BQ;EACI,8CAAA;AP84BZ;AO74BY;EACI,gBAAA;AP+4BhB;AO94BgB;EACI,oBAAA;APg5BpB;AO74BY;EACI,oDAAA;EACA,gBAAA;EACA,qDAAA;AP+4BhB;AO14BI;EACI,gCAAA;AP44BR;AO34BQ;EACI,8CAAA;AP64BZ;AO34BQ;EACI,uBAAA;EACA,eAAA;AP64BZ;AOz4BQ;EACI,wCAAA;AP24BZ;AO14BY;EACI,SAAA;AP44BhB;AOz4BgB;EACI,uBAAA;AP24BpB;AOz4BgB;EACI,qBAAA;AP24BpB;AOx4BY;EACI,uDAAA;AP04BhB;;AOr4BA,yEAAA;AC9FA,sEAAA;AACA;EACI,SAAA;ARu+BJ;AQt+BI;EACI,kBAAA;EACA,6BAAA;EACA,4CAAA;ARw+BR;ACp+BE;EOPE;IAKQ,kBAAA;ER0+BV;AACF;AQx+BI;EACI,mCAAA;AR0+BR;AQz+BQ;EACI,wBAAA;EACA,mBAAA;AR2+BZ;AQx+BI;EACI,aAAA;AR0+BR;ACn/BE;EOQE;IAGQ,aAAA;ER4+BV;AACF;AQ1+BI;EACI,yCAAA;EACA,gBAAA;AR4+BR;;AQz+BA,oEAAA;AC7BA,2EAAA;AACA;EACI,SAAA;AT0gCJ;;ASvgCA;EACI,SAAA;EACA,kBAAA;AT0gCJ;;ASvgCA;EACI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,uBAAA;AT0gCJ;;ASvgCA;EACI,2BAAA;AT0gCJ;;ASvgCA;EACI,oBAAA;EACA,oBAAA;EACA,+BAAA;EACA,gCAAA;EACA,6BAAA;AT0gCJ;;AStgCA;EACI,0BAAA;EACA,sBAAA;ATygCJ;;AStgCA;EACI,0BAAA;EACA,4CAAA;EACA,wCAAA;EACA,wBAAA;EACA,kCAAA;EACA,8BAAA;ATygCJ;;AStgCI;EACI,0CAAA;EACA,wCAAA;ATygCR;;ASrgCA;EACI,kBAAA;ATwgCJ;;AStgCA;EACI,eAAA;ATygCJ;;AStgCA;EACI,sBAAA;EACA,iCAAA;EACA,sCAAA;EACA,uBAAA;ATygCJ;ACniCE;EQsBF;IAMQ,qBAAA;ET2gCN;AACF;;ASxgCA;EACI,qCAAA;EACA,mCAAA;AT2gCJ;AC7iCE;EQgCF;IAIQ,qCAAA;IACA,mCAAA;ET6gCN;AACF;;ASzgCI;EACI,+BAAA;AT4gCR;;AStgCA;EACI,4CAAA;EACA,wBAAA;EACA,6BAAA;EACA,gBAAA;ATygCJ;AC5kCE;EQ+DF;IAMQ,gBAAA;ET2gCN;AACF;AC9lCE;EQ4EF;IASQ,gBAAA;ET6gCN;AACF;;AS1gCA;EACI,qBAAA;AT6gCJ;;AS1gCA;EACI,4CAAA;EACA,6BAAA;EACA,iBAAA;AT6gCJ;;AS3gCA;EACI,kCAAA;AT8gCJ;;AS3gCA;EACI,kCAAA;AT8gCJ;;AS1gCA;EACI,6BAAA;EACA,4BAAA;EACA,sBAAA;EACA,0BAAA;AT6gCJ;AC/mCE;EQ8FF;IAMQ,4BAAA;IACA,0BAAA;ET+gCN;AACF;;AS5gCA;EACI,4CAAA;EACA,uBAAA;AT+gCJ;;AS7gCA;EACI,4CAAA;EACA,iCAAA;ATghCJ;;AS7gCA;EACI,4CAAA;EACA,sBAAA;ATghCJ;;AS7gCA;EACI,uBAAA;ATghCJ;AS/gCI;EACI,UAAA;ATihCR;AS/gCI;EACI,mBAAA;ATihCR;AS/gCI;EACI,mBAAA;EACA,mBAAA;ATihCR;AS/gCI;EACI,mBAAA;ATihCR;;AS1gCQ;EACI,iCAAA;AT6gCZ;AS3gCQ;EACI,iCAAA;AT6gCZ;;ASvgCA,sBAAA;AAEI;EACI,oCAAA;EACA,mCAAA;ATygCR;ASvgCI;EACI,qBAAA;EACA,iCAAA;ATygCR;ASvgCI;EACI,oBAAA;ATygCR;ASvgCI;EACI,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,oCAAA;ATygCR;;ACxqCE;EQoKF;IAEQ,WAAA;ETugCN;AACF;AClsCE;EQwLF;IAKQ,WAAA;ETygCN;AACF;;ACnrCE;EQ+KE;IACI,uBAAA;ETwgCN;ESvgCM;IACI,eAAA;ETygCV;AACF;AStgCA,yEAAA;ACpNA,oFAAA;AACA;EACI,SAAA;AV6tCJ;ACnrCE;ES3CF;IAGQ,QAAA;EV+tCN;AACF;AU9tCI;EACI,mCAAA;EACA,uFAAA;EACA,kBAAA;EACA,kBAAA;AVguCR;AC9rCE;EStCE;IAMQ,6BAAA;EVkuCV;AACF;AUhuCY;EACI,aAAA;AVkuChB;AU/tCQ;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;EACA,gBAAA;AViuCZ;AC9sCE;ESzBM;IAQQ,aAAA;EVmuCd;AACF;AUhuCY;EACI,WAAA;AVkuChB;AU3tCY;EACI,iCAAA;EACA,sBAAA;AV6tChB;AU5tCgB;EACI,iCAAA;AV8tCpB;AUxtCI;EACI,SAAA;AV0tCR;AUxtCY;EACI,gCAAA;EACA,0BAAA;EACA,YAAA;EACA,yBAAA;AV0tChB;AUntCY;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;AVqtChB;AUptCgB;EACI,yBAAA;AVstCpB;;AUhtCA,kFAAA;AC5EA;EACI,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,qCAAA;AXgyCJ;AW/xCI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,oDAAA;AXiyCR;;AW7xCA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,kBAAA;EACA,wBAAA;EACA,yCAAA;EACA,QAAA;AXgyCJ;;AW5xCA;EACI;IACI,UAAA;EX+xCN;EW7xCE;IACI,YAAA;EX+xCN;AACF;AYn0CA,yFAAA;AAEC;EACC,WAAA;EACA,SAAA;EACA,2BAAA;EACM,WAAA;AZo0CR;AYn0CE;EACC,sBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,qBAAA;EACA,uBAAA;AZq0CH;AYp0CG;EACC,sCAAA;AZs0CJ;AYp0CG;EACa,yEAAA;AZs0ChB;AYn0CE;EACC,iCAAA;EACS,uBAAA;AZq0CZ;AYl0CG;EACC,iCAAA;AZo0CJ;AYh0CI;EACI,WAAA;AZk0CR;AYh0CC;EACC,SAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;AZk0CF;;AY/zCA,uFAAA;AC5CA,uFAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;Ab+2CF;;Aa52CA;EACE,uBAAA;Ab+2CF;;Aa52CA;EACE,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;Ab+2CF;;Aa52CA;EACE,kBAAA;Ab+2CF;;Aa52CA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;Ab+2CF;;Aa52CA;EACE,qBAAA;Ab+2CF;;Aa52CA;;;;;;EAME,kBAAA;EACA,gCAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;Ab+2CF;;Aa72CA;EACE,6BAAA;Abg3CF;;Aa92CA;EACE,6BAAA;Abi3CF;;Aa/2CA;EACE,+BAAA;Abk3CF;;Aah3CA;EACE,8BAAA;Abm3CF;;Aaj3CA;EACE,8BAAA;Abo3CF;;Aal3CA;EACE,6BAAA;Abq3CF;;Aal3CA;;;;;;EAME,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,oBAAA;Abq3CF;Aap3CE;;;;;;EACE,uBAAA;Ab23CJ;;Aav3CA;EACE,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,cAAA;Ab03CF;;Aax3CA;EACE,cAAA;Ab23CF;;Aaz3CA;EACE,eAAA;EACA,YAAA;Ab43CF;;Aa13CA;EACE,eAAA;Ab63CF;;Aa33CA;;EAEE,UAAA;EACA,SAAA;EACA,gBAAA;Ab83CF;;Aa53CA;EACE,SAAA;EACA,6BAAA;Ab+3CF;Aa93CE;EACE,aAAA;EACA,gBAAA;Abg4CJ;;Aa73CA;EACE,UAAA;EACA,gBAAA;Abg4CF;;Aa93CA;EACE,UAAA;Abi4CF;;Aa/3CA,qFAAA;ACxHA,mFAAA;AAEE;EACE,gCAAA;Ad0/CJ;;Ac3/CE;EACE,gCAAA;Ad8/CJ;;Ac//CE;EACE,gCAAA;AdkgDJ;;AcngDE;EACE,gCAAA;AdsgDJ;;AcvgDE;EACE,gCAAA;Ad0gDJ;;Ac3gDE;EACE,gCAAA;Ad8gDJ;;Ac/gDE;EACE,gCAAA;AdkhDJ;;AcnhDE;EACE,gCAAA;AdshDJ;;AcvhDE;EACE,iCAAA;Ad0hDJ;;Ac3hDE;EACE,iCAAA;Ad8hDJ;;Ac/hDE;EACE,iCAAA;AdkiDJ;;AcniDE;EACE,iCAAA;AdsiDJ;;AcviDE;EACE,iCAAA;Ad0iDJ;;Ac3iDE;EACE,iCAAA;Ad8iDJ;;Ac/iDE;EACE,iCAAA;AdkjDJ;;AcnjDE;EACE,iCAAA;AdsjDJ;;AcvjDE;EACE,iCAAA;Ad0jDJ;;Ac3jDE;EACE,iCAAA;Ad8jDJ;;Ac/jDE;EACE,iCAAA;AdkkDJ;;AcnkDE;EACE,iCAAA;AdskDJ;;AcvkDE;EACE,iCAAA;Ad0kDJ;;Ac3kDE;EACE,iCAAA;Ad8kDJ;;Ac/kDE;EACE,iCAAA;AdklDJ;;AcnlDE;EACE,iCAAA;AdslDJ;;AcvlDE;EACE,iCAAA;Ad0lDJ;;Ac3lDE;EACE,iCAAA;Ad8lDJ;;Ac/lDE;EACE,iCAAA;AdkmDJ;;AcnmDE;EACE,iCAAA;AdsmDJ;;AcvmDE;EACE,iCAAA;Ad0mDJ;;Ac3mDE;EACE,iCAAA;Ad8mDJ;;Ac/mDE;EACE,iCAAA;AdknDJ;;AcnnDE;EACE,iCAAA;AdsnDJ;;AcvnDE;EACE,iCAAA;Ad0nDJ;;Ac3nDE;EACE,iCAAA;Ad8nDJ;;Ac/nDE;EACE,iCAAA;AdkoDJ;;AcnoDE;EACE,kCAAA;AdsoDJ;;AcvoDE;EACE,kCAAA;Ad0oDJ;;Ac3oDE;EACE,kCAAA;Ad8oDJ;;Ac/oDE;EACE,kCAAA;AdkpDJ;;AcnpDE;EACE,kCAAA;AdspDJ;;AcjpDE;EACE,uCAAA;AdopDJ;;AcrpDE;EACE,uCAAA;AdwpDJ;;AczpDE;EACE,uCAAA;Ad4pDJ;;Ac7pDE;EACE,uCAAA;AdgqDJ;;AcjqDE;EACE,uCAAA;AdoqDJ;;AcrqDE;EACE,uCAAA;AdwqDJ;;AczqDE;EACE,uCAAA;Ad4qDJ;;Ac7qDE;EACE,uCAAA;AdgrDJ;;AcjrDE;EACE,wCAAA;AdorDJ;;AcrrDE;EACE,wCAAA;AdwrDJ;;AczrDE;EACE,wCAAA;Ad4rDJ;;Ac7rDE;EACE,wCAAA;AdgsDJ;;AcjsDE;EACE,wCAAA;AdosDJ;;AcrsDE;EACE,wCAAA;AdwsDJ;;AczsDE;EACE,wCAAA;Ad4sDJ;;Ac7sDE;EACE,wCAAA;AdgtDJ;;AcjtDE;EACE,wCAAA;AdotDJ;;AcrtDE;EACE,wCAAA;AdwtDJ;;AcztDE;EACE,wCAAA;Ad4tDJ;;Ac7tDE;EACE,wCAAA;AdguDJ;;AcjuDE;EACE,wCAAA;AdouDJ;;AcruDE;EACE,wCAAA;AdwuDJ;;AczuDE;EACE,wCAAA;Ad4uDJ;;Ac7uDE;EACE,wCAAA;AdgvDJ;;AcjvDE;EACE,wCAAA;AdovDJ;;AcrvDE;EACE,wCAAA;AdwvDJ;;AczvDE;EACE,wCAAA;Ad4vDJ;;Ac7vDE;EACE,wCAAA;AdgwDJ;;AcjwDE;EACE,wCAAA;AdowDJ;;AcrwDE;EACE,wCAAA;AdwwDJ;;AczwDE;EACE,wCAAA;Ad4wDJ;;Ac7wDE;EACE,wCAAA;AdgxDJ;;AcjxDE;EACE,wCAAA;AdoxDJ;;AcrxDE;EACE,wCAAA;AdwxDJ;;AczxDE;EACE,wCAAA;Ad4xDJ;;Ac7xDE;EACE,yCAAA;AdgyDJ;;AcjyDE;EACE,yCAAA;AdoyDJ;;AcryDE;EACE,yCAAA;AdwyDJ;;AczyDE;EACE,yCAAA;Ad4yDJ;;Ac7yDE;EACE,yCAAA;AdgzDJ;;Ac3yDE;EACE,sCAAA;Ad8yDJ;;Ac/yDE;EACE,sCAAA;AdkzDJ;;AcnzDE;EACE,sCAAA;AdszDJ;;AcvzDE;EACE,sCAAA;Ad0zDJ;;Ac3zDE;EACE,sCAAA;Ad8zDJ;;Ac/zDE;EACE,sCAAA;Adk0DJ;;Acn0DE;EACE,sCAAA;Ads0DJ;;Acv0DE;EACE,sCAAA;Ad00DJ;;Ac30DE;EACE,uCAAA;Ad80DJ;;Ac/0DE;EACE,uCAAA;Adk1DJ;;Acn1DE;EACE,uCAAA;Ads1DJ;;Acv1DE;EACE,uCAAA;Ad01DJ;;Ac31DE;EACE,uCAAA;Ad81DJ;;Ac/1DE;EACE,uCAAA;Adk2DJ;;Acn2DE;EACE,uCAAA;Ads2DJ;;Acv2DE;EACE,uCAAA;Ad02DJ;;Ac32DE;EACE,uCAAA;Ad82DJ;;Ac/2DE;EACE,uCAAA;Adk3DJ;;Acn3DE;EACE,uCAAA;Ads3DJ;;Acv3DE;EACE,uCAAA;Ad03DJ;;Ac33DE;EACE,uCAAA;Ad83DJ;;Ac/3DE;EACE,uCAAA;Adk4DJ;;Acn4DE;EACE,uCAAA;Ads4DJ;;Acv4DE;EACE,uCAAA;Ad04DJ;;Ac34DE;EACE,uCAAA;Ad84DJ;;Ac/4DE;EACE,uCAAA;Adk5DJ;;Acn5DE;EACE,uCAAA;Ads5DJ;;Acv5DE;EACE,uCAAA;Ad05DJ;;Ac35DE;EACE,uCAAA;Ad85DJ;;Ac/5DE;EACE,uCAAA;Adk6DJ;;Acn6DE;EACE,uCAAA;Ads6DJ;;Acv6DE;EACE,uCAAA;Ad06DJ;;Ac36DE;EACE,uCAAA;Ad86DJ;;Ac/6DE;EACE,uCAAA;Adk7DJ;;Acn7DE;EACE,uCAAA;Ads7DJ;;Acv7DE;EACE,wCAAA;Ad07DJ;;Ac37DE;EACE,wCAAA;Ad87DJ;;Ac/7DE;EACE,wCAAA;Adk8DJ;;Acn8DE;EACE,wCAAA;Ads8DJ;;Acv8DE;EACE,wCAAA;Ad08DJ;;Acr8DE;EACE,6CAAA;Adw8DJ;;Acz8DE;EACE,6CAAA;Ad48DJ;;Ac78DE;EACE,6CAAA;Adg9DJ;;Acj9DE;EACE,6CAAA;Ado9DJ;;Acr9DE;EACE,6CAAA;Adw9DJ;;Acz9DE;EACE,6CAAA;Ad49DJ;;Ac79DE;EACE,6CAAA;Adg+DJ;;Acj+DE;EACE,6CAAA;Ado+DJ;;Acr+DE;EACE,8CAAA;Adw+DJ;;Acz+DE;EACE,8CAAA;Ad4+DJ;;Ac7+DE;EACE,8CAAA;Adg/DJ;;Acj/DE;EACE,8CAAA;Ado/DJ;;Acr/DE;EACE,8CAAA;Adw/DJ;;Acz/DE;EACE,8CAAA;Ad4/DJ;;Ac7/DE;EACE,8CAAA;AdggEJ;;AcjgEE;EACE,8CAAA;AdogEJ;;AcrgEE;EACE,8CAAA;AdwgEJ;;AczgEE;EACE,8CAAA;Ad4gEJ;;Ac7gEE;EACE,8CAAA;AdghEJ;;AcjhEE;EACE,8CAAA;AdohEJ;;AcrhEE;EACE,8CAAA;AdwhEJ;;AczhEE;EACE,8CAAA;Ad4hEJ;;Ac7hEE;EACE,8CAAA;AdgiEJ;;AcjiEE;EACE,8CAAA;AdoiEJ;;AcriEE;EACE,8CAAA;AdwiEJ;;AcziEE;EACE,8CAAA;Ad4iEJ;;Ac7iEE;EACE,8CAAA;AdgjEJ;;AcjjEE;EACE,8CAAA;AdojEJ;;AcrjEE;EACE,8CAAA;AdwjEJ;;AczjEE;EACE,8CAAA;Ad4jEJ;;Ac7jEE;EACE,8CAAA;AdgkEJ;;AcjkEE;EACE,8CAAA;AdokEJ;;AcrkEE;EACE,8CAAA;AdwkEJ;;AczkEE;EACE,8CAAA;Ad4kEJ;;Ac7kEE;EACE,8CAAA;AdglEJ;;AcjlEE;EACE,+CAAA;AdolEJ;;AcrlEE;EACE,+CAAA;AdwlEJ;;AczlEE;EACE,+CAAA;Ad4lEJ;;Ac7lEE;EACE,+CAAA;AdgmEJ;;AcjmEE;EACE,+CAAA;AdomEJ;;Ac/lEE;EACE,2CAAA;AdkmEJ;;AcnmEE;EACE,2CAAA;AdsmEJ;;AcvmEE;EACE,2CAAA;Ad0mEJ;;Ac3mEE;EACE,2CAAA;Ad8mEJ;;Ac/mEE;EACE,2CAAA;AdknEJ;;AcnnEE;EACE,2CAAA;AdsnEJ;;AcvnEE;EACE,2CAAA;Ad0nEJ;;Ac3nEE;EACE,2CAAA;Ad8nEJ;;Ac/nEE;EACE,4CAAA;AdkoEJ;;AcnoEE;EACE,4CAAA;AdsoEJ;;AcvoEE;EACE,4CAAA;Ad0oEJ;;Ac3oEE;EACE,4CAAA;Ad8oEJ;;Ac/oEE;EACE,4CAAA;AdkpEJ;;AcnpEE;EACE,4CAAA;AdspEJ;;AcvpEE;EACE,4CAAA;Ad0pEJ;;Ac3pEE;EACE,4CAAA;Ad8pEJ;;Ac/pEE;EACE,4CAAA;AdkqEJ;;AcnqEE;EACE,4CAAA;AdsqEJ;;AcvqEE;EACE,4CAAA;Ad0qEJ;;Ac3qEE;EACE,4CAAA;Ad8qEJ;;Ac/qEE;EACE,4CAAA;AdkrEJ;;AcnrEE;EACE,4CAAA;AdsrEJ;;AcvrEE;EACE,4CAAA;Ad0rEJ;;Ac3rEE;EACE,4CAAA;Ad8rEJ;;Ac/rEE;EACE,4CAAA;AdksEJ;;AcnsEE;EACE,4CAAA;AdssEJ;;AcvsEE;EACE,4CAAA;Ad0sEJ;;Ac3sEE;EACE,4CAAA;Ad8sEJ;;Ac/sEE;EACE,4CAAA;AdktEJ;;AcntEE;EACE,4CAAA;AdstEJ;;AcvtEE;EACE,4CAAA;Ad0tEJ;;Ac3tEE;EACE,4CAAA;Ad8tEJ;;Ac/tEE;EACE,4CAAA;AdkuEJ;;AcnuEE;EACE,4CAAA;AdsuEJ;;AcvuEE;EACE,4CAAA;Ad0uEJ;;Ac3uEE;EACE,6CAAA;Ad8uEJ;;Ac/uEE;EACE,6CAAA;AdkvEJ;;AcnvEE;EACE,6CAAA;AdsvEJ;;AcvvEE;EACE,6CAAA;Ad0vEJ;;Ac3vEE;EACE,6CAAA;Ad8vEJ;;AczvEE;EACE,4CAAA;Ad4vEJ;;Ac7vEE;EACE,4CAAA;AdgwEJ;;AcjwEE;EACE,4CAAA;AdowEJ;;AcrwEE;EACE,4CAAA;AdwwEJ;;AczwEE;EACE,4CAAA;Ad4wEJ;;Ac7wEE;EACE,4CAAA;AdgxEJ;;AcjxEE;EACE,4CAAA;AdoxEJ;;AcrxEE;EACE,4CAAA;AdwxEJ;;AczxEE;EACE,6CAAA;Ad4xEJ;;Ac7xEE;EACE,6CAAA;AdgyEJ;;AcjyEE;EACE,6CAAA;AdoyEJ;;AcryEE;EACE,6CAAA;AdwyEJ;;AczyEE;EACE,6CAAA;Ad4yEJ;;Ac7yEE;EACE,6CAAA;AdgzEJ;;AcjzEE;EACE,6CAAA;AdozEJ;;AcrzEE;EACE,6CAAA;AdwzEJ;;AczzEE;EACE,6CAAA;Ad4zEJ;;Ac7zEE;EACE,6CAAA;Adg0EJ;;Acj0EE;EACE,6CAAA;Ado0EJ;;Acr0EE;EACE,6CAAA;Adw0EJ;;Acz0EE;EACE,6CAAA;Ad40EJ;;Ac70EE;EACE,6CAAA;Adg1EJ;;Acj1EE;EACE,6CAAA;Ado1EJ;;Acr1EE;EACE,6CAAA;Adw1EJ;;Acz1EE;EACE,6CAAA;Ad41EJ;;Ac71EE;EACE,6CAAA;Adg2EJ;;Acj2EE;EACE,6CAAA;Ado2EJ;;Acr2EE;EACE,6CAAA;Adw2EJ;;Acz2EE;EACE,6CAAA;Ad42EJ;;Ac72EE;EACE,6CAAA;Adg3EJ;;Acj3EE;EACE,6CAAA;Ado3EJ;;Acr3EE;EACE,6CAAA;Adw3EJ;;Acz3EE;EACE,6CAAA;Ad43EJ;;Ac73EE;EACE,6CAAA;Adg4EJ;;Acj4EE;EACE,6CAAA;Ado4EJ;;Acr4EE;EACE,8CAAA;Adw4EJ;;Acz4EE;EACE,8CAAA;Ad44EJ;;Ac74EE;EACE,8CAAA;Adg5EJ;;Acj5EE;EACE,8CAAA;Ado5EJ;;Acr5EE;EACE,8CAAA;Adw5EJ;;Acn5EE;EACE,0CAAA;Ads5EJ;;Acv5EE;EACE,0CAAA;Ad05EJ;;Ac35EE;EACE,0CAAA;Ad85EJ;;Ac/5EE;EACE,0CAAA;Adk6EJ;;Acn6EE;EACE,0CAAA;Ads6EJ;;Acv6EE;EACE,0CAAA;Ad06EJ;;Ac36EE;EACE,0CAAA;Ad86EJ;;Ac/6EE;EACE,0CAAA;Adk7EJ;;Acn7EE;EACE,2CAAA;Ads7EJ;;Acv7EE;EACE,2CAAA;Ad07EJ;;Ac37EE;EACE,2CAAA;Ad87EJ;;Ac/7EE;EACE,2CAAA;Adk8EJ;;Acn8EE;EACE,2CAAA;Ads8EJ;;Acv8EE;EACE,2CAAA;Ad08EJ;;Ac38EE;EACE,2CAAA;Ad88EJ;;Ac/8EE;EACE,2CAAA;Adk9EJ;;Acn9EE;EACE,2CAAA;Ads9EJ;;Acv9EE;EACE,2CAAA;Ad09EJ;;Ac39EE;EACE,2CAAA;Ad89EJ;;Ac/9EE;EACE,2CAAA;Adk+EJ;;Acn+EE;EACE,2CAAA;Ads+EJ;;Acv+EE;EACE,2CAAA;Ad0+EJ;;Ac3+EE;EACE,2CAAA;Ad8+EJ;;Ac/+EE;EACE,2CAAA;Adk/EJ;;Acn/EE;EACE,2CAAA;Ads/EJ;;Acv/EE;EACE,2CAAA;Ad0/EJ;;Ac3/EE;EACE,2CAAA;Ad8/EJ;;Ac//EE;EACE,2CAAA;AdkgFJ;;AcngFE;EACE,2CAAA;AdsgFJ;;AcvgFE;EACE,2CAAA;Ad0gFJ;;Ac3gFE;EACE,2CAAA;Ad8gFJ;;Ac/gFE;EACE,2CAAA;AdkhFJ;;AcnhFE;EACE,2CAAA;AdshFJ;;AcvhFE;EACE,2CAAA;Ad0hFJ;;Ac3hFE;EACE,2CAAA;Ad8hFJ;;Ac/hFE;EACE,4CAAA;AdkiFJ;;AcniFE;EACE,4CAAA;AdsiFJ;;AcviFE;EACE,4CAAA;Ad0iFJ;;Ac3iFE;EACE,4CAAA;Ad8iFJ;;Ac/iFE;EACE,4CAAA;AdkjFJ;;Ac7iFA;EACE,gCAAA;AdgjFF;;Ac7iFA;EACE,8BAAA;AdgjFF;;Ac7iFA;EACE,iCAAA;AdgjFF;;Ac7iFA;EACE,+BAAA;AdgjFF;;Ac7iFA;EACE,mCAAA;EACA,iCAAA;AdgjFF;Ac/iFE;EAHF;IAII,mCAAA;IACA,iCAAA;EdkjFF;AACF;AcjjFE;EAPF;IAQI,oCAAA;IACA,kCAAA;EdojFF;AACF;;AcljFA;EACI,mCAAA;AdqjFJ;AcpjFI;EAFJ;IAGI,mCAAA;EdujFF;AACF;ActjFI;EALJ;IAMI,oCAAA;EdyjFF;AACF;;AcvjFA;EACI,iCAAA;Ad0jFJ;AczjFI;EAFJ;IAGI,iCAAA;Ed4jFF;AACF;Ac3jFI;EALJ;IAMI,kCAAA;Ed8jFF;AACF;;Ac5jFA;EACI,mCAAA;EACA,iCAAA;Ad+jFJ;Ac9jFI;EAHJ;IAII,mCAAA;IACA,iCAAA;EdikFF;AACF;AchkFI;EAPJ;IAQI,mCAAA;IACA,iCAAA;EdmkFF;AACF;;AcjkFA;EACI,mCAAA;AdokFJ;AcnkFI;EAFJ;IAGI,mCAAA;EdskFF;AACF;AcrkFI;EALJ;IAMI,mCAAA;EdwkFF;AACF;;ActkFE;EACE,iCAAA;AdykFJ;AcxkFI;EAFF;IAGE,iCAAA;Ed2kFF;AACF;Ac1kFI;EALF;IAME,iCAAA;Ed6kFF;AACF;;Ac5kFC,iFAAA;ACvHD,oFAAA;AAEE;EACE,iCAAA;AfssFJ;;AevsFE;EACE,iCAAA;Af0sFJ;;Ae3sFE;EACE,iCAAA;Af8sFJ;;Ae/sFE;EACE,iCAAA;AfktFJ;;AentFE;EACE,iCAAA;AfstFJ;;AevtFE;EACE,iCAAA;Af0tFJ;;Ae3tFE;EACE,iCAAA;Af8tFJ;;Ae/tFE;EACE,iCAAA;AfkuFJ;;AenuFE;EACE,kCAAA;AfsuFJ;;AevuFE;EACE,kCAAA;Af0uFJ;;Ae3uFE;EACE,kCAAA;Af8uFJ;;Ae/uFE;EACE,kCAAA;AfkvFJ;;AenvFE;EACE,kCAAA;AfsvFJ;;AevvFE;EACE,kCAAA;Af0vFJ;;Ae3vFE;EACE,kCAAA;Af8vFJ;;Ae/vFE;EACE,kCAAA;AfkwFJ;;AenwFE;EACE,kCAAA;AfswFJ;;AevwFE;EACE,kCAAA;Af0wFJ;;Ae3wFE;EACE,kCAAA;Af8wFJ;;Ae/wFE;EACE,kCAAA;AfkxFJ;;AenxFE;EACE,kCAAA;AfsxFJ;;AevxFE;EACE,kCAAA;Af0xFJ;;Ae3xFE;EACE,kCAAA;Af8xFJ;;Ae/xFE;EACE,kCAAA;AfkyFJ;;AenyFE;EACE,kCAAA;AfsyFJ;;AevyFE;EACE,kCAAA;Af0yFJ;;Ae3yFE;EACE,kCAAA;Af8yFJ;;Ae/yFE;EACE,kCAAA;AfkzFJ;;AenzFE;EACE,kCAAA;AfszFJ;;AevzFE;EACE,kCAAA;Af0zFJ;;Ae3zFE;EACE,kCAAA;Af8zFJ;;Ae/zFE;EACE,kCAAA;Afk0FJ;;Aen0FE;EACE,kCAAA;Afs0FJ;;Aev0FE;EACE,kCAAA;Af00FJ;;Ae30FE;EACE,kCAAA;Af80FJ;;Ae/0FE;EACE,mCAAA;Afk1FJ;;Aen1FE;EACE,mCAAA;Afs1FJ;;Aev1FE;EACE,mCAAA;Af01FJ;;Ae31FE;EACE,mCAAA;Af81FJ;;Ae/1FE;EACE,mCAAA;Afk2FJ;;Ae71FE;EACE,wCAAA;Afg2FJ;;Aej2FE;EACE,wCAAA;Afo2FJ;;Aer2FE;EACE,wCAAA;Afw2FJ;;Aez2FE;EACE,wCAAA;Af42FJ;;Ae72FE;EACE,wCAAA;Afg3FJ;;Aej3FE;EACE,wCAAA;Afo3FJ;;Aer3FE;EACE,wCAAA;Afw3FJ;;Aez3FE;EACE,wCAAA;Af43FJ;;Ae73FE;EACE,yCAAA;Afg4FJ;;Aej4FE;EACE,yCAAA;Afo4FJ;;Aer4FE;EACE,yCAAA;Afw4FJ;;Aez4FE;EACE,yCAAA;Af44FJ;;Ae74FE;EACE,yCAAA;Afg5FJ;;Aej5FE;EACE,yCAAA;Afo5FJ;;Aer5FE;EACE,yCAAA;Afw5FJ;;Aez5FE;EACE,yCAAA;Af45FJ;;Ae75FE;EACE,yCAAA;Afg6FJ;;Aej6FE;EACE,yCAAA;Afo6FJ;;Aer6FE;EACE,yCAAA;Afw6FJ;;Aez6FE;EACE,yCAAA;Af46FJ;;Ae76FE;EACE,yCAAA;Afg7FJ;;Aej7FE;EACE,yCAAA;Afo7FJ;;Aer7FE;EACE,yCAAA;Afw7FJ;;Aez7FE;EACE,yCAAA;Af47FJ;;Ae77FE;EACE,yCAAA;Afg8FJ;;Aej8FE;EACE,yCAAA;Afo8FJ;;Aer8FE;EACE,yCAAA;Afw8FJ;;Aez8FE;EACE,yCAAA;Af48FJ;;Ae78FE;EACE,yCAAA;Afg9FJ;;Aej9FE;EACE,yCAAA;Afo9FJ;;Aer9FE;EACE,yCAAA;Afw9FJ;;Aez9FE;EACE,yCAAA;Af49FJ;;Ae79FE;EACE,yCAAA;Afg+FJ;;Aej+FE;EACE,yCAAA;Afo+FJ;;Aer+FE;EACE,yCAAA;Afw+FJ;;Aez+FE;EACE,0CAAA;Af4+FJ;;Ae7+FE;EACE,0CAAA;Afg/FJ;;Aej/FE;EACE,0CAAA;Afo/FJ;;Aer/FE;EACE,0CAAA;Afw/FJ;;Aez/FE;EACE,0CAAA;Af4/FJ;;Aev/FE;EACE,uCAAA;Af0/FJ;;Ae3/FE;EACE,uCAAA;Af8/FJ;;Ae//FE;EACE,uCAAA;AfkgGJ;;AengGE;EACE,uCAAA;AfsgGJ;;AevgGE;EACE,uCAAA;Af0gGJ;;Ae3gGE;EACE,uCAAA;Af8gGJ;;Ae/gGE;EACE,uCAAA;AfkhGJ;;AenhGE;EACE,uCAAA;AfshGJ;;AevhGE;EACE,wCAAA;Af0hGJ;;Ae3hGE;EACE,wCAAA;Af8hGJ;;Ae/hGE;EACE,wCAAA;AfkiGJ;;AeniGE;EACE,wCAAA;AfsiGJ;;AeviGE;EACE,wCAAA;Af0iGJ;;Ae3iGE;EACE,wCAAA;Af8iGJ;;Ae/iGE;EACE,wCAAA;AfkjGJ;;AenjGE;EACE,wCAAA;AfsjGJ;;AevjGE;EACE,wCAAA;Af0jGJ;;Ae3jGE;EACE,wCAAA;Af8jGJ;;Ae/jGE;EACE,wCAAA;AfkkGJ;;AenkGE;EACE,wCAAA;AfskGJ;;AevkGE;EACE,wCAAA;Af0kGJ;;Ae3kGE;EACE,wCAAA;Af8kGJ;;Ae/kGE;EACE,wCAAA;AfklGJ;;AenlGE;EACE,wCAAA;AfslGJ;;AevlGE;EACE,wCAAA;Af0lGJ;;Ae3lGE;EACE,wCAAA;Af8lGJ;;Ae/lGE;EACE,wCAAA;AfkmGJ;;AenmGE;EACE,wCAAA;AfsmGJ;;AevmGE;EACE,wCAAA;Af0mGJ;;Ae3mGE;EACE,wCAAA;Af8mGJ;;Ae/mGE;EACE,wCAAA;AfknGJ;;AennGE;EACE,wCAAA;AfsnGJ;;AevnGE;EACE,wCAAA;Af0nGJ;;Ae3nGE;EACE,wCAAA;Af8nGJ;;Ae/nGE;EACE,wCAAA;AfkoGJ;;AenoGE;EACE,yCAAA;AfsoGJ;;AevoGE;EACE,yCAAA;Af0oGJ;;Ae3oGE;EACE,yCAAA;Af8oGJ;;Ae/oGE;EACE,yCAAA;AfkpGJ;;AenpGE;EACE,yCAAA;AfspGJ;;AejpGE;EACE,8CAAA;AfopGJ;;AerpGE;EACE,8CAAA;AfwpGJ;;AezpGE;EACE,8CAAA;Af4pGJ;;Ae7pGE;EACE,8CAAA;AfgqGJ;;AejqGE;EACE,8CAAA;AfoqGJ;;AerqGE;EACE,8CAAA;AfwqGJ;;AezqGE;EACE,8CAAA;Af4qGJ;;Ae7qGE;EACE,8CAAA;AfgrGJ;;AejrGE;EACE,+CAAA;AforGJ;;AerrGE;EACE,+CAAA;AfwrGJ;;AezrGE;EACE,+CAAA;Af4rGJ;;Ae7rGE;EACE,+CAAA;AfgsGJ;;AejsGE;EACE,+CAAA;AfosGJ;;AersGE;EACE,+CAAA;AfwsGJ;;AezsGE;EACE,+CAAA;Af4sGJ;;Ae7sGE;EACE,+CAAA;AfgtGJ;;AejtGE;EACE,+CAAA;AfotGJ;;AertGE;EACE,+CAAA;AfwtGJ;;AeztGE;EACE,+CAAA;Af4tGJ;;Ae7tGE;EACE,+CAAA;AfguGJ;;AejuGE;EACE,+CAAA;AfouGJ;;AeruGE;EACE,+CAAA;AfwuGJ;;AezuGE;EACE,+CAAA;Af4uGJ;;Ae7uGE;EACE,+CAAA;AfgvGJ;;AejvGE;EACE,+CAAA;AfovGJ;;AervGE;EACE,+CAAA;AfwvGJ;;AezvGE;EACE,+CAAA;Af4vGJ;;Ae7vGE;EACE,+CAAA;AfgwGJ;;AejwGE;EACE,+CAAA;AfowGJ;;AerwGE;EACE,+CAAA;AfwwGJ;;AezwGE;EACE,+CAAA;Af4wGJ;;Ae7wGE;EACE,+CAAA;AfgxGJ;;AejxGE;EACE,+CAAA;AfoxGJ;;AerxGE;EACE,+CAAA;AfwxGJ;;AezxGE;EACE,+CAAA;Af4xGJ;;Ae7xGE;EACE,gDAAA;AfgyGJ;;AejyGE;EACE,gDAAA;AfoyGJ;;AeryGE;EACE,gDAAA;AfwyGJ;;AezyGE;EACE,gDAAA;Af4yGJ;;Ae7yGE;EACE,gDAAA;AfgzGJ;;Ae3yGE;EACE,4CAAA;Af8yGJ;;Ae/yGE;EACE,4CAAA;AfkzGJ;;AenzGE;EACE,4CAAA;AfszGJ;;AevzGE;EACE,4CAAA;Af0zGJ;;Ae3zGE;EACE,4CAAA;Af8zGJ;;Ae/zGE;EACE,4CAAA;Afk0GJ;;Aen0GE;EACE,4CAAA;Afs0GJ;;Aev0GE;EACE,4CAAA;Af00GJ;;Ae30GE;EACE,6CAAA;Af80GJ;;Ae/0GE;EACE,6CAAA;Afk1GJ;;Aen1GE;EACE,6CAAA;Afs1GJ;;Aev1GE;EACE,6CAAA;Af01GJ;;Ae31GE;EACE,6CAAA;Af81GJ;;Ae/1GE;EACE,6CAAA;Afk2GJ;;Aen2GE;EACE,6CAAA;Afs2GJ;;Aev2GE;EACE,6CAAA;Af02GJ;;Ae32GE;EACE,6CAAA;Af82GJ;;Ae/2GE;EACE,6CAAA;Afk3GJ;;Aen3GE;EACE,6CAAA;Afs3GJ;;Aev3GE;EACE,6CAAA;Af03GJ;;Ae33GE;EACE,6CAAA;Af83GJ;;Ae/3GE;EACE,6CAAA;Afk4GJ;;Aen4GE;EACE,6CAAA;Afs4GJ;;Aev4GE;EACE,6CAAA;Af04GJ;;Ae34GE;EACE,6CAAA;Af84GJ;;Ae/4GE;EACE,6CAAA;Afk5GJ;;Aen5GE;EACE,6CAAA;Afs5GJ;;Aev5GE;EACE,6CAAA;Af05GJ;;Ae35GE;EACE,6CAAA;Af85GJ;;Ae/5GE;EACE,6CAAA;Afk6GJ;;Aen6GE;EACE,6CAAA;Afs6GJ;;Aev6GE;EACE,6CAAA;Af06GJ;;Ae36GE;EACE,6CAAA;Af86GJ;;Ae/6GE;EACE,6CAAA;Afk7GJ;;Aen7GE;EACE,6CAAA;Afs7GJ;;Aev7GE;EACE,8CAAA;Af07GJ;;Ae37GE;EACE,8CAAA;Af87GJ;;Ae/7GE;EACE,8CAAA;Afk8GJ;;Aen8GE;EACE,8CAAA;Afs8GJ;;Aev8GE;EACE,8CAAA;Af08GJ;;Aer8GE;EACE,6CAAA;Afw8GJ;;Aez8GE;EACE,6CAAA;Af48GJ;;Ae78GE;EACE,6CAAA;Afg9GJ;;Aej9GE;EACE,6CAAA;Afo9GJ;;Aer9GE;EACE,6CAAA;Afw9GJ;;Aez9GE;EACE,6CAAA;Af49GJ;;Ae79GE;EACE,6CAAA;Afg+GJ;;Aej+GE;EACE,6CAAA;Afo+GJ;;Aer+GE;EACE,8CAAA;Afw+GJ;;Aez+GE;EACE,8CAAA;Af4+GJ;;Ae7+GE;EACE,8CAAA;Afg/GJ;;Aej/GE;EACE,8CAAA;Afo/GJ;;Aer/GE;EACE,8CAAA;Afw/GJ;;Aez/GE;EACE,8CAAA;Af4/GJ;;Ae7/GE;EACE,8CAAA;AfggHJ;;AejgHE;EACE,8CAAA;AfogHJ;;AergHE;EACE,8CAAA;AfwgHJ;;AezgHE;EACE,8CAAA;Af4gHJ;;Ae7gHE;EACE,8CAAA;AfghHJ;;AejhHE;EACE,8CAAA;AfohHJ;;AerhHE;EACE,8CAAA;AfwhHJ;;AezhHE;EACE,8CAAA;Af4hHJ;;Ae7hHE;EACE,8CAAA;AfgiHJ;;AejiHE;EACE,8CAAA;AfoiHJ;;AeriHE;EACE,8CAAA;AfwiHJ;;AeziHE;EACE,8CAAA;Af4iHJ;;Ae7iHE;EACE,8CAAA;AfgjHJ;;AejjHE;EACE,8CAAA;AfojHJ;;AerjHE;EACE,8CAAA;AfwjHJ;;AezjHE;EACE,8CAAA;Af4jHJ;;Ae7jHE;EACE,8CAAA;AfgkHJ;;AejkHE;EACE,8CAAA;AfokHJ;;AerkHE;EACE,8CAAA;AfwkHJ;;AezkHE;EACE,8CAAA;Af4kHJ;;Ae7kHE;EACE,8CAAA;AfglHJ;;AejlHE;EACE,+CAAA;AfolHJ;;AerlHE;EACE,+CAAA;AfwlHJ;;AezlHE;EACE,+CAAA;Af4lHJ;;Ae7lHE;EACE,+CAAA;AfgmHJ;;AejmHE;EACE,+CAAA;AfomHJ;;Ae/lHE;EACE,2CAAA;AfkmHJ;;AenmHE;EACE,2CAAA;AfsmHJ;;AevmHE;EACE,2CAAA;Af0mHJ;;Ae3mHE;EACE,2CAAA;Af8mHJ;;Ae/mHE;EACE,2CAAA;AfknHJ;;AennHE;EACE,2CAAA;AfsnHJ;;AevnHE;EACE,2CAAA;Af0nHJ;;Ae3nHE;EACE,2CAAA;Af8nHJ;;Ae/nHE;EACE,4CAAA;AfkoHJ;;AenoHE;EACE,4CAAA;AfsoHJ;;AevoHE;EACE,4CAAA;Af0oHJ;;Ae3oHE;EACE,4CAAA;Af8oHJ;;Ae/oHE;EACE,4CAAA;AfkpHJ;;AenpHE;EACE,4CAAA;AfspHJ;;AevpHE;EACE,4CAAA;Af0pHJ;;Ae3pHE;EACE,4CAAA;Af8pHJ;;Ae/pHE;EACE,4CAAA;AfkqHJ;;AenqHE;EACE,4CAAA;AfsqHJ;;AevqHE;EACE,4CAAA;Af0qHJ;;Ae3qHE;EACE,4CAAA;Af8qHJ;;Ae/qHE;EACE,4CAAA;AfkrHJ;;AenrHE;EACE,4CAAA;AfsrHJ;;AevrHE;EACE,4CAAA;Af0rHJ;;Ae3rHE;EACE,4CAAA;Af8rHJ;;Ae/rHE;EACE,4CAAA;AfksHJ;;AensHE;EACE,4CAAA;AfssHJ;;AevsHE;EACE,4CAAA;Af0sHJ;;Ae3sHE;EACE,4CAAA;Af8sHJ;;Ae/sHE;EACE,4CAAA;AfktHJ;;AentHE;EACE,4CAAA;AfstHJ;;AevtHE;EACE,4CAAA;Af0tHJ;;Ae3tHE;EACE,4CAAA;Af8tHJ;;Ae/tHE;EACE,4CAAA;AfkuHJ;;AenuHE;EACE,4CAAA;AfsuHJ;;AevuHE;EACE,4CAAA;Af0uHJ;;Ae3uHE;EACE,6CAAA;Af8uHJ;;Ae/uHE;EACE,6CAAA;AfkvHJ;;AenvHE;EACE,6CAAA;AfsvHJ;;AevvHE;EACE,6CAAA;Af0vHJ;;Ae3vHE;EACE,6CAAA;Af8vHJ;;Ae1vHA;EACE,aAAA;Af6vHF;;Ae1vHA;EACE,gDAAA;Af6vHF;;Ae1vHA;EACE,iCAAA;Af6vHF;;Ae1vHA;EACE,+BAAA;Af6vHF;;Ae1vHA;EACE,kCAAA;Af6vHF;;Ae1vHA;EACE,gCAAA;Af6vHF;;AezvHA;EACE,oCAAA;EACA,kCAAA;Af4vHF;Ae3vHE;EAHF;IAII,oCAAA;IACA,kCAAA;Ef8vHF;AACF;Ae7vHE;EAPF;IAQI,oCAAA;IACA,kCAAA;EfgwHF;AACF;Ae/vHE;EAXF;IAYI,qCAAA;IACA,mCAAA;EfkwHF;AACF;;Ae9vHA;EACE,oCAAA;EACA,kCAAA;AfiwHF;AehwHE;EAHF;IAII,oCAAA;IACA,kCAAA;EfmwHF;AACF;;AejwHA;EACI,oCAAA;AfowHJ;AenwHI;EAFJ;IAGI,oCAAA;EfswHF;AACF;;AepwHA;EACI,kCAAA;AfuwHJ;AetwHI;EAFJ;IAGI,kCAAA;EfywHF;AACF;;AetwHA;EACI,oCAAA;EACA,kCAAA;AfywHJ;AexwHI;EAHJ;IAII,oCAAA;IACA,kCAAA;Ef2wHF;AACF;Ae1wHI;EAPJ;IAQI,oCAAA;IACA,kCAAA;Ef6wHF;AACF;;Ae3wHA;EACI,oCAAA;Af8wHJ;Ae7wHI;EAFJ;IAGI,oCAAA;EfgxHF;AACF;Ae/wHI;EALJ;IAMI,oCAAA;EfkxHF;AACF;;AehxHE;EACE,kCAAA;AfmxHJ;AelxHI;EAFF;IAGE,kCAAA;EfqxHF;AACF;AepxHI;EALF;IAME,kCAAA;EfuxHF;AACF;;AerxHA,kFAAA;ACxIA,oFAAA;AACA,uBAAA;AAEI;EAEI,oCAAA;AhB+5HR;AgB75HI;EACI,gDAAA;AhB+5HR;AgB75HI;EACI,kDAAA;AhB+5HR;AgB75HI;EACI,2CAAA;AhB+5HR;;AgB35HA;EACI,iBAAA;AhB85HJ;;AgB35HA,8BAAA;AAEI;EADJ;IAEQ,UAAA;EhB85HN;AACF;;AgB35HA;EACI;IACI,wBAAA;EhB85HN;AACF;AgB15HI;EACI,wBAAA;AhB45HR;;AgBx5HA,eAAA;AAEI;EACI,uBAAA;AhB05HR;AgBx5HI;EACI,uBAAA;AhB05HR;AgBx5HI;EACI,uBAAA;AhB05HR;;AgBt5HA;EACI,6BAAA;AhBy5HJ;;AgBv5HA;EACI,6BAAA;AhB05HJ;;AgBv5HA;EACI,sBAAA;AhB05HJ;;AgBt5HI;EACI,gCAAA;AhBy5HR;AgBv5HI;EACI,mCAAA;AhBy5HR;AgBv5HI;EACI,mCAAA;AhBy5HR;AgBv5HI;EACI,8BAAA;AhBy5HR;AgBv5HI;EACI,iCAAA;AhBy5HR;AgBv5HI;EACI,+BAAA;AhBy5HR;AgBv5HI;EACI,6BAAA;AhBy5HR;;AgBp5HI;EACI,mCAAA;AhBu5HR;;AgBl5HI;EACI,iCAAA;AhBq5HR;;AgBh5HI;EACI,cAAA;AhBm5HR;AgBj5HI;EACI,cAAA;AhBm5HR;AgBj5HI;EACI,iBAAA;AhBm5HR;;AgB/4HA,eAAA;AAGQ;EACI,0BAAA;AhBg5HZ;AgB54HQ;EACI,qBAAA;AhB84HZ;;AgBx4HI;EACI,gCAAA;AhB24HR;AgBz4HI;EACI,oCAAA;AhB24HR;AgBz4HI;EACI,qCAAA;AhB24HR;AgBz4HI;EACI,6BAAA;AhB24HR;;AgBv4HA,iBAAA;AACA;EACI,iCAAA;EACA,uCAAA;EACA,6CAAA;EACA,WAAA;EACA,YAAA;AhB04HJ;;AgBv4HA;EACI,6BAAA;AhB04HJ;;AgBx4HA;EACI,eAAA;AhB24HJ;;AgBz4HA;EACI,eAAA;AhB44HJ;;AgBx4HA;EACI,2BAAA;EACA,kDAAA;EACA,uBAAA;AhB24HJ;AgB14HI;EACI,qBAAA;AhB44HR;;AgBz4HA;EACI,yBAAA;AhB44HJ;;AgBx4HI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,uFAAA;EACA,WAAA;AhB24HR;AgBx4HQ;EACI,mLAAA;EACA,UAAA;AhB04HZ;;AgBr4HA;EACI,oCAAA;AhBw4HJ;;AgBr4HA;EACI,wEAAA;AhBw4HJ;;AgBr4HA;EACI,UAAA;AhBw4HJ;;AgBn4HQ;EACI,mCAAA;AhBs4HZ;;AgBl4HA,kFAAA;ACpNA,2EAAA;AACA,oBAAA;AACE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AjB0lIJ;;AiBxlIA,2BAAA;AACE;EACE,aAAA;EACA,mBAAA;AjB2lIJ;;AiBzlIE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AjB4lIJ;;AiB1lIE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AjB6lIJ;;AiB3lIA,yBAAA;AACA,yEAAA;ACtBI;EACE,0BAAA;AlBqnIN;;AkBtnII;EACE,2BAAA;AlBynIN;;AkB1nII;EACE,yBAAA;AlB6nIN;;AkB9nII;EACE,2BAAA;AlBioIN;;AkBloII;EACE,0BAAA;AlBqoIN;;AkBtoII;EACE,2BAAA;AlByoIN;;AkB1oII;EACE,wBAAA;AlB6oIN;;AkB9oII;EACE,2BAAA;AlBipIN;;AkBlpII;EACE,0BAAA;AlBqpIN;;AkBtpII;EACE,2BAAA;AlBypIN;;AkB1pII;EACE,yBAAA;AlB6pIN;;AkB9pII;EACE,2BAAA;AlBiqIN;;AkBlqII;EACE,0BAAA;AlBqqIN;;AkBtqII;EACE,sBAAA;AlByqIN;;AkB1qII;EACE,0BAAA;AlB6qIN;;AkB9qII;EACE,yBAAA;AlBirIN;;AkBlrII;EACE,0BAAA;AlBqrIN;;AkBtrII;EACE,wBAAA;AlByrIN;;AkB1rII;EACE,0BAAA;AlB6rIN;;AkB9rII;EACE,yBAAA;AlBisIN;;AkBlsII;EACE,0BAAA;AlBqsIN;;AkBtsII;EACE,sBAAA;AlBysIN;;AkB1sII;EACE,sBAAA;AlB6sIN;;AkB9sII;EACE,wBAAA;AlBitIN;;AkBltII;EACE,yBAAA;AlBqtIN;;AkBttII;EACE,sBAAA;AlBytIN;;AkB1tII;EACE,yBAAA;AlB6tIN;;AkB9tII;EACE,wBAAA;AlBiuIN;;AkBluII;EACE,yBAAA;AlBquIN;;AkBtuII;EACE,sBAAA;AlByuIN;;AkB1uII;EACE,yBAAA;AlB6uIN;;AkB9uII;EACE,wBAAA;AlBivIN;;AkBlvII;EACE,yBAAA;AlBqvIN;;AkBtvII;EACE,sBAAA;AlByvIN;;AkB1vII;EACE,0BAAA;AlB6vIN;;AkB9vII;EACE,0BAAA;AlBiwIN;;AkBlwII;EACE,wBAAA;AlBqwIN;;AkBtwII;EACE,sBAAA;AlBywIN;;AkB1wII;EACE,uBAAA;AlB6wIN;;AkB9wII;EACE,2BAAA;AlBixIN;;AkB5wIE;EACE,uBAAA;AlB+wIJ;AkB7wIE;EACE,uBAAA;AlB+wIJ;AkB7wIE;EACE,uBAAA;AlB+wIJ;;AkB1wII;EACE,2BAAA;AlB6wIN;;AkB9wII;EACE,4BAAA;AlBixIN;;AkBlxII;EACE,0BAAA;AlBqxIN;;AkBtxII;EACE,4BAAA;AlByxIN;;AkB1xII;EACE,2BAAA;AlB6xIN;;AkB9xII;EACE,4BAAA;AlBiyIN;;AkBlyII;EACE,yBAAA;AlBqyIN;;AkBtyII;EACE,4BAAA;AlByyIN;;AkB1yII;EACE,2BAAA;AlB6yIN;;AkB9yII;EACE,4BAAA;AlBizIN;;AkBlzII;EACE,0BAAA;AlBqzIN;;AkBtzII;EACE,4BAAA;AlByzIN;;AkB1zII;EACE,2BAAA;AlB6zIN;;AkB9zII;EACE,uBAAA;AlBi0IN;;AkBl0II;EACE,2BAAA;AlBq0IN;;AkBt0II;EACE,0BAAA;AlBy0IN;;AkB10II;EACE,2BAAA;AlB60IN;;AkB90II;EACE,yBAAA;AlBi1IN;;AkBl1II;EACE,2BAAA;AlBq1IN;;AkBt1II;EACE,0BAAA;AlBy1IN;;AkB11II;EACE,2BAAA;AlB61IN;;AkB91II;EACE,uBAAA;AlBi2IN;;AkBl2II;EACE,uBAAA;AlBq2IN;;AkBt2II;EACE,yBAAA;AlBy2IN;;AkB12II;EACE,0BAAA;AlB62IN;;AkB92II;EACE,uBAAA;AlBi3IN;;AkBl3II;EACE,0BAAA;AlBq3IN;;AkBt3II;EACE,yBAAA;AlBy3IN;;AkB13II;EACE,0BAAA;AlB63IN;;AkB93II;EACE,uBAAA;AlBi4IN;;AkBl4II;EACE,0BAAA;AlBq4IN;;AkBt4II;EACE,yBAAA;AlBy4IN;;AkB14II;EACE,0BAAA;AlB64IN;;AkB94II;EACE,uBAAA;AlBi5IN;;AkBl5II;EACE,2BAAA;AlBq5IN;;AkBt5II;EACE,2BAAA;AlBy5IN;;AkB15II;EACE,yBAAA;AlB65IN;;AkB95II;EACE,uBAAA;AlBi6IN;;AkBl6II;EACE,wBAAA;AlBq6IN;;AkBt6II;EACE,4BAAA;AlBy6IN;;AkBt6IA;EACE,wBAAA;AlBy6IF;;AkBr6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;AkBt6IE;EACE,4BAAA;AlBw6IJ;;AkBn6IE;EACE,2BAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,2BAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;AkBp6IE;EACE,gBAAA;AlBs6IJ;;AkBh6IE;EACE,iBAAA;AlBm6IJ;;AkB/5IA;EACE,uBAAA;AlBk6IF;;AkB/5IA;EACE,sBAAA;AlBk6IF;;AmBlgJM;EACE,gCAAA;AnBqgJR;;AmBtgJM;EACE,iCAAA;AnBygJR;;AmB1gJM;EACE,iCAAA;AnB6gJR;;AmB9gJM;EACE,iCAAA;AnBihJR;;AmBlhJM;EACE,iCAAA;AnBqhJR;;AmBthJM;EACE,iCAAA;AnByhJR;;AmB1hJM;EACE,iCAAA;AnB6hJR;;AmB9hJM;EACE,iCAAA;AnBiiJR;;AmBliJM;EACE,iCAAA;AnBqiJR;;AmBtiJM;EACE,iCAAA;AnByiJR;;AmB1iJM;EACE,oCAAA;AnB6iJR;;AmB9iJM;EACE,qCAAA;AnBijJR;;AmBljJM;EACE,qCAAA;AnBqjJR;;AmBtjJM;EACE,qCAAA;AnByjJR;;AmB1jJM;EACE,qCAAA;AnB6jJR;;AmB9jJM;EACE,qCAAA;AnBikJR;;AmBlkJM;EACE,qCAAA;AnBqkJR;;AmBtkJM;EACE,qCAAA;AnBykJR;;AmB1kJM;EACE,qCAAA;AnB6kJR;;AmB9kJM;EACE,qCAAA;AnBilJR;;AmBllJM;EACE,mCAAA;AnBqlJR;;AmBtlJM;EACE,oCAAA;AnBylJR;;AmB1lJM;EACE,oCAAA;AnB6lJR;;AmB9lJM;EACE,oCAAA;AnBimJR;;AmBlmJM;EACE,oCAAA;AnBqmJR;;AmBtmJM;EACE,oCAAA;AnBymJR;;AmB1mJM;EACE,oCAAA;AnB6mJR;;AmB9mJM;EACE,oCAAA;AnBinJR;;AmBlnJM;EACE,oCAAA;AnBqnJR;;AmBtnJM;EACE,oCAAA;AnBynJR;;AmB1nJM;EACE,gCAAA;AnB6nJR;;AmB9nJM;EACE,iCAAA;AnBioJR;;AmBloJM;EACE,iCAAA;AnBqoJR;;AmBtoJM;EACE,iCAAA;AnByoJR;;AmB1oJM;EACE,iCAAA;AnB6oJR;;AmB9oJM;EACE,iCAAA;AnBipJR;;AmBlpJM;EACE,iCAAA;AnBqpJR;;AmBtpJM;EACE,iCAAA;AnBypJR;;AmB1pJM;EACE,iCAAA;AnB6pJR;;AmB9pJM;EACE,iCAAA;AnBiqJR;;AmBlqJM;EACE,iCAAA;AnBqqJR;;AmBtqJM;EACE,kCAAA;AnByqJR;;AmB1qJM;EACE,kCAAA;AnB6qJR;;AmB9qJM;EACE,kCAAA;AnBirJR;;AmBlrJM;EACE,kCAAA;AnBqrJR;;AmBtrJM;EACE,mCAAA;AnByrJR;;AmB1rJM;EACE,oCAAA;AnB6rJR;;AmB9rJM;EACE,oCAAA;AnBisJR;;AmBlsJM;EACE,oCAAA;AnBqsJR;;AmBtsJM;EACE,oCAAA;AnBysJR;;AmB1sJM;EACE,oCAAA;AnB6sJR;;AmB9sJM;EACE,oCAAA;AnBitJR;;AmBltJM;EACE,oCAAA;AnBqtJR;;AmBttJM;EACE,oCAAA;AnBytJR;;AmB1tJM;EACE,oCAAA;AnB6tJR;;AmB9tJM;EACE,kCAAA;AnBiuJR;;AmBluJM;EACE,mCAAA;AnBquJR;;AmBtuJM;EACE,mCAAA;AnByuJR;;AmB1uJM;EACE,mCAAA;AnB6uJR;;AmB9uJM;EACE,mCAAA;AnBivJR;;AmBlvJM;EACE,mCAAA;AnBqvJR;;AmBtvJM;EACE,mCAAA;AnByvJR;;AmB1vJM;EACE,mCAAA;AnB6vJR;;AmB9vJM;EACE,mCAAA;AnBiwJR;;AmBlwJM;EACE,mCAAA;AnBqwJR;;AmBtwJM;EACE,mCAAA;AnBywJR;;AmB1wJM;EACE,oCAAA;AnB6wJR;;AmB9wJM;EACE,oCAAA;AnBixJR;;AmBlxJM;EACE,oCAAA;AnBqxJR;;AmBtxJM;EACE,oCAAA;AnByxJR;;AmB1xJM;EACE,oCAAA;AnB6xJR;;AmB9xJM;EACE,oCAAA;AnBiyJR;;AmBlyJM;EACE,oCAAA;AnBqyJR;;AmBtyJM;EACE,oCAAA;AnByyJR;;AmB1yJM;EACE,oCAAA;AnB6yJR;;AmB9yJM;EACE,mCAAA;AnBizJR;;AmBlzJM;EACE,oCAAA;AnBqzJR;;AmBtzJM;EACE,oCAAA;AnByzJR;;AmB1zJM;EACE,oCAAA;AnB6zJR;;AmB9zJM;EACE,oCAAA;AnBi0JR;;AmBl0JM;EACE,oCAAA;AnBq0JR;;AmBt0JM;EACE,oCAAA;AnBy0JR;;AmB10JM;EACE,oCAAA;AnB60JR;;AmB90JM;EACE,oCAAA;AnBi1JR;;AmBl1JM;EACE,oCAAA;AnBq1JR;;AmBt1JM;EACE,gCAAA;AnBy1JR;;AmB11JM;EACE,iCAAA;AnB61JR;;AmB91JM;EACE,iCAAA;AnBi2JR;;AmBl2JM;EACE,iCAAA;AnBq2JR;;AmBt2JM;EACE,iCAAA;AnBy2JR;;AmB12JM;EACE,iCAAA;AnB62JR;;AmB92JM;EACE,iCAAA;AnBi3JR;;AmBl3JM;EACE,iCAAA;AnBq3JR;;AmBt3JM;EACE,iCAAA;AnBy3JR;;AmB13JM;EACE,iCAAA;AnB63JR;;AmB93JM;EACE,oCAAA;AnBi4JR;;AmBl4JM;EACE,qCAAA;AnBq4JR;;AmBt4JM;EACE,qCAAA;AnBy4JR;;AmBl4JI;EACI,2CAAA;AnBq4JR;AmBn4JI;EACI,wCAAA;AnBq4JR;AmBn4JI;EACI,kCAAA;AnBq4JR;;AmB93JQ;EACI,gCAAA;AnBi4JZ;;AmBl4JQ;EACI,iCAAA;AnBq4JZ;;AmBt4JQ;EACI,iCAAA;AnBy4JZ;;AmB14JQ;EACI,iCAAA;AnB64JZ;;AmB94JQ;EACI,iCAAA;AnBi5JZ;;AmBl5JQ;EACI,iCAAA;AnBq5JZ;;AmBt5JQ;EACI,iCAAA;AnBy5JZ;;AmB15JQ;EACI,iCAAA;AnB65JZ;;AmB95JQ;EACI,iCAAA;AnBi6JZ;;AmBl6JQ;EACI,iCAAA;AnBq6JZ;;AmBt6JQ;EACI,oCAAA;AnBy6JZ;;AmB16JQ;EACI,qCAAA;AnB66JZ;;AmB96JQ;EACI,qCAAA;AnBi7JZ;;AmBl7JQ;EACI,qCAAA;AnBq7JZ;;AmBt7JQ;EACI,qCAAA;AnBy7JZ;;AmB17JQ;EACI,qCAAA;AnB67JZ;;AmB97JQ;EACI,qCAAA;AnBi8JZ;;AmBl8JQ;EACI,qCAAA;AnBq8JZ;;AmBt8JQ;EACI,qCAAA;AnBy8JZ;;AmB18JQ;EACI,qCAAA;AnB68JZ;;AmB98JQ;EACI,mCAAA;AnBi9JZ;;AmBl9JQ;EACI,oCAAA;AnBq9JZ;;AmBt9JQ;EACI,oCAAA;AnBy9JZ;;AmB19JQ;EACI,oCAAA;AnB69JZ;;AmB99JQ;EACI,oCAAA;AnBi+JZ;;AmBl+JQ;EACI,oCAAA;AnBq+JZ;;AmBt+JQ;EACI,oCAAA;AnBy+JZ;;AmB1+JQ;EACI,oCAAA;AnB6+JZ;;AmB9+JQ;EACI,oCAAA;AnBi/JZ;;AmBl/JQ;EACI,oCAAA;AnBq/JZ;;AmBt/JQ;EACI,gCAAA;AnBy/JZ;;AmB1/JQ;EACI,iCAAA;AnB6/JZ;;AmB9/JQ;EACI,iCAAA;AnBigKZ;;AmBlgKQ;EACI,iCAAA;AnBqgKZ;;AmBtgKQ;EACI,iCAAA;AnBygKZ;;AmB1gKQ;EACI,iCAAA;AnB6gKZ;;AmB9gKQ;EACI,iCAAA;AnBihKZ;;AmBlhKQ;EACI,iCAAA;AnBqhKZ;;AmBthKQ;EACI,iCAAA;AnByhKZ;;AmB1hKQ;EACI,iCAAA;AnB6hKZ;;AmB9hKQ;EACI,iCAAA;AnBiiKZ;;AmBliKQ;EACI,kCAAA;AnBqiKZ;;AmBtiKQ;EACI,kCAAA;AnByiKZ;;AmB1iKQ;EACI,kCAAA;AnB6iKZ;;AmB9iKQ;EACI,kCAAA;AnBijKZ;;AmBljKQ;EACI,mCAAA;AnBqjKZ;;AmBtjKQ;EACI,oCAAA;AnByjKZ;;AmB1jKQ;EACI,oCAAA;AnB6jKZ;;AmB9jKQ;EACI,oCAAA;AnBikKZ;;AmBlkKQ;EACI,oCAAA;AnBqkKZ;;AmBtkKQ;EACI,oCAAA;AnBykKZ;;AmB1kKQ;EACI,oCAAA;AnB6kKZ;;AmB9kKQ;EACI,oCAAA;AnBilKZ;;AmBllKQ;EACI,oCAAA;AnBqlKZ;;AmBtlKQ;EACI,oCAAA;AnBylKZ;;AmB1lKQ;EACI,kCAAA;AnB6lKZ;;AmB9lKQ;EACI,mCAAA;AnBimKZ;;AmBlmKQ;EACI,mCAAA;AnBqmKZ;;AmBtmKQ;EACI,mCAAA;AnBymKZ;;AmB1mKQ;EACI,mCAAA;AnB6mKZ;;AmB9mKQ;EACI,mCAAA;AnBinKZ;;AmBlnKQ;EACI,mCAAA;AnBqnKZ;;AmBtnKQ;EACI,mCAAA;AnBynKZ;;AmB1nKQ;EACI,mCAAA;AnB6nKZ;;AmB9nKQ;EACI,mCAAA;AnBioKZ;;AmBloKQ;EACI,mCAAA;AnBqoKZ;;AmBtoKQ;EACI,oCAAA;AnByoKZ;;AmB1oKQ;EACI,oCAAA;AnB6oKZ;;AmB9oKQ;EACI,oCAAA;AnBipKZ;;AmBlpKQ;EACI,oCAAA;AnBqpKZ;;AmBtpKQ;EACI,oCAAA;AnBypKZ;;AmB1pKQ;EACI,oCAAA;AnB6pKZ;;AmB9pKQ;EACI,oCAAA;AnBiqKZ;;AmBlqKQ;EACI,oCAAA;AnBqqKZ;;AmBtqKQ;EACI,oCAAA;AnByqKZ;;AmB1qKQ;EACI,mCAAA;AnB6qKZ;;AmB9qKQ;EACI,oCAAA;AnBirKZ;;AmBlrKQ;EACI,oCAAA;AnBqrKZ;;AmBtrKQ;EACI,oCAAA;AnByrKZ;;AmB1rKQ;EACI,oCAAA;AnB6rKZ;;AmB9rKQ;EACI,oCAAA;AnBisKZ;;AmBlsKQ;EACI,oCAAA;AnBqsKZ;;AmBtsKQ;EACI,oCAAA;AnBysKZ;;AmB1sKQ;EACI,oCAAA;AnB6sKZ;;AmB9sKQ;EACI,oCAAA;AnBitKZ;;AmBltKQ;EACI,gCAAA;AnBqtKZ;;AmBttKQ;EACI,iCAAA;AnBytKZ;;AmB1tKQ;EACI,iCAAA;AnB6tKZ;;AmB9tKQ;EACI,iCAAA;AnBiuKZ;;AmBluKQ;EACI,iCAAA;AnBquKZ;;AmBtuKQ;EACI,iCAAA;AnByuKZ;;AmB1uKQ;EACI,iCAAA;AnB6uKZ;;AmB9uKQ;EACI,iCAAA;AnBivKZ;;AmBlvKQ;EACI,iCAAA;AnBqvKZ;;AmBtvKQ;EACI,iCAAA;AnByvKZ;;AmB1vKQ;EACI,oCAAA;AnB6vKZ;;AmB9vKQ;EACI,qCAAA;AnBiwKZ;;AmBlwKQ;EACI,qCAAA;AnBqwKZ;;AmB/vKA,eAAA;AAGQ;EACI,sBAAA;AnBgwKZ;AmB5vKQ;EACI,2CAAA;AnB8vKZ;AmB1vKQ;EACI,wCAAA;AnB4vKZ;AmBxvKQ;EACI,kCAAA;AnB0vKZ;;AoB3yKM;EACE,uCAAA;ApB8yKR;;AoB/yKM;EACE,wCAAA;ApBkzKR;;AoBnzKM;EACE,wCAAA;ApBszKR;;AoBvzKM;EACE,wCAAA;ApB0zKR;;AoB3zKM;EACE,wCAAA;ApB8zKR;;AoB/zKM;EACE,wCAAA;ApBk0KR;;AoBn0KM;EACE,wCAAA;ApBs0KR;;AoBv0KM;EACE,wCAAA;ApB00KR;;AoB30KM;EACE,wCAAA;ApB80KR;;AoB/0KM;EACE,wCAAA;ApBk1KR;;AoBn1KM;EACE,2CAAA;ApBs1KR;;AoBv1KM;EACE,4CAAA;ApB01KR;;AoB31KM;EACE,4CAAA;ApB81KR;;AoB/1KM;EACE,4CAAA;ApBk2KR;;AoBn2KM;EACE,4CAAA;ApBs2KR;;AoBv2KM;EACE,4CAAA;ApB02KR;;AoB32KM;EACE,4CAAA;ApB82KR;;AoB/2KM;EACE,4CAAA;ApBk3KR;;AoBn3KM;EACE,4CAAA;ApBs3KR;;AoBv3KM;EACE,4CAAA;ApB03KR;;AoB33KM;EACE,0CAAA;ApB83KR;;AoB/3KM;EACE,2CAAA;ApBk4KR;;AoBn4KM;EACE,2CAAA;ApBs4KR;;AoBv4KM;EACE,2CAAA;ApB04KR;;AoB34KM;EACE,2CAAA;ApB84KR;;AoB/4KM;EACE,2CAAA;ApBk5KR;;AoBn5KM;EACE,2CAAA;ApBs5KR;;AoBv5KM;EACE,2CAAA;ApB05KR;;AoB35KM;EACE,2CAAA;ApB85KR;;AoB/5KM;EACE,2CAAA;ApBk6KR;;AoBn6KM;EACE,uCAAA;ApBs6KR;;AoBv6KM;EACE,wCAAA;ApB06KR;;AoB36KM;EACE,wCAAA;ApB86KR;;AoB/6KM;EACE,wCAAA;ApBk7KR;;AoBn7KM;EACE,wCAAA;ApBs7KR;;AoBv7KM;EACE,wCAAA;ApB07KR;;AoB37KM;EACE,wCAAA;ApB87KR;;AoB/7KM;EACE,wCAAA;ApBk8KR;;AoBn8KM;EACE,wCAAA;ApBs8KR;;AoBv8KM;EACE,wCAAA;ApB08KR;;AoB38KM;EACE,wCAAA;ApB88KR;;AoB/8KM;EACE,yCAAA;ApBk9KR;;AoBn9KM;EACE,yCAAA;ApBs9KR;;AoBv9KM;EACE,yCAAA;ApB09KR;;AoB39KM;EACE,yCAAA;ApB89KR;;AoB/9KM;EACE,0CAAA;ApBk+KR;;AoBn+KM;EACE,2CAAA;ApBs+KR;;AoBv+KM;EACE,2CAAA;ApB0+KR;;AoB3+KM;EACE,2CAAA;ApB8+KR;;AoB/+KM;EACE,2CAAA;ApBk/KR;;AoBn/KM;EACE,2CAAA;ApBs/KR;;AoBv/KM;EACE,2CAAA;ApB0/KR;;AoB3/KM;EACE,2CAAA;ApB8/KR;;AoB//KM;EACE,2CAAA;ApBkgLR;;AoBngLM;EACE,2CAAA;ApBsgLR;;AoBvgLM;EACE,yCAAA;ApB0gLR;;AoB3gLM;EACE,0CAAA;ApB8gLR;;AoB/gLM;EACE,0CAAA;ApBkhLR;;AoBnhLM;EACE,0CAAA;ApBshLR;;AoBvhLM;EACE,0CAAA;ApB0hLR;;AoB3hLM;EACE,0CAAA;ApB8hLR;;AoB/hLM;EACE,0CAAA;ApBkiLR;;AoBniLM;EACE,0CAAA;ApBsiLR;;AoBviLM;EACE,0CAAA;ApB0iLR;;AoB3iLM;EACE,0CAAA;ApB8iLR;;AoB/iLM;EACE,0CAAA;ApBkjLR;;AoBnjLM;EACE,2CAAA;ApBsjLR;;AoBvjLM;EACE,2CAAA;ApB0jLR;;AoB3jLM;EACE,2CAAA;ApB8jLR;;AoB/jLM;EACE,2CAAA;ApBkkLR;;AoBnkLM;EACE,2CAAA;ApBskLR;;AoBvkLM;EACE,2CAAA;ApB0kLR;;AoB3kLM;EACE,2CAAA;ApB8kLR;;AoB/kLM;EACE,2CAAA;ApBklLR;;AoBnlLM;EACE,2CAAA;ApBslLR;;AoBvlLM;EACE,0CAAA;ApB0lLR;;AoB3lLM;EACE,2CAAA;ApB8lLR;;AoB/lLM;EACE,2CAAA;ApBkmLR;;AoBnmLM;EACE,2CAAA;ApBsmLR;;AoBvmLM;EACE,2CAAA;ApB0mLR;;AoB3mLM;EACE,2CAAA;ApB8mLR;;AoB/mLM;EACE,2CAAA;ApBknLR;;AoBnnLM;EACE,2CAAA;ApBsnLR;;AoBvnLM;EACE,2CAAA;ApB0nLR;;AoB3nLM;EACE,2CAAA;ApB8nLR;;AoB/nLM;EACE,uCAAA;ApBkoLR;;AoBnoLM;EACE,wCAAA;ApBsoLR;;AoBvoLM;EACE,wCAAA;ApB0oLR;;AoB3oLM;EACE,wCAAA;ApB8oLR;;AoB/oLM;EACE,wCAAA;ApBkpLR;;AoBnpLM;EACE,wCAAA;ApBspLR;;AoBvpLM;EACE,wCAAA;ApB0pLR;;AoB3pLM;EACE,wCAAA;ApB8pLR;;AoB/pLM;EACE,wCAAA;ApBkqLR;;AoBnqLM;EACE,wCAAA;ApBsqLR;;AoBvqLM;EACE,2CAAA;ApB0qLR;;AoB3qLM;EACE,4CAAA;ApB8qLR;;AoB/qLM;EACE,4CAAA;ApBkrLR;;AoBzqLQ;EACI,uCAAA;ApB4qLZ;;AoB7qLQ;EACI,wCAAA;ApBgrLZ;;AoBjrLQ;EACI,wCAAA;ApBorLZ;;AoBrrLQ;EACI,wCAAA;ApBwrLZ;;AoBzrLQ;EACI,wCAAA;ApB4rLZ;;AoB7rLQ;EACI,wCAAA;ApBgsLZ;;AoBjsLQ;EACI,wCAAA;ApBosLZ;;AoBrsLQ;EACI,wCAAA;ApBwsLZ;;AoBzsLQ;EACI,wCAAA;ApB4sLZ;;AoB7sLQ;EACI,wCAAA;ApBgtLZ;;AoBjtLQ;EACI,2CAAA;ApBotLZ;;AoBrtLQ;EACI,4CAAA;ApBwtLZ;;AoBztLQ;EACI,4CAAA;ApB4tLZ;;AoB7tLQ;EACI,4CAAA;ApBguLZ;;AoBjuLQ;EACI,4CAAA;ApBouLZ;;AoBruLQ;EACI,4CAAA;ApBwuLZ;;AoBzuLQ;EACI,4CAAA;ApB4uLZ;;AoB7uLQ;EACI,4CAAA;ApBgvLZ;;AoBjvLQ;EACI,4CAAA;ApBovLZ;;AoBrvLQ;EACI,4CAAA;ApBwvLZ;;AoBzvLQ;EACI,0CAAA;ApB4vLZ;;AoB7vLQ;EACI,2CAAA;ApBgwLZ;;AoBjwLQ;EACI,2CAAA;ApBowLZ;;AoBrwLQ;EACI,2CAAA;ApBwwLZ;;AoBzwLQ;EACI,2CAAA;ApB4wLZ;;AoB7wLQ;EACI,2CAAA;ApBgxLZ;;AoBjxLQ;EACI,2CAAA;ApBoxLZ;;AoBrxLQ;EACI,2CAAA;ApBwxLZ;;AoBzxLQ;EACI,2CAAA;ApB4xLZ;;AoB7xLQ;EACI,2CAAA;ApBgyLZ;;AoBjyLQ;EACI,uCAAA;ApBoyLZ;;AoBryLQ;EACI,wCAAA;ApBwyLZ;;AoBzyLQ;EACI,wCAAA;ApB4yLZ;;AoB7yLQ;EACI,wCAAA;ApBgzLZ;;AoBjzLQ;EACI,wCAAA;ApBozLZ;;AoBrzLQ;EACI,wCAAA;ApBwzLZ;;AoBzzLQ;EACI,wCAAA;ApB4zLZ;;AoB7zLQ;EACI,wCAAA;ApBg0LZ;;AoBj0LQ;EACI,wCAAA;ApBo0LZ;;AoBr0LQ;EACI,wCAAA;ApBw0LZ;;AoBz0LQ;EACI,wCAAA;ApB40LZ;;AoB70LQ;EACI,yCAAA;ApBg1LZ;;AoBj1LQ;EACI,yCAAA;ApBo1LZ;;AoBr1LQ;EACI,yCAAA;ApBw1LZ;;AoBz1LQ;EACI,yCAAA;ApB41LZ;;AoB71LQ;EACI,0CAAA;ApBg2LZ;;AoBj2LQ;EACI,2CAAA;ApBo2LZ;;AoBr2LQ;EACI,2CAAA;ApBw2LZ;;AoBz2LQ;EACI,2CAAA;ApB42LZ;;AoB72LQ;EACI,2CAAA;ApBg3LZ;;AoBj3LQ;EACI,2CAAA;ApBo3LZ;;AoBr3LQ;EACI,2CAAA;ApBw3LZ;;AoBz3LQ;EACI,2CAAA;ApB43LZ;;AoB73LQ;EACI,2CAAA;ApBg4LZ;;AoBj4LQ;EACI,2CAAA;ApBo4LZ;;AoBr4LQ;EACI,yCAAA;ApBw4LZ;;AoBz4LQ;EACI,0CAAA;ApB44LZ;;AoB74LQ;EACI,0CAAA;ApBg5LZ;;AoBj5LQ;EACI,0CAAA;ApBo5LZ;;AoBr5LQ;EACI,0CAAA;ApBw5LZ;;AoBz5LQ;EACI,0CAAA;ApB45LZ;;AoB75LQ;EACI,0CAAA;ApBg6LZ;;AoBj6LQ;EACI,0CAAA;ApBo6LZ;;AoBr6LQ;EACI,0CAAA;ApBw6LZ;;AoBz6LQ;EACI,0CAAA;ApB46LZ;;AoB76LQ;EACI,0CAAA;ApBg7LZ;;AoBj7LQ;EACI,2CAAA;ApBo7LZ;;AoBr7LQ;EACI,2CAAA;ApBw7LZ;;AoBz7LQ;EACI,2CAAA;ApB47LZ;;AoB77LQ;EACI,2CAAA;ApBg8LZ;;AoBj8LQ;EACI,2CAAA;ApBo8LZ;;AoBr8LQ;EACI,2CAAA;ApBw8LZ;;AoBz8LQ;EACI,2CAAA;ApB48LZ;;AoB78LQ;EACI,2CAAA;ApBg9LZ;;AoBj9LQ;EACI,2CAAA;ApBo9LZ;;AoBr9LQ;EACI,0CAAA;ApBw9LZ;;AoBz9LQ;EACI,2CAAA;ApB49LZ;;AoB79LQ;EACI,2CAAA;ApBg+LZ;;AoBj+LQ;EACI,2CAAA;ApBo+LZ;;AoBr+LQ;EACI,2CAAA;ApBw+LZ;;AoBz+LQ;EACI,2CAAA;ApB4+LZ;;AoB7+LQ;EACI,2CAAA;ApBg/LZ;;AoBj/LQ;EACI,2CAAA;ApBo/LZ;;AoBr/LQ;EACI,2CAAA;ApBw/LZ;;AoBz/LQ;EACI,2CAAA;ApB4/LZ;;AoB7/LQ;EACI,uCAAA;ApBggMZ;;AoBjgMQ;EACI,wCAAA;ApBogMZ;;AoBrgMQ;EACI,wCAAA;ApBwgMZ;;AoBzgMQ;EACI,wCAAA;ApB4gMZ;;AoB7gMQ;EACI,wCAAA;ApBghMZ;;AoBjhMQ;EACI,wCAAA;ApBohMZ;;AoBrhMQ;EACI,wCAAA;ApBwhMZ;;AoBzhMQ;EACI,wCAAA;ApB4hMZ;;AoB7hMQ;EACI,wCAAA;ApBgiMZ;;AoBjiMQ;EACI,wCAAA;ApBoiMZ;;AoBriMQ;EACI,2CAAA;ApBwiMZ;;AoBziMQ;EACI,4CAAA;ApB4iMZ;;AoB7iMQ;EACI,4CAAA;ApBgjMZ;;AoBziME;EACE,+BAAA;ApB4iMJ;AoB1iME;EACE,+BAAA;ApB4iMJ;;AqBlkMM;EAEE,oCAAA;ArBokMR;;AqBtkMM;EAEE,oCAAA;ArBwkMR;;AqB1kMM;EAEE,oCAAA;ArB4kMR;;AqB9kMM;EAEE,oCAAA;ArBglMR;;AqBllMM;EAEE,oCAAA;ArBolMR;;AqBtlMM;EAEE,oCAAA;ArBwlMR;;AqB1lMM;EAEE,oCAAA;ArB4lMR;;AqB9lMM;EAEE,oCAAA;ArBgmMR;;AqBlmMM;EAEE,oCAAA;ArBomMR;;AqBtmMM;EAEE,oCAAA;ArBwmMR;;AqB1mMM;EAEE,oCAAA;ArB4mMR;;AqB9mMM;EAEE,oCAAA;ArBgnMR;;AqBlnMM;EAEE,oCAAA;ArBonMR;;AqBtnMM;EAEE,oCAAA;ArBwnMR;;AqB1nMM;EAEE,oCAAA;ArB4nMR;;AqB9nMM;EAEE,oCAAA;ArBgoMR;;AqBloMM;EAEE,oCAAA;ArBooMR;;AqBtoMM;EAEE,oCAAA;ArBwoMR;;AqB1oMM;EAEE,oCAAA;ArB4oMR;;AqB9oMM;EAEE,oCAAA;ArBgpMR;;AqBlpMM;EAEE,oCAAA;ArBopMR;;AqBtpMM;EAEE,oCAAA;ArBwpMR;;AqB1pMM;EAEE,oCAAA;ArB4pMR;;AqB9pMM;EAEE,oCAAA;ArBgqMR;;AqBlqMM;EAEE,oCAAA;ArBoqMR;;AqBtqMM;EAEE,oCAAA;ArBwqMR;;AqB1qMM;EAEE,oCAAA;ArB4qMR;;AqB9qMM;EAEE,oCAAA;ArBgrMR;;AqBlrMM;EAEE,oCAAA;ArBorMR;;AqBtrMM;EAEE,oCAAA;ArBwrMR;;AqB1rMM;EAEE,oCAAA;ArB4rMR;;AqB9rMM;EAEE,oCAAA;ArBgsMR;;AqBlsMM;EAEE,oCAAA;ArBosMR;;AqBtsMM;EAEE,oCAAA;ArBwsMR;;AqB1sMM;EAEE,oCAAA;ArB4sMR;;AqB9sMM;EAEE,oCAAA;ArBgtMR;;AqBltMM;EAEE,oCAAA;ArBotMR;;AqBttMM;EAEE,oCAAA;ArBwtMR;;AqB1tMM;EAEE,oCAAA;ArB4tMR;;AqB9tMM;EAEE,oCAAA;ArBguMR;;AqBluMM;EAEE,oCAAA;ArBouMR;;AqBtuMM;EAEE,oCAAA;ArBwuMR;;AqB1uMM;EAEE,oCAAA;ArB4uMR;;AqB9uMM;EAEE,oCAAA;ArBgvMR;;AqBlvMM;EAEE,oCAAA;ArBovMR;;AqBtvMM;EAEE,oCAAA;ArBwvMR;;AqB1vMM;EAEE,oCAAA;ArB4vMR;;AqB9vMM;EAEE,oCAAA;ArBgwMR;;AqBlwMM;EAEE,oCAAA;ArBowMR;;AqBtwMM;EAEE,oCAAA;ArBwwMR;;AqB1wMM;EAEE,oCAAA;ArB4wMR;;AqB9wMM;EAEE,oCAAA;ArBgxMR;;AqBlxMM;EAEE,oCAAA;ArBoxMR;;AqBtxMM;EAEE,oCAAA;ArBwxMR;;AqB1xMM;EAEE,oCAAA;ArB4xMR;;AqB9xMM;EAEE,oCAAA;ArBgyMR;;AqBlyMM;EAEE,oCAAA;ArBoyMR;;AqBtyMM;EAEE,oCAAA;ArBwyMR;;AqB1yMM;EAEE,oCAAA;ArB4yMR;;AqB9yMM;EAEE,oCAAA;ArBgzMR;;AqBlzMM;EAEE,oCAAA;ArBozMR;;AqBtzMM;EAEE,oCAAA;ArBwzMR;;AqB1zMM;EAEE,oCAAA;ArB4zMR;;AqB9zMM;EAEE,oCAAA;ArBg0MR;;AqBl0MM;EAEE,oCAAA;ArBo0MR;;AqBt0MM;EAEE,oCAAA;ArBw0MR;;AqB10MM;EAEE,oCAAA;ArB40MR;;AqB90MM;EAEE,oCAAA;ArBg1MR;;AqBl1MM;EAEE,oCAAA;ArBo1MR;;AqBt1MM;EAEE,oCAAA;ArBw1MR;;AqB11MM;EAEE,oCAAA;ArB41MR;;AqB91MM;EAEE,oCAAA;ArBg2MR;;AqBl2MM;EAEE,oCAAA;ArBo2MR;;AqBt2MM;EAEE,oCAAA;ArBw2MR;;AqB12MM;EAEE,oCAAA;ArB42MR;;AqB92MM;EAEE,oCAAA;ArBg3MR;;AqBl3MM;EAEE,oCAAA;ArBo3MR;;AqBt3MM;EAEE,oCAAA;ArBw3MR;;AqB13MM;EAEE,oCAAA;ArB43MR;;AqB93MM;EAEE,oCAAA;ArBg4MR;;AqBl4MM;EAEE,oCAAA;ArBo4MR;;AqBt4MM;EAEE,oCAAA;ArBw4MR;;AqB14MM;EAEE,oCAAA;ArB44MR;;AqB94MM;EAEE,oCAAA;ArBg5MR;;AqBl5MM;EAEE,oCAAA;ArBo5MR;;AqBt5MM;EAEE,oCAAA;ArBw5MR;;AqB15MM;EAEE,oCAAA;ArB45MR;;AqB95MM;EAEE,oCAAA;ArBg6MR;;AqBl6MM;EAEE,oCAAA;ArBo6MR;;AqBt6MM;EAEE,oCAAA;ArBw6MR;;AqB16MM;EAEE,oCAAA;ArB46MR;;AqB96MM;EAEE,oCAAA;ArBg7MR;;AqBl7MM;EAEE,oCAAA;ArBo7MR;;AqBt7MM;EAEE,oCAAA;ArBw7MR;;AqB17MM;EAEE,oCAAA;ArB47MR;;AqB97MM;EAEE,oCAAA;ArBg8MR;;AqBl8MM;EAEE,oCAAA;ArBo8MR;;AqBt8MM;EAEE,oCAAA;ArBw8MR;;AqB/7MQ;EAEI,oCAAA;ArBi8MZ;;AqBn8MQ;EAEI,oCAAA;ArBq8MZ;;AqBv8MQ;EAEI,oCAAA;ArBy8MZ;;AqB38MQ;EAEI,oCAAA;ArB68MZ;;AqB/8MQ;EAEI,oCAAA;ArBi9MZ;;AqBn9MQ;EAEI,oCAAA;ArBq9MZ;;AqBv9MQ;EAEI,oCAAA;ArBy9MZ;;AqB39MQ;EAEI,oCAAA;ArB69MZ;;AqB/9MQ;EAEI,oCAAA;ArBi+MZ;;AqBn+MQ;EAEI,oCAAA;ArBq+MZ;;AqBv+MQ;EAEI,oCAAA;ArBy+MZ;;AqB3+MQ;EAEI,oCAAA;ArB6+MZ;;AqB/+MQ;EAEI,oCAAA;ArBi/MZ;;AqBn/MQ;EAEI,oCAAA;ArBq/MZ;;AqBv/MQ;EAEI,oCAAA;ArBy/MZ;;AqB3/MQ;EAEI,oCAAA;ArB6/MZ;;AqB//MQ;EAEI,oCAAA;ArBigNZ;;AqBngNQ;EAEI,oCAAA;ArBqgNZ;;AqBvgNQ;EAEI,oCAAA;ArBygNZ;;AqB3gNQ;EAEI,oCAAA;ArB6gNZ;;AqB/gNQ;EAEI,oCAAA;ArBihNZ;;AqBnhNQ;EAEI,oCAAA;ArBqhNZ;;AqBvhNQ;EAEI,oCAAA;ArByhNZ;;AqB3hNQ;EAEI,oCAAA;ArB6hNZ;;AqB/hNQ;EAEI,oCAAA;ArBiiNZ;;AqBniNQ;EAEI,oCAAA;ArBqiNZ;;AqBviNQ;EAEI,oCAAA;ArByiNZ;;AqB3iNQ;EAEI,oCAAA;ArB6iNZ;;AqB/iNQ;EAEI,oCAAA;ArBijNZ;;AqBnjNQ;EAEI,oCAAA;ArBqjNZ;;AqBvjNQ;EAEI,oCAAA;ArByjNZ;;AqB3jNQ;EAEI,oCAAA;ArB6jNZ;;AqB/jNQ;EAEI,oCAAA;ArBikNZ;;AqBnkNQ;EAEI,oCAAA;ArBqkNZ;;AqBvkNQ;EAEI,oCAAA;ArBykNZ;;AqB3kNQ;EAEI,oCAAA;ArB6kNZ;;AqB/kNQ;EAEI,oCAAA;ArBilNZ;;AqBnlNQ;EAEI,oCAAA;ArBqlNZ;;AqBvlNQ;EAEI,oCAAA;ArBylNZ;;AqB3lNQ;EAEI,oCAAA;ArB6lNZ;;AqB/lNQ;EAEI,oCAAA;ArBimNZ;;AqBnmNQ;EAEI,oCAAA;ArBqmNZ;;AqBvmNQ;EAEI,oCAAA;ArBymNZ;;AqB3mNQ;EAEI,oCAAA;ArB6mNZ;;AqB/mNQ;EAEI,oCAAA;ArBinNZ;;AqBnnNQ;EAEI,oCAAA;ArBqnNZ;;AqBvnNQ;EAEI,oCAAA;ArBynNZ;;AqB3nNQ;EAEI,oCAAA;ArB6nNZ;;AqB/nNQ;EAEI,oCAAA;ArBioNZ;;AqBnoNQ;EAEI,oCAAA;ArBqoNZ;;AqBvoNQ;EAEI,oCAAA;ArByoNZ;;AqB3oNQ;EAEI,oCAAA;ArB6oNZ;;AqB/oNQ;EAEI,oCAAA;ArBipNZ;;AqBnpNQ;EAEI,oCAAA;ArBqpNZ;;AqBvpNQ;EAEI,oCAAA;ArBypNZ;;AqB3pNQ;EAEI,oCAAA;ArB6pNZ;;AqB/pNQ;EAEI,oCAAA;ArBiqNZ;;AqBnqNQ;EAEI,oCAAA;ArBqqNZ;;AqBvqNQ;EAEI,oCAAA;ArByqNZ;;AqB3qNQ;EAEI,oCAAA;ArB6qNZ;;AqB/qNQ;EAEI,oCAAA;ArBirNZ;;AqBnrNQ;EAEI,oCAAA;ArBqrNZ;;AqBvrNQ;EAEI,oCAAA;ArByrNZ;;AqB3rNQ;EAEI,oCAAA;ArB6rNZ;;AqB/rNQ;EAEI,oCAAA;ArBisNZ;;AqBnsNQ;EAEI,oCAAA;ArBqsNZ;;AqBvsNQ;EAEI,oCAAA;ArBysNZ;;AqB3sNQ;EAEI,oCAAA;ArB6sNZ;;AqB/sNQ;EAEI,oCAAA;ArBitNZ;;AqBntNQ;EAEI,oCAAA;ArBqtNZ;;AqBvtNQ;EAEI,oCAAA;ArBytNZ;;AqB3tNQ;EAEI,oCAAA;ArB6tNZ;;AqB/tNQ;EAEI,oCAAA;ArBiuNZ;;AqBnuNQ;EAEI,oCAAA;ArBquNZ;;AqBvuNQ;EAEI,oCAAA;ArByuNZ;;AqB3uNQ;EAEI,oCAAA;ArB6uNZ;;AqB/uNQ;EAEI,oCAAA;ArBivNZ;;AqBnvNQ;EAEI,oCAAA;ArBqvNZ;;AqBvvNQ;EAEI,oCAAA;ArByvNZ;;AqB3vNQ;EAEI,oCAAA;ArB6vNZ;;AqB/vNQ;EAEI,oCAAA;ArBiwNZ;;AqBnwNQ;EAEI,oCAAA;ArBqwNZ;;AqBvwNQ;EAEI,oCAAA;ArBywNZ;;AqB3wNQ;EAEI,oCAAA;ArB6wNZ;;AqB/wNQ;EAEI,oCAAA;ArBixNZ;;AqBnxNQ;EAEI,oCAAA;ArBqxNZ;;AqBvxNQ;EAEI,oCAAA;ArByxNZ;;AqB3xNQ;EAEI,oCAAA;ArB6xNZ;;AqB/xNQ;EAEI,oCAAA;ArBiyNZ;;AqBnyNQ;EAEI,oCAAA;ArBqyNZ;;AqBvyNQ;EAEI,oCAAA;ArByyNZ;;AqB3yNQ;EAEI,oCAAA;ArB6yNZ;;AqB/yNQ;EAEI,oCAAA;ArBizNZ;;AqBnzNQ;EAEI,oCAAA;ArBqzNZ;;AqBvzNQ;EAEI,oCAAA;ArByzNZ;;AqB3zNQ;EAEI,oCAAA;ArB6zNZ;;AqB/zNQ;EAEI,oCAAA;ArBi0NZ;;AqBn0NQ;EAEI,oCAAA;ArBq0NZ;;AqB7zNM;EACE,8CAAA;ArBg0NR;;AqB1zNA;EACE,8BAAA;ArB6zNF;;AqBzzNE;EACE,oCAAA;ArB4zNJ;AqB1zNE;EACE,oCAAA;ArB4zNJ;AqB1zNE;EACE,oCAAA;ArB4zNJ;AqB1zNE;EACE,oCAAA;ArB4zNJ;AqB1zNE;EACE,oCAAA;ArB4zNJ;AqB1zNE;EACE,oCAAA;ArB4zNJ;;AsBh3NA,0BAAA;AAEI;EACI,kBAAA;AtBk3NR;;AsB72NI;EACE,6BAAA;AtBg3NN;;AsBj3NI;EACE,8BAAA;AtBo3NN;;AsBr3NI;EACE,0BAAA;AtBw3NN;;AsBz3NI;EACE,8BAAA;AtB43NN;;AsB73NI;EACE,6BAAA;AtBg4NN;;AsBj4NI;EACE,4BAAA;AtBo4NN;;AsBr4NI;EACE,8BAAA;AtBw4NN;;AsBz4NI;EACE,6BAAA;AtB44NN;;AsB74NI;EACE,0BAAA;AtBg5NN;;AsBj5NI;EACE,6BAAA;AtBo5NN;;AsB/4NI;EACE,8BAAA;AtBk5NN;;AsBn5NI;EACE,+BAAA;AtBs5NN;;AsBv5NI;EACE,6BAAA;AtB05NN;;AsB35NI;EACE,+BAAA;AtB85NN;;AsB/5NI;EACE,8BAAA;AtBk6NN;;AsBn6NI;EACE,+BAAA;AtBs6NN;;AsBv6NI;EACE,4BAAA;AtB06NN;;AsB36NI;EACE,+BAAA;AtB86NN;;AsB/6NI;EACE,8BAAA;AtBk7NN;;AsBn7NI;EACE,+BAAA;AtBs7NN;;AsBv7NI;EACE,6BAAA;AtB07NN;;AsB37NI;EACE,+BAAA;AtB87NN;;AsB/7NI;EACE,8BAAA;AtBk8NN;;AsBn8NI;EACE,0BAAA;AtBs8NN;;AsBv8NI;EACE,8BAAA;AtB08NN;;AsB38NI;EACE,6BAAA;AtB88NN;;AsB/8NI;EACE,8BAAA;AtBk9NN;;AsBn9NI;EACE,4BAAA;AtBs9NN;;AsBv9NI;EACE,8BAAA;AtB09NN;;AsB39NI;EACE,6BAAA;AtB89NN;;AsB/9NI;EACE,8BAAA;AtBk+NN;;AsBn+NI;EACE,0BAAA;AtBs+NN;;AsBv+NI;EACE,0BAAA;AtB0+NN;;AsB3+NI;EACE,4BAAA;AtB8+NN;;AsB/+NI;EACE,6BAAA;AtBk/NN;;AsBn/NI;EACE,0BAAA;AtBs/NN;;AsBv/NI;EACE,6BAAA;AtB0/NN;;AsB3/NI;EACE,4BAAA;AtB8/NN;;AsB//NI;EACE,6BAAA;AtBkgON;;AsBngOI;EACE,0BAAA;AtBsgON;;AsBvgOI;EACE,6BAAA;AtB0gON;;AsB3gOI;EACE,4BAAA;AtB8gON;;AsB/gOI;EACE,6BAAA;AtBkhON;;AsBnhOI;EACE,0BAAA;AtBshON;;AsBvhOI;EACE,8BAAA;AtB0hON;;AsB3hOI;EACE,8BAAA;AtB8hON;;AsB/hOI;EACE,4BAAA;AtBkiON;;AsBniOI;EACE,0BAAA;AtBsiON;;AsBviOI;EACE,2BAAA;AtB0iON;;AsB3iOI;EACE,+BAAA;AtB8iON;;AsB3iOA,wBAAA;ACjBA,qBAAA;AAEI;EACE,2CAAA;AvB+jON;AuB7jOI;EACE,gFAAA;AvB+jON;AuB7jOI;EACE,oFAAA;AvB+jON;AuB7jOI;EACE,mFAAA;AvB+jON;AuB7jOI;EACE,iDAAA;AvB+jON;AuB7jOI;EACE,iDAAA;AvB+jON;;AuB5jOA,mBAAA;ACtBA,kBAAA;AAEI;EACG,kCAAA;AxBqlOP;;AwBtlOI;EACG,mCAAA;AxBylOP;;AwB1lOI;EACG,iCAAA;AxB6lOP;;AwB9lOI;EACG,mCAAA;AxBimOP;;AwBlmOI;EACG,kCAAA;AxBqmOP;;AwBtmOI;EACG,mCAAA;AxBymOP;;AwB1mOI;EACG,gCAAA;AxB6mOP;;AwB9mOI;EACG,mCAAA;AxBinOP;;AwBlnOI;EACG,kCAAA;AxBqnOP;;AwBtnOI;EACG,mCAAA;AxBynOP;;AwB1nOI;EACG,iCAAA;AxB6nOP;;AwB9nOI;EACG,mCAAA;AxBioOP;;AwBloOI;EACG,kCAAA;AxBqoOP;;AwBtoOI;EACG,8BAAA;AxByoOP;;AwB1oOI;EACG,kCAAA;AxB6oOP;;AwB9oOI;EACG,iCAAA;AxBipOP;;AwBlpOI;EACG,kCAAA;AxBqpOP;;AwBtpOI;EACG,gCAAA;AxBypOP;;AwB1pOI;EACG,kCAAA;AxB6pOP;;AwB9pOI;EACG,iCAAA;AxBiqOP;;AwBlqOI;EACG,kCAAA;AxBqqOP;;AwBtqOI;EACG,8BAAA;AxByqOP;;AwB1qOI;EACG,8BAAA;AxB6qOP;;AwB9qOI;EACG,gCAAA;AxBirOP;;AwBlrOI;EACG,iCAAA;AxBqrOP;;AwBtrOI;EACG,8BAAA;AxByrOP;;AwB1rOI;EACG,iCAAA;AxB6rOP;;AwB9rOI;EACG,gCAAA;AxBisOP;;AwBlsOI;EACG,iCAAA;AxBqsOP;;AwBtsOI;EACG,8BAAA;AxBysOP;;AwB1sOI;EACG,iCAAA;AxB6sOP;;AwB9sOI;EACG,gCAAA;AxBitOP;;AwBltOI;EACG,iCAAA;AxBqtOP;;AwBttOI;EACG,8BAAA;AxBytOP;;AwB1tOI;EACG,kCAAA;AxB6tOP;;AwB9tOI;EACG,kCAAA;AxBiuOP;;AwBluOI;EACG,gCAAA;AxBquOP;;AwBtuOI;EACG,8BAAA;AxByuOP;;AwB1uOI;EACG,+BAAA;AxB6uOP;;AwB9uOI;EACG,mCAAA;AxBivOP;;AwB5uOE;EACC,qCAAA;AxB+uOH;;AyBvvOA,yCAAA;AACA;EACI,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;AzB0vOJ;ACpuOE;EwB5BF;IAQQ,qBAAA;EzB4vON;AACF;ACzuOE;EwBlBE;IAEQ,kBAAA;IACA,kBAAA;IACA,oBAAA;IACA,qBAAA;IACA,uBAAA;EzB6vOV;AACF;;AyB1vOA,6CAAA;ACrBA,kBAAA;AACA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,uCAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A1BmxOJ;A0BlxOI;EACI,mBAAA;EACA,UAAA;A1BoxOR;;A0BhxOA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,oBAAA;EACA,uCAAA;EACA,UAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A1BmxOJ;ACpxOE;EyBGM;IACI,mBAAA;IACA,UAAA;E1BoxOV;AACF;;A0BjxOA,gBAAA;ACrCA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A3B0zOF;;A2BvzOA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A3B0zOF;;A2BvzOA;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A3B0zOF;;A4Bh1OI;EACE,qBAAA;EACA,sBAAA;A5Bm1ON;A4Bj1OI;EACE,yBAAA;A5Bm1ON;A4Bl1OM;EACE,yBAAA;A5Bo1OR;A4Bj1OI;EACE,yBAAA;A5Bm1ON;;A6B71OI;EACE,6BAAA;A7Bg2ON;;A6Bj2OI;EACE,6BAAA;A7Bo2ON;;A6Br2OI;EACE,6BAAA;A7Bw2ON;;A6Bz2OI;EACE,6BAAA;A7B42ON;;A6B72OI;EACE,6BAAA;A7Bg3ON;;A6Bj3OI;EACE,6BAAA;A7Bo3ON;;A6Br3OI;EACE,6BAAA;A7Bw3ON;;A6Bz3OI;EACE,6BAAA;A7B43ON;;A6B73OI;EACE,8BAAA;A7Bg4ON;;A6Bj4OI;EACE,8BAAA;A7Bo4ON;;A6Br4OI;EACE,8BAAA;A7Bw4ON;;A6Bz4OI;EACE,8BAAA;A7B44ON;;A6B74OI;EACE,8BAAA;A7Bg5ON;;A6Bj5OI;EACE,8BAAA;A7Bo5ON;;A6Br5OI;EACE,8BAAA;A7Bw5ON;;A6Bz5OI;EACE,8BAAA;A7B45ON;;A6B75OI;EACE,8BAAA;A7Bg6ON;;A6Bj6OI;EACE,8BAAA;A7Bo6ON;;A6Br6OI;EACE,8BAAA;A7Bw6ON;;A6Bz6OI;EACE,8BAAA;A7B46ON;;A6B76OI;EACE,8BAAA;A7Bg7ON;;A6Bj7OI;EACE,8BAAA;A7Bo7ON;;A6Br7OI;EACE,8BAAA;A7Bw7ON;;A6Bz7OI;EACE,8BAAA;A7B47ON;;A6B77OI;EACE,8BAAA;A7Bg8ON;;A6Bj8OI;EACE,8BAAA;A7Bo8ON;;A6Br8OI;EACE,8BAAA;A7Bw8ON;;A6Bz8OI;EACE,8BAAA;A7B48ON;;A6B78OI;EACE,8BAAA;A7Bg9ON;;A6Bj9OI;EACE,8BAAA;A7Bo9ON;;A6Br9OI;EACE,8BAAA;A7Bw9ON;;A6Bz9OI;EACE,8BAAA;A7B49ON;;A6B79OI;EACE,8BAAA;A7Bg+ON;;A6Bj+OI;EACE,8BAAA;A7Bo+ON;;A6Br+OI;EACE,8BAAA;A7Bw+ON;;A6Bz+OI;EACE,+BAAA;A7B4+ON;;A6B7+OI;EACE,+BAAA;A7Bg/ON;;A6Bj/OI;EACE,+BAAA;A7Bo/ON;;A6Br/OI;EACE,+BAAA;A7Bw/ON;;A6Bz/OI;EACE,+BAAA;A7B4/ON;;A8B//OA,wBAAA;AAGI;EACE,iCAAA;A9BggPN;;A8B1/OI;EACE,qCAAA;A9B6/ON;;A8Bt/OA;EACI,kBAAA;EACA,UAAA;EACA,wBAAA;A9By/OJ;;A8Bt/OA;EACI,kBAAA;A9By/OJ;A8Bv/OQ;EACI,mBAAA;EACA,UAAA;EACA,qBAAA;A9By/OZ;A8Br/OgB;EADJ;IAEQ,uBAAA;IACA,0CAAA;E9Bw/OlB;AACF;;A8Bn/OA,sBAAA;AC1CA;EACI,+BAAA;A/BiiPJ;;A+B/hPA;EACI,gCAAA;A/BkiPJ;;A+B9hPA;EACI,+BAAA;A/BiiPJ;;A+B/hPA;EACI,gCAAA;A/BkiPJ;;AgC9iPA,oFAAA;AACA;EACE,mCAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AhCijPF;;AgC/iPA,mFAAA;ACbA,qFAAA;AhCuBE;EgCrBE;IAEQ,WAAA;EjC+jPV;EiC7jPc;IACI,yBAAA;EjC+jPlB;EiC7jPc;IACI,+BAAA;IACA,gCAAA;EjC+jPlB;EiC9jPkB;IACI,aAAA;EjCgkPtB;AACF;AiC1jPW;EACK,mCAAA;EACA,+BAAA;AjC4jPhB;AiC3jPgB;EACI,gCAAA;AjC6jPpB;AiC3jPgB;EACI,wBAAA;AjC6jPpB;AiC3jPgB;EACI,wBAAA;AjC6jPpB;AC7jPE;EgCDc;IAGQ,sBAAA;EjC+jPtB;AACF;AiC9jPoB;EACI,sCAAA;EACA,0BAAA;AjCgkPxB;AiC7jPgB;EACI,iCAAA;EACA,iDAAA;AjC+jPpB;AC1kPE;EgCYkB;IAEQ,oCAAA;EjCgkP1B;AACF;;AC/kPE;EgCyBM;IACI,0BAAA;EjC0jPV;AACF;AiCtjPA;EACI,kBAAA;AjCwjPJ;AiCvjPI;EACI,uBAAA;EACA,wBAAA;AjCyjPR;AC9kPE;EgCmBE;IAIQ,kCAAA;IACA,mCAAA;EjC2jPV;AACF;AC3lPE;EgC0BE;IAQQ,kCAAA;IACA,mCAAA;EjC6jPV;AACF;AiC5jPQ;EACI,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,uCAAA;AjC8jPZ;AiC1jPQ;EACI,uBAAA;EACA,wBAAA;AjC4jPZ;;AiCxjPA,qBAAA;AAEI;EACI,wBAAA;AjC0jPR;AiCzjPQ;EACI,mCAAA;EACA,cAAA;AjC2jPZ;;AiCtjPA,mFAAA;ACvGA,4DAAA;AACA;EACI,uBAAA;AlCiqPJ;AkChqPI;EACI,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,2BAAA;EACA,mCAAA;EACA,yCAAA;AlCkqPR;AChpPE;EiC3BE;IAWQ,uBAAA;ElCoqPV;AACF;;AkChqPA;EACI;IACE,4BAAA;ElCmqPJ;EkCjqPE;IACE,wBAAA;ElCmqPJ;AACF;AkC/pPI;EACI,gBAAA;AlCiqPR;ACrrPE;EiCmBE;IAGQ,gBAAA;ElCmqPV;AACF;;AkC/pPA,sCAAA;AACA;EACI,SAAA;AlCkqPJ;AC7pPE;EiCNF;IAGQ,SAAA;ElCoqPN;AACF;ACzqPE;EiCCF;IAMQ,SAAA;ElCsqPN;AACF;AkCnqPY;EACI,uBAAA;AlCqqPhB;AkCpqPgB;EACI,uBAAA;AlCsqPpB;AkCjqPY;EACI,sBAAA;AlCmqPhB;AkClqPgB;EAFJ;IAGQ,uBAAA;ElCqqPlB;AACF;AkCjqPI;EACI,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AlCmqPR;AkClqPQ;EANJ;IAOQ,mBAAA;ElCqqPV;AACF;ACxsPE;EiC2BE;IAUQ,oBAAA;ElCuqPV;AACF;AkCnqPQ;EADJ;IAEQ,mBAAA;ElCsqPV;AACF;ACltPE;EiCyCE;IAKQ,oBAAA;ElCwqPV;AACF;;AkCpqPA;EACI,kBAAA;AlCuqPJ;AkCrqPQ;EACI,wBAAA;AlCuqPZ;AkClqPQ;EACI,uBAAA;AlCoqPZ;AkClqPQ;EACI,qDAAA;AlCoqPZ;AkCjqPI;EACI,kBAAA;AlCmqPR;AkClqPQ;EACI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;EACA,gBAAA;EACA,oCAAA;EACA,uBAAA;AlCoqPZ;;AkC/pPA,kBAAA;AACA;EACI,kBAAA;EACA,qBAAA;EAEA,uBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;AlCiqPJ;AkChqPI;EAbJ;IAcQ,iBAAA;IACA,gBAAA;ElCmqPN;AACF;AkClqPI;EACI,YAAA;EACA,gBAAA;AlCoqPR;AkClqPI;EACI,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;AlCoqPR;ACxxPE;EiCgHE;IAMQ,gBAAA;ElCsqPV;AACF;AkCnqPgB;EACI,kCAAA;AlCqqPpB;AkChqPI;EACI,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,iBAAA;EACA,sBAAA;AlCkqPR;AkCjqPQ;EACI,iCAAA;AlCmqPZ;AkCjqPQ;EACI,kBAAA;AlCmqPZ;;AkC/pPA,gBAAA;AACA,oCAAA;AAGA,wCAAA;AACA;EACI,6CAAA;AlCgqPJ;;AkC7pPA;EACI,eAAA;AlCgqPJ;;AkC7pPA;EACI,kBAAA;EACA,oBAAA;EACA,6BAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;AlC+pPJ;AkC5pPY;EACI,kBAAA;EACA,0BAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;AlC8pPhB;AkC7pPgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;EACA,uBAAA;AlC+pPpB;AkC7pPgB;EACI,gCAAA;EACA,sBAAA;EACA,gBAAA;AlC+pPpB;AkC9pPoB;EACI,2BAAA;AlCgqPxB;;AkCxpPA;EAGY;IACI,gCAAA;IACA,iCAAA;IACA,gBAAA;ElCypPd;EkCvpPU;IACI,mBAAA;IACA,UAAA;ElCypPd;AACF;ACr3PE;EiCkOE;IAEQ,4BAAA;IACA,0BAAA;ElCqpPV;AACF;ACl4PE;EiCyOE;IAMQ,6BAAA;ElCupPV;AACF;AkCrpPI;EAEQ;IACI,iCAAA;IACA,2CAAA;ElCspPd;EkCrpPc;IACI,gBAAA;ElCupPlB;AACF;;AkCjpPA,cAAA;AACA;EACI,kBAAA;AlCopPJ;AkCnpPI;EAFJ;IAGQ,YAAA;ElCspPN;AACF;AkCrpPI;EACI,WAAA;AlCupPR;AC75PE;EiCqQE;IAGQ,eAAA;IACA,2BAAA;ElCypPV;AACF;AkCxpPQ;EACI,gBAAA;AlC0pPZ;;AkCtpPA;EACI,WAAA;EACA,4BAAA;EACA,YAAA;EACA,iBAAA;AlCypPJ;AkCxpPI;EACI,iBAAA;AlC0pPR;AC35PE;EiCgQE;IAGQ,iBAAA;ElC4pPV;AACF;AkC1pPI;EAXJ;IAYQ,UAAA;ElC6pPN;AACF;;AkC1pPA,sCAAA;AAGI;EACI,2BAAA;AlC2pPR;;AkCvpPA,iFAAA;ACxTA,wFAAA;AACA;EACI,eAAA;AnCm9PJ;AmCl9PI;EACI,eAAA;AnCo9PR;AC56PE;EkC3CF;IAMQ,eAAA;EnCq9PN;AACF;ACx7PE;EkCpCF;IASQ,0BAAA;EnCu9PN;AACF;ACp8PE;EkC7BF;IAYQ,yBAAA;EnCy9PN;AACF;ACl8PE;EkCrBE;IAEQ,2BAAA;EnCy9PV;AACF;ACr9PE;EkCPE;IAKQ,6BAAA;EnC29PV;AACF;;AmCv9PA;EACI,yCAAA;AnC09PJ;;AmCv9PA,yBAAA;AlCAE;EkCGM;IACI,8BAAA;IACA,8BAAA;IACA,8CAAA;IACA,4CAAA;EnCy9PV;AACF;ACj+PE;EkCUE;IAEQ,aAAA;EnCy9PV;AACF;AmCv9PI;EACI,wCAAA;EACA,YAAA;AnCy9PR;ACr9PE;EkCNE;IAIQ,YAAA;EnC29PV;AACF;ACj+PE;EkCCE;IAOQ,YAAA;EnC69PV;AACF;AC7+PE;EkCQE;IAUQ,YAAA;EnC+9PV;AACF;;AmC39PA,gCAAA;AlChBE;EkCiBF;IAEQ,oBAAA;EnC89PN;AACF;AChgQE;EkC+BF;IAKQ,oBAAA;EnCg+PN;AACF;AC5gQE;EkCsCF;IAQQ,oBAAA;EnCk+PN;AACF;AC1gQE;EkC4CU;IACI,0BAAA;IACA,oCAAA;EnCi+Pd;AACF;;AmC79PA,8BAAA;AAGA,gCAAA;AAEI;EACI,mCAAA;EACA,kBAAA;EACA,gBAAA;AnC69PR;AmC59PQ;EACI,gBAAA;EACA,yBAAA;EACA,wBAAA;EACA,2BAAA;AnC89PZ;;AmC19PA,8BAAA;AAGA,2CAAA;AlCvEE;EkCyEE;IACI,eAAA;IACA,qBAAA;IACA,oBAAA;IACA,mBAAA;IACA,UAAA;IACA,aAAA;IACA,gBAAA;IACA,uBAAA;IACA,aAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EnC29PN;EmC19PM;IACI,wBAAA;EnC49PV;EmC19PM;IACI,2BAAA;EnC49PV;EmCz9PkB;IACI,0BAAA;IACA,iCAAA;IACA,gBAAA;EnC29PtB;EmC19PsB;IACI,wBAAA;EnC49P1B;EmCx9Pc;IACI,wCAAA;EnC09PlB;EmCt9PM;IACI,gBAAA;IACA,mBAAA;IACA,UAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,YAAA;IACA,2BAAA;IACA,aAAA;IACA,yBAAA;IACA,4BAAA;EnCw9PV;EmCv9PU;IACI,aAAA;EnCy9Pd;EmCv9PU;IACI,4BAAA;EnCy9Pd;EmCv9PkB;IACI,kBAAA;EnCy9PtB;EmCx9PsB;IACI,qBAAA;EnC09P1B;AACF;AmCn9PA,yCAAA;AACA,sFAAA;ACrKA,8BAAA;AACA;EACI,eAAA;EACA,mCAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;EACA,4BAAA;EACA,uBAAA;EACA,uBAAA;ApC2nQJ;AoC1nQI;EACI,yBAAA;ApC4nQR;;AoCznQA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;ApC4nQJ;AoC3nQI;EACI,mCAAA;EACA,wBAAA;ApC6nQR;;AoCxnQI;EACI,cAAA;EACA,wBAAA;ApC2nQR;AoCvnQoB;EACI,wCAAA;ApCynQxB;AoCrnQY;EACI,mDAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;ApCunQhB;AoCnnQQ;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;ApCqnQZ;AoCpnQY;EACI,WAAA;EACA,eAAA;EACA,mDAAA;ApCsnQhB;AoCnnQgB;EACI,6BAAA;EACA,uBAAA;ApCqnQpB;AoCnnQgB;EACI,aAAA;ApCqnQpB;;AoC/mQA,8BAAA;ACnFA,4DAAA;AACA;EACI,wBAAA;ArCssQJ;AqCrsQI;EACI,6CAAA;ArCusQR;AqCrsQI;EACI,+CAAA;ArCusQR;AqCpsQQ;EACI,sBAAA;ArCssQZ;AqCpsQgB;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;ArCssQpB;;AqC/rQA;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ArCksQJ;;AqChsQA,0DAAA;AC9BA,gFAAA;AACE;EACE,eAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,8CAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EAEA,4BAAA;EACA,6BAAA;AtCkuQJ;ACvtQE;EqC5BA;IAmBI,sBAAA;IACA,qBAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;EtCouQJ;AACF;AsCnuQI;EACI,UAAA;EACA,mBAAA;EACA,wBAAA;AtCquQR;AsCnuQI;EACE,sBAAA;AtCquQN;AsCnuQI;EACI,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EAEA,4BAAA;EACA,kCAAA;AtCquQR;AC3vQE;EqCKE;IAmBM,YAAA;IACA,WAAA;IACA,iBAAA;EtCuuQR;AACF;;AsCnuQE;EACE,UAAA;AtCsuQJ;;AsCpuQE;EACE,wBAAA;EACA,eAAA;EACA,sBAAA;EAEA,4BAAA;AtCuuQJ;;AsCruQA,8EAAA;ACvEA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;AvCgzQJ;AuC/yQI;EACI,mBAAA;EACA,UAAA;EACA,mBAAA;AvCizQR;;AwCl0QA,oEAAA;AAEE;EACI,aAAA;AxCo0QN;AwCl0QE;EACE,YAAA;EACE,YAAA;EACA,cAAA;AxCo0QN;AwCn0QM;EACI,YAAA;AxCq0QV;AwCp0QU;EACE,YAAA;AxCs0QZ;;AwCh0QA,uBAAA;AACA;EACE,WAAA;EACA,YAAA;AxCm0QF;AwCl0QE;EACE,sBAAA;AxCo0QJ;AC7zQE;EuCXF;IAOI,WAAA;IACA,YAAA;ExCq0QF;AACF;AC10QE;EuCJF;IAWI,WAAA;IACA,YAAA;ExCu0QF;AACF;;AwCn0QA,oBAAA;AACA;EACE,kBAAA;AxCs0QF;AwCr0QE;EACE,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,wBAAA;EACA,UAAA;AxCu0QJ;AwCt0QI;EACE,wBAAA;EACA,sBAAA;AxCw0QN;;AwCl0QE;EACE,kBAAA;EACA,UAAA;AxCq0QJ;AwCl0QI;EACE,mBAAA;EACA,UAAA;AxCo0QN;;AwC/zQA,mBAAA;AACA;EACI,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;AxCk0QJ;AwCj0QI;EACI,qBAAA;EACA,aAAA;AxCm0QR;AwCl0QQ;EACI,YAAA;EACA,uCAAA;EACA,wBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;AxCo0QZ;AwCl0QQ;EACI,WAAA;EACA,sCAAA;AxCo0QZ;;AwCh0QA,iBAAA;AACA,oEAAA;AClGA,2EAAA;AACA;EACI,mBAAA;AzCs6QJ;ACn4QE;EwCpCF;IAGQ,mBAAA;EzCw6QN;AACF;AyCr6QQ;EADJ;IAEQ,yBAAA;IACA,yBAAA;EzCw6QV;AACF;AyCv6QQ;EALJ;IAMQ,8BAAA;EzC06QV;AACF;;AyCv6QA,yEAAA;ACjBA,+EAAA;AACA;EACE,gBAAA;A1C47QF;ACv6QE;EyCtBF;IAGI,mBAAA;E1C87QF;AACF;A0C77QE;EACE,eAAA;A1C+7QJ;A0C77QE;EACE,SAAA;A1C+7QJ;;A0C37QA;EACE,kBAAA;EACA,8DAAA;EACA,8DAAA;EACA,iEAAA;EACA,6DAAA;EAEA,mDAAA;EAEA,sBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,+CAAA;A1C67QF;ACl8QE;EyCTF;IAgBI,gBAAA;IACA,0BAAA;E1C+7QF;AACF;A0C77QE;EACE,2DAAA;A1C+7QJ;AC/6QE;EyCjBA;IAGI,iBAAA;E1Ci8QJ;AACF;ACl8QE;EyCHA;IAMI,mBAAA;E1Cm8QJ;AACF;AC98QE;EyCIA;IASI,kBAAA;E1Cq8QJ;AACF;AC19QE;EyCWA;IAYI,mBAAA;E1Cu8QJ;AACF;A0Cr8QE;EACE,gBAAA;A1Cu8QJ;ACt8QE;EyCFA;IAGI,gBAAA;E1Cy8QJ;AACF;AC9+QE;EyCwCE;IAEI,gBAAA;IACA,WAAA;E1Cw8QN;AACF;;ACp/QE;EyCiDF;IAEI,eAAA;E1Cs8QF;AACF;;A0Cn8QA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;A1Cs8QF;ACt+QE;EyC2BF;IAOI,WAAA;IACA,YAAA;IACA,mBAAA;E1Cw8QF;AACF;AClgRE;EyCgDF;IAYI,oBAAA;E1C08QF;AACF;A0Cz8QE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,SAAA;EACA,oCAAA;A1C28QJ;AC3/QE;EyCyCA;IASI,QAAA;E1C68QJ;AACF;A0C38QE;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;A1C68QJ;;A0Cz8QA;EACE;IACE,2BAAA;E1C48QF;E0C18QA;IACE,0BAAA;E1C48QF;E0C18QA;IACE,2BAAA;E1C48QF;AACF;A0C18QA,6EAAA;ACnHA,2FAAA;AACA;EACI,gBAAA;A3CgkRJ;A2C7jRY;EACI,mBAAA;EACA,UAAA;EACA,kBAAA;A3C+jRhB;A2C9jRgB;EACI,mBAAA;A3CgkRpB;A2C5jRQ;EACI,wBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;A3C8jRZ;A2C7jRY;EACI,mBAAA;A3C+jRhB;A2C3jRI;EACI,UAAA;A3C6jRR;;A2CxjRI;EACI,aAAA;EACA,2DAAA;EACA,SAAA;A3C2jRR;A2CxjRgB;EACI,mBAAA;A3C0jRpB;A2CtjRgB;EACI,mBAAA;A3CwjRpB;A2CpjRgB;EACI,mBAAA;A3CsjRpB;A2CljRgB;EACI,mBAAA;A3CojRpB;A2ChjRgB;EACI,mBAAA;A3CkjRpB;A2C9iRgB;EACI,mBAAA;A3CgjRpB;A2C5iRgB;EACI,mBAAA;A3C8iRpB;A2C1iRgB;EACI,mBAAA;A3C4iRpB;A2CxiRgB;EACI,mBAAA;A3C0iRpB;A2CtiRgB;EACI,mBAAA;A3CwiRpB;A2CpiRgB;EACI,gBAAA;A3CsiRpB;A2CjiRI;EACI,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,eAAA;EACA,cAAA;A3CmiRR;A2CliRQ;EACI,uBAAA;A3CoiRZ;A2ChiRQ;EACI,qBAAA;A3CkiRZ;;A2C5hRI;EACI,mBAAA;EACA,kBAAA;A3C+hRR;;A2C3hRI;EACI,uBAAA;A3C8hRR;;A2C3hRA,yFAAA;AC1HA,yFAAA;AACA;EACI,uDAAA;A5CypRJ;AC3oRE;E2CfF;IAGQ,kBAAA;E5C2pRN;AACF;A4C1pRI;EACI,gBAAA;A5C4pRR;ACvnRE;E2CnCE;IAEQ,4BAAA;E5C4pRV;AACF;;A4CzpRA,uFAAA;ACfA,iFAAA;AACA;EACI,kBAAA;A7C4qRJ;;A6C1qRA,+EAAA;ACJA,oFAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,kBAAA;A9CkrRJ;A8ChrRQ;EACI,qBAAA;A9CkrRZ;ACvoRE;E6CxCE;IAEQ,eAAA;IACA,4BAAA;E9CirRV;AACF;A8C/qRI;EACI,4BAAA;A9CirRR;A8C/qRI;EACI,aAAA;EACA,WAAA;EACA,yBAAA;A9CirRR;A8ChrRQ;EACI,gBAAA;EACA,WAAA;EACA,uBAAA;A9CkrRZ;A8C9qRI;EACI,mBAAA;A9CgrRR;A8C9qRY;EACI,YAAA;EACA,aAAA;A9CgrRhB;ACtrRE;E6CIU;IAIQ,YAAA;E9CkrRlB;AACF;ACzsRE;E6CkBU;IAOQ,YAAA;E9CorRlB;AACF;;ACzrRE;E6CaM;IACI,iBAAA;E9CgrRV;E8C/qRU;IACI,gBAAA;E9CirRd;E8C5qRc;IACI,6BAAA;E9C8qRlB;E8C3qRU;IACI,mBAAA;E9C6qRd;E8C3qRU;IACI,8BAAA;E9C6qRd;AACF;A8CzqRA,kFAAA;ACvEA,wEAAA;A9CmDE;E8ChDM;IAEQ,gBAAA;IACA,WAAA;E/CivRd;AACF;ACntRE;E8ClCM;IAMQ,gBAAA;E/CmvRd;AACF;;A+C/uRA,sEAAA;ACdA,8FAAA;AACA;EACE,iCAAA;EAEA,mDAAA;EAEA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;AhDiwRF;AgDhwRE;EAEE,mDAAA;AhDkwRJ;AgDhwRE;EACE,eAAA;AhDkwRJ;AgDhwRE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AhDkwRJ;AgD9vRM;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;AhDgwRR;AgD9vRM;EACE,wBAAA;AhDgwRR;;AgDzvRI;EACE,mBAAA;AhD4vRN;AgDxvRI;EACE,mBAAA;AhD0vRN;AgDtvRI;EACE,mBAAA;AhDwvRN;AgDpvRI;EACE,mBAAA;AhDsvRN;AgDlvRI;EACE,mBAAA;AhDovRN;AgDhvRI;EACE,mBAAA;AhDkvRN;AgD9uRI;EACE,mBAAA;AhDgvRN;AgD5uRI;EACE,mBAAA;AhD8uRN;;AgD1uRA,4FAAA;AC7EQ;EADJ;IAEQ,mBAAA;EjD4zRV;AACF;AiD1zRI;EACI,oBAAA;AjD4zRR;;AkDn0RA,kGAAA;AAEI;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,mCAAA;AlDq0RR;AkDn0RI;EACI,UAAA;EACA,iCAAA;AlDq0RR;;AkD/zRQ;EACI,sBAAA;EACA,kCAAA;AlDk0RZ;AkDh0RQ;EACI,sBAAA;AlDk0RZ;;AkD9zRA,gGAAA;AC5BA,uEAAA;AAEI;EACI,2BAAA;AnD61RR;ACpzRE;EkD1CE;IAGQ,2BAAA;EnD+1RV;AACF;ACv0RE;EkD5BE;IAMQ,0BAAA;EnDi2RV;AACF;;AmD91RA,qEAAA;ACZA,uBAAA;AACA;EACI,yFAAA;ApD82RJ;;AoD52RA,qBAAA;ACJA,6EAAA;AACA;EACI,yBAAA;EACA,uDAAA;ArDo3RJ;;ACz1RE;EoDvBE;IAEQ,sBAAA;ErDm3RV;AACF;;AqDh3RA,2EAAA;ACbA,uBAAA;AAEI;EACI,YAAA;EACA,cAAA;EACA,aAAA;AtDg4RR;;AsD33RI;;;;;;EAMI,oCAAA;AtD83RR;AsD53RI;EACI,oCAAA;AtD83RR;;AsD13RI;;;;;;EAMI,sCAAA;AtD63RR;AsD33RI;EACI,sCAAA;AtD63RR;;AsD13RA,qBAAA;ACnCA,6FAAA;AACA;EACI,4DAAA;EACA,kBAAA;AvDi6RJ;AC/3RE;EsDpCF;IAIQ,0DAAA;EvDm6RN;AACF;AC34RE;EsD7BF;IAOQ,0DAAA;EvDq6RN;AACF;ACv5RE;EsDtBF;IAUQ,0DAAA;EvDu6RN;AACF;AuDt6RI;EACI,YAAA;EACA,oBAAA;AvDw6RR;ACz5RE;EsDjBE;IAIQ,sBAAA;EvD06RV;AACF;AuDx6RI;EACI,gBAAA;AvD06RR;ACj6RE;EsDVE;IAGQ,gBAAA;EvD46RV;AACF;ACp7RE;EsDIE;IAMQ,gBAAA;EvD86RV;AACF;ACz7RE;EsDaE;IAEQ,iBAAA;EvD86RV;AACF;AuD56RI;EACI,2DAAA;EACA,eAAA;EACA,cAAA;AvD86RR;ACn8RE;EsDkBE;IAKQ,cAAA;IACA,6BAAA;IACA,gBAAA;IACA,mBAAA;EvDg7RV;AACF;;AuD76RA,2FAAA;AC9CA,sBAAA;AAEI;EACI,sDAAA;AxD89RR;;AwD39RA,oBAAA;ACNA,yFAAA;AAEI;EACI,aAAA;AzDo+RR;;AyD/9RI;EACI,yBAAA;AzDk+RR;AyDj+RQ;EACI,gBAAA;EACA,cAAA;AzDm+RZ;;AyD99RA;EACI,yBAAA;AzDi+RJ;;AyD/9RA;EACI,aAAA;EACA,sBAAA;AzDk+RJ;;AyDh+RA,uFAAA;ACxBA,oFAAA;AACA;EACI,6CAAA;A1D4/RJ;A0D3/RI;EACI,gBAAA;A1D6/RR;;A0Dz/RA;EACI,6FAAA;A1D4/RJ;;A0D1/RA,kFAAA;ACXA,uEAAA;A1DuBE;E0DrBE;IAEQ,sBAAA;E3DwgSV;AACF;;A2DrgSA,qEAAA;ACRA,KAAA;AAGQ;EACI,gBAAA;A5D+gSZ;;A4D3gSA,KAAA;ACRA,wFAAA;AAEI;EACI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;A7DshSR;;A6DnhSA,sFAAA;ACTA,8FAAA;A7DUE;E6DRE;IAEQ,sBAAA;E9D+hSV;AACF;;A8D5hSA,4FAAA;ACRA,2FAAA;AACA;EACI,oCAAA;EACA,eAAA;A/DwiSJ;A+DviSI;EAHJ;IAIQ,eAAA;E/D0iSN;AACF;;A+DviSA;EACI,kBAAA;EACA,cAAA;A/D0iSJ;;A+DviSA;EACI,UAAA;EACA,sBAAA;EACA,YAAA;A/D0iSJ;A+DziSI;EACI,wBAAA;EACA,YAAA;EACA,QAAA;EACA,oBAAA;A/D2iSR;;A+DxiSA;EACI,QAAA;EACA,SAAA;A/D2iSJ;;A+DxiSA;EACI,sCAAA;A/D2iSJ;;A+DxiSA;EACI;IACI,uBAAA;E/D2iSN;E+DziSE;IACI,yBAAA;E/D2iSN;E+DziSE;IACI,yBAAA;E/D2iSN;AACF;A+DziSA,yFAAA;AC7CA,8FAAA;AACA;EACI,6FAAA;AhEylSJ;;AgEvlSA,4FAAA;ACJA;EACI,aAAA;EACA,SAAA;AjE+lSJ;;AkEjmSA,sFAAA;AAEI;EACI,2BAAA;AlEmmSR;;AkE9lSI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AlEimSR;AkEhmSQ;EACI,WAAA;EACA,SAAA;AlEkmSZ;AkEhmSQ;EACI,WAAA;EACA,SAAA;AlEkmSZ;AkE9lSgB;EACI,gBAAA;EACA,mBAAA;EACA,UAAA;AlEgmSpB;AkE3lSI;EACI,0CAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;AlE6lSR;;AkE1kSA,oFAAA;ACtDA,0GAAA;AAGQ;EADJ;IAEQ,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;EnEmoSV;AACF;;AmE9nSI;EADJ;IAEQ,kBAAA;IACA,MAAA;IACA,WAAA;EnEkoSN;AACF;AmEjoSI;EANJ;IAOQ,SAAA;EnEooSN;AACF;AmEnoSI;EATJ;IAUQ,OAAA;EnEsoSN;AACF;;AmEnoSA;EACI,gBAAA;AnEsoSJ;AmEroSI;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;AnEuoSR;AmEtoSQ;EACI,oBAAA;AnEwoSZ;AmEtoSQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,2EAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AnEwoSZ;AmEnoSQ;EACI,8BAAA;EACA,qBAAA;AnEqoSZ;;AmE/nSI;EACI,aAAA;EACA,gBAAA;AnEkoSR;AmE/nSQ;EACI,0BAAA;AnEioSZ;AmEhoSY;EACI,iBAAA;EACA,gBAAA;AnEkoShB;;AmE5nSI;EACI,wBAAA;AnE+nSR;;AmE1nSQ;EADJ;IAEQ,wBAAA;EnE8nSV;AACF;;AmE3nSA,wGAAA;ACvFA,yFAAA;AAGQ;EACI,mDAAA;ApEotSZ;AoEhtSI;EACI,YAAA;ApEktSR;;AoE7sSA;EACI,kBAAA;ApEgtSJ;;AoE7sSI;EACI,iBAAA;EACA,oBAAA;ApEgtSR;;AoE7sSA,uFAAA;ACvBA,yFAAA;AAEI;EADJ;IAEQ,aAAA;ErEwuSN;AACF;;AqEtuSA;EACI,aAAA;EACA,2DAAA;EACA,SAAA;ArEyuSJ;;AqEtuSA;EACI;IACI,2DAAA;ErEyuSN;EqExuSM;IACI,aAAA;IACA,mBAAA;IACA,mBAAA;ErE0uSV;EqEzuSU;IACI,gBAAA;IACA,uBAAA;ErE2uSd;EqEzuSU;IACI,wBAAA;IACA,iBAAA;IACA,YAAA;ErE2uSd;AACF;AqEtuSA;EACI;IACI,wBAAA;ErEwuSN;AACF;AqEruSA;EACI;IACI,eAAA;IACA,MAAA;IACA,aAAA;IACA,sBAAA;IACA,WAAA;IACA,OAAA;IACA,2BAAA;IACA,gBAAA;IACA,YAAA;IACA,uCAAA;IACA,4BAAA;IACA,uBAAA;ErEuuSN;EqEtuSM;IACI,wBAAA;ErEwuSV;EqEtuSM;IACI,2BAAA;IACA,oBAAA;ErEwuSV;AACF;AqEruSA,uFAAA;AC7DA,gFAAA;AAEI;EACI,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AtEoySR;AsEnySQ;EACI,eAAA;AtEqySZ;AsE9xSA,8EAAA;AChBA,6EAAA;AAEI;EACI,aAAA;AvEgzSR;AuE/ySQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,gCAAA;EACA,UAAA;EACA,wBAAA;EACA,8CAAA;AvEizSZ;;AuE7ySA,2EAAA;AChBA,2EAAA;AACA;EACI,mBAAA;AxEi0SJ;AwEh0SI;EACI,gBAAA;AxEk0SR;;AwE/zSA,yEAAA;ACNI;EACI,kBAAA;AzEy0SR;AyEv0SY;EACI,aAAA;AzEy0ShB;AyEt0SQ;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,iCAAA;AzEw0SZ;AyEv0SY;EARJ;IASQ,aAAA;EzE00Sd;AACF;;A0E51SA,sFAAA;AACA;EACI,aAAA;EACA,6CAAA;EACA,SAAA;A1E+1SJ;AC9zSE;EyEpCF;IAKQ,yCAAA;E1Ei2SN;AACF;ACx1SE;EyEfF;IAQQ,qCAAA;E1Em2SN;AACF;A0El2SI;EACI,yCAAA;A1Eo2SR;ACp0SE;EyEjCE;IAGQ,qCAAA;E1Es2SV;AACF;;A0Ej2SI;EACI,aAAA;A1Eo2SR;;A0Ej2SA,oFAAA;ACxBA,gGAAA;AACA;EACI,aAAA;EACA,iDAAA;EACA,SAAA;A3E63SJ;ACr1SE;E0E3CF;IAKQ,6CAAA;E3E+3SN;AACF;ACj2SE;E0EpCF;IAQQ,yCAAA;E3Ei4SN;AACF;AC33SE;E0EfF;IAWQ,qCAAA;E3Em4SN;AACF;A2El4SI;EACI,yCAAA;A3Eo4SR;ACv2SE;E0E9BE;IAGQ,qCAAA;E3Es4SV;AACF;;A2Eh4SI;EACI,YAAA;A3Em4SR;A2Ej4SI;EACI,YAAA;EACA,yBAAA;A3Em4SR;;A2Eh4SA,8FAAA;AChCA;EACE,aAAA;A5Eo6SF;;A4Eh6SE;EACE,WAAA;A5Em6SJ;A4E/5SI;EACE,WAAA;A5Ei6SN;;A4E35SE;EACE,mBAAA;A5E85SJ;ACz5SE;E2ENA;IAII,mBAAA;E5E+5SJ;AACF;A4E35SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5E65SN;AC/4SE;E2ElBE;IAOI,UAAA;E5E85SN;AACF;AC35SE;E2EXE;IAWI,UAAA;E5E+5SN;AACF;AC96SE;E2EGE;IAeI,UAAA;E5Eg6SN;AACF;A4E75SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5E+5SN;ACp6SE;E2ECE;IAOI,UAAA;E5Eg6SN;AACF;ACh7SE;E2EQE;IAWI,UAAA;E5Ei6SN;AACF;ACn8SE;E2EsBE;IAeI,UAAA;E5Ek6SN;AACF;ACj8SE;E2EeE;IAmBI,WAAA;E5Em6SN;AACF;;A4E75SE;EACE,mBAAA;A5Eg6SJ;ACj9SE;E2EgDA;IAII,iBAAA;E5Ei6SJ;AACF;A4E75SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5E+5SN;ACv8SE;E2EoCE;IAOI,UAAA;E5Eg6SN;AACF;ACn9SE;E2E2CE;IAWI,UAAA;E5Ei6SN;AACF;ACt+SE;E2EyDE;IAeI,UAAA;E5Ek6SN;AACF;A4E/5SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Ei6SN;AC59SE;E2EuDE;IAOI,UAAA;E5Ek6SN;AACF;ACx+SE;E2E8DE;IAWI,UAAA;E5Em6SN;AACF;ACp/SE;E2EqEE;IAeI,WAAA;E5Eo6SN;AACF;AChgTE;E2E4EE;IAmBI,UAAA;E5Eq6SN;AACF;;A4E/5SE;EACE,mBAAA;A5Ek6SJ;ACzgTE;E2EsGA;IAII,mBAAA;E5Em6SJ;AACF;A4E/5SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5Ei6SN;AC//SE;E2E0FE;IAOI,UAAA;E5Ek6SN;AACF;AC3gTE;E2EiGE;IAWI,UAAA;E5Em6SN;AACF;AC9hTE;E2E+GE;IAeI,UAAA;E5Eo6SN;AACF;A4Ej6SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Em6SN;ACphTE;E2E6GE;IAOI,UAAA;E5Eo6SN;AACF;AChiTE;E2EoHE;IAWI,UAAA;E5Eq6SN;AACF;AC5iTE;E2E2HE;IAeI,WAAA;E5Es6SN;AACF;ACxjTE;E2EkIE;IAmBI,UAAA;E5Eu6SN;AACF;;A4Ej6SE;EACE,mBAAA;A5Eo6SJ;A4Ej6SE;EACE,WAAA;EACA,YAAA;A5Em6SJ;A4E/5SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;A5Ei6SN;A4E95SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Eg6SN;;A4E15SE;EACE,mBAAA;A5E65SJ;ACrlTE;E2EuLA;IAII,mBAAA;E5E85SJ;AACF;A4E15SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5E45SN;AC3kTE;E2E2KE;IAOI,UAAA;E5E65SN;AACF;ACvlTE;E2EkLE;IAWI,UAAA;E5E85SN;AACF;AC1mTE;E2EgME;IAeI,UAAA;E5E+5SN;AACF;A4E55SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5E85SN;AChmTE;E2E8LE;IAOI,UAAA;E5E+5SN;AACF;AC5mTE;E2EqME;IAWI,UAAA;E5Eg6SN;AACF;ACxnTE;E2E4ME;IAeI,WAAA;E5Ei6SN;AACF;ACpoTE;E2EmNE;IAmBI,UAAA;E5Ek6SN;AACF;;A4E55SE;EACE,mBAAA;A5E+5SJ;AC7oTE;E2E6OA;IAII,mBAAA;E5Eg6SJ;AACF;A4E55SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5E85SN;ACnoTE;E2EiOE;IAOI,UAAA;E5E+5SN;AACF;AC/oTE;E2EwOE;IAWI,UAAA;E5Eg6SN;AACF;AClqTE;E2EsPE;IAeI,UAAA;E5Ei6SN;AACF;A4E95SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Eg6SN;ACxpTE;E2EoPE;IAOI,UAAA;E5Ei6SN;AACF;ACpqTE;E2E2PE;IAWI,UAAA;E5Ek6SN;AACF;AChrTE;E2EkQE;IAeI,WAAA;E5Em6SN;AACF;AC5rTE;E2EyQE;IAmBI,UAAA;E5Eo6SN;AACF;;A4E95SE;EACE,mBAAA;A5Ei6SJ;ACrsTE;E2EmSA;IAII,mBAAA;E5Ek6SJ;AACF;A4E95SI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;A5Eg6SN;AC3rTE;E2EuRE;IAOI,WAAA;E5Ei6SN;AACF;ACvsTE;E2E8RE;IAWI,WAAA;E5Ek6SN;AACF;AC1tTE;E2E4SE;IAeI,WAAA;E5Em6SN;AACF;A4Eh6SI;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;A5Ek6SN;AChtTE;E2E0SE;IAOI,WAAA;E5Em6SN;AACF;AC5tTE;E2EiTE;IAWI,WAAA;E5Eo6SN;AACF;ACxuTE;E2EwTE;IAeI,WAAA;E5Eq6SN;AACF;ACpvTE;E2E+TE;IAmBI,WAAA;E5Es6SN;AACF;;A4Eh6SE;EACE,mBAAA;A5Em6SJ;AC7vTE;E2EyVA;IAII,iBAAA;E5Eo6SJ;AACF;A4Eh6SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5Ek6SN;ACnvTE;E2E6UE;IAOI,UAAA;E5Em6SN;AACF;AC/vTE;E2EoVE;IAWI,UAAA;E5Eo6SN;AACF;AClxTE;E2EkWE;IAeI,UAAA;E5Eq6SN;AACF;A4El6SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Eo6SN;ACxwTE;E2EgWE;IAOI,UAAA;E5Eq6SN;AACF;ACpxTE;E2EuWE;IAWI,UAAA;E5Es6SN;AACF;AChyTE;E2E8WE;IAeI,WAAA;E5Eu6SN;AACF;AC5yTE;E2EqXE;IAmBI,UAAA;E5Ew6SN;AACF;;A4El6SE;EACE,mBAAA;A5Eq6SJ;ACrzTE;E2E+YA;IAII,mBAAA;E5Es6SJ;AACF;A4El6SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5Eo6SN;AC3yTE;E2EmYE;IAOI,UAAA;E5Eq6SN;AACF;ACvzTE;E2E0YE;IAWI,UAAA;E5Es6SN;AACF;AC10TE;E2EwZE;IAeI,UAAA;E5Eu6SN;AACF;A4Ep6SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Es6SN;ACh0TE;E2EsZE;IAOI,UAAA;E5Eu6SN;AACF;AC50TE;E2E6ZE;IAWI,UAAA;E5Ew6SN;AACF;ACx1TE;E2EoaE;IAeI,WAAA;E5Ey6SN;AACF;ACp2TE;E2E2aE;IAmBI,UAAA;E5E06SN;AACF;;A4Ep6SE;EACE,WAAA;A5Eu6SJ;;A4El6SE;EACE,mBAAA;A5Eq6SJ;ACj3TE;E2E2cA;IAII,mBAAA;E5Es6SJ;AACF;A4El6SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5Eo6SN;ACv2TE;E2E+bE;IAOI,UAAA;E5Eq6SN;AACF;ACn3TE;E2EscE;IAWI,UAAA;E5Es6SN;AACF;ACt4TE;E2EodE;IAeI,UAAA;E5Eu6SN;AACF;A4Ep6SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Es6SN;AC53TE;E2EkdE;IAOI,UAAA;E5Eu6SN;AACF;ACx4TE;E2EydE;IAWI,UAAA;E5Ew6SN;AACF;ACp5TE;E2EgeE;IAeI,WAAA;E5Ey6SN;AACF;ACh6TE;E2EueE;IAmBI,UAAA;E5E06SN;AACF;;A4Ep6SE;EACE,mBAAA;A5Eu6SJ;A4En6SI;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A5Eq6SN;AC/6TE;E2EsgBE;IAOI,WAAA;E5Es6SN;AACF;A4En6SI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,UAAA;A5Eq6SN;;A4E/5SE;EACE,wBAAA;EACA,QAAA;A5Ek6SJ;A4Eh6SI;EACE,SAAA;A5Ek6SN;A4E/5SI;EACE,WAAA;A5Ei6SN;;A4E35SE;EACE,wBAAA;A5E85SJ;A4E55SE;EACE,uBAAA;A5E85SJ;A4E55SE;EACE,WAAA;A5E85SJ;;A4Ez5SE;;EAEE,WAAA;EACA,kBAAA;EACA,mBAAA;A5E45SJ;A4Ez5SE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EAEA,4CAAA;A5E05SJ;A4Ev5SE;EACE,eAAA;EACA,SAAA;EACA,4CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;A5Ey5SJ;A4Ev5SI;EACE,aAAA;A5Ey5SN;;A4Ep5SA;EACE,mDAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A5Eu5SF;;A4Ep5SA;EACE,wBAAA;EACA,uBAAA;EACA,mBAAA;A5Eu5SF;;A4Ep5SA;EACE,WAAA;EACA,mBAAA;A5Eu5SF;;A4Ep5SA;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,oCAAA;A5Eu5SF;;A4Ep5SA;EACE,iBAAA;EACA,YAAA;EACA,oCAAA;EACA,4CAAA;A5Eu5SF;;A4Ep5SA;EACE,iBAAA;EACA,YAAA;EACA,oCAAA;EACA,4CAAA;A5Eu5SF;;A4Ep5SA;EACE;IACE,yBAAA;IACA,aAAA;IACA,gBAAA;IACA,SAAA;IACA,oCAAA;E5Eu5SF;E4Ep5SA;IACE,iBAAA;IACA,YAAA;IACA,sCAAA;E5Es5SF;AACF;A4En5SA;EACE,kBAAA;EACA,UAAA;A5Eq5SF;;A4El5SA;EACE,aAAA;A5Eq5SF;;A4El5SA;EACE,kCAAA;A5Eq5SF;;A4El5SA;EACE,uBAAA;A5Eq5SF;;AC9iUE;E2E4pBF;IAEI,yBAAA;E5Eq5SF;AACF;;ACpjUE;E2EkqBF;IAEI,wBAAA;E5Eq5SF;AACF;;A4El5SA;EACE,yBAAA;A5Eq5SF;;A4El5SA;EACE,iBAAA;A5Eq5SF;;A4El5SA;EACE,mBAAA;EACA,UAAA;A5Eq5SF;;A4Ej5SE;EACE,kBAAA;A5Eo5SJ;;A4Eh5SA;EACE,WAAA;A5Em5SF;;A4E54SE;;;;EACE,wBAAA;A5Ek5SJ;A4Eh5SE;;;;EACE,gDAAA;A5Eq5SJ;A4Ep5SI;;;;EACE,wBAAA;EACA,WAAA;A5Ey5SN;;A4En5SE;EACE,wBAAA;A5Es5SJ;A4Ep5SE;EACE,UAAA;A5Es5SJ;;A4Ej5SE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;EACA,SAAA;A5Eo5SJ;A4El5SE;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;A5Eo5SJ;A4Ej5SI;EACE,WAAA;A5Em5SN;;A4E74SE;EACE,aAAA;EACA,wBAAA;A5Eg5SJ;A4E94SE;EACE,QAAA;EACA,2BAAA;A5Eg5SJ;;AC5oUE;E2EiwBA;IAEI,aAAA;E5E84SJ;AACF","sourcesContent":["/*====================== CSS Index Here =======================*/\n/*\n01. Abstracts\n    1.1. Classes\n    1.2. Extend\n    1.3. Functions\n    1.4. Mixins\n    1.5. Variable\n    1.6. Wordpress Default\n\n02. Base\n    2.1. Margin\n    2.2. Padding\n    2.3. Typography\n\n03. Components\n    3.1. Accordion\n    3.2. Button\n    3.3. Form\n    3.4. Pagination\n    3.6. Tab\n\n04. Layout\n    4.1. Blog Sidebar\n    4.2. Breadcrumb\n    4.3. Comment\n    4.4. Footer\n    4.5. Header Top\n    4.6. Header\n    4.7. Preloader\n    4.8. Scroll Top\n    4.9. Section Heading\n    4.10. Slick\n    4.11. Social Icon\n*/\n/*======================== CSS Index End ======================*/","/* Convert to Rem start */\n$font-base: 16px;\n@function rem($target, $context: $font-base) {\n  @if ($target == 0) {\n    @return 0;\n  }\n  @return calc($target / $context * 1rem);\n}\n/* Convert to Rem End */\n\n\n/* ======================== Functions Css End ======================= */\n// Convert px to REM \n@function convertToRem($px) {\n  $val: calc($px / 16);\n  @return $val;\n}\n@function formatFloatingNumber($number) {\n  @return calc(round($number * 1000) / 1000);\n}\n@function clampCal($minSize, $maxSize, $minWidth: 768, $maxWidth: 1399) {\n  $minREMsize: convertToRem($minSize);\n  $maxREMsize: convertToRem($maxSize);\n  $minREMwidth: convertToRem($minWidth);\n  $maxREMwidth: convertToRem($maxWidth);\n\n  $slopFontCal: calc($maxREMsize - $minREMsize);\n  $slopWidthCal: calc($maxREMwidth - $minREMwidth);\n  $slop: calc($slopFontCal / $slopWidthCal);\n\n  $minusWidth: calc($minREMwidth * -1);\n  $xAxisIntersection: calc($minusWidth * $slop + $minREMsize);\n  $preferred: calc($slop * 100);\n\n  $xAxisMax: formatFloatingNumber($xAxisIntersection);\n  $preferredMax: formatFloatingNumber($preferred);\n\n  @return clamp(\n    #{$minREMsize}rem,\n    #{$xAxisMax}rem + #{$preferredMax}vw,\n    #{$maxREMsize}rem\n  );\n}\n\n\n// Use of this function, Please Uncomment this class and see how it works \n// .demoClass {\n//   padding: clampCal(24, 40);\n//   font-size: clampCal(20, 48);\n// }\n// ============ If You need all properties you can use like this way ============ \n// .demoClass {\n//   padding: clampCal(24, 40, 424, 991); // Here Properties are small device padding, Large device padding, small device width, Large device width   \n// }\n/* ======================== Functions Css End ======================= */\n\n","/* Font Family*/\n@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Exo:ital,wght@0,100..900;1,100..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Outfit:wght@100..900&family=Quicksand:wght@300..700&display=swap');\n\n$colors: (\n  \"main\": (\n    \"50\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.9)),\n    \"100\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.8)),\n    \"200\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.7)),\n    \"300\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.6)),\n    \"400\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.5)),\n    \"500\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) + (100% - var(--main-l)) * 0.4)),\n    \"600\": hsl(var(--main-h), var(--main-s), var(--main-l)), // main theme color\n    \"700\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) - var(--main-l) * 0.1)),\n    \"800\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) - var(--main-l) * 0.2)),\n    \"900\": hsl(var(--main-h), var(--main-s), calc(var(--main-l) - var(--main-l) * 0.3))\n  ),\n  \"main-two\": (\n    \"50\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.9)),\n    \"100\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.8)),\n    \"200\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.7)),\n    \"300\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.6)),\n    \"400\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.5)),\n    \"500\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) + (100% - var(--main-two-l)) * 0.4)),\n    \"600\": hsl(var(--main-two-h), var(--main-two-s), var(--main-two-l)), // main-two theme secondary color\n    \"700\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) - var(--main-two-l) * 0.1)),\n    \"800\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) - var(--main-two-l) * 0.2)),\n    \"900\": hsl(var(--main-two-h), var(--main-two-s), calc(var(--main-two-l) - var(--main-two-l) * 0.3))\n  ),\n  \n  \"neutral\": (\n    \"50\": #ECF1F9,\n    \"100\": #E6E6E6,\n    \"200\": #CCCCCC,\n    \"300\": #B3B3B3,\n    \"400\": #999999,\n    \"500\": #808080,\n    \"600\": #121535,\n    \"700\": #060710,\n    \"800\": #11132e,\n    \"900\": #1A1A1A,\n  ),\n  \n  \"gray\": (\n    \"50\": #F1F1F1,\n    \"100\": #E6E6E6,\n    \"200\": #CCCCCC,\n    \"300\": #B3B3B3,\n    \"400\": #999999,\n    \"500\": #808080,\n    \"600\": #666666,\n    \"700\": #4D4D4D,\n    \"800\": #333333,\n    \"900\": #1A1A1A,\n  ),\n\n\n\n  \"light\": (\n    \"50\": #F5F6FA,\n    \"100\": #F3F4F6,\n    \"600\": #E4F1FF,\n    \"700\": #374151,\n    \"800\": #1F2937,\n  ),\n  \n  \"primary\": (\n    \"50\": #E4F1FF,\n    \"100\": #BFDCFF,\n    \"200\": #95C7FF,\n    \"300\": #6BB1FF,\n    \"400\": #519FFF,\n    \"500\": #458EFF,\n    \"600\": #487FFF,\n    \"700\": #486CEA,\n    \"800\": #4759D6,\n    \"900\": #4536B6\n  ),\n\n  \"danger\": (\n    \"50\": #FEF2F2,\n    \"100\": #FEE2E2,\n    \"200\": #FECACA,\n    \"300\": #FCA5A5,\n    \"400\": #F87171,\n    \"500\": #EF4444,\n    \"600\": #DC2626,\n    \"700\": #B91C1C,\n    \"800\": #991B1B,\n    \"900\": #7F1D1D\n  ),\n\n  \"success\": (\n    \"50\": #F0FDF4,\n    \"100\": #DCFCE7,\n    \"200\": #BBF7D0,\n    \"300\": #86EFAC,\n    \"400\": #4ADE80,\n    \"500\": #22C55E,\n    \"600\": #27AE60,\n    \"700\": #15803D,\n    \"800\": #166534,\n    \"900\": #14532D\n  ),\n\n  \"warning\": (\n    \"50\": #FEFCE8,  \n    \"100\": #FEF9C3,\n    \"200\": #FEF08A,\n    \"300\": #FDE047,\n    \"400\": #FACC15,\n    \"500\": #EAB308,\n    \"600\": #FF9F29,\n    \"700\": #f39016,\n    \"800\": #e58209,\n    \"900\": #d77907\n  ),\n\n  \"info\": (\n    \"50\": #EFF6FF,\n    \"100\": #DBEAFE,\n    \"200\": #BFDBFE,\n    \"300\": #93C5FD,\n    \"400\": #60A5FA,\n    \"500\": #3B82F6,\n    \"600\": #2563EB,\n    \"700\": #1D4ED8,\n    \"800\": #1E40AF,\n    \"900\": #1E3A8A\n  ),\n\n  \"tertiary\": (\n    \"50\": #d1c8ff,\n    \"100\": #c2b6ff,\n    \"600\": #3C23B5,\n  ),\n);\n\n// Space\n$spaces: (\n  \"2\": #{rem(2px)},\n  \"3\": #{rem(3px)},\n  \"4\": #{rem(4px)},\n  \"5\": #{rem(5px)},\n  \"6\": #{rem(6px)},\n  \"7\": #{rem(7px)},\n  \"8\": #{rem(8px)},\n  \"9\": #{rem(9px)},\n  \"10\": #{rem(10px)},\n  \"11\": #{rem(11px)},\n  \"12\": #{rem(12px)},\n  \"13\": #{rem(13px)},\n  \"14\": #{rem(14px)},\n  \"16\": #{rem(16px)},\n  \"18\": #{rem(18px)},\n  \"20\": #{rem(20px)},\n  \"22\": #{rem(22px)},\n  \"24\": #{rem(24px)},\n  \"26\": #{rem(26px)},\n  \"28\": #{rem(28px)},\n  \"30\": #{rem(30px)},\n  \"32\": #{rem(32px)},\n  \"36\": #{rem(32px)},\n  \"40\": #{rem(40px)}, \n  \"44\": #{rem(44px)}, \n  \"48\": #{rem(48px)},\n  \"52\": #{rem(52px)},\n  \"56\": #{rem(56px)},\n  \"60\": #{rem(60px)},\n  \"64\": #{rem(64px)},\n  \"68\": #{rem(68px)},\n  \"72\": #{rem(72px)},\n  \"76\": #{rem(76px)},\n  \"80\": #{rem(80px)},\n  \"90\": #{rem(90px)},\n  \"110\": #{rem(110px)},\n  \"120\": #{rem(120px)},\n  \"144\": #{rem(144px)},\n  \"160\": #{rem(160px)},\n  \"210\": #{rem(210px)},\n);\n\n$font-sizes: (\n  \"xs\": #{rem(12px)},\n  \"sm\": #{rem(14px)},\n  \"md\": #{rem(16px)},\n  \"lg\": #{rem(18px)},\n  \"xl\": #{rem(20px)},\n  \"2xl\": #{rem(24px)},\n  \"3xl\": #{rem(30px)},\n  \"4xl\": #{rem(36px)},\n  \"5xl\": #{rem(48px)},\n  \"6xl\": #{rem(60px)},\n);\n\n/* ========================= Variable Css Start ======================== */\n:root {    \n\n  /* Font Family Variable */\n  --heading-font: \"Quicksand\", sans-serif ;\n  --heading-font-two: \"Exo\", sans-serif;\n  --heading-font-three: \"Outfit\", sans-serif;;\n  --heading-font-four: \"Dancing Script\", cursive;;\n  --body-font: \"Inter\", sans-serif;\n  \n  /* Font Size Variable Start */  \n  --heading-one: clamp(2.25rem, -0.0733rem + 6.3692vw, 4.5rem); // Min:36px - Max:72px\n  --heading-two: clamp(2rem, 0.7133rem + 2.8846vw, 3.5rem); // Min: 32px - Max: 56px\n  --heading-three: clamp(1.75rem, 0.3353rem + 2.1661vw, 3rem); // Min: 28px - Max: 48px\n  --heading-four: clamp(1.5rem, 0.5569rem + 1.444vw, 2.5rem); // Min: 24px - Max: 40px\n  --heading-five: clamp(1.25rem, 1.2rem + 0.722vw, 2.25rem); // Min: 20px - Max: 36px\n  --heading-six: clamp(1.125rem, 0.769rem + 0.6813vw, 1.5rem); // Min: 18px - Max-24px\n\n  --display-200: clamp(3.75rem, -0.0733rem + 6.3692vw, 12.5rem); // Min:40px - Max:200px\n  --display-one: clamp(2.5rem, -0.0733rem + 6.3692vw, 7.5rem); // Min:40px - Max:120px\n  /* Font Size End */\n\n  /* template main color */\n  --main-h: 148;\n  --main-s: 59%;\n  --main-l: 39%;\n  --main: var(--main-h) var(--main-s) var(--main-l);\n\n  /* template main color */\n  --main-two-h: 25;\n  --main-two-s: 100%;\n  --main-two-l: 49%;\n  --main-two: var(--main-two-h) var(--main-two-s) var(--main-two-l);\n\n   /* White Color */\n  --white: 0 0% 100%;\n  --black: 235 49% 14%;\n  --light: 0 0% 51%;\n  \n  --heading-color: var(--black);\n  --body-color: var(--light);\n  --body-bg: var(--gray);\n  --border-color: 236 13% 77%;\n\n  --bg-color-one: #F3FAF2; \n  --bg-color-two: #FFFBF4; \n  --bg-color-three: #F1F1F1; \n  --neutral: #121535; \n\n  --translate-x-middle: translateX(-50%); \n  --translate-y-middle: translateY(-50%); \n    \n  // spacing\n  @each $property, $value in $spaces {\n    --size-#{$property}: #{$value};\n  }\n  \n  // Colors\n  @each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      --#{$color}-#{$shade}: #{$value};\n    }\n  }\n\n  // font sizes\n  @each $property, $value in $font-sizes {\n    --font-#{$property}: #{$value};\n  }  \n}\n/* ========================= Variable Css End ======================== */\n","// Plugin CSS\n@import \"~animate.css\";\n@import \"slick-carousel/slick/slick.css\";\n@import \"slick-carousel/slick/slick-theme.css\";\n@import 'select2/dist/css/select2.min.css';\n@import \"/public/assets/sass/main.scss\";","/* ============================ Mixins Css Start ============================ */\n/* Media Breakpoint for Each Device Start */\n@mixin xxsm-screen {\n  @media screen and (max-width: 374px) {\n    @content;\n  }\n}\n\n// Xtra Small\n@mixin xsm-screen {\n  @media screen and (max-width: 424px) {\n    @content;\n  }\n}\n// Medium Small Screen (max-width: 575)\n@mixin msm-screen {\n  @media screen and (max-width: 575px) {\n    @content;\n  }\n}\n\n//Small Screen (max-width: 767)\n@mixin sm-screen {\n  @media screen and (max-width: 767px) {\n    @content;\n  }\n}\n\n//Large Screen (max-width: 991)\n@mixin md-screen {\n  @media screen and (max-width: 991px) {\n    @content;\n  }\n}\n\n//Xtra Large Screen (max-width: 1199)\n@mixin lg-screen {\n  @media screen and (max-width: 1199px) {\n    @content;\n  }\n}\n\n//Xtra Large Screen i (max-width: 1399)\n@mixin xl-screen {\n  @media screen and (max-width: 1399px) {\n    @content;\n  }\n}\n\n//Xtra Large Screen ii (max-width: 1499)\n@mixin xxl-screen {\n  @media screen and (max-width: 1499px) {\n    @content;\n  }\n}\n//Xtra Large Screen ii (max-width: 1599)\n@mixin xxxl-screen {\n  @media screen and (max-width: 1599px) {\n    @content;\n  }\n}\n/* Media Breakpoint for Each Device End */\n\n/* ============================ Mixins Css End ============================ */\n","/* =========================== Accordion Css start ============================= */ \n.common-accordion {\n    .accordion-item {\n        border: 1px solid var(--border-color);\n        background-color: hsl(var(--white)) !important;\n        border-radius: 8px;\n        overflow: hidden;\n        &:not(:last-child) {\n            margin-block-end:20px;\n        }\n    }\n    .accordion-header {\n        line-height: 1;\n    }\n    .accordion-body {\n        padding: 20px 30px;\n        \n        padding-block-start: 0;\n        @include msm-screen {\n            padding: 12px 20px;\n            padding-block-start: 0;\n        }\n    }\n    &:first-of-type .accordion-button.collapsed {\n        border-radius: 5px;  \n    }\n    &:last-of-type .accordion-button.collapsed {\n        border-radius: 5px;  \n    }\n    .accordion-button{\n        color: var(--heading-color);\n         \n        padding: 20px 30px;\n        padding-inline-end: 46px; \n        font-weight: 600;\n        font-size: clampCal(16, 20);\n        font-family: var(--heading-font);\n        @include msm-screen {\n            padding: 12px 20px;\n            padding-inline-end: 36px;\n        }\n        &::after {\n            background-image: none;\n        }\n        &:focus {\n            box-shadow: none;\n        }\n        &:not(.collapsed) {\n            background-color: transparent !important;\n            box-shadow: none;\n            color: hsl(var(--main));\n            &::after {\n                background-image: none;\n                color: hsl(var(--main)); ; \n            }\n        }\n        &[aria-expanded=\"true\"], &[aria-expanded=\"false\"] {\n            &::after {\n                font-family: \"Phosphor\";\n                font-weight: 900;\n                content: \"\\E136\";\n                color: hsl(var(--main));\n                display: inline-block;\n                position: absolute;\n                inset-block-start: 50%;\n                transform: translateY(-50%);\n                inset-inline-end: 30px;\n                height: unset;\n                 \n                text-align: center;\n                @include msm-screen {\n                    inset-inline-end: 20px;\n                }\n            }\n        }\n        &[aria-expanded=\"false\"] {\n            &::after {\n                content: \"\\f107\";\n                color: hsl(var(--heading-color));\n            }\n        }\n    }\n}\n/* ================================= Accordion Css End =========================== */","/* ================================= Button Css Start =========================== */\n.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\n    color: none;\n    background-color: none;\n    border-color: none;\n}\n\n.btn {\n    position: relative;\n    border-radius: 5px;\n    border: 1px solid transparent;\n    font-weight: 500;\n    font-family: var(--body-font);\n    color: hsl(var(--white)) !important;\n    z-index: 1;\n    line-height: 1;\n    padding: 13px 24px;\n    &:hover, &:focus, &:focus-visible {\n        box-shadow: none !important;\n    }\n    @include xl-screen {\n        padding: 10px 20px;         \n        font-size: rem(14px);\n    }\n    &-sm {\n        padding: 10px 16px !important;\n    }\n    &:active {\n        transform: scale(1.01);\n    }\n    // ============= Different Color Button Start ==================\n    &-main {\n        background-color: hsl(var(--main)) !important;\n        border-color: hsl(var(--main)) !important;\n        &:hover {\n            background-color: var(--main-800) !important;\n            border-color: var(--main-800) !important;\n        }\n    }\n    &-outline-main {\n        background-color: transparent!important;\n        border-color: hsl(var(--main)) !important;\n        color: hsl(var(--main)) !important;\n        &:hover {\n            background-color: hsl(var(--main)/.15) !important;\n            border-color: hsl(var(--main)/.4) !important;\n        }\n    }\n    &-main-two {\n        background-color: hsl(var(--main-two)) !important;\n        border-color: hsl(var(--main-two)) !important;\n        color: hsl(var(--white)) !important;\n        &:hover {\n            background-color: var(--main-two-800) !important;\n            border-color: var(--main-two-800) !important;\n        }\n    }\n    &-outline-main-two {\n        background-color: transparent!important;\n        border-color: hsl(var(--main-two)) !important;\n        color: hsl(var(--main-two)) !important;\n        &:hover {\n            background-color: hsl(var(--main-two)/.15) !important;\n            border-color: hsl(var(--main-two)/.4) !important;\n        }\n    }\n    &-white {\n        background-color: hsl(var(--white)) !important;\n        border-color: hsl(var(--white)) !important;\n        color: hsl(var(--heading-color)) !important;\n        &:hover {\n            background-color: hsl(var(--white)/.9) !important;\n            border-color: hsl(var(--white)/.9) !important;\n        }\n    }\n    &-outline-white {\n        background-color: transparent!important;\n        border-color: hsl(var(--white)) !important;\n        color: hsl(var(--white)) !important;\n        &:hover {\n            background-color: hsl(var(--white)) !important;\n            border-color: hsl(var(--white)) !important;\n            color: hsl(var(--heading-color)) !important;\n        }\n    }\n    &-black {\n        background-color: hsl(var(--black)) !important;\n        border-color: hsl(var(--black)) !important;\n        color: hsl(var(--white)) !important;\n        &:hover {\n            background-color: hsl(var(--black)/.8) !important;\n            border-color: hsl(var(--black)/.8) !important;\n        }\n    }\n    &-outline-black {\n        background-color: transparent!important;\n        border-color: hsl(var(--black)) !important;\n        color: hsl(var(--black)) !important;\n        &:hover {\n            background-color: hsl(var(--black)) !important;\n            border-color: hsl(var(--black)) !important;\n            color: hsl(var(--white)) !important;\n        }\n    }\n}\n/* ================================= Button Css End =========================== */","/* ================================= Form Css Start =========================== */\n/* input Start */\n.common-input {\n    border-radius: 5px;\n    font-weight: 400;\n    outline: none;\n    width: 100%;\n    padding: 17px 24px;\n    background-color: transparent !important; \n    border: 1px solid var(--gray-100);\n    color: hsl(var(--black)); \n    line-height: 1;\n    &.style-two {\n        background-color: hsl(var(--white)) !important;\n        color: hsl(var(--black)); \n    }\n    @include md-screen {\n        padding: 12px 24px;\n    }\n    @include sm-screen {\n        padding: 10px 16px;\n         \n    }\n    &::placeholder {\n        color: var(--gray-500);\n        transition: .2s linear;\n        font-size: rem(14px);\n        font-weight: 400;\n    }\n    &--md {\n        padding: 13px 16px;\n         \n    }\n    &--lg {\n        padding: 23px 24px;\n        @include sm-screen {\n            padding: 18px 24px;\n        }\n    } \n    &:focus {\n        border-color: hsl(var(--main)); \n        box-shadow: none;\n        &::placeholder {\n            visibility: hidden;\n            opacity: 0;\n        }\n    }\n    &:disabled, &[readonly] {\n        background-color: hsl(var(--black)/.2); \n        opacity: 1;\n        border: 0;\n    }\n    &[type=\"password\"] {\n        color: hsl(var(--black)/.5);\n        &:focus {\n            color: hsl(var(--black)); \n        }\n    }\n    &[type=\"file\"] {\n        line-height: 50px;\n        padding: 0;\n        position: relative;\n        &::file-selector-button {\n            border: 1px solid hsl(var(--black) / .08);\n            padding: 4px 6px;\n            border-radius: .2em;\n            background-color: hsl(var(--main)) !important;\n            transition: .2s linear;\n            line-height: 25px;\n            position: relative;\n            margin-inline-start: 15px;\n            color: hsl(var(--body-color)) !important;\n            &:hover {\n                background-color: hsl(var(--main));\n                border: 1px solid hsl(var(--main));\n                color: hsl(var(--black));\n            }\n        }\n    }\n}\n.common-input {\n    &--withIcon {\n        padding-inline-end: 50px !important;\n    }\n    &--withLeftIcon {\n        padding-inline-start: 50px !important;\n    }\n}\n/* input End */\n\n/* input icon */\n.input-icon {\n    position: absolute;\n    inset-inline-end: 24px;\n    inset-block-start: 50%;\n    transform: translateY(-50%);\n    color: hsl(var(--heading-color));\n     \n    &--left {\n        inset-inline-start: 20px;\n        inset-inline-end: auto;\n    }\n}\ntextarea+.input-icon {\n    inset-block-start: 15px;\n    transform: translateY(0);\n}\n/* input icon */\n\n/* Label */\n.form-label {\n    margin-block-end: 6px;\n    color: hsl(var(--heading-color));\n    font-weight: 500;\n}\n\n/* Form Select */  \n.select-has-icon {\n    position: relative;\n    &::before {\n        position: absolute;\n        content: \"\\f107\";\n        inset-inline-end: 20px;\n        inset-block-start: 50%;\n        transform: translateY(-50%);\n        font-family: \"Phosphor\";\n        font-weight: 900;\n         \n        color: hsl(var(--main)); \n        transition: 0.2s linear;\n        pointer-events: none;\n        color: hsl(var(--black)) !important; \n    }\n    &.icon-black::before {\n        -webkit-text-fill-color: hsl(var(--black)); \n    }\n    select {\n        background-image: none;\n        -webkit-appearance: none;\n        padding: 20px 24px;\n        font-size: 18px;\n        @include md-screen {\n            padding: 15px 24px;\n        }\n        @include sm-screen {\n            padding: 12px 16px;\n        }\n    }\n    .common-input {\n        padding-inline-end: 30px !important;\n    }\n} \n.select {\n    color: hsl(var(--black) / .6) !important;\n    padding: 16px 24px;\n    @include md-screen {\n        padding: 11px 24px;\n    }\n    @include sm-screen {\n        padding: 9px 24px;\n         \n    }\n    &:focus {\n        border-color: hsl(var(--main));\n        color: hsl(var(--black)) !important;\n        outline: none;\n    }\n    option {\n        background-color: hsl(var(--white));\n        color: hsl(var(--heading-color));\n    }\n}\n/* Form Select End */\n\n// Message Field Css\ntextarea {\n    &.common-input {\n        height: 140px;\n        @include sm-screen {\n            height: 110px;\n        }\n    }\n}\n/* Autofill Css */\ninput:-webkit-autofill, input:-webkit-autofill:hover, input:-webkit-autofill:focus, input:-webkit-autofill:active, \ntextarea:-webkit-autofill, textarea:-webkit-autofill:hover, textarea:-webkit-autofill:focus, textarea:-webkit-autofill:active {\n    -webkit-transition: background-color 5000s ease-in-out 0s;\n    transition: background-color 5000s ease-in-out 0s;\n}\ninput:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill, textarea:-webkit-autofill, textarea:-webkit-autofill, textarea:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0px 1000px transparent inset;\n    -webkit-text-fill-color: hsl(var(--heading-color)) !important;\n    caret-color: hsl(var(--heading-color));\n}\n/* Autofill Css End */\n\n/* Show Hide Password */\ninput#your-password, input#confirm-password {\n    padding-inline-end: 50px;\n}\n.password-show-hide {\n    position: absolute;\n    inset-inline-end: 20px;\n    z-index: 5;\n    cursor: pointer;\n    inset-block-start: 50%;\n    transform: translateY(-50%);\n    color: hsl(var(--black)/.4);\n}\n\n/* Number Arrow None */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\ninput[type=number]{\n    -moz-appearance: textfield;\n}\n\n/* Custom Checkbox & Radio Css Start */\n.common-check {\n    @extend .flex-align; \n    margin-block-end: 16px;\n    &:last-child {\n        margin-block-end: 0;\n    }\n    a {\n        display: inline;\n    }\n    &.common-radio {\n        .form-check-input {\n            border-radius: 50%;\n            &:checked { \n                background-color: transparent !important;\n                &::after {\n                    visibility: visible;\n                    opacity: 1;\n                    -webkit-transform: translate(-50%, -50%) scale(1);\n                    transform: translate(-50%, -50%) scale(1);\n                }\n            }\n        }\n    }\n\n    .form-check-input {\n        transition: .2s linear;\n        box-shadow: none;\n        background-color: transparent;\n        box-shadow: none !important;\n        border: 0;\n        position: relative;\n        border-radius: 3px;\n        width: 18px;\n        height: 18px;\n        border: 1px solid hsl(var(--black) / .4);   \n        cursor: pointer;\n        transition: .2s linear;\n        margin-block-start: 0;\n        &::before {\n            position: absolute;\n            content: \"\\E182\";\n            font-family: \"Phosphor\";\n            font-weight: 900;\n            color: hsl(var(--white)); \n            font-size: 12px;\n            inset-block-start: 50%;\n            inset-inline-start: 50%;\n            transform: translate(-50%, -50%);\n            transition: .2s linear;\n            visibility: hidden;\n            opacity: 0;\n        }\n        &::after {\n            position: absolute;\n            content: \"\";\n            inset-block-start: 50%;\n            inset-inline-start: 50%;\n            -webkit-transform: translate(-50%, -50%) scale(.2);\n            transform: translate(-50%, -50%) scale(.2);\n            width: 10px;\n            height: 10px;\n            background-color: hsl(var(--main));\n            border-radius: 50%;\n            transition: .2s linear;\n            z-index: 1;\n            visibility: hidden;\n            opacity: 0;\n        }\n        &:checked {\n            background-color: hsl(var(--main)) !important;\n            border-color: hsl(var(--main)) !important;\n            box-shadow: none;\n            &[type=checkbox] {\n                background-image:none;\n            }\n            &::before {\n                visibility: visible;\n                opacity: 1;\n            }\n        }\n    }\n    .form-check-label {\n        font-weight: 500;\n        width: calc(100% - 18px);\n        padding-inline-start: 12px;\n        cursor: pointer;\n         \n        color: hsl(var(--heading-color)); \n        font-family: var(--poppins-font)\n    }\n}\n\n.checked {\n    &-black {\n        .form-check-input {\n            border: 1px solid hsl(var(--black));   \n            &::after {\n                background-color: hsl(var(--black));\n            }\n            &:checked {\n                background-color: hsl(var(--black)) !important;\n                border-color: hsl(var(--black)) !important;\n            }\n        }\n    }\n    &-primary {\n        .form-check-input {\n            border: 1px solid var(--primary-600);   \n            &::after {\n                background-color: var(--primary-600);\n            }\n            &:checked {\n                background-color: var(--primary-600) !important;\n                border-color: var(--primary-600) !important;\n            }\n        }\n    }\n    &-gray {\n        .form-check-input {\n            border: 1px solid var(--gray-600);   \n            &::after {\n                background-color: var(--gray-600);\n            }\n            &:checked {\n                background-color: var(--gray-600) !important;\n                border-color: var(--gray-600) !important;\n            }\n        }\n    }\n    &-success {\n        .form-check-input {\n            border: 1px solid var(--success-600);   \n            &::after {\n                background-color: var(--success-600);\n            }\n            &:checked {\n                background-color: var(--success-600) !important;\n                border-color: var(--success-600) !important;\n            }\n        }\n    }\n    &-danger {\n        .form-check-input {\n            border: 1px solid var(--danger-600);   \n            &::after {\n                background-color: var(--danger-600);\n            }\n            &:checked {\n                background-color: var(--danger-600) !important;\n                border-color: var(--danger-600) !important;\n            }\n        }\n    }\n    &-purple {\n        .form-check-input {\n            border: 1px solid var(--tertiary-600);   \n            &::after {\n                background-color: var(--tertiary-600);\n            }\n            &:checked {\n                background-color: var(--tertiary-600) !important;\n                border-color: var(--tertiary-600) !important;\n            }\n        }\n    }\n    &-white {\n        .form-check-input {\n            border: 1px solid var(--gray-100);   \n            &::after {\n                background-color: var(--gray-100);\n            }\n            &:checked {\n                background-color: var(--gray-100) !important;\n                border-color: var(--gray-100) !important;\n            }\n        }\n    }\n}\n/* Custom Checkbox & Radio Css End */\n\n.toggle-password.active::before {\n    content: \"\\e220\" !important;\n}\n/* ================================= Form Css End =========================== */","/* ================================= Pagination Css Start =========================== */\n.pagination {\n    margin-block-start: 64px;\n    @include lg-screen {\n        margin-block-start: 48px;\n    }\n    @include md-screen {\n        margin-block-start: 40px;\n    }\n    @include sm-screen {\n        margin-block-start: 32px;\n    }\n    .page-item {\n        &.active {\n            .page-link {\n                background-color: var(--main-600) !important;\n                border-color: var(--main-600) !important;\n                color: hsl(var(--white)) !important;\n            }\n        }\n        .page-link {\n            box-shadow: none !important;   \n            &:hover, &:active, &:focus {\n                color: var(--main-600) !important;\n                background-color: var(--main-100) !important;\n                border-color: var(--main-300) !important;\n                \n            }\n        }\n    }\n}\n/* ================================= Pagination Css End =========================== */","/* ================================= Tab Css Start =========================== */\n.common-tab {\n    margin-block-end: 20px;\n    gap: 8px;\n    .nav-item {\n        border-bottom: 0;\n        .nav-link {\n            color: var(--gray-500);\n            padding: 9px 24px !important;\n            background-color: transparent;\n            transition: .2s linear;\n            border: 1px solid var(--border-color);\n            position: relative;\n            font-weight: 400;\n            overflow: hidden;\n            border-radius: 50px;\n            font-size: 16px;\n            @include xl-screen {\n                padding: 6px 16px !important;\n                font-size: rem(14px);\n            }\n            &.active {\n                color: hsl(var(--white)) !important; \n                border-color: var(--main-600) !important;\n                background-color: var(--main-600) !important;\n            }\n            &:hover {\n                color: var(--main-600);\n            }\n        }\n    }\n    &.style-two {\n        .nav-link {\n            border: 1px solid var(--gray-100);\n            color: var(--neutral-600);\n            &.active {\n                color: hsl(var(--white)) !important; \n                border-color: var(--main-two-600) !important;\n                background-color: var(--main-two-600) !important;\n            }\n            &:hover {\n                color: var(--main-two-600);\n            }\n        }\n    }\n}\n/* ================================= Tab Css End =========================== */\n","/* ======================= Common Table Css Start ======================= */\n.table-card {\n    border: 1px solid hsl(var(--white)/.2);\n    border-radius: 10px;\n    padding: clampCal(20, 36);\n}\n.table {\n    color: hsl(var(--white));\n    margin-block-end: 0;\n    min-width: max-content;\n    &>:not(caption)>*>* {\n        border-bottom: 0;\n    }\n    tr {\n        th {\n            padding-inline-start: 0;\n            padding: 32px;\n            &:first-child {\n                padding-inline-start: 0;\n            }\n            &:last-child {\n                padding-inline-end: 0;\n            }\n        }\n        th, td {\n            text-align: center;\n            vertical-align: middle;\n            &:first-child {\n                text-align: left;\n            }\n            &:last-child {\n                text-align: right;\n                padding-inline-end: 0;\n            }\n        }\n    }\n    thead {\n        tr {\n            border-bottom: 1px solid hsl(var(--white)/.2);\n            th {\n                padding-block-start: 0;\n                font-size: clampCal(16, 20);\n                font-weight: 400;\n                padding-block-end: clampCal(16, 30);\n            }\n        }\n    }\n    tbody {\n        tr {\n            border-bottom: 1px solid hsl(var(--white)/.2);\n            &:last-child {\n                border-bottom: 0;\n                td {\n                    padding-block-end: 0;\n                }\n            }\n            td {\n                font-size: clampCal(14, 16);\n                font-weight: 400;\n                padding: clampCal(16, 30) 0;\n            }\n        }\n    }\n\n    &.style-two {\n        color: hsl(var(--heading-color));\n        thead tr, tbody tr {\n            border-bottom: 1px solid hsl(var(--black)/.1);\n        }\n        thead tr th {\n            padding-block-end: 16px;\n            font-size: 15px;\n        }\n    }\n    &.style-three {\n        tbody tr {\n            border-bottom: 1px solid var(--gray-100);\n            &:last-child {\n                border: 0;\n            }\n            td {\n                &:first-child {\n                    padding-inline-start: 0;\n                }\n                &:last-child {\n                    padding-inline-end: 0;\n                }\n            }\n            td {\n                padding: clampCal(24, 40) 24px;\n            }\n        }\n    }\n}\n/* ======================= Common Table Css End ======================= */","/* ================= Common Card Css Start ========================= */\n.common-card {\n    border: 0;\n    .card-header, .card-footer {\n        padding: 12px 24px;\n        background-color: transparent;\n        border-bottom: 1px solid var(--border-color);\n        @include xsm-screen {\n            padding: 12px 16px;\n        }\n    }\n    .card-header {\n        background-color: hsl(var(--black));\n        .title {\n            color: hsl(var(--white));\n            margin-block-end: 0;\n        }\n    }\n    .card-body {\n        padding: 24px;\n        @include xsm-screen {\n            padding: 16px;\n        }\n    }\n    .card-footer {\n        border-top: 1px solid var(--border-color);\n        border-bottom: 0;\n    }\n}\n/* ================= Common Card Css End ========================= */","/* ======================= Select 2 Css Start =========================== */\n.select2-container--default .select2-selection--single {\n    border: 0;\n}\n\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n    border: 0;\n    position: relative;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow b::before {\n    position: relative;\n    content: \"\\e136\";\n    font-family: \"Phosphor\";\n    font-weight: 900;\n    color: hsl(var(--heading-color) / 0.4);\n    transition: 0.2s linear;\n}\n\n.select2-container--open.select2-container--default .select2-selection--single .select2-selection__arrow b::before {\n    content: \"\\E13C\" !important;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n    border: 0 !important;\n    margin: 0 !important;\n    inset-block-start: 0 !important;\n    inset-inline-start: 0 !important;\n    position: relative !important; \n}\n\n\n.select2-container {\n    height: inherit !important;\n    width: auto !important;\n}\n\n.select2-selection.select2-selection--single {\n    height: inherit !important;\n    border: 1px solid var(--gray-200) !important;\n    background-color: transparent !important;\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n}\n.radius-end-0 {\n    .select2-selection.select2-selection--single {\n        border-start-start-radius: 50px !important;\n        border-end-start-radius: 50px !important;\n    }\n}\n\n.select2-selection.select2-selection--single {\n    position: relative;\n}\n.select2-container .selection {\n    height: inherit;\n}\n\n.select2-selection__arrow {\n    right: 16px !important;\n    inset-block-start: 50% !important;\n    transform: translateY(-50%) !important;\n    width: unset !important;\n    @include lg-screen {\n        right: 6px !important;\n    }\n}\n\n.select2-container .select2-selection--single .select2-selection__rendered {\n    padding-inline-start: 24px !important;\n    padding-inline-end: 40px !important;\n    @include lg-screen {\n        padding-inline-start: 10px !important;\n        padding-inline-end: 24px !important;\n    }\n}\n\n.select-border-end-0 {\n    .select2-selection.select2-selection--single { \n        border-inline-end: 0 !important;\n    }\n}\n\n\n\n.select2-dropdown {\n    border: 1px solid var(--gray-100) !important;  \n    padding: 10px !important;  \n    border-radius: 6px !important;  \n    min-width: 200px;\n    @include sm-screen {\n        min-width: 170px;\n    }\n    @include xsm-screen {\n        min-width: 150px;\n    }\n}\n\n.select2-search--dropdown {\n    padding: 0 !important;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field {\n    border: 1px solid var(--gray-100) !important;\n    border-radius: 6px !important;\n    padding: 4px 10px;\n}\n.select2-container--default .select2-search--dropdown .select2-search__field:focus-visible {\n    outline: 1px solid var(--main-200);\n}\n\n.select2-results {\n    margin-block-start: 8px !important;\n}\n\n\n.select2-results__option.select2-results__option--selectable {\n    border-radius: 6px !important;\n    padding: 6px 12px !important;\n    color: var(--gray-500);\n    font-size: 14px !important;\n    @include sm-screen {\n        padding: 4px 10px !important;\n        font-size: 12px !important;\n    }\n}\n\n.select2-container--default .select2-results__option--highlighted.select2-results__option--selectable {\n    background-color:  var(--main-600) !important;\n    color: white !important;\n}\n.select2-results__option.select2-results__option--selectable:hover {\n    background-color: var(--main-100) !important;\n    color: var(--main-600) !important;\n}\n\n.select2-container--default .select2-results__option--selected, .select2-container--default .select2-results__option--selected:hover {\n    background-color: var(--main-600) !important;\n    color: #fff !important;\n}\n\n.select2-container--default .select2-results>.select2-results__options {\n    padding-inline-end: 8px;\n    &::-webkit-scrollbar {\n        width: 6px;\n    }\n    &::-webkit-scrollbar-track {\n        background: #e4e4e4;\n    }\n    &::-webkit-scrollbar-thumb {\n        background: #a2a2a2;\n        border-radius: 50px;\n    }\n    &::-webkit-scrollbar-thumb:hover {\n        background: #6d6d6d;\n    }\n}\n\n\n.select2-container--open {\n    &.select2-container--default .select2-selection--single {\n        .select2-selection__rendered {\n            color: var(--main-600) !important;\n        }\n        .select2-selection__arrow b::before {\n            color: var(--main-600) !important;\n        }\n    }\n}\n\n\n/* Location Box Css  */\n.location-box {\n    .select2-container .select2-selection--single .select2-selection__rendered {\n        padding-inline-start: 0px !important;\n        padding-inline-end: 50px !important;\n    }\n    .select2-selection__arrow {\n        right: 0px !important;\n        inset-block-start: 10% !important;\n    }\n    .select2-selection.select2-selection--single {\n        border: 0 !important;\n    }\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        line-height: 14px;\n        color: var(--gray-900);\n        font-weight: 700;\n        font-family: var(--heading-font-two);\n    }\n}\n\n\n.select2-container--open .select2-dropdown {\n    @include md-screen {\n        left: -74px;\n    }\n    @include xsm-screen {\n        left:   -40px;\n    }\n}\n\n\n@include md-screen {\n    .location-box, .search-category.h-48 {\n        height: 40px !important;\n        .select2-selection__rendered {\n            font-size: 12px;\n        }\n    }\n}\n/* ======================= Select 2 Css End =========================== */","/* ========================== Count Down Css Start =============================== */\n.countdown-list {\n    gap: 20px;\n    @include xl-screen {\n        gap: 6px;\n    }\n    &__item {\n        background-color: hsl(var(--white));\n        padding: clampCal(6, 12, 1399, 1599) clampCal(8, 16, 1399, 1599);\n        border-radius: 8px;\n        position: relative;\n        @include xl-screen {\n            font-size: rem(12px) !important;\n        }\n        &:last-child {\n            &::before {\n                display: none;\n            }\n        }\n        &::before {\n            position: absolute;\n            content: \":\";\n            inset-block-start: 50%;\n            inset-inline-end: -10px;\n            transform: translateY(-50%);\n            font-weight: 700;\n            @include xl-screen {\n                display: none;\n            }\n        }\n        &.colon-white {\n            &::before {\n                color: #fff;\n            }\n        }\n    }\n\n    &.style-two {\n        .countdown-list {\n            &__item {\n                background-color: var(--main-600);\n                color: #fff !important;\n                &::before {\n                    color: var(--main-600) !important;\n                }\n            }\n        }\n    }\n\n    &.style-three {\n        gap: 12px;\n        .countdown-list {\n            &__item {\n                background-color: var(--main-50);\n                font-size: 11px !important;\n                padding: 6px;\n                color: #1A1A1A !important;\n            }\n        }\n    }\n\n    &.style-four {\n        .countdown-list {\n            &__item {\n                width: 64px;\n                height: 64px;\n                align-items: center;\n                padding: 2px;\n                justify-content: center;\n                &::before {\n                    color: var(--neutral-600);\n                }\n            }\n        }\n    }\n}\n/* ========================== Count Down Css End =============================== */",".badge-notification {\n    margin-bottom: 6px;\n    position: absolute;\n    inset-block-start: -18px;\n    inset-inline-start: 0;\n    animation: notification .8s infinite;\n    &::before {\n        position: absolute;\n        content: \"\";\n        width: 11px;\n        height: 6px;\n        background-color: inherit;\n        top: calc(100% - 1px);\n        clip-path: polygon(0% 0%, 100% 0%, 0% 100%, 0% 100%);\n    }\n}\n\n.badge-style-two::before {\n    position: absolute;\n    content: \"\";\n    width: 12px;\n    height: 12px;\n    background: var(--main-two-600);\n    border-radius: 2px;\n    inset-inline-start: -4px;\n    transform: translateY(-50%) rotate(45deg);\n    top: 50%;\n}\n\n\n@keyframes notification {\n    0%, 100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: .3;\n    }\n}","/* ================================= Range Slider Css Start =========================== */\n.custom--range {\n\t#slider-range {\n\t\theight: 4px;\n\t\tborder: 0;\n\t\tbackground: var(--gray-200);\n        margin: 8px;\n\t\t.ui-slider-handle {\n\t\t\twidth: 16px !important;\n\t\t\theight: 16px !important;\n\t\t\tbackground-color: var(--main-600) !important;\n\t\t\tborder-radius: 50%;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t\tborder: 0 !important;\n\t\t\toutline: 0 !important;\n\t\t\ttransition: .2s linear;\n\t\t\t&:hover, &.ui-state-active {\n\t\t\t\ttransform: translateY(-50%) scale(1.3);\n\t\t\t}\n\t\t\t&.ui-state-active {\n                box-shadow: 0px 0px 12px 4px #95959541 !important;  \n\t\t\t}\n\t\t}\n\t\t.ui-widget-header {\n\t\t\tbackground-color: var(--main-600);\n            transition: .2s linear;\n\t\t}\n\t\tspan {\n\t\t\t&:focus {\n\t\t\t\tbackground-color: var(--main-600);\n\t\t\t}\n\t\t}\n\t}\n    &__prices{\n        width: 58px;\n    }\n\tinput {\n\t\tborder: 0;\n\t\tcolor: hsl(var(--body-color));\n\t\tfont-weight: 500;\n\t\toutline: 0;\n\t}\n}\n/* ================================= Range Slider Css End =========================== */","/* ================================= Typography Css Start =========================== */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--body-font);\n  color: hsl(var(--body-color));\n  word-break: break-word;\n  background-color: hsl(var(--white));\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\nhtml, body {\n  overflow-x: hidden;\n}\n\np {\n  font-weight: 400;\n  margin: 0;\n  line-height: 1.6;\n}\n\nspan {\n  display: inline-block;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0 0 16px 0;\n  font-family: var(--heading-font);\n  color: hsl(var(--heading-color));\n  line-height: 1.2;\n  font-weight: 700;\n}\nh1, .h1 {\n  font-size: var(--heading-one);\n}\nh2, .h2 {\n  font-size: var(--heading-two);\n}\nh3, .h3 {\n  font-size: var(--heading-three);\n}\nh4, .h4 {\n  font-size: var(--heading-four);\n}\nh5, .h5 {\n  font-size: var(--heading-five);\n}\nh6, .h6 {\n  font-size: var(--heading-six);\n}\n\nh1 > a,\nh2 > a,\nh3 > a,\nh4 > a,\nh5 > a,\nh6 > a {\n  font-weight: inherit;\n  font-size: inherit;\n  color: inherit;\n  transition: 0.2s linear;\n  line-height: inherit;\n  &:hover {\n    color: hsl(var(--main));\n  }\n}\n\na {\n  display: inline-block;\n  transition: 0.2s linear;\n  text-decoration: none;\n  color: #0661e9;\n}\na:hover {\n  color: #1d72f2;\n}\nimg {\n  max-width: 100%;\n  height: auto;\n}\nselect {\n  cursor: pointer;\n}\nul,\nol {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\nbutton {\n  border: 0;\n  background-color: transparent;\n  &:focus {\n    outline: none;\n    box-shadow: none;\n  }\n}\n.form-select:focus {\n  outline: 0;\n  box-shadow: none;\n}\ninput:focus-visible {\n  outline: 0;\n}\n/* ================================= Typography Css End =========================== */\n","/* ================================= Margin Css Start =========================== */\n@each $property, $value in $spaces {\n  .m-#{$property} {\n    margin: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .mx-#{$property} {\n    margin-inline: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .my-#{$property} {\n    margin-block: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .ms-#{$property} {\n    margin-inline-start: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .me-#{$property} {\n    margin-inline-end: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .mt-#{$property} {\n    margin-block-start: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .mb-#{$property} {\n    margin-block-end: var(--size-#{$property}) !important;\n  }\n}\n\n\n.mt-0 {\n  margin-block-start: 0!important;\n}\n\n.mb-0 {\n  margin-block-end: 0!important;\n}\n\n.ms-0 {\n  margin-inline-start: 0!important;\n}\n\n.me-0 {\n  margin-inline-end: 0!important;\n}\n\n.my-120 {\n  margin-block-start: 60px !important;\n  margin-block-end: 60px !important;\n  @media (min-width: 576px) {\n    margin-block-start: 80px !important;\n    margin-block-end: 80px !important;\n  }\n  @media (min-width: 992px) {\n    margin-block-start: 120px !important;\n    margin-block-end: 120px !important;\n  }\n}\n.mt-120 {\n    margin-block-start: 60px !important;\n    @media (min-width: 576px) {\n    margin-block-start: 80px !important;\n  }\n    @media (min-width: 992px) {\n    margin-block-start: 120px !important;\n  }\n}\n.mb-120 {\n    margin-block-end: 60px !important;\n    @media (min-width: 576px) {\n    margin-block-end: 80px !important;\n  }\n    @media (min-width: 992px) {\n    margin-block-end: 120px !important;\n  }\n}\n.my-60 {\n    margin-block-start: 30px !important;\n    margin-block-end: 30px !important;\n    @media (min-width: 576px) {\n    margin-block-start: 40px !important;\n    margin-block-end: 40px !important;\n  }\n    @media (min-width: 992px) {\n    margin-block-start: 60px !important;\n    margin-block-end: 60px !important;\n  }\n}\n.mt-60 {\n    margin-block-start: 30px !important;\n    @media (min-width: 576px) {\n    margin-block-start: 40px !important;\n  }\n    @media (min-width: 992px) {\n    margin-block-start: 60px !important;\n  }\n}\n  .mb-60 {\n    margin-block-end: 30px !important;\n    @media (min-width: 576px) {\n    margin-block-end: 40px !important;\n  }\n    @media (min-width: 992px) {\n    margin-block-end: 60px !important;\n  }\n}/* ================================= Margin Css End =========================== */\n","/* ================================= Padding Css Start =========================== */\n@each $property, $value in $spaces {\n  .p-#{$property} {\n    padding: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .px-#{$property} {\n    padding-inline: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .py-#{$property} {\n    padding-block: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .ps-#{$property} {\n    padding-inline-start: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .pe-#{$property} {\n    padding-inline-end: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .pt-#{$property} {\n    padding-block-start: var(--size-#{$property}) !important;\n  }\n}\n\n@each $property, $value in $spaces {\n  .pb-#{$property} {\n    padding-block-end: var(--size-#{$property}) !important;\n  }\n}\n\n.p--24 {\n  padding: 24px;\n}\n\n.p-56-px {\n  padding: clampCal(8, 56, 1299, 1699);\n}\n\n.pt-0 {\n  padding-block-start: 0!important;\n}\n\n.pb-0 {\n  padding-block-end: 0!important;\n}\n\n.ps-0 {\n  padding-inline-start: 0!important;\n}\n\n.pe-0 {\n  padding-inline-end: 0!important;\n}\n\n\n.py-100 {\n  padding-block-start: 40px !important;\n  padding-block-end: 40px !important;\n  @media (min-width: 992px) {\n    padding-block-start: 60px !important;\n    padding-block-end: 60px !important;\n  }\n  @media (min-width: 1200px) {\n    padding-block-start: 80px !important;\n    padding-block-end: 80px !important;\n  }\n  @media (min-width: 1400px) {\n    padding-block-start: 100px !important;\n    padding-block-end: 100px !important;\n  }\n}\n\n\n.py-80 {\n  padding-block-start: 60px !important;\n  padding-block-end: 60px !important;\n  @media (min-width: 992px) {\n    padding-block-start: 80px !important;\n    padding-block-end: 80px !important;\n  }\n}\n.pt-80 {\n    padding-block-start: 60px !important;\n    @media (min-width: 992px) {\n    padding-block-start: 80px !important;\n  }\n}\n.pb-80 {\n    padding-block-end: 60px !important;\n    @media (min-width: 992px) {\n    padding-block-end: 80px !important;\n  }\n}\n\n.py-60 {\n    padding-block-start: 30px !important;\n    padding-block-end: 30px !important;\n    @media (min-width: 576px) {\n    padding-block-start: 40px !important;\n    padding-block-end: 40px !important;\n  }\n    @media (min-width: 992px) {\n    padding-block-start: 60px !important;\n    padding-block-end: 60px !important;\n  }\n}\n.pt-60 {\n    padding-block-start: 30px !important;\n    @media (min-width: 576px) {\n    padding-block-start: 40px !important;\n  }\n    @media (min-width: 992px) {\n    padding-block-start: 60px !important;\n  }\n}\n  .pb-60 {\n    padding-block-end: 30px !important;\n    @media (min-width: 576px) {\n    padding-block-end: 40px !important;\n  }\n    @media (min-width: 992px) {\n    padding-block-end: 60px !important;\n  }\n}\n/* ================================= Padding Css End =========================== */\n","\n/* ================================= Classes Css Start =========================== */\n/* Section Background */\n.bg-color {\n    &-one {\n        // background-color: var(--bg-color-one) !important;\n        background-color: #ebf5ff !important;\n    }\n    &-two {\n        background-color: var(--bg-color-two) !important;\n    }\n    &-three {\n        background-color: var(--bg-color-three) !important;\n    }\n    &-neutral {\n        background-color: var(--neutral) !important;\n    }\n}\n\n.container-lg {\n    max-width: 1680px;\n}\n\n/* Column Extra Small Screen */\n.col-xs-6 {\n    @media screen and (min-width: 425px) and (max-width: 575px) {\n        width: 50%;\n    }\n}\n\n@media (min-width: 424px) {\n    .d-xs-flex {\n        display: flex !important;\n    }\n}\n\n.opacity {\n    &-6 {\n        opacity: .06 !important;\n    }\n}\n\n/* Transition */\n.transition {\n    &-1 {\n        transition: .1s linear;\n    }\n    &-2 {\n        transition: .2s linear;\n    }\n    &-3 {\n        transition: .3s linear;\n    }\n}\n\n.display-200 {\n    font-size: var(--display-200);\n}\n.display-one {\n    font-size: var(--display-one);\n}\n\n.min-width-max-content {\n    min-width: max-content;\n}\n\n.inset {\n    &-inline-start-0 {\n        inset-inline-start: 0 !important;\n    }\n    &-inline-start-100 {\n        inset-inline-start: 100% !important;\n    }\n    &-inline-start-auto {\n        inset-inline-start: auto !important;\n    }\n    &-inline-end-0 {\n        inset-inline-end: 0 !important;\n    }\n    &-inline-end-auto {\n        inset-inline-end: auto !important;\n    }\n    &-block-start-0 {\n        inset-block-start: 0 !important;\n    }\n    &-block-end-0 {\n        inset-block-end: 0 !important;\n    }\n}\n\n.start {\n    &-auto {\n        inset-inline-start: auto !important;\n    }\n}\n\n.end {\n    &-auto {\n        inset-inline-end: auto !important;\n    }\n}\n\n.line-height {\n    &-0 {\n        line-height: 0;\n    }\n    &-1 {\n        line-height: 1;\n    }\n    &-73 {\n        line-height: .73;\n    }\n}\n\n/* Text Color */\n.hover-text {\n    &-decoration-underline {\n        &:hover {\n            text-decoration: underline;\n        }\n    }\n    &-decoration-none {\n        &:hover {\n            text-decoration: none;\n        }\n    }\n}\n\n.font {\n    &-heading {\n        font-family: var(--heading-font);\n    }\n    &-heading-two {\n        font-family: var(--heading-font-two);\n    }\n    &-heading-four {\n        font-family: var(--heading-font-four);\n    }\n    &-body {\n        font-family: var(--body-font);\n    }\n}\n\n/* Bg Image Css */\n.bg-img {\n    background-size: cover !important;\n    background-repeat: no-repeat !important;\n    background-position: center center !important;\n    width: 100%;\n    height: 100%;\n}\n\n.list-inside {\n    list-style: inside !important;\n}\n.aspect-ratio-1 {\n    aspect-ratio: 1;\n}\n.cursor-pointer {\n    cursor: pointer;\n}\n\n\n.bg-blur {\n    backdrop-filter: blur(90px);\n    background-color: hsl(var(--white)/.3) !important;\n    transition: .2s linear;\n    &:hover {\n        transform: scale(1.2);\n    }\n}\n.rotate-10 {\n    transform: rotate(-10deg);\n}\n\n.bg-overlay {\n    &::before {\n        position: absolute;\n        content: \"\";\n        width: 100%;\n        height: 100%;\n        left: 0;\n        top: 0;\n        background: linear-gradient(0deg, rgba(18, 21, 53, 0.7) 0%, rgba(18, 21, 53, 0.7) 100%);\n        z-index: -1;\n    }\n    &.style-two {\n        &::before {\n            background: linear-gradient(180deg, rgb(18 21 53 / 47%) 34.18%, rgba(18, 21, 53, 0.5) 75.48%), linear-gradient(180deg, rgba(18, 21, 53, 0) 27.17%, rgba(18, 21, 53, 0.5) 79.35%);\n            z-index: 0;\n        }\n    }\n}\n\n.bg-start {\n    background-position: left !important;\n}\n\n.arrow-left-clip {\n    clip-path: polygon(10% 0, 100% 0, 100% 50%, 100% 100%, 10% 100%, 0% 50%);\n}\n\n.w-30-percent {\n    width: 30%;\n}\n\n.group {\n    &:hover {\n        .group-item-white {\n            color: hsl(var(--white)) !important;\n        }\n    }\n}\n/* ================================= Classes Css End =========================== */","\n/* ============================ Extend Css Start ======================== */\n/* Cover image Css */\n  .cover-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;  \n  }\n/* Display Flex Css Start */ \n  .flex-align {\n    display: flex;\n    align-items: center;\n  }\n  .flex-center {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .flex-between {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n/* Display Flex Css End */\n/* ============================ Extend Css End ======================== */\n\n","// width height\n@each $property, $value in $spaces {\n    .w-#{$property} {\n      width: $value !important;\n    }\n}\n\n.w {\n  &-300 {\n    width: 300px !important;\n  }\n  &-265 {\n    width: 265px !important;\n  }\n  &-unset {\n    width: unset !important;\n  }\n}\n\n@each $property, $value in $spaces {\n    .h-#{$property} {\n      height: $value !important;\n    }\n}\n.h-unset {\n  height: unset !important;\n}\n\n.max-h {\n  &-unset {\n    max-height: unset !important;\n  }\n  &-120 {\n    max-height: 120px !important;\n  }\n  &-200 {\n    max-height: 200px !important;\n  }\n  &-260 {\n    max-height: 260px !important;\n  }\n  &-300 {\n    max-height: 300px !important;\n  }\n  &-326 {\n    max-height: 326px !important;\n  }\n  &-400 {\n    max-height: 400px !important;\n  }\n  &-540 {\n    max-height: 540px !important;\n  }\n}\n\n.max-w {\n  &-unset {\n    max-width: unset !important;\n  }\n  &-120 {\n    max-width: 120px;\n  }\n  &-260 {\n    max-width: 260px !important;\n  }\n  &-375 {\n    max-width: 375px;\n  }\n  &-340 {\n    max-width: 340px;\n  }\n  &-392 {\n    max-width: 392px;\n  }\n  &-275 {\n    max-width: 275px;\n  }\n  &-472 {\n    max-width: 472px;\n  }\n  &-418 {\n    max-width: 418px;\n  }\n  &-990 {\n    max-width: 990px;\n  }\n}\n\n\n.min-h {\n  &-485 {\n    min-height: 485px;\n  }\n}\n\n.top-n6 {\n  inset-block-start: -6px;\n}\n\n.end-n4 {\n  inset-inline-end: -6px;\n}\n","\n// // Colors\n@each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      .text-#{$color}-#{$shade} {\n        color: var(--#{$color}-#{$shade}) !important;\n      }\n    }\n  }\n\n  \n.text {\n    &-heading {\n        color: hsl(var(--heading-color)) !important;\n    }\n    &-body {\n        color: hsl(var(--body-color)) !important;\n    }\n    &-main {\n        color: hsl(var(--main)) !important;\n    }\n}\n  \n  @each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      .hover-text-#{$color}-#{$shade} {\n        &:hover {\n            color: var(--#{$color}-#{$shade}) !important;\n        }\n      }\n    }\n  }\n\n/* Text Color */\n.hover-text {\n   &-white {\n        &:hover {\n            color: #fff !important;\n        }\n    }\n    &-heading {\n        &:hover {\n            color: hsl(var(--heading-color)) !important;\n        }\n    }\n    &-body {\n        &:hover {\n            color: hsl(var(--body-color)) !important;\n        }\n    }\n    &-main {\n        &:hover {\n            color: hsl(var(--main)) !important;\n        }\n    }\n}\n","// border\n@each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      .border-#{$color}-#{$shade} {\n        border-color: var(--#{$color}-#{$shade}) !important;\n      }\n    }\n}\n\n// hover border\n@each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      .hover-border-#{$color}-#{$shade} {\n        &:hover {\n            border-color: var(--#{$color}-#{$shade}) !important;\n        }\n      }\n    }\n}\n\n.border {\n  &-dashed {\n    border-style: dashed !important;\n  }\n  &-dotted {\n    border-style: dotted !important;\n  }\n}\n","// background\n@each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      .bg-#{$color}-#{$shade} {\n        // background-color: var(--#{$color}-#{$shade}) !important;\n        background-color: #2F8DD5 !important;\n      }\n    }\n}\n\n// hover background\n@each $color, $shades in $colors {\n    @each $shade, $value in $shades {\n      .hover-bg-#{$color}-#{$shade} {\n        &:hover {\n            // background-color: var(--#{$color}-#{$shade}) !important;\n            background-color: #83c0ee !important;\n        }\n      }\n    }\n  }\n\n  .hover-bg {\n    &-white {\n      &:hover {\n        background-color: hsl(var(--white)) !important;\n      }\n    }\n  }\n\n\n.bg-light-purple {\n  background: #ECDBEC !important;\n}\n\n.bg {\n  &-yellow-light {\n    background-color: #FFFCE1 !important;\n  }\n  &-danger-light {\n    background-color: #FFEBEE !important;\n  }\n  &-purple-light {\n    background-color: #F5E7FC !important;\n  }\n  &-danger-light {\n    background-color: #FFE2F5 !important;\n  }\n  &-warning-light {\n    background-color: #FBEEDD !important;\n  }\n  &-success-light {\n    background-color: #F6F5DB !important;\n  }\n}","/* Font Size Class Start */\n.text {\n    &-inherit {\n        font-size: inherit;\n    }\n}\n\n@each $property, $value in $font-sizes {\n    .text-#{$property} {\n      font-size: $value !important;\n    }\n}  \n\n@each $property, $value in $spaces {\n    .text-#{$property} {\n      font-size: $value !important;\n    }\n}  \n/* Font Size Class End */","\n/* Box shadow start */\n.box-shadow {\n    &-sm {\n      box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);  \n    }\n    &-md {\n      box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);  \n    }\n    &-lg {\n      box-shadow: 0px 7px 21px -5px rgb(0 0 0 / 10%), 0 4px 21px -4px rgb(0 0 0 / 10%);  \n    }\n    &-xl {\n      box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);  \n    }\n    &-2xl {\n      box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);  \n    }\n    &-inner {\n      box-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);  \n    }\n}\n/* Box shadow End */\n","/* Border Radius */\n@each $property, $value in $spaces {\n    .rounded-#{$property} {\n       border-radius: #{$value} !important;\n    }\n  }\n  \n\n  .rounded-top-right-0 {\n   border-top-right-radius: 0 !important;\n  }","\n/* Hide Scroll bar Css For Custom Modal */\n.scroll-hide {\n    position: absolute;\n    overflow-y: hidden;\n    padding-inline-end: 17px;\n    inset-block-start: 0;\n    inset-inline-start: 0;\n    width: 100%;\n    @include md-screen {\n        padding-inline-end: 0;\n    }\n    &-sm {\n        @include md-screen {\n            position: absolute;\n            overflow-y: hidden;\n            inset-block-start: 0;\n            inset-inline-start: 0;\n            width: calc(100% - 0px);\n        }\n    }\n}\n/* Hide Scroll bar Css For Custom Modal End */\n","\n/* Overlay Start */\n.overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    background-color: hsl(var(--black) / .6);\n    z-index: 99;\n    transition: .2s linear;\n    visibility: hidden;\n    opacity: 0;\n    &.show-overlay {\n        visibility: visible;\n        opacity: 1;\n    }\n}\n\n.side-overlay {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    content: \"\";\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    background-color: hsl(var(--black) / .6);\n    z-index: 8;\n    transition: .2s linear;\n    visibility: hidden;\n    opacity: 0;\n    @include md-screen {\n        &.show {\n            visibility: visible;\n            opacity: 1;\n        }\n    }\n}\n/* Overlay End */","\n// Line Clamp start\n.text-line-1 {\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n  \n.text-line-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n  \n.text-line-3 {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n  // Line Clamp End",".scroll-sm {\n    &::-webkit-scrollbar {\n      width: 4px !important;\n      height: 4px !important;\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #b1b3b8;\n      &:hover {\n        background-color: #7e7d7d;\n      }\n    }\n    &::-webkit-scrollbar-track {\n      background-color: #d6d9de;\n    }\n}","// Gap Css\n@each $property, $value in $spaces {\n    .gap-#{$property} {\n      gap: var(--size-#{$property}) !important;\n    }\n  }","/* Hover Classes Start */\n.item-hover {\n  &:hover {\n    .item-hover__text {\n      color: var(--main-600) !important;\n    }\n  }\n}\n.item-hover-two {\n  &:hover {\n    .item-hover__text {\n      color: var(--main-two-600) !important;\n    }\n  }\n}\n\n\n\n.on-hover-dropdown {\n    visibility: hidden;\n    opacity: 0;\n    margin-block-start: 16px;\n}\n\n.on-hover-item {\n    position: relative;\n    &:hover {\n        .on-hover-dropdown {\n            visibility: visible;\n            opacity: 1;\n            margin-block-start: 0;\n        }\n        > a {\n            &::before {\n                @media (min-width: 992px) {\n                    color: hsl(var(--main));\n                    transform: translateY(-50%) rotate(180deg);\n                }\n            }\n        }\n    }\n}\n/* Hover Classes End */\n",".g-8, .gy-8 {\n    --bs-gutter-y: .5rem !important;\n}\n.g-12, .gy-12 {\n    --bs-gutter-y: .75rem !important;\n}\n\n\n.g-8, .gx-8 {\n    --bs-gutter-x: .5rem !important;\n}\n.g-12, .gx-12 {\n    --bs-gutter-x: .75rem !important;\n}","/* ================================= preload Css Start =========================== */\n.preloader {\n  background-color: hsl(var(--white));\n  inset-block-end: 0;\n  inset-inline-start: 0;\n  position: fixed;\n  inset-inline-end: 0;\n  inset-block-start: 0;\n  z-index: 9999;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n/* ================================= preload Css End ===========================  */\n","/* =========================== header top Css Start =============================== */\n.header-top {\n    &__right {\n        @include sm-screen {\n            width: 100%;\n            li {\n                &:last-child {\n                    margin-inline-start: auto;\n                }\n                &:nth-last-child(2) {\n                    margin-inline-end: 0 !important;\n                    padding-inline-end: 0 !important;\n                    &::before {\n                        display: none;\n                    }\n                }\n               \n            }\n        }\n        &.style-two {\n           > li {\n                padding-inline-end: 16px !important; \n                margin-inline-end: 0 !important;\n                &:last-child {\n                    padding-inline-end: 0 !important;\n                }\n                &::before {\n                    display: none !important;\n                }\n                a {\n                    padding-inline-end: 20px;\n                    @include md-screen {\n                        color: #fff !important;\n                    }\n                    &::before {\n                        color: var(--heading-color) !important;\n                        font-size: 14px !important;\n                    }\n                }\n                > ul {\n                    inset-inline-end: auto !important;\n                    inset-inline-start: calc(-100% + -24px) !important;\n                    li a {\n                        @include md-screen {\n                            color: var(--neutral-600) !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n@include md-screen {\n    .border-right-item {\n        a {\n            font-size: 12px !important;\n        }\n    }\n}\n\n.border-right-item {\n    position: relative;\n    &:not(:last-child) {\n        margin-inline-end: 24px;\n        padding-inline-end: 24px;\n        @include xl-screen {\n            margin-inline-end: 16px !important;\n            padding-inline-end: 16px !important;\n        }\n        @include lg-screen {\n            margin-inline-end: 10px !important;\n            padding-inline-end: 10px !important;\n        }\n        &::before {\n            position: absolute;\n            content: \"\";\n            inset-block-start: 50%;\n            transform: translateY(-50%);\n            inset-inline-end: 0;\n            width: 1px;\n            height: 15px;\n            background-color: hsl(var(--white)/.3);\n        }\n    }\n    &-sm-space {\n        &:not(:last-child) {\n            margin-inline-end: 20px;\n            padding-inline-end: 20px;\n        }\n    }\n}\n/* Has Dropdown Css */\n.arrow-white {\n    > a {\n        padding-inline-end: 12px;\n        &::before {\n            color: hsl(var(--white)) !important; \n            font-size: 8px;\n        }\n    }\n}\n\n/* =========================== header top Css End =============================== */","/* ============= Header Start Here ======================= */\n.header {\n    transition: .2s linear;\n    &.fixed-header {\n        position: fixed;\n        inset-inline-start: 0;\n        inset-block-start: 0;\n        inset-inline-end: 0;\n        width: 100%;\n        z-index: 8;\n        backdrop-filter: blur(24px);\n        animation: slideDown 0.35s ease-out;    \n        box-shadow: 0 5px 16px rgba(0, 0, 0, 0.1);\n        @include md-screen {\n            inset-block-start: -1px;\n        }\n    }\n}\n\n@keyframes slideDown {\n    from {\n      transform: translateY(-100%);\n    }\n    to {\n      transform: translateY(0);\n    }\n}\n\n.logo {\n    img {\n        max-width: 200px;\n        @include xsm-screen {\n            max-width: 148px;\n        }\n    }\n}\n\n/* Header Menu and Submenu Css Start */\n.nav-menu {\n    gap: 32px;\n    @include xl-screen {\n        gap: 24px;\n    }\n    @include lg-screen {\n        gap: 16px;\n    }\n    &__item {\n        &.activePage {\n            > a {\n                color: hsl(var(--main));\n                &::before {\n                    color: hsl(var(--main));\n                }\n            }\n        }\n        &:hover {\n            > a {\n                color: var(--gray-400);\n                @media (min-width: 992px) {\n                    color: hsl(var(--main));\n                }\n            }\n        }\n    }\n    &__link {\n        color: var(--gray-400);\n        font-weight: 500;\n        width: 100%;\n        padding: 16px 0;\n        width: 100%;\n        @media (max-width: 1299px) {\n            font-size: rem(14px);\n        } \n        @include lg-screen {\n            font-size: rem(13px);\n        }\n    }   \n\n    .common-dropdown__link {\n        @media (max-width: 1299px) {\n            font-size: rem(14px);\n        } \n        @include lg-screen {\n            font-size: rem(13px);\n        }\n    }\n}\n\n.has-submenu {\n    position: relative;\n    .nav-menu {\n        &__link {\n            padding-inline-end: 16px;\n        }\n    }\n\n    &.active {\n        > a, > a::before{\n            color: hsl(var(--main));\n        }\n        > a::before {\n            transform: translateY(-50%) rotate(180deg) !important; \n        }\n    }\n    > a {\n        position: relative;\n        &::before {\n            position: absolute;\n            content: \"\\E136\";\n            inset-inline-end: 0;\n            inset-block-start: 50%;\n            transform: translateY(-50%);\n            font-family: 'Phosphor';\n            font-weight: 900;\n            color: hsl(var(--heading-color)/.4);\n            transition: .2s linear;\n        }\n    }\n}\n\n/* Submenu Start */\n.common-dropdown {\n    position: absolute;\n    inset-inline-start: 0;\n    @extend .box-shadow-lg; \n    inset-block-start: 100%;\n    width: max-content;\n    background-color: hsl(var(--white));\n    border-radius: 6px;\n    min-width: 190px;\n    overflow: hidden;\n    padding: 8px;\n    transition: .2s linear;\n    z-index: 99;\n    @media (min-width: 992px) {\n        max-height: 400px;\n        overflow-y: auto;\n    }\n    &--sm {\n        width: 132px;\n        min-width: unset;\n    }\n    &__item {\n        display: block;\n        border-radius: 4px;\n        transition: .2s linear;\n        position: relative;\n        @include md-screen {\n            border-radius: 0;\n        }\n        &.activePage {\n            .common-dropdown {\n                &__link {\n                    color: hsl(var(--main)) !important;\n                }\n            }\n        }\n    }\n    &__link {\n        color: var(--gray-400);\n        font-weight: 500;\n        width: 100%;\n        padding-inline-end: 16px;\n        width: 100%;\n        padding: 8px 14px;\n        border-radius: inherit;\n        &:hover {\n            color: var(--gray-600) !important;\n        }\n        &::before {\n            position: absolute;\n        }\n    }\n}\n/* Submenu End */\n/* Header Menu and Submenu Css End */\n\n\n/* Category Submenus Submenu Css Start */\n.menu-category-wrapper {\n    gap: clampCal(12, 72, 1199, 1699);\n}\n\n.submenus-submenu-wrapper {\n    overflow: unset;\n}\n\n.submenus-submenu {\n    position: absolute;\n    z-index: 99999999999;\n    background: hsl(var(--white));\n    width: 300px;\n    inset-inline-start: 100%;\n    inset-block-start: 0px;\n    @extend .box-shadow-lg;\n    border-radius: 6px;\n    visibility: hidden;\n    opacity: 0;\n    overflow: hidden;\n    &__list {\n        li {\n            a {\n                padding: 10px 16px;\n                padding-inline-start: 32px;\n                display: block;\n                color: var(--gray-500);\n                position: relative;\n                &::before {\n                    position: absolute;\n                    content: \"\";\n                    width: 8px;\n                    height: 8px;\n                    inset-inline-start: 16px;\n                    inset-block-start: 50%;\n                    transform: translateY(-50%);\n                    background: var(--gray-300);\n                    border-radius: 80%;\n                    transition: 0.2s linear;\n                }\n                &:hover {\n                    background-color: var(--gray-50);\n                    color: var(--gray-800);\n                    font-weight: 600;\n                    &::before {\n                        background: var(--gray-600);\n                    }\n                }\n            }\n        }\n    }\n}\n\n@media (min-width: 991px) {\n    .has-submenus-submenu {\n        &:hover {\n            > a {\n                background-color: var(--gray-50);\n                color: var(--gray-900) !important;\n                font-weight: 600;\n            }\n            .submenus-submenu {\n                visibility: visible;\n                opacity: 1;\n            }\n        }\n    } \n}\n\n.category {\n    .category__button {\n        @include sm-screen {\n            padding: 12px 3px !important;\n            font-size: 12px !important;\n        }\n        @include msm-screen {\n            padding-left: 10px !important;\n        }\n    }\n    @media (min-width: 992px) {\n        &:hover {\n            .category__button {\n                color: var(--main-600) !important;\n                background-color: var(--gray-50) !important;\n                .arrow-icon i::before {\n                    content: \"\\E13C\";\n                }\n            }\n        }\n    }\n}\n\n/* Style Two */\n.category-two {\n    position: relative;\n    @media (min-width: 992px) {\n        width: 265px;\n    }\n    .category__button {\n        width: 100%;\n        @include msm-screen {\n            font-size: 12px;\n            padding: 8px 4px !important;\n        }\n        &.active .arrow-icon i::before {\n            content: \"\\E13A\";\n        }\n    }\n}\n.responsive-dropdown.style-two {\n    width: 100%;\n    border-radius: 0 0 16px 16px;  \n    width: 265px;\n    max-height: 900px;\n    .responsive-dropdown__list {\n        max-height: 900px;\n        @include lg-screen {\n            max-height: 438px;\n        }\n    }\n    @media (min-width: 992px) {\n        z-index: 1;\n    }\n}\n\n/* Category Submenus Submenu Css End */\n\n.header-border-0 {\n    .header {\n        border-bottom: 0 !important;\n    }\n}\n\n/* ================================= Header Css End =========================== */\n","/* =========================== header Middle Css Start =============================== */\n.header-middle {\n    padding: 30px 0;\n    &.style-two {\n        padding: 24px 0;\n    }\n    @include xl-screen {\n        padding: 24px 0;\n    }\n    @include lg-screen {\n        padding: 16px 0 !important;\n    }\n    @include md-screen {\n        padding: 8px 0 !important;\n    }\n\n    .location-box {\n        @include lg-screen {\n            padding: 6px 8px !important;\n        }\n        @include sm-screen {\n            padding-left: 14px !important;\n        }\n    }\n}\n\n.form-location-wrapper {\n    gap: clampCal(8, 16, 1199, 1599);\n}\n\n/* Search Form Css Here */\n.search-form {\n    @include md-screen {\n        .select2-selection.select2-selection--single {\n            border-radius: 50px !important;\n            border-radius: 50px !important;\n            background-color: hsl(var(--white)) !important;\n            border: 1px solid var(--gray-100) !important;\n        }\n    }\n    &__wrapper {\n        @include md-screen {\n            display: none;\n        }\n    }\n    &__input {\n        border-color: var(--gray-200) !important;\n        width: 520px;\n        @include xxl-screen {\n            width: 400px;\n        }\n        @include xl-screen {\n            width: 300px;\n        }\n        @include lg-screen {\n            width: 200px;\n        }\n    }\n}\n\n/* Header Activities Css Start */\n.header-two-activities {\n    @include xl-screen {\n        gap: 24px !important;\n    }\n    @include md-screen {\n        gap: 16px !important;\n    }\n    @include sm-screen {\n        gap: 10px !important;\n    }\n\n    @include md-screen {\n        .item-hover-two {\n            > span {\n                font-size: 18px !important;\n                color: var(--neutral-600) !important;\n            }\n        }\n    }\n}\n/* Header Activities Css End */\n\n\n/* Header Activities Css start */\n.search-category {\n    &.style-two {\n        background-color: hsl(var(--white));\n        border-radius: 8px;\n        overflow: hidden;\n        .select2-container--default .select2-selection--single {\n            border-radius: 0;\n            border-left: 0 !important;\n            border-top: 0 !important;\n            border-bottom: 0 !important;\n        }\n    }\n}\n/* Header Activities Css End */\n\n\n/* Category Dropdown Responsive Css Start */\n@include md-screen {\n    .responsive-dropdown {\n        position: fixed;\n        inset-inline-start: 0;\n        inset-block-start: 0;\n        visibility: visible;\n        opacity: 1;\n        margin-top: 0;\n        border-radius: 0;\n        width: unset !important;\n        height: 100vh;\n        overflow-y: auto;\n        transform: translateX(-100%);\n        padding-top: 8px !important;\n        &.active {\n            transform: translateX(0);\n        }\n        ul {\n            max-height: 100% !important;\n            li {\n                &.active {\n                    > a {\n                        background: var(--gray-50);\n                        color: var(--gray-800) !important;\n                        font-weight: 600;\n                        .icon {\n                            transform: rotate(90deg);\n                        }\n                    }\n                }\n                a {\n                    border-bottom: 1px solid var(--gray-100);\n                }\n            }\n        }\n        .submenus-submenu{\n            position: static;\n            visibility: visible;\n            opacity: 1;\n            box-shadow: none;\n            border-radius: 0;\n            margin-left: 40px;\n            width: unset;\n            padding-top: 8px !important;\n            display: none;\n            padding-top: 0 !important;\n            padding-bottom: 0 !important;\n            &__title {\n                display: none;\n            }\n            &__list {\n                max-height: unset !important;               \n                li {\n                    a {\n                        padding-left: 16px;\n                        &::before {\n                            inset-inline-start: 0;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n/* Category Dropdown Responsive Css End */\n/* =========================== header Middle Css End =============================== */\n","\n\n/* Mobile Menu Sidebar Start */\n.mobile-menu {\n    position: fixed;\n    background-color: hsl(var(--white));\n    width: 300px;\n    height: 100vh;\n    overflow-y: auto;\n    padding: 24px;\n    z-index: 991;\n    transform: translateX(-100%);\n    transition: .2s linear;\n    padding-block-end: 68px;\n    &.active {\n        transform: translateX(0%);\n    }\n}\n.close-button {\n    position: absolute;\n    inset-inline-end: 8px;\n    inset-block-start: 8px;\n    width: 28px;\n    height: 28px;\n    background-color: var(--gray-200);\n    border-radius: 50%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: .2s;\n    &:hover {\n        background-color: hsl(var(--black));\n        color: hsl(var(--white));\n    }\n}\n\n.nav-menu {\n    &--mobile {\n        display: block;\n        margin-block-start: 16px;\n        .nav-menu {\n            &__item {\n                > a {\n                    &::before {\n                        transform: translateY(-50%) rotate(0deg);\n                    }\n                }\n            }\n            &__link {\n                border-bottom: 1px solid var(--gray-100) !important;\n                position: relative;\n                padding: 12px 0;\n                padding-inline-end: 16px;\n              \n            } \n        }\n        .nav-submenu {\n            position: static;\n            visibility: visible;\n            opacity: 1;\n            box-shadow: none;\n            width: 100%;\n            margin-block-start: 0;\n            padding: 0;\n            margin-inline-start: 16px;\n            display: none;\n            transition: 0s;\n            &__link {\n                width: 100%;\n                padding: 10px 0;\n                border-bottom: 1px solid var(--gray-100) !important;\n            }\n            &__item {\n                &:hover {\n                    background-color: transparent;\n                    color: hsl(var(--main));\n                }\n                &::before {\n                    display: none;\n                }\n            }\n        }\n    }\n}\n/* Mobile Menu Sidebar Start */","\n/* ============= Footer Start Here ======================= */\n.footer {\n    margin-block-start: auto;\n    &-item-wrapper {\n        gap: clampCal(32, 44, 1199, 1899);\n    }\n    &-item-two-wrapper {\n        gap: clampCal(32, 90, 1199, 1899);\n    }\n    &-item {\n        &__logo {\n            margin-block-end: 20px;\n            a {\n                img {\n                    width: 100%;\n                    height: 100%;\n                    max-width: 190px;\n                    max-height: 64px;\n                }\n            }\n        }\n    }\n}\n\n.body-bottom-bg {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    z-index: -1;\n}\n/* ============= Footer End Here ======================= */","\n/* ===================== Scroll to Top Start ================================= */\n  .progress-wrap {\n    position: fixed;\n    inset-inline-end: 36px;\n    inset-block-end: 36px;\n    height: 46px;\n    line-height: 46px;\n    width: 46px;\n    cursor: pointer;\n    display: block;\n    border-radius: 50px;\n    box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.2);\n    z-index: 10000;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(15px);\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n    background-color: transparent;\n    @include md-screen {\n      inset-inline-end: 24px;\n      inset-block-end: 24px;\n      height: 40px;\n      width: 40px;\n      line-height: 40px;\n    }\n    &.active-progress {\n        opacity: 1;\n        visibility: visible;\n        transform: translateY(0);\n    }\n    &:hover {\n      transform: scale(1.06);\n    }\n    &::after {\n        position: absolute;\n        font-family: 'Phosphor';\n        font-weight: 900;\n        content: '\\E08E';\n        text-align: center;\n        height: 46px;\n        width: 46px;\n        line-height: 46px;\n        font-size: 18px;\n        inset-inline-start: 0;\n        inset-block-start: 0;\n        cursor: pointer;\n        display: block;\n        z-index: 1;\n        -webkit-transition: all 200ms linear;\n        transition: all 200ms linear;\n        color: hsl(var(--main)) !important;\n        @include md-screen {\n          height: 40px;\n          width: 40px;\n          line-height: 40px;\n        }\n    }\n  }\n  \n  .progress-wrap svg path {\n    fill: none;\n  }\n  .progress-wrap svg.progress-circle path {\n    stroke: hsl(var(--main));\n    stroke-width: 5;\n    box-sizing: border-box;\n    -webkit-transition: all 200ms linear;\n    transition: all 200ms linear;\n  }\n/* ===================== Scroll to Top End ================================= */\n",".search-box {\n    position: fixed;\n    width: 100%;\n    height: 100%;;\n    z-index: 9;\n    background: hsl(var(--black));\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    visibility: hidden;\n    opacity: 0;\n    transition: .2s linear;\n    transform: scale(.8);\n    z-index: 9;\n    &.active {\n        visibility: visible;\n        opacity: 1;\n        transform: scale(1);\n    }\n}","/* ================= Slick Arrow & Dots css Start ================ */ \n.slick-initialized.slick-slider {\n  .slick-track {\n      display: flex;\n  }\n  .slick-slide {\n    cursor: grab;\n      height: auto;\n      margin: 0 10px;\n      > div {\n          height: 100%;\n          > div {\n            height: 100%;\n          }\n      }\n  }\n}\n\n/* Slick Slider Arrow */\n.slick-arrow {\n  width: 48px;\n  height: 48px;\n  &:active {\n    transform: scale(1.02);\n  }\n  @include md-screen {\n    width: 40px;\n    height: 40px;\n  }\n  @include sm-screen {\n    width: 32px;\n    height: 32px;\n  }\n}\n\n\n/* Arrow Style Two */\n.arrow-center {\n  position: relative;\n  .slick-arrow {\n    position: absolute;\n    inset-block-start: 50%;\n    transform: translateY(-50%);\n    inset-inline-start: 16px;\n    z-index: 2;\n    &.slick-next {\n      inset-inline-start: auto;\n      inset-inline-end: 16px;\n    }\n  }\n}\n\n.slick-arrows-style-three {\n  .slick-arrow {\n    visibility: hidden;\n    opacity: 0;\n  }\n  &:hover {\n    .slick-arrow {\n      visibility: visible;\n      opacity: 1;\n    }\n  }\n}\n\n/* Dots Css Start */ \n.slick-dots {\n    text-align: center;\n    position: absolute;\n    inset-block-end: 60px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    z-index: 1;\n    line-height: 1;\n    li {\n        display: inline-block;\n        display: flex;\n        button {\n            border: none;\n            background-color: hsl(var(--white)/.3 );\n            color: hsl(var(--white));;\n            margin: 0 3px;\n            width: 12px;\n            height: 12px;\n            border-radius: 1px;\n            border-radius: 50px;\n            text-indent: -9999px;\n            transition: .3s linear;\n        }\n        &.slick-active button {\n            width: 40px;  \n            background-color: hsl(var(--main-two));\n        }\n    }\n}\n/* Dots Css End */\n/* ================= Slick Arrow & Dots css Start ================ */ \n","/* ================== Section Heading Css Start ========================= */\n.section-heading {\n    margin-bottom: 40px;\n    @include lg-screen {\n        margin-bottom: 24px;\n    }\n\n    &.writing-mode {\n        @media (min-width: 1200px) {\n            writing-mode: vertical-lr;\n            transform: rotate(180deg);\n        }\n        @media (max-width: 1199px) {\n            margin-bottom: 60px !important;\n        }\n    }\n}\n/* ================== Section Heading Css End ========================= */","/* ============================== Banner Css Start ========================== */\n.banner {\n  margin-top: 32px;\n  @include sm-screen {\n    margin-bottom: 32px;\n  }\n  .slick-slider {\n    position: unset;\n  }\n  .slick-initialized.slick-slider .slick-slide {\n    margin: 0;\n  }\n}\n\n.banner-item {\n  position: relative;\n  padding-block-start: clampCal(32, 100, 768, 1599);\n  padding-block-end: clampCal(32, 220, 768, 1599);\n  padding-inline-start: clampCal(16, 142, 992, 1599);\n  padding-inline-end: clampCal(16, 76, 992, 1599);\n  -webkit-mask-image: url(\"~/public/assets/images/bg/banner-bg2.png\");\n  mask-image: url(\"~/public/assets/images/bg/banner-bg2.png\");\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  // background: #d3ebc0;\n  background: #83c0ee;\n  mask-position: top;\n  mask-size: 100% 100%;\n  gap: clampCal(24, 72);\n  @include sm-screen {\n    mask-image: none;\n    overflow: unset !important;\n  }\n\n  &__title {\n    margin-block-end: clampCal(16, 60);\n    @include xxl-screen {\n      font-size: rem(56px);\n    }\n    @include lg-screen {\n      font-size: rem(46px);\n    }\n    @include md-screen {\n      font-size: rem(28px);\n    }\n    @include sm-screen {\n      font-size: rem(26px);\n    }\n  }\n  &__content {\n    max-width: 852px;\n    @include xxl-screen {\n      max-width: 750px;\n    }\n  }\n  &__thumb {\n    img {\n      @include msm-screen {\n        max-width: 350px;\n        width: 100%;\n      }\n    }\n  }\n}\n\n.banner-slider__inner {\n  @include msm-screen {\n    flex-wrap: wrap;\n  }\n}\n\n.scroll-down {\n  width: 94px;\n  height: 94px;\n  position: relative;\n  margin-bottom: 24px;\n  z-index: 2;\n  @include xl-screen {\n    width: 74px;\n    height: 74px;\n    margin-bottom: 16px;\n  }\n  @include sm-screen {\n    margin-bottom: -36px;\n  }\n  &::before {\n    position: absolute;\n    content: \"\";\n    width: 2px;\n    height: 32px;\n    border: 2px dashed hsl(var(--white) / 0.4);\n    top: 16px;\n    animation: upDown 2s linear infinite;\n    @include xl-screen {\n      top: 8px;\n    }\n  }\n  .icon {\n    animation: upDown 2s linear infinite;\n    font-size: rem(28px);\n    margin-top: 16px;\n  }\n}\n\n@keyframes upDown {\n  0% {\n    transform: translateY(10px);\n  }\n  50% {\n    transform: translateY(0px);\n  }\n  100% {\n    transform: translateY(10px);\n  }\n}\n/* ============================== Banner Css End ========================== */\n","/* ============================ Feature Section Css start =============================== */\n.feature {\n    margin-top: 32px;\n    .arrow-center {\n        &:hover {\n            .slick-arrow {\n                visibility: visible;\n                opacity: 1;\n                margin-left: -28px;\n                &.slick-next {\n                    margin-right: -20px;\n                }\n            }\n        }\n        .slick-arrow {\n            transform: translateY(0);\n            margin-left: -40px;\n            border: 1px solid var(--gray-100);\n            visibility: hidden;\n            opacity: 0;\n            top: 54px;\n            &.slick-next {\n                margin-right: -30px;\n            }\n        }\n    }\n    &.feature-three .arrow-center .slick-arrow {\n        top: 110px;\n    }\n}\n\n.feature-item {\n    &-wrapper {\n        display: grid;\n        grid-template-columns: repeat(auto-fit, minmax(132px, 1fr));\n        gap: 16px;\n        .feature-item {\n            &:nth-child(10n + 1) {\n                .feature-item__thumb {\n                    background: #E8F9E9;\n                }\n            }\n            &:nth-child(10n + 2) {\n                .feature-item__thumb {\n                    background: #FCEDED;\n                }\n            }\n            &:nth-child(10n + 3) {\n                .feature-item__thumb {\n                    background: #F6EBF3;\n                }\n            }\n            &:nth-child(10n + 4) {\n                .feature-item__thumb {\n                    background: #FCF2E7;\n                }\n            }\n            &:nth-child(10n + 5) {\n                .feature-item__thumb {\n                    background: #F5FBE3;\n                }\n            }\n            &:nth-child(10n + 6) {\n                .feature-item__thumb {\n                    background: #E3FBE9;\n                }\n            }\n            &:nth-child(10n + 7) {\n                .feature-item__thumb {\n                    background: #E9E3FB;\n                }\n            }\n            &:nth-child(10n + 8) {\n                .feature-item__thumb {\n                    background: #ECF8F2;\n                }\n            }\n            &:nth-child(10n + 9) {\n                .feature-item__thumb {\n                    background: #F8F5E5;\n                }\n            }\n            &:nth-child(10n + 10) {\n                .feature-item__thumb {\n                    background: #F0F8E5;\n                }\n            }\n            &:nth-child(10n + 11) {\n                .feature-item__thumb {\n                    background: #ddd;\n                }\n            }\n        }\n    }\n    &__thumb {\n        max-width: 153px;\n        max-height: 153px;\n        background-color: var(--main-50);\n        aspect-ratio: 1;\n        margin: 0 auto;\n        img {\n            transition: .2s linear;\n        }\n    }\n    &:hover {\n        .feature-item__thumb img {\n            transform: scale(1.2);\n        }\n    }\n}\n\n.featured-products, .popular-products {\n    .product-card {\n        flex-direction: row;\n        align-items: unset;\n    }\n}\n.popular-products {\n    .product-card__thumb {\n        width: 120px !important;\n    }\n}\n/* ============================ Feature Section Css End =============================== */","/* ======================== promotional banner Css Start ============================== */\n.promotional-banner-item {\n    padding: clampCal(32, 84) 24px;\n    @include msm-screen {\n        padding: 24px 16px;\n    }\n    &__content {\n        max-width: 200px;\n    }\n    &__title {\n        @include xl-screen {\n            font-size: rem(24px) !important;\n        }\n    }\n}\n/* ======================== promotional banner Css End ============================== */","/* ========================= flash sales Start ================================ */\n.flash-sales-item {\n    padding: 40px 32px;\n}\n/* ========================= flash sales End ================================ */","/* ============================= Product Card Css Start ========================== */\n.product-card {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: start;\n    &:hover {\n        .product-card__thumb img {\n            transform: scale(1.2);\n        }\n    }\n    &__cart {   \n        @include xxl-screen {\n            font-size: 12px;\n            padding: 9px 12px !important;\n        }\n    }\n    &__badge {\n        border-radius: 16px 0 16px 0;\n    }\n    &__thumb {\n        height: 232px;\n        width: 100%;\n        transition: 0s !important;\n        img {\n            max-width: 200px;\n            width: 100%;\n            transition: .1s linear;\n        }\n    }\n\n    &.style-two {\n        flex-direction: row;\n        .product-card {\n            &__thumb {\n                width: 260px;\n                height: 190px;\n                @include md-screen {\n                    width: 190px;\n                }\n                @include msm-screen {\n                    width: 124px;\n                }\n            }\n        }\n    }\n}\n\n@include lg-screen {\n    .product-card {\n        &__thumb {\n            min-height: 160px;\n            img {\n                max-width: 120px;\n            }\n        }\n        &__content {\n            .product-card {\n                &__price span {\n                    font-size: rem(12px) !important;\n                }\n            }\n            .title .link {\n                font-size: rem(14px);\n            }\n            .text-xs {\n                font-size: rem(10px) !important;\n            }\n        }\n    }\n}\n/* ============================= Product Card Css End ========================== */","/* ======================= Offer Css Start =========================== */\n.offer-card {\n    &__thumb {\n        img {\n            @include xxl-screen {\n                max-width: 246px;\n                width: 100%;\n            }\n            @include lg-screen {\n                max-width: 163px;\n            }\n        }\n    }\n}\n/* ======================= Offer Css End =========================== */","/* ===================================== Vendor Css Start ================================== */\n.vendor-card {\n  background-color: var(--main-100);\n  -webkit-mask-image: url(\"~/public/assets/images/shape/box-shape2.png\");\n  mask-image: url(\"~/public/assets/images/shape/box-shape2.png\");\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  background: #f4f6e6;\n  mask-position: top;\n  mask-size: 100% 100%;\n  &.style-two {\n    -webkit-mask-image: url(\"~/public/assets/images/shape/box-shape3.png\");\n    mask-image: url(\"~/public/assets/images/shape/box-shape3.png\");\n  }\n  &__logo {\n    max-width: 66px;\n  }\n  &__item {\n    max-width: 64px;\n    max-height: 64px;\n    aspect-ratio: 1;\n    width: 100%;\n    height: 100%;\n  }\n  .vendor-card__list {\n    &.style-two {\n      .vendor-card__item {\n        max-width: 88px;\n        max-height: 88px;\n        border-radius: 8px !important;\n      }\n      .slick-slide {\n        margin: 0 4px !important;\n      }\n    }\n  }\n}\n.vendor-card-wrapper div[class*=\"col\"] {\n  &:nth-child(8n + 1) {\n    .vendor-card {\n      background: #f4f6e6;\n    }\n  }\n  &:nth-child(8n + 2) {\n    .vendor-card {\n      background: #e6f6f6;\n    }\n  }\n  &:nth-child(8n + 3) {\n    .vendor-card {\n      background: #f6e6f6;\n    }\n  }\n  &:nth-child(8n + 4) {\n    .vendor-card {\n      background: #f8eae4;\n    }\n  }\n  &:nth-child(8n + 5) {\n    .vendor-card {\n      background: #f8eae4;\n    }\n  }\n  &:nth-child(8n + 6) {\n    .vendor-card {\n      background: #dee6f3;\n    }\n  }\n  &:nth-child(8n + 7) {\n    .vendor-card {\n      background: #daf2db;\n    }\n  }\n  &:nth-child(8n + 8) {\n    .vendor-card {\n      background: #ebf1da;\n    }\n  }\n}\n/* ===================================== Vendor Css End ================================== */\n",".delivery {\n    &-section {\n        @media (min-width: 768px) {\n            margin-bottom: 28px;\n        }\n    }\n    &__man {\n        margin-bottom: -56px;\n    }\n}","/* ================================== short product Css Start ================================== */\n.underlined-line {\n    &::before, &::after {\n        position: absolute;\n        content: \"\";\n        width: 100%;\n        height: 2px;\n        left: 0;\n        bottom: 0;\n        background-color: hsl(var(--white));\n    }\n    &::after {\n        width: 50%;\n        background-color: var(--main-600);\n    }\n}\n\n.short-product-list {\n    &.arrow-style-two {\n        .slick-arrow {\n            inset-inline-end: 16px;\n            inset-block-end: calc(100% + 52px);\n        } \n        .slick-prev {\n            inset-inline-end: 50px;\n        }\n    }\n}\n/* ================================== short product Css End ================================== */","/* ========================= Brand Css Start ======================== */\n.brand-item {\n    img {\n        max-width: 152px !important;\n        @include xl-screen {\n            max-width: 132px !important;\n        }\n        @include md-screen {\n            max-width: 86px !important;\n        }\n    }\n}\n/* ========================= Brand Css End ======================== */","/* Shipping Css Start */\n.shipping-item {\n    padding: clampCal(24, 32)  clampCal(24, 54, 1399, 1899);\n}\n/* Shipping Css End */","/* ======================= Newsletter Css Start =========================== */\n.newsletter-box {\n    background-color: #121535;\n    padding: 32px clampCal(24, 64, 1199, 1499);\n}\n\n.newsletter-two {\n    &__form {\n        @include md-screen {\n            width: 100% !important;\n        }\n    }\n}\n/* ======================= Newsletter Css End =========================== */","/* Home Two Css Start */\n.color-two {\n    &:root {\n        --main-h: 24;\n        --main-s: 100%;\n        --main-l: 49%;\n    }\n}\n\n.font-exo {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        font-family: var(--heading-font-two);\n    }\n    h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n        font-family: var(--heading-font-two);\n    }\n}\n.font-outfit {\n    h1,\n    h2,\n    h3,\n    h4,\n    h5,\n    h6 {\n        font-family: var(--heading-font-three);\n    }\n    h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n        font-family: var(--heading-font-three);\n    }\n}\n/* Home Two Css End */\n","/* ================================= Banner Two Css Start ================================= */\n.banner-item-two {\n    padding: 186px clamp(2rem, -10.739rem + 17vw, 6.25rem) 186px;\n    position: relative;\n    @include lg-screen {\n        padding: 86px clampCal(32, 100, 1199, 1599) 86px;\n    }\n    @include md-screen {\n        padding: 60px clampCal(32, 100, 1199, 1599) 60px;\n    }\n    @include sm-screen {\n        padding: 40px clampCal(32, 100, 1199, 1599) 40px;\n    }\n    &-wrapper {\n        margin: 32px;\n        margin-inline-end: 0;\n        @include md-screen {\n            margin-inline-start: 0;\n        }\n    }\n    &__content {\n        max-width: 504px;\n        @include md-screen {\n            max-width: 362px;\n        }\n        @include msm-screen {\n            max-width: 320px;\n        }\n    }\n    &__title {\n        @include msm-screen {\n            font-size: 1.5rem;\n        }\n    }\n    &__thumb {\n        inset-inline-end: clampCal(24, 140, 1199, 1599);\n        text-align: end;\n        max-width: 41%;\n        @include msm-screen {\n            max-width: 50%;\n            position: relative !important; \n            margin-top: 32px;\n            inset-inline-end: 0; \n        }\n    }\n}\n/* ================================= Banner Two Css End ================================= */","/* Week Deals Start  */\n.deal-week-box {\n    &__content {\n        padding: clampCal(24, 60) 0;\n    }\n}\n/* Week Deals End  */","/* ============================ trending products css Start =========================== */\n.trending-products-three {\n    .product-card__thumb {\n        height: 330px;\n    }\n}\n\n.trending-products {\n    &-box {\n        background-color: #F3EDDE;\n        &__title {\n            max-width: 364px;\n            margin: 0 auto;\n        }\n    }\n}\n\n.expand-btn {\n    color: var(--neutral-600);\n}\n.expand-icons {\n    display: none;\n    flex-direction: column;\n}\n/* ============================ trending products css End =========================== */","/* =============================== Discount css Start ============================ */\n.discount-item {\n    padding: clampCal(24, 48, 1199, 1599);\n    &__content{\n        max-width: 320px;\n    }\n}\n\n.discount-three-item {\n    padding: clampCal(32, 136) clampCal(24, 56);\n}\n/* =============================== Discount css End ============================ */","/* ====================== Popular Products Start ==================== */\n.popular-products {\n    .product-card {\n        @include sm-screen {\n            flex-direction: column;\n        }\n    }\n}\n/* ====================== Popular Products End ==================== */","/*  */\n.day-sale {\n    &-box {\n        &__content {\n            max-width: 500px;\n        }\n    }\n}\n/*  */","/* ========================== Top Brand Section Start ================================ */\n.top-brand {\n    &__item {\n        max-height: 84px;\n        max-width: 160px;\n        width: 100%;\n        aspect-ratio: 1;\n    }\n}\n/* ========================== Top Brand Section End ================================ */","/* ================================ Featured Products Css Start ============================ */\n.featured-products {\n    .product-card {\n        @include xsm-screen {\n            flex-direction: column;\n        }\n    }\n}\n/* ================================ Featured Products Css End ============================ */","/* ============================= Banner Three Css Start ================================= */\n.banner-three {\n    background-color: var(--neutral-600);\n    padding: 80px 0;\n    @media (width: 991px) {\n        padding: 60px 0;\n    }\n}\n\n.animation {\n    position: absolute;\n    max-width: 10%;\n}\n\n.star-shape {\n    bottom: 4%;\n    inset-inline-start: 5%;\n    opacity: .3;\n    &.style-two {\n        inset-inline-start: auto;\n        bottom: auto;\n        top: 10%;\n        inset-inline-end: 8%;\n    }\n}\n.line-shape {\n    top: 14%;\n    left: 58%;\n}\n\n.animation-rotate {\n    animation: rotation 6s linear infinite;\n}\n\n@keyframes rotation {\n    0% {\n        transform: rotate(0deg);\n    }\n    50% {\n        transform: rotate(180deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n/* ============================= Banner Three Css End ================================= */","/* ============================== Promotional Banner Three Start ==========================  */\n.promo-three-item {\n    padding: clampCal(32, 118) clampCal(24, 64);\n}\n/* ============================== Promotional Banner Three End ==========================  */",".js-marquee {\n    display: flex;\n    gap: 32px;\n}\n","/* ============================== Deals Section Css Start ========================== */\n.deals {\n    &__img {\n        transform: translateY(12px);\n    }\n}\n\n.products-group {\n    &__list {\n        position: absolute;\n        left: 35%;\n        bottom: 30%;\n        z-index: 1;\n        &:nth-child(2) {\n            bottom: 48%;\n            left: 65%;\n        }\n        &:nth-child(3) {\n            bottom: 56%;\n            left: 80%;\n        }\n        &:hover {\n            .products-group {\n                &__card {\n                    margin-bottom: 0;\n                    visibility: visible;\n                    opacity: 1;\n                }\n            }       \n        }\n    }\n    &__card {\n        transform: translateX(-68%) rotate(-10deg);\n        margin-bottom: -32px;\n        visibility: hidden;\n        opacity: 0;\n    }\n}\n\n\n\n// @media (min-width: 575px) {\n//     .rotate-10 {\n//         transform: rotate(-10deg);\n//     }\n//     .positioned {\n//         position: absolute;\n//         width: 100%;\n//         inset-inline-start: 60px;\n//         inset-block-start: 60px;\n//         z-index: 1;\n//     }\n// }\n\n/* ============================== Deals Section Css End ========================== */","/* ================================= Testimonials Section Css Start ==================================== */\n.testimonials-item {\n    &__desc {\n        @media (min-width: 768px) {\n            display: -webkit-box;\n            -webkit-line-clamp: 3;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n        }\n    }\n}\n\n.testimonials-slider {\n    @media (min-width: 768px) {\n        position: absolute;\n        top: 0;\n        left: 25.50%;\n    }\n    @media (max-width: 1299px) {\n        left: 34%;\n    }\n    @media (max-width: 767px) {\n        left: 0;\n    }\n}\n\n.testimonials-thumbs {\n    overflow: hidden;\n    &__img {\n        max-height: 350px;\n        height: 100%;\n        width: 100%;\n        transition: .6s linear;\n        position: relative;\n        img {\n            object-position: top;\n        }\n        &::before {\n            position: absolute;\n            content: \"\";\n            width: 100%;\n            height: 100%;\n            left: 0;\n            top: 0;\n            background: linear-gradient(2deg, #000000e8, transparent);\n            visibility: hidden;\n            opacity: 0;\n            transition: .2s linear;\n        }\n    }\n    \n    &:hover {\n        .testimonials-thumbs__img::before, .testimonials-thumbs__content {\n            visibility: visible !important;\n            opacity: 1 !important;\n        }\n    }\n}\n\n.testimonials {\n    .slick-slider .slick-track {\n        display: flex;\n        align-items: end;\n    }\n    .slick-slide {\n        &.slick-active.slick-current .testimonials-thumbs {\n            overflow: unset !important;\n            &__img {\n                object-fit: cover;\n                max-height: 100%;\n            }\n        }\n    }\n}\n.testimonials-thumbs-slider  {\n    .slick-slide {\n        height: 630px !important;\n    }\n}\n.testimonials-slider {\n    .slick-slide {\n        @media (min-width: 768px) {\n            height: 630px !important;\n        }\n    }\n}\n/* ================================= Testimonials Section Css End ==================================== */","/* ============================ Product Details Css Start ============================= */\n.product-details {\n    &__thumb {\n        &-slider {\n            padding: clampCal(48, 116);\n        }\n    }\n\n    .slick-initialized.slick-slider .slick-slide > div > div {\n        height: 100%;\n    }\n}\n\n\n.product-dContent__box, .product-dContent__header {\n    padding: 16px 40px;\n}\n.product-dContent {\n    &__box {\n        padding-top: 48px;\n        padding-bottom: 48px;\n    }\n}\n/* ============================ Product Details Css End ============================= */","/* ================================ Shop Page css Start =============================== */\n.list-grid-btns {\n    @media (max-width: 479px) {\n        display: none;\n    }\n}\n.list-grid-wrapper {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));\n    gap: 24px;\n}\n\n@media (min-width: 480px) {\n    .list-view {\n        grid-template-columns: repeat(auto-fit, minmax(430px, 1fr));\n        .product-card {\n            display: flex;\n            align-items: center;\n            flex-direction: row;\n            &__thumb {\n                max-width: 200px;\n                height: 100% !important;\n            }\n            &__content {\n                margin-top: 0 !important;\n                margin-left: 20px;\n                flex-grow: 1;\n            }\n        }\n    }\n}\n\n@media (max-width: 1199px) {\n    .shop-sidebar__box {\n        padding: 16px !important;\n    }\n}\n\n@media (max-width: 991px) {\n    .shop-sidebar {\n        position: fixed;\n        top: 0;\n        height: 100vh;\n        background-color: #fff;\n        z-index: 11;\n        left: 0;\n        border-radius: 0 !important;\n        overflow-y: auto;\n        width: 300px;\n        border-right: 1px solid var(--gray-100);\n        transform: translateX(-100%);\n        transition: .2s linear;\n        &.active {\n            transform: translateX(0);\n        }\n        &__box {\n            border-radius: 0 !important;\n            border: 0 !important;\n        }\n    }\n}\n/* ================================ Shop Page css End =============================== */","/* ========================== Cart Page Css Start ============================ */\n.table-product {\n    &__thumb {\n        max-width: 150px;\n        max-height: 150px;\n        width: 100%;\n        height: 100%;\n        aspect-ratio: 1;\n        img {\n            max-width: 75px;\n        }\n    }\n    &__content {\n\n    }\n}\n/* ========================== Cart Page Css End ============================ */","/* ======================= Checkout Css Start ============================= */\n.payment-item {\n    &__content {\n        display: none;\n        &::before {\n            position: absolute;\n            content: \"\";\n            width: 20px;\n            height: 14px;\n            background-color: var(--main-50);\n            left: 32px;\n            bottom: calc(100% + -1px);\n            clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n        }\n    }\n}\n/* ======================= Checkout Css End ============================= */","/* ========================= Blog Css Start ============================= */\n.blog-item {\n    margin-bottom: 48px;\n    &:last-child {\n        margin-bottom: 0;\n    }\n}\n/* ========================= Blog Css End ============================= */",".line-wrapper {\n    > div {\n        position: relative;\n        &:last-child {\n            &::before {\n                display: none;\n            }\n        }\n        &::before {\n            position: absolute;\n            content: \"\";\n            width: 1px;\n            height: 100%;\n            right: 0;\n            top: 0;\n            background: hsl(var(--white) / 0.1);\n            @media (max-width: 991px) {\n                display: none;\n            }\n        }\n    }\n}","/* ======================== Vendors Two Page css Start ============================= */\n.grid-cols-3 {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr !important;\n    gap: 24px;\n    @include lg-screen {\n        grid-template-columns: 1fr 1fr !important;\n    }\n    @include msm-screen {\n        grid-template-columns: 1fr !important;\n    }\n    &.list-view {\n        grid-template-columns: 1fr 1fr !important;\n        @include xl-screen {\n            grid-template-columns: 1fr !important;\n        }\n    }\n}\n\n.list-view {\n    .vendors-two-item {\n        display: flex;\n    }\n}\n/* ======================== Vendors Two Page css End ============================= */","/* ============================== Vendor Two Details Css Start =============================== */\n.grid-cols-4 {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr !important;\n    gap: 24px;\n    @include xl-screen {\n        grid-template-columns: 1fr 1fr 1fr !important;\n    }\n    @include lg-screen {\n        grid-template-columns: 1fr 1fr !important;\n    }\n    @include msm-screen {\n        grid-template-columns: 1fr !important;\n    }\n    &.list-view {\n        grid-template-columns: 1fr 1fr !important;\n        @include xl-screen {\n            grid-template-columns: 1fr !important;\n        }\n    }\n}\n\n\n.vendor-two-details {\n    .shop-sidebar {\n        width: 332px;\n    }\n    &__contents {\n        flex-grow: 1;\n        width: calc(100% - 356px);\n    }\n}\n/* ============================== Vendor Two Details Css End =============================== */",".slick-arrow::before {\n  display: none;\n}\n\n.slick-arrow {\n  .ph {\n    color: #333;\n  }\n\n  &:hover {\n    .ph {\n      color: #fff;\n    }\n  }\n}\n\n.flash-sales {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .flash-sales__slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -60px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -60px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n    }\n  }\n}\n\n.hot-deals {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 5px;\n    }\n  }\n\n  .hot-deals-slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -60px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -60px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n  }\n}\n\n.organic-food {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .organic-food__slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -60px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -60px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n  }\n}\n\n.short-product {\n  .mr-point {\n    margin-right: 124px;\n  }\n\n  .slick-arrow {\n    width: 38px;\n    height: 38px;\n  }\n\n  .short-product-list {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -70px;\n      left: auto;\n      right: 50px;\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -70px;\n      left: auto;\n      right: 5px;\n    }\n  }\n}\n\n.brand {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .brand-slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -60px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -60px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n  }\n}\n\n.new-arrival {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .new-arrival__slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -60px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -60px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -58px;\n      }\n\n      @include lg-screen {\n        top: -40px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -37px;\n      }\n    }\n  }\n}\n\n.deals-weeek {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .deals-week-slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -300px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -290px;\n      }\n\n      @include lg-screen {\n        top: -218px;\n      }\n\n      @include sm-screen {\n        top: -218px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -300px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -290px;\n      }\n\n      @include lg-screen {\n        top: -218px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -218px;\n      }\n    }\n  }\n}\n\n.top-selling-products {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 5px;\n    }\n  }\n\n  .top-selling-product-slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -45px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -42px;\n      }\n\n      @include lg-screen {\n        top: -42px;\n      }\n\n      @include sm-screen {\n        top: -42px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -45px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -42px;\n      }\n\n      @include lg-screen {\n        top: -42px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -42px;\n      }\n    }\n  }\n}\n\n.featured-products {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .featured-product-slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -45px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -42px;\n      }\n\n      @include lg-screen {\n        top: -38px;\n      }\n\n      @include sm-screen {\n        top: -38px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -45px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -42px;\n      }\n\n      @include lg-screen {\n        top: -38px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -38px;\n      }\n    }\n  }\n}\n\n.vendor-card {\n  .slick-arrow .ph {\n    color: #fff;\n  }\n}\n\n.recommended {\n  .mr-point {\n    margin-right: 124px;\n\n    @include sm-screen {\n      margin-right: 108px;\n    }\n  }\n\n  .recommended-slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -45px;\n      right: 60px;\n      left: auto;\n\n      @include xl-screen {\n        top: -42px;\n      }\n\n      @include lg-screen {\n        top: -42px;\n      }\n\n      @include sm-screen {\n        top: -42px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -45px;\n      right: 0px;\n      left: auto;\n\n      @include xl-screen {\n        top: -42px;\n      }\n\n      @include lg-screen {\n        top: -42px;\n      }\n\n      @include md-screen {\n        right: 14px;\n      }\n\n      @include sm-screen {\n        top: -42px;\n      }\n    }\n  }\n}\n\n.top-brand {\n  .mr-point {\n    margin-right: 124px;\n  }\n\n  .top-brand__slider {\n    .slick-arrow.slick-prev {\n      position: absolute;\n      top: -45px;\n      right: 60px;\n      left: auto;\n\n      @include sm-screen {\n        right: 46px;\n      }\n    }\n\n    .slick-arrow.slick-next {\n      position: absolute;\n      top: -45px;\n      right: 0px;\n      left: auto;\n    }\n  }\n}\n\n.banner-item-two__slider {\n  .slick-dots {\n    display: flex !important;\n    gap: 4px;\n\n    li {\n      margin: 0;\n    }\n\n    .slick-active {\n      width: auto;\n    }\n  }\n}\n\n.banner-three-slider {\n  .slick-next {\n    right: -100px !important;\n  }\n  .slick-prev {\n    left: -100px !important;\n  }\n  .slick-arrow .ph {\n    color: #ddd;\n  }\n}\n\n.horizontal-slider {\n  .example-track.example-track-0,\n  .example-track.example-track-2 {\n    height: 8px;\n    border-radius: 5px;\n    background: #cccccc;\n  }\n\n  .example-track.example-track-1 {\n    height: 8px;\n    border-radius: 5px;\n    z-index: 9;\n\n    background-color: var(--main-600) !important;\n  }\n\n  .example-thumb {\n    left: 76.7775px;\n    top: 12px;\n    background-color: var(--main-600) !important;\n    border-radius: 5px;\n    width: 40px;\n    height: 35px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: none;\n    }\n  }\n}\n\n.product-details__thumb-slider {\n  padding: clamp(3rem, -2.173rem + 10.777vw, 7.25rem);\n  min-width: 400px;\n  height: 600px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.center {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n.product-details__images-slider .thum {\n  width: 60px;\n  object-fit: contain;\n}\n\n.mobile-menu .nav-submenu {\n  display: block !important;\n  max-height: 0;\n  overflow: hidden;\n  height: 0;\n  transition: all 0s linear !important;\n}\n\n.mobile-menu .nav-submenu.open {\n  max-height: 500px;\n  height: 100%;\n  transition: all 2s linear !important;\n  /* Adjust this value based on your content */\n}\n\n.submenus-submenu.open {\n  max-height: 500px;\n  height: 100%;\n  transition: all 2s linear !important;\n  /* Adjust this value based on your content */\n}\n\n@media screen and (max-width: 991px) {\n  .responsive-dropdown.cat .submenus-submenu {\n    display: block !important;\n    max-height: 0;\n    overflow: hidden;\n    height: 0;\n    transition: all 0s linear !important;\n  }\n\n  .responsive-dropdown.cat .submenus-submenu.open {\n    max-height: 500px;\n    height: 100%;\n    transition: all 0.5s linear !important;\n  }\n}\n\n.promotional-banner {\n  position: relative;\n  z-index: 0;\n}\n\n.scroll-to-top {\n  z-index: 9999;\n}\n\n.common-dropdown__item .common-dropdown__link.activePage {\n  color: hsl(var(--main)) !important;\n}\n\n.nav-menu__link.activePage {\n  color: hsl(var(--main));\n}\n\n.category-two {\n  @include md-screen {\n    display: block !important;\n  }\n}\n\n.category.main {\n  @include md-screen {\n    display: none !important;\n  }\n}\n\n.nav-menu--mobile .nav-submenu {\n  margin-inline-start: 10px;\n}\n\n.nav-menu--mobile .nav-submenu__link {\n  padding: 10px 8px;\n}\n\n.has-submenus-submenu:focus-within .submenus-submenu {\n  visibility: visible;\n  opacity: 1;\n}\n\n.Marquee_text-slider {\n  .rfm-child {\n    margin-right: 40px;\n  }\n}\n\n.countdown-list__item::before {\n  content: \"\";\n}\n\n.trending-products-three,\n.popular-products-three,\n.vendor-two-details,\n.new-arrival-three {\n  .group:hover .expand-icons {\n    display: flex !important;\n  }\n  .group:hover .expand-btn {\n    background-color: var(--main-two-600) !important;\n    .ph {\n      transform: rotate(45deg);\n      color: #fff;\n    }\n  }\n}\n\n.top-brand.three {\n  .slick-arrow {\n    transform: translateY(0);\n  }\n  .top-brand__slider .slick-arrow {\n    top: -68px;\n  }\n}\n\n.testimonials {\n  .slick-arrow.slick-prev {\n    position: absolute;\n    bottom: -100px;\n    top: auto;\n    transform: translateX(-50%);\n    left: 46%;\n  }\n  .slick-arrow.slick-next {\n    position: absolute;\n    bottom: -100px;\n    top: auto;\n    transform: translateX(-50%);\n    right: 46%;\n  }\n  .slick-arrow {\n    i {\n      color: #fff;\n    }\n  }\n}\n\n.instagram {\n  .slick-arrow {\n    z-index: 9999;\n    transform: translateY(0);\n  }\n  .instagram-slider .slick-arrow {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n.vendor-two {\n  .list-grid-wrapper.list-view {\n    @include sm-screen {\n      display: grid;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
